/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Shopping Cart page component. The component displays the Shopping cart page details.
 * 
 * App Name: SDI-Walmart
 * Author: M.Sushmitha
 * Created Date: 08/10/2020
 */

import React, { Component } from 'react';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import SearchResultsStore from '../stores/SearchResultsStore';
import Modal from 'react-modal';
import Image from 'react-image-resizer';
import ReactPaginate from 'react-paginate'; //WW-687_PC_01 (4/20/2023)-Aparna
import Select from 'react-select';
/*[10/11/22,WW-521-Implementation of Character counter], Priyanka D */
import CharacterCounter from 'react-character-counter'
import ProfileStore from '../stores/ProfileStore';
import * as ProfileAction from '../actions/ProfileAction';
import * as FavItemMainAction from '../actions/FavItemMainAction';
import FavItemMainStore from '../stores/FavItemMainStore';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';
//import { withTranslation, Trans } from 'react-i18next'
//import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next'
import i18n from '../i18n';
//[09/29/22, WAL-780_PC_IDSC_01, Dhevanesam R]
import Carousel from 'better-react-carousel';
import Autocomplete from 'react-autocomplete'; //WAL-541_PC_12 -Aparna
import { RotatingLines } from 'react-loader-spinner'
//import { getZipData } from 'geolib';


/*
 * CookieService is used for the Usage of the local database values in the component. 
 * The Local database is used for maintaining the login user falgs m
 * 
 * */
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
/*
 *Datepicker plugin is used for the usage of react date picker.
 * 
 * */
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
/*
 * QuickItemComponent is used in the shoppingcartcomponent for checking item whether it can be added by using quick item option.
 * Adding 
 */
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import QuickItemComponent from '../components/QuickItemComponent';
import WOPartsComponent from '../components/WOPartsComponent';
import PDFPreviewComponent from './PDFPreviewComponent';
/*
 * ShoppingCartAction has the action method used to call the API method for data response.
 * */
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
/*
 * ShoppingCartstore has the store case whhich emits the action response and invokes the response method.
 * */
import ShoppingCartStore from '../stores/ShoppingCartStore';
/*
 * MenuAction has the action method used to call the API method for data response.
 * When an item is added to cart or the page is made to favorite.Menu bar has to reloaded.
 * For this purpose manuaction is used in Shoppingcartcomponent.
 * */
import * as MenuAction from '../actions/MenuAction';
/*
 *Import the Jquery to use jquery feature for binding the value to the field and so on.
 */
import * as $ from 'jquery';
import { minWidth } from '@material-ui/system';
import DistanceCalculator from 'distance-calculator-js';
import swal from 'sweetalert';
import Rating from 'material-ui-rating'
import { Divider } from '@material-ui/core';
import * as WALNonCatalogAction from '../actions/WALNonCatalogAction';
import WALNonCatalogStore from '../stores/WALNonCatalogStore';
let qckKeycounter = 0;
let rmvAttachindex = -1;
//let OLDueDateVal;
let currentPagePath;
let Searchkeywoed = ""
let AlreadyInCart = 0
let QuickItemId = ""
let OrderSuccessCOunt = 0
let LOCATION = "";
/*[03/10/22, PC_01,A1QA-145], Priyanka D */
let CurrentLatitude = null;
let CurrentLongitude = null;
//[2/10/22, PC_SC_03, WW-330, Dhevanesm R]
let WillCallBenVal;
let QtyFromItemDet = "";
let IsFromShoppingCart = false;
let userDeniedLocation = false;
let displayExtraLoader = true; // this is used to display extra loader to eliminate the delay , WW-921, Divis Kumar R K
//[12/06/2024, WW-1221 Preventive work order -Vishwa S]
let isQuoteOrderSubmit = false;
let refOrderNo = "";
let cartDelete = false;
let WOBtnClick = false;

const blk = {
    backgroundColor: "Ghostwhite",
    padding: "4px 4px",
    marginTop: "9px",
    float: "left",
    right: "initial",
    border: "1px  solid gray"
}
const la = {
    backgroundColor: "Orange",
    padding: "3px 3px",
    marginTop: "11px",
    float: "left",
    right: "initial",
    border: "1px  solid gray"
}
const lal = {
    backgroundColor: "Green",
    padding: "3px 3px",
    marginTop: "11px",
    float: "left",
    right: "initial",
    border: "1px  solid gray"
}
const txt = {
    color: "black",
    float: "left",
    fontSize: '15px',
    textAlign: "initial",
    marginLeft: "12px"
}
const Errtxt = {
    color: "Red",
    float: "left",
    fontSize: '15px',
    textAlign: "initial",
    marginLeft: "70px"
}
const dot = {
    alignItems: 'center',
    display: 'flex',
    ':before': {
        backgroundColor: "yellow",
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
        border: "1px  solid gray"
    },
}
const dott = (color = '#ccc') => ({
    alignItems: 'center',
    display: 'flex',
    ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        marginLeft: 10,
        height: 10,
        width: 10,
    },
});
const colourStyles = {
    //control: styles => ({ ...styles, backgroundColor: 'white' }),
    //option: (styles, { locpick }) => ({ ...styles, ...dot(locpick.color) })
    option: (styles, { data }) => {
        //const color = (locpick[i].color)
        return {
            ...styles,
            alignItems: 'center',
            display: 'flex',
            ':before': {
                backgroundColor: data.color,
                borderRadius: 10,
                content: '" "',
                display: 'block',
                marginRight: 8,
                height: 10,
                width: 10,
                border: "1px  solid gray"
            }
        }
    }
    //input: styles => ({ ...styles, ...dott() }),
    //placeholder: styles => ({ ...styles, ...dott() }),
    //singleValue: (styles, { data }) => ({ ...styles, ...dott(data.color) }),
}
class ShoppingCart extends Component {
    /**
     * SC_PC_03 
     * Declare a �constructor� method with �props� as its parameters.
     */
    constructor(props) {
        super(props);
        //this.BuildFavMenu = this.BuildFavMenu.bind(this);
        //this.bindFavSubItem = this.bindFavSubItem.bind(this);
        //this.BindCart = this.BindCart.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.quickItemClick = this.quickItemClick.bind(this);
        this.BuildShoppingCartPage = this.BuildShoppingCartPage.bind(this);
        this.loadQuickItem = this.loadQuickItem.bind(this);
        this.closeFavPopup = this.closeFavPopup.bind(this);
        this.DeleteItemStatus = this.DeleteItemStatus.bind(this);
        this.COStatus = this.COStatus.bind(this);
        //**NEW**ADDED**(1/21/2021)
        this.OrderPlacedStatus = this.OrderPlacedStatus.bind(this);
        this.NAItems = this.NAItems.bind(this)
        this.onChange = this.onChange.bind(this);//WAL-541_PC_13 -Aparna
        this.onSelect = this.onSelect.bind(this);//WAL-541_PC_13 -Aparna
        this.IsRefrigerantInCart = this.IsRefrigerantInCart.bind(this);//WAL-541_PC_13 -Aparna
        this.FavOrderremoveAttachmentResponse = this.FavOrderremoveAttachmentResponse.bind(this);//WAL-600_PC_02 -Aparna
        this.WarehouseIconresponse = this.WarehouseIconresponse.bind(this);
        this.bindSuppliers_InPopup = this.bindSuppliers_InPopup.bind(this);
        //WAL-1034_PC_43 -Aparna
        this.AnykeyPress = this.AnykeyPress.bind(this);
        this.WOText = React.createRef();
        this.handleStoreChange = this.handleStoreChange.bind(this);
        //WW-920_PC_
        this.UpdateItemStatus = this.UpdateItemStatus.bind(this);

        //**END******
        //this.quickItemClick = this.quickItemClick.bind(this);
        /*
         * All the below mentioned State variable are used in the component to bind,update,show popup and so on.
         * */
        this.state = {
            GreaterThan100Miles: false, tradeMismatchItems: [],
            onchangeshipto: false,
            Pick: [],
            ShowOrderDetails: 0,
            OnlyCatalogItem: true,
            showprice: (CookieService.getLocalStorageValues("Session_ShowPrice") == "0" && CookieService.getLocalStorageValues("Session_ISAPriceBlock") == "Y" ? "0" : ""),
            OLDueDateVal: "",
            apiURL: "",
            sizedd: 5,
            isFavorited: false,
            strCplusitemid: "0",
            isExpand: true, //WW-1321 Set Default Item View to "Expanded" on page load of cart - Nandhini L
            ItemDate: "",
            txtItemID: "",
            startDate: "",
            ItemIndex: 0,
            CartItems: [],
            FavMenu: [],
            FavMenuSub: [],
            EmployeeCC: [],
            ShipToDDValue: [],
            shiptoDropdown: [],/*[11/22/21, PC_SC_01, WW-282], Priyanka D//Declaring a state variable for storing shiptovalues along with latitude and longitude from backend*/
            showshipto: true,
            MachineTable: [],
            TypeTable: [],
            SiteCurrencyTable: [],
            ActiveFieldToUpdate: "",
            CloseModal: "",
            ItemId: "",
            UniqId: "",
            Description: "",
            FavItemIdPopUp: "",
            FavSDICatgPopUp: "",
            FavYourCatgPopUp: "", FavSubCategory: "",
            FavItemDescripPopUp: "", FavSAP: "",
            FavYourDescripPopUp: "",
            FavMFGPopUp: "",
            FavSupplierPopUp: "",
            FavMFGPartNUMPopUp: "",
            txtUOMHidePopUp: "",
            txtMfgItemidHidePopUp: "",
            txtItemidHidePopUp: "",
            ISCoreChargePopUp: false,
            txtMFGHidePopUp: "",
            chkLineNumFlag: "False",
            attachmentPathArr: [],
            attachmentErrormsg: "",
            FavorPopUptitle: "",
            filter: [],
            truckstore: false,
            QuickItemEntryPUp: false,
            AddFavPUp: false,
            FavOrderConfPUp: false,
            AddAttachPUp: false,
            LineIncrePUp: false,
            CancelOrderConfPUp: false,
            RemoveItemPUp: false,
            EditDescPopUp: false, Favsupplierid: "", FavMFGpart: "", WNA: [], NAYFlag: false, NADeleteItemID: [],
            OrderEmpyId: " ",
            Login_UserId: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Login_UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            WordOrderNoLength: 10,
            hdfChangeLineNum: "N",
            hdfZeusNonCata: "N",
            OLEmplyIdLabel: "Employee ID",
            OLShipToIdLabel: "Ship To",
            ItemMachinePartNum: [],
            SearchKey: "",
            Session_ZEUSNOCATALOGSITE: CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE"),
            Session_ZEUS_SITE: CookieService.getLocalStorageValues("Session_ZEUS_SITE"),
            Session_MANORDNO: CookieService.getLocalStorageValues("Session_MANORDNO"),
            removeattach: [],
            curtrucklat: "",
            curtrucklong: "",
            CartCOunt: "",
            QuickitemEnabled: false,
            OrderPlacedstatus: "",
            FavOrder: false,
            base64URL: "",
            ShowPdf: false,
            PricedOrderNum: "",
            NonCataOrderNum: "",
            submitbtn: false,
            BilltoStore: "",
            BilltoStoreLocation: {},
            isWorkToStoreValid: false, EmplyeeNameDD: [],
            PagelaodCartValue: [],
            isAllItem_are_Pickup: false, pickup_vendor: [], PickupStore: [], pickupcheck: false, PickupStoreSelected: [], HalLocationSelected: [], halocations: [], halstorehours: [], hallocaddress: [], sethalboolenval: false, displayFedexDrop: false, Radiolocation: false, Radiopincode: false, HalStore: "", HALCountryCodeDD: [],
            pickupstore_tbl: [], PickupVendor: "", GraingerStore: [], GraingerQTY: [], lowesitem: false, Checkedbillto: true, EnableShipTo: true,
            Graingermsg: []/******NEW***(pickup)wal-158**/, WONUM: localStorage.getItem("WONum") == null || localStorage.getItem("WONum") == undefined ? '' : localStorage.getItem("WONum")/*[04/26/22,PC_WW-365], Removed Substring condition Priyanka D */, BilltostoreEnable: false, ERRWO: false, isPickup: false, workorderclick: false,
            USER_CHAR1: (CookieService.getLocalStorageValues("WO_Priority") != undefined && CookieService.getLocalStorageValues("WO_Priority") != null && CookieService.getLocalStorageValues("WO_Priority") != "" ? CookieService.getLocalStorageValues("WO_Priority") : ""), //WW-718_PC_04 -Aparna
            //[2/10/22, PC_SC_03, WW-330, Dhevanesm R]
            isAllItem_are_Inv: false, WillCallbool: false, displayPickDrop: false, BenPickLbl: "", FavOrdDes: "", FavOrdCat: "", autocompleteData: [], autocompleteDataRstl: [], autocompleteItemDataRstl: [], autocompleteItemData: [],//WAL-541_PC_03 -Aparna WW-368_SuggestionCat_for_shopping_PC_04
            //[2/28/22], PC_IC_01, WW-316, Dhevanesam R
            ImgResponseVal: [], ImgCssVal: "", attachmentErrormsg: "", ImageFileName: "", ImageFilePath: "", attachmentPathArrImg: "", ImagePathArr: [], selectedOrderImg: "",
            defaultshipto: {}, Bentonville_WO: false,
            /*[07/18/22, 2381-Lowe Item cannot be mixed with other vendor items], Priyanka D */
            IsMultipleSupplier: "Shopping cart contains items from multiple suppliers.",
            IsOkbuttonshow: "Press OK to continue or Cancel to remove unwanted items.", CategoryErr: false,
            //[09/29/22, WAL-780_PC_IDSC_02, Dhevanesam R]
            HideCarouseArrow: false,
            ColumnsCarousel: 5,
            IsFeedbackPopup: false,
            IsRateNow: true,
            OrderCount: 0,
            SurveyQues: [],
            QuesNo: 0,
            HandleNextQues: 0,
            Comments: "",
            SurveyFeedback: [],
            FavOrdsubCategoryResults: [], FavOrdsubCategory: [], FavOrdSubCategoryErr: false, FavOrdSubCat: "",
            subCategoryResults: [], subCategory: [], SubCategoryErr: false, //WW-516_PC_13 (10/3/2022)-Aparna
            Halloc: [],
            Haldisplay: "", StarRating: 0, HalSelectedOphrs: [], zipCode: "", favUnavailItems: [], RefrigerantTxt: "", hasRefrigerant: false, RefrigerantItem: "", shiptoLat: "", shipToLong: "", shiptoDD: [],
            isValidWO: localStorage.getItem("WONum") == null || localStorage.getItem("WONum") == undefined ? false : true, PickupVendorID: "",
            Choose_Delivery_Btn_Click: false, supplierList: [], validationFailedIndex: -1, supplier_PageNo: 1, splitDelivery_ZipCode: "", chooseDelivery_Submit_btn_Click: false, splitdelivery_Zipcode_Error: "",//WW-687_PC_01 (4/19/2023)-Aparna
            WO_Parts: localStorage.getItem("WO_Parts") != null && localStorage.getItem("WO_Parts") != undefined && localStorage.getItem("WO_Parts") != "" ? JSON.parse(localStorage.getItem("WO_Parts")) : [], //Bug :3618 ,WAL-1034_PC_01 -Aparna 
            isRefrigerantItemInCart: false, //WW-774_PC_01 -Aparna
            userZipCode: false, splitDelivery_userZipCode: false, ZipCode_no: "", isGraingerrZipCodeChange: false, inventry_zipcode_Error: false, splitdelivery_Delivery_Error: "", isCountryMatch: true,
            IsInteractiveNonCat: false,
            isPageloadIsValidWO: true,
            isQuoteOrderDisplay: false, //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
            cartConfirmationPopupTxt: ""
        }
        //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        isQuoteOrderSubmit = false;
        refOrderNo = "";
        cartDelete = false;
   
    }
    /*
     * RF No: SC_PC_07
     * componentwillmount is the method which is loaded and exceute first.
     * When the Shoppingcart page loaded.s
     * */


    componentDidMount() {

        console.log("BiltoStoreValue", localStorage.getItem("BiltoStoreValue"))
        console.log("ShipToID", localStorage.getItem("ShipToID"))
        console.log("WONum", localStorage.getItem("WONum"))
        console.log("StoreValue", localStorage.getItem("StoreValue"))
        QtyFromItemDet = "";
        IsFromShoppingCart = false;
        const queryParams = new URLSearchParams(window.location.search);
        let ShoppingCartPage = queryParams.get('FavItemPage');
        /*[04/10/23, PC_4247_13 - set the Asset Tag Id field with the localStorage item value with the key "WOAssetID", Vishwa S]*/
        if ((localStorage.getItem("WOAssetID") !== null || localStorage.getItem("WOAssetID") !== undefined) && (localStorage.getItem("WONum") !== null || localStorage.getItem("WONum") !== undefined)) {
            $(`#OLMachDD`).val(localStorage.getItem("WOAssetID"));
        }
        if (ShoppingCartPage == 'ItemDetail') {
            QtyFromItemDet = queryParams.get('qtyadj');
            IsFromShoppingCart = true
        }
        if (!navigator.geolocation) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Geolocation is not supported by your browser"
            });
        } else {
            navigator.geolocation.getCurrentPosition(
                this.handleSuccess,
                this.handleError
            );
        }
        //WW-398_PC_02 (5/5/2022) -Aparna
        this.BentonvilleStore_Check()
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);

        /*
         *  RF No: SC_PC_08
         *  LoadCartItem is the method used to get the pageload data from the database.
         * */
        $('#QTY-popup').modal('hide');//A1QA regression bug - 74  - Deepthi
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CookieService.updateLocalStorageValues('kenstancount', 0);
        this.LoadCartItem()
        NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
        ShoppingCartStore.on("latlongresp", this.trucklatlong);
        /*
         * RF No: SC_PC_10
         * This emit call is done when the Getcartitem action has the response.
         * */
        ShoppingCartStore.on("Cartitem", this.BuildShoppingCartPage);
        /*
         * RF No: SC_PC_11
         * This emit call is done when the UpdateItemDesp action has the response.
         * Item level Details filled or updateed.
         * */
        ShoppingCartStore.on("UpdateStatus", this.UpdateItemStatus);
        /*
         * This emit call is done when the UpdateCartEmpCC action has the response.
         * Order level Employee CC or Due date is filled.
         * */
        ShoppingCartStore.on("UpdateStatusOL", this.UpdateitemStatusOL.bind(this));
        /*This emit call is done when the quick item or favorite menu item is filled or click for adding item to the cart.
         */
        ShoppingCartStore.on("quickItemCheck", this.loadQuickItem);
        /*
         * This emit call is done when the GetAddFavItemDetail action has the response.
         * */
        ShoppingCartStore.on("FavItemDetails", this.BindAddFavPopUp.bind(this));
        /*
         * This emit call is done when the updateFavsMenu action has the response.
         * */
        ShoppingCartStore.on("FavItemUpdate", this.closeFavPopup);
        /*
         * RF No: SC_PC_12
         * This emit call is done when the DeleteCartItem action has the response.
         * */
        ShoppingCartStore.on("deleteItem", this.DeleteItemStatus);
        /*
         * RF No: SC_PC_13
         * This emit call is done when the SubmitOrder action has the response.
         * */

        ShoppingCartStore.on("PlaceOrder", this.OrderPlacedStatus.bind(this));
        /* This emit call is done when the order pdf is generate and return from the API throught Action.
         */
        ShoppingCartStore.on("OrderPDF", this.OrderPDFShow.bind(this));
        /*
         * This emit calls are reused from the Non catalog page.
         * During the Attachment bind or remove.
         * */
        ShoppingCartStore.on('attachmentResponse', this.loadAttachments);
        ShoppingCartStore.on('rmvAttach', this.removeAttachmentResponse);
        ShoppingCartStore.on('favorderrmvAttact', this.FavOrderremoveAttachmentResponse);
        ShoppingCartStore.on('HALocations', this.BindHALResponse.bind(this));
        //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
        ShoppingCartStore.on('Zipcode_Validation', this.Zipcode_Validtn_Response);
        /*
         * RF No: SC_PC_14
         * This emit call is done when the CancelOrderItem action has the response.
         * */
        ShoppingCartStore.on('CancelOrder', this.COStatus);
        /*
        * Favorite page response listeners
        */
        ShoppingCartStore.on('favpage', this.loadFavPageResponse);
        ShoppingCartStore.on('updateFavPage', this.updateFavPageResponse);
        /*******NEW************wal-158****/
        ShoppingCartStore.on('grainger', this.Graingerdata);
        ShoppingCartStore.on('WOfail', this.workorderfail);
        ShoppingCartStore.on('workordercheck', this.workOrder_Validation_Response);
        ShoppingCartStore.on('Warehousecheck', this.warehouseqtyresponse);
        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.on('WarehouseIcon', this.WarehouseIconresponse);
        ItemDetailNewStore.on('GetRecommendedItems', this.GetRecommendedItemsResposne);
        //ShoppingCartStore.on('workordercheck', this.bill_to_store);
        /*[03/16/22,WAL-721_PC_11,WAL-721], Priyanka D */
        ShoppingCartStore.on('ReorderResponse', this.ReorderResponse);
        /************END***************/
        /*response of deletefavitem*/
        ShoppingCartStore.on('DelFavPage', this.DelFavItem);
        //[2/22/22], WW-243, PC_SP_01, Dhevanesam R
        ShoppingCartStore.on('NONCAT_UploadAttachments1', this.loadAttachmentsImg);
        SearchResultsStore.on('SrchFavitemAdd', this.FavSuccess);
        ShoppingCartStore.on('FeedbackResponse', this.FeedbackResponse);
        WALNonCatalogStore.on('WalmartNonCatalog_removecartItem', this.removeItemResponse);
        window.scrollTo(0, 0)
    }
    componentWillUnmount() {
        ShoppingCartStore.removeListener("latlongresp", this.trucklatlong);
        /*
         * RF No: SC_PC_10
         * This emit call is done when the Getcartitem action has the response.
         * */
        ShoppingCartStore.removeListener("Cartitem", this.BuildShoppingCartPage);
        /*
         * RF No: SC_PC_11
         * This emit call is done when the UpdateItemDesp action has the response.
         * Item level Details filled or updateed.
         * */
        ShoppingCartStore.removeListener("UpdateStatus", this.UpdateItemStatus);
        /*
         * This emit call is done when the UpdateCartEmpCC action has the response.
         * Order level Employee CC or Due date is filled.
         * */
        ShoppingCartStore.removeListener("UpdateStatusOL", this.UpdateitemStatusOL.bind(this));
        /*This emit call is done when the quick item or favorite menu item is filled or click for adding item to the cart.
         */
        ShoppingCartStore.removeListener("quickItemCheck", this.loadQuickItem);
        /*
         * This emit call is done when the GetAddFavItemDetail action has the response.
         * */
        ShoppingCartStore.removeListener("FavItemDetails", this.BindAddFavPopUp.bind(this));
        /*
         * This emit call is done when the updateFavsMenu action has the response.
         * */
        ShoppingCartStore.removeListener("FavItemUpdate", this.closeFavPopup);
        /*
         * RF No: SC_PC_12
         * This emit call is done when the DeleteCartItem action has the response.
         * */
        ShoppingCartStore.removeListener("deleteItem", this.DeleteItemStatus);
        /*
         * RF No: SC_PC_13
         * This emit call is done when the SubmitOrder action has the response.
         * */
        ShoppingCartStore.removeListener("PlaceOrder", this.OrderPlacedStatus.bind(this));
        /* This emit call is done when the order pdf is generate and return from the API throught Action.
         */
        ShoppingCartStore.removeListener("OrderPDF", this.OrderPDFShow.bind(this));
        /*
         * This emit calls are reused from the Non catalog page.
         * During the Attachment bind or remove.
         * */
        ShoppingCartStore.removeListener('attachmentResponse', this.loadAttachments);
        ShoppingCartStore.removeListener('rmvAttach', this.removeAttachmentResponse);
        ShoppingCartStore.removeListener('HALocations', this.BindHALResponse.bind(this));
        /*
         * RF No: SC_PC_14
         * This emit call is done when the CancelOrderItem action has the response.
         * */
        ShoppingCartStore.removeListener('CancelOrder', this.COStatus);
        /*
        * Favorite page response listeners
        */
        ShoppingCartStore.removeListener('favpage', this.loadFavPageResponse);
        ShoppingCartStore.removeListener('updateFavPage', this.updateFavPageResponse);
        ////****NEW***wal-158****
        ShoppingCartStore.removeListener('grainger', this.Graingerdata);
        ShoppingCartStore.removeListener('WOfail', this.workorderfail);
        ShoppingCartStore.removeListener('workordercheck', this.workOrder_Validation_Response);
        ShoppingCartStore.removeListener('Warehousecheck', this.warehouseqtyresponse);
        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.removeListener('WarehouseIcon', this.WarehouseIconresponse);
        ////*****END******
        ShoppingCartStore.removeListener('DelFavPage', this.DelFavItem);
        ItemDetailNewStore.removeListener('GetRecommendedItems', this.GetRecommendedItemsResposne);
        /*[04/18/22,PC_WW-359_02], Priyanka D */
        ShoppingCartStore.removeListener('ReorderResponse', this.ReorderResponse);
        SearchResultsStore.removeListener('SrchFavitemAdd', this.FavSuccess);
        //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
        ShoppingCartStore.removeListener('Zipcode_Validation', this.Zipcode_Validtn_Response);
        WALNonCatalogStore.removeListener('WalmartNonCatalog_removecartItem', this.removeItemResponse);
    }


    /*
     * RF No: SC_PC_14
     * This method is invoked inside the compouentwillmount.
     * Action method Getcartitem is called to get the page load response of the shopping cart page from the API throught Action.
     * Action method getCurrentFavPage is called to get the page favorite status.
     * */

    ReorderResponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let ReorderResponse = JSON.parse(ShoppingCartStore.ReorderResponse);
        //to hide favorder pop-up
        let hasEquipmentItem = [];
        let { CartItems } = this.state;
        if (CartItems) {
            hasEquipmentItem = CartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');

        }
        if (ReorderResponse == "False") {
            /*[11/25/22, PC_WAL-926_08], Priyanka D */
            if (this.state.hdfChangeLineNum == "Y") {
                this.setState({ LineIncrePUp: true });
                $('#line-increment').modal('show');
            } else {
                /*[11/25/22, PC_WAL-926_08], Priyanka D */
                let punchoutcheck = false;
                let nonpunchout = false;
                let SrcNCCheck = false
                //[1/11/23, WW-552, Dhevanesam R]
                let cartFormItems = [];
                let { CartItems } = this.state
                CartItems.forEach((x) => {
                    /*[06/09/22,WW-401, Only for Lowes punchout item, fav order popup should not be shown], Priyanka D */
                    if (x.PaintColor == "PUNCHOUT") {
                        punchoutcheck = true;
                    }
                    if (x.PaintColor == "WNST" || x.PaintColor == "WCAT") {
                        SrcNCCheck = true;
                    }
                })
                CartItems.map((val, index) => {
                    if (val.FilePath != undefined && val.FilePath != null && val.FilePath != "" && val.FilePath != " ") {
                        if (val.FilePath[0].toLowerCase().includes('form')) {
                            cartFormItems.push(val)
                        }
                    }
                })
                if (punchoutcheck || SrcNCCheck || isQuoteOrderSubmit || hasEquipmentItem.length > 0) { //WW-1221 Preventive work order -Vishwa S
                    this.AddFavOrder("False")
                }

                else {
                    if (cartFormItems.length > 0) {
                        this.AddFavOrder("False")
                    }
                    else {
                        this.setState({ FavOrderConfPUp: true });
                        $('#Fav-confirmation').modal('show');
                    }
                }

            }

            this.setState({ isreorder: ReorderResponse })
        }
        else {
            let isreorder = ReorderResponse.isReorder[0].lblerror;
            let reorderitems = ReorderResponse.reorderitems
            let Options = {};
            let Arraydata = ReorderResponse.Reasons;
            let locReason = []
            Arraydata.map((val, index) => {
                let localArray = {
                    value: val.FIELDVALUE,
                    label: val.XLATLONGNAME,
                }
                locReason.push(localArray)
            });
            this.setState({ reoderOptions: locReason, reorderitems: reorderitems });
            if (isreorder) {
                this.setState({ isreorder: true })
                $('#reorderreason').modal('show');
            }
        }
    }
    favpopupclose = () => {
        $('#add-fav-popup').modal('hide');
        this.setState({ FavYourCatgPopUp: "", FavSubCategory: "", subCategoryResults: [], ImagePathArr: [] });
    }
    FavSuccess = () => {
        let Status = JSON.parse(SearchResultsStore.FavitemAddList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("Status", Status)
        let Favstatus = Status.ErrorMsg
        if (Favstatus.length > 0) {
            if (Favstatus[0].Error_Msg == "Favorite item inserted sucessfully") {
                //e.preventDefault();
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Favorite item inserted sucessfully"
                });
                //alert("Favorite item inserted sucessfully")
                let favsub = Status.FavSubMenu
                // MenuAction.refreshMasterData()
                //2284 Favorite item_Not able to see the items in fav items when item added to favs from shopping cart - Deepthi
                this.setState({ FavoritesSubMenu: favsub, FavMenuSub: favsub });
                $('#add-fav-popup').modal('hide');
            }
            else {
                //e.stopImmediatePropagation();
                //e.preventDefault();
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Technical Issue Try again"
                });
                //        alert("Technical Issue Try again");
            }
            this.setState({ FavYourCatgPopUp: "", FavSubCategory: "" });
        }
    }
    //WW-375 Ability to add Image to Fav Order -Deepthi
    loadAttachmentsImg = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = ShoppingCartStore.NONCAT_UploadAttachments1.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(ShoppingCartStore.NONCAT_UploadAttachments1);
            //let tempAttachments = this.state.attachmentPathArrImg;
            //tempAttachments = tempAttachments.concat(attachmentResponse); attachmentResponse[0].FilePath
            console.log("attachmentPathArrImg", attachmentResponse)
            this.setState({ attachmentPathArrImg: attachmentResponse });

            //console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    LoadCartItem = (isPageLoadParam) => {
        /**
        * Invoke the action to check the current page is favorited
        */

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: this.state.Login_UserId,
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        ShoppingCartAction.getCurrentFavPage(getFavPageBO);
        /*
         * Object used to get the page load data.
         * */
        // $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let GetCartBO = {
            userID: this.state.Login_UserId,
            userBU: this.state.Login_UserBU,
            punchinSessionID: "",
            Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
            Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            CurrentPage_Url: "/SDIXZEUS/ShoppingCart",
            Session_PARTLIST: CookieService.getLocalStorageValues("Session_PARTLIST"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_CARTFAIL: "N",
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            /*[12/24/21, PC_SC_01], Priyanka D//Passing the Location value */
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
            Source: "WEB",
            //[1/20/23, WW-542_PC_21, Dhevanesam R]
            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
            IsPageLoad: isPageLoadParam != undefined && isPageLoadParam != null ? isPageLoadParam : true
        }
        ShoppingCartAction.Getcartitem(GetCartBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /*
     * RF No: SC_PC_19 && RF No: SC_PC_20 && RF No: SC_PC_21
     * All the Page load hide and show based on the flags is hadled in this method.
     * State variables are set by the response value.
     * */
    trucklatlong = () => {
        ////
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let LatLongResp_Data = JSON.parse(ShoppingCartStore.getlatlongresp);
        let latitude = LatLongResp_Data[0].Latitude;
        let longitude = LatLongResp_Data[0].Longitude;
        this.setState({ curtrucklat: latitude, curtrucklong: longitude, pickupcheck: true })
        this.Bindpickupstore();
    }
    BuildShoppingCartPage = () => {

        let ItemID = [];
        let arr = [];
        let enableshipto = true; //WW-673_PC_BL_02 //WW
        if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") == 'N') {
            enableshipto = false;
        }
        /*[11/25/22, PC_WAL-926_04], Priyanka D */
        let unAvailItems = [];
        let notAvailItem = [];
        let locCountryMatch = true;
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
        let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";
        //  WW -452_PC_03 Test suppliers pickup Pavithra R
        if (localStorage.getItem("WONum") == null) {
            localStorage.removeItem("BilltoStoreLocationLat")
            localStorage.removeItem("BilltoStoreLocationLong")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let PageLaod_Data = JSON.parse(ShoppingCartStore.CartitemList);
        /*[11/25/22, PC_WAL-926_04], Priyanka D */
        let availableItems = PageLaod_Data.AvailableItems

        PageLaod_Data.CartItems.forEach((val, ind1) => {
            let ItemID = val.Itemid.toString()
            if (!ItemID.toLowerCase().includes("noncat") && !ItemID.toLowerCase().includes("core")) {
                let ind = availableItems.findIndex(avail => avail.ItemID === val.Itemid);
                if (ind == -1) {
                    unAvailItems.push(val);
                }
            }
        });

        //[12/06/2024, WW-1221 Preventive work order - to check cart for quote and equipment items -Vishwa S]
        let hasQuoteItem = [];
        let hasEquipmentItem = []
        hasQuoteItem = PageLaod_Data.CartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
        hasEquipmentItem = PageLaod_Data.CartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');

        if (!hasEquipmentItem.length > 0 && !hasQuoteItem.length > 0 && (IsThirdParty != false || CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" || (CookieService.getLocalStorageValues("Session_User_Division") != undefined && CookieService.getLocalStorageValues("Session_User_Division") != null && CookieService.getLocalStorageValues("Session_User_Division") == "WALMART HOME OFFICE"))) {
            this.setState({ isQuoteOrderDisplay: true })
        }
        if (hasQuoteItem.length > 0) {
            refOrderNo = hasQuoteItem[0].ISA_QUOTE_REF
        }

        if (unAvailItems.length > 0) {
            unAvailItems.map((val, index) => {
                let loc = {
                    item: val.Itemid,
                    label: "Not Available",
                    qty: "0",
                    mfgpart: val.Manufacturerpartnumber
                }
                notAvailItem.push(loc)

            })
        }

        if (this.state.isPageloadIsValidWO) {
            PageLaod_Data.CartItems.map((val, index) => {
                if (PageLaod_Data.CartItems[index].FilePath != null && PageLaod_Data.CartItems[index].FilePath != undefined) {
                    //[12/21/22, PC_WW-552_FE_29], Dhevanesam R
                    if (PageLaod_Data.CartItems[index].FilePath[0].toUpperCase().includes('FORM')) {
                        ItemID[index] = val.Itemid
                        arr.push(ItemID[index]);
                        CookieService.updateLocalStorageValues("FormList", arr)
                        console.log("FormList", CookieService.getLocalStorageValues("FormList"))
                    }
                }
            })
            let { showprice } = this.state;
            let pickup = false;
            let SiteCurrency = PageLaod_Data.siteCurrencyTable;
            let IsAEESvalue = PageLaod_Data.IsAEESValue;
            let PunchInFlagTable = PageLaod_Data.PunchInFlagTable;
            let showShiptoTable = PageLaod_Data.showShipto
            let HashTable = PageLaod_Data.Hashtable;
            let ShipDD = [];
            ShipDD = PageLaod_Data.ShipToDD;
            let EnterprisesTable = PageLaod_Data.EnterpriseTable;
            let Update_Session = PageLaod_Data.Update_Session;
            let FlagTable = PageLaod_Data.FlagTable;
            let WordOrderNoLengthLocal = 7;
            let hdfZeusNonCataLocal = "N";
            let hdfChangeLineNumLocal = "N";
            let OLEmplyIdLabelLocal = "Employee ID";
            let OLShipToIdLabelLocal = "Ship To";
            let ShoppingCartPrilg = HashTable.filter((item, index) => item.Key == "ADDCART");
            //WW-1163 Request to source item check -Vishwa S
            let isIntNonCat = PageLaod_Data.IntNonCatTable;
            if (isIntNonCat != undefined && isIntNonCat != null && isIntNonCat.length != 0) {
                if (isIntNonCat[0].IsIntNonCat.toLowerCase() == "true") {
                    this.setState({ IsInteractiveNonCat: true })
                }
                else {
                    this.setState({ IsInteractiveNonCat: false })
                }
            }

            /*If the cartitem count is 0, then the pickupcheckbox should be unchecked*/

            this.setState({ shiptoDD: ShipDD })

            //let shipLat = localStorage.getItem("BilltoStoreLocationLat")
            //let shiplong = localStorage.getItem("BilltoStoreLocationLong")

            //if (shipLat != null && shiplong != null) {
            //    this.setState({ shiptoLat: shipLat, shiptoLong: shiplong })
            //}



            if (this.state.CartCOunt == "0") {
                //$("#pickupcheck").prop("checked", false);
                this.setState({ pickupcheck: false });
            }
            if (Update_Session != null && Update_Session != "") {
                if (Update_Session.length > 0) {
                    if (Update_Session[0].Session_TESTMODE != null && Update_Session[0].Session_TESTMODE != "") {
                        CookieService.updateLocalStorageValues("Session_TESTMODE", Update_Session[0].Session_TESTMODE);
                    }
                    if (Update_Session[0].Session_CartFail != null && Update_Session[0].Session_CartFail != "") {
                        CookieService.updateLocalStorageValues("Session_CartFail", Update_Session[0].Session_CartFail);
                    }
                    if (Update_Session[0].dtCM != null && Update_Session[0].dtCM != "") {
                        CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
                    }
                    if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                        CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
                    }
                    if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                        CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
                    }
                }
            }
            //document.getElementById("CartCount").innerHTML = PageLaod_Data.CartItems.length;
            let ManOrno = CookieService.getLocalStorageValues("Session_MANORDNO")
            if (ManOrno != " " && ManOrno != null) {
                if (CookieService.getLocalStorageValues("Session_MANORDNO") == "A") {
                    WordOrderNoLengthLocal = 10;
                }
                if (CookieService.getLocalStorageValues("Session_ORDLNRENUM") == "Y") {
                    hdfChangeLineNumLocal = "Y"
                }
            }
            //else {
            //    document.getElementById("CustomerOrderNo").hidden = true
            //}
            //if (CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE") == "Y") {
            //    document.getElementById("EditFavLink").hidden = true
            //    document.getElementById("QuickItemEntry").hidden = true
            //    document.getElementById("FavMenu").hidden = true
            //}
            if (CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE") == "Y" && CookieService.getLocalStorageValues("Session_ZEUS_SITE") == "N") {
                //document.getElementById("OLDueDateDiv").hidden = true
                //document.getElementById("OLPriority").hidden = true
                hdfZeusNonCataLocal = "Y"
            }
            const queryParams = new URLSearchParams(window.location.search)
            const QS_src = queryParams.get('SearchKey');
            Searchkeywoed = QS_src
            //if (QS_src == "" || QS_src == null) {
            //    document.getElementById("BackSearchpage").hidden = true
            //}
            CookieService.updateLocalStorageValues("Session_SearchValue", "");
            if (SiteCurrency[0].length != 0) {
                CookieService.updateLocalStorageValues("SESSION_SITE_CURRENCY", SiteCurrency);
            }
            if (IsAEESvalue.length != 0) {
                OLEmplyIdLabelLocal = "Requisitioner Name:"
            }
            if (PunchInFlagTable.length != 0) {
                CookieService.updateLocalStorageValues("Session_Punchin", PunchInFlagTable.Session_PunchIn);
                if (PunchInFlagTable.WorkOrderA != null) {
                    $('#OLWorkOrderTB').val(PunchInFlagTable.WorkOrderA)
                }
            }
            //WW-1237 Home office users employee id do not prefill - Yuvarani K
            if ((CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" && CookieService.getLocalStorageValues("Session_AGENTUSERID") == "") || (CookieService.getLocalStorageValues("Session_User_Division") != undefined && CookieService.getLocalStorageValues("Session_User_Division") != null && CookieService.getLocalStorageValues("Session_User_Division") == "WALMART HOME OFFICE")) {
                OLEmplyIdLabelLocal = "Employee ID:" //***new**removed (by name)*****
            }
            if ((EnterprisesTable[0].ShipToFlag == "Y" && showShiptoTable[0].Show == "true") || ShipDD.length > 1) {
                OLShipToIdLabelLocal = "Ship To";
            }
            // let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
            //There were around 50,000 machine number was found for doyles1 account need to check that for temp I'm concating the length to 100
            let machinenumdata = [];
            if (PageLaod_Data.MachineNum) {
                if (PageLaod_Data.MachineNum.length > 1000) {
                    //PageLaod_Data.MachineNum.length = 1000;
                    machinenumdata = PageLaod_Data.MachineNum;
                    machinenumdata = machinenumdata.sort(function (x, y) {
                        return x.ISA_MACHINE_NO - y.ISA_MACHINE_NO;
                    });
                    // machinenumdata.sort(function (a, b) {return a-b})
                } else {
                    machinenumdata = PageLaod_Data.MachineNum;
                    machinenumdata = machinenumdata.sort(function (x, y) {
                        return x.ISA_MACHINE_NO - y.ISA_MACHINE_NO;
                    });
                    // machinenumdata.sort(function (a, b) {return a-b})
                }
            };
            let FavmenuDD = PageLaod_Data.FavMenu
            let filteredFavmenuDD = []
            if (FavmenuDD != null && FavmenuDD != undefined) {
                if (FavmenuDD.length > 0) {
                    filteredFavmenuDD = FavmenuDD.filter((v, i, a) => a.findIndex(t => (t.FavText.trim().toUpperCase() === v.FavText.trim().toUpperCase())) === i)
                }
            }
            let CartitemList = PageLaod_Data.CartItems
            let loccart = [];
            CartitemList.forEach((x) => {
                let val = (parseInt(x.Quantity) / parseInt(x.MIN_ORD_QTY));
                if (parseInt(x.Quantity) < parseInt(x.MIN_ORD_QTY)) {
                    x.MinOrdMsg = "Quantity Added For This Item is " + x.Quantity + ". But The Minimum Quantity is " + x.MIN_ORD_QTY + ".";
                    x.Quantity = x.MIN_ORD_QTY;
                }
                else if ((parseInt(x.Quantity) % parseInt(x.MIN_ORD_QTY)) != 0) {
                    x.MinOrdMsg = "Quantity Added For This Item is " + x.Quantity + ". But The Minimum Quantity is " + x.MIN_ORD_QTY + ".";
                    x.Quantity = x.MIN_ORD_QTY;
                }
                else {
                    x.MinOrdMsg = "";
                }
                if (IsFromShoppingCart) {
                    const queryParams = new URLSearchParams(window.location.search);
                    if (x.Manufacturerpartnumber == queryParams.get('ManufacturePartNumber') && x.Manufacturer == queryParams.get('ManufactureName') && x.SUPPLIERNAME.toUpperCase() == queryParams.get('Suppliername').toUpperCase()) {
                        x.Quantity = QtyFromItemDet;
                    }
                }
                loccart.push(x);
            })
            CartitemList = loccart;
            let Employeedata = PageLaod_Data.EmployeeCC
            let Loginempolyeeid = {
                ISA_EMPLOYEE_NAME: CookieService.getLocalStorageValues("Session_USERNAME"),
                EMP_ID: this.state.Login_UserId
            }
            let employidDrop = PageLaod_Data.EmployeeCC
            //employidDrop.push(Loginempolyeeid)
            let employidDropDown = employidDrop.filter((v, i, a) => a.findIndex(t => (t.EMP_ID.trim().toUpperCase() === v.EMP_ID.trim().toUpperCase())) === i)
            let Empolyeevalue = []
            if (employidDropDown != null && employidDropDown != undefined) {
                /*[04/07/22WW-243] Regression bug-Cannot able to add an item from quick item entryPriyanka D */
                let EmployeeID = (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"))
                Empolyeevalue = employidDropDown.filter((iresult, idx) => iresult.EMP_ID.toUpperCase() == EmployeeID.toUpperCase())
            }
            this.EmployeeDD(employidDropDown);
            // this.HalCountryCodeDD();
            //let employeevaluelist = []
            //let preferedemployee = {
            //    value: "0",
            //    label: "--Select Ship To--"
            //}
            ////changing drop down list to searchable React Select
            //employidDropDown.map((val, index) => {
            //    if (val != null && val != undefined) {
            //        //return (<option key={iresult.EMP_ID} value={iresult.EMP_ID}>{iresult.ISA_EMPLOYEE_NAME}</option>)
            //        if (index == 0) {
            //            let defaultvalue = {
            //                value: "0",
            //                label: "--Select Ship To--"
            //            }
            //            employeevaluelist.push(defaultvalue)
            //        }
            //        let localArray = {
            //            value: val.EMP_ID,
            //            label: val.ISA_EMPLOYEE_NAME
            //        }
            //        if (val.EMP_ID == this.state.OrderEmpyId) {
            //            preferedemployee = localArray;
            //        }
            //        employeevaluelist.push(localArray);
            //    }
            //})
            if (CartitemList != null && CartitemList != undefined) {
                if (CartitemList.length > 0) {
                    var l = 0
                    if (Empolyeevalue != "" && Empolyeevalue != null) {
                        if (Empolyeevalue.length > 0) {
                            for (l = 0; l < CartitemList.length; l++) {
                                if (CartitemList[l].EmpChgCode == null || CartitemList[l].EmpChgCode == "" || CartitemList[l].EmpChgCode == "0") {
                                    CartitemList[l].EmpChgCode = this.state.OrderEmpyId.value
                                }
                            }
                        }
                    }
                    this.setState({
                        supplier: CartitemList[0].SupplierID,
                        PaintColor: CartitemList[0].PaintColor
                    })
                }
            }
            //WW-1237 Home office users employee id do not prefill - Yuvarani K
            if (CookieService.getLocalStorageValues("Session_User_Division") != undefined && CookieService.getLocalStorageValues("Session_User_Division") != null && CookieService.getLocalStorageValues("Session_User_Division") == "WALMART HOME OFFICE") {
                this.setState({ OrderEmpyId: " " })
            }
            let OnlyCatalogitemdata = true
            CartitemList.map((val, index) => {
                let NonCat = val.Itemid.slice(0, 6)
                if (NonCat.toUpperCase() == "NONCAT") {
                    OnlyCatalogitemdata = false
                }
            })
            let today = new Date();
            today.setDate(today.getDate() + 5);
            let dateOL = this.handledate(today);
            ///***NEW****wal-158 */
            today = this.calcWorkingDaysdrop(5);
            dateOL = this.calcWorkingDays(5);
            ///*******END******** */
            let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
            let ShiptoValue = []
            /*[01/06/22, PC_SC_23,WW-283], Priyanka D*/
            //WW-774_PC_04 -Aparna
            let isRefrigerantInCart = this.isRefrigerantItemInCart(CartitemList)
            let ShiptoddValue = []
            let PerferedShipto = {
                value: "0",
                label: "--Select Ship To--"
            }
            if (PageLaod_Data.ShipToDD != null && PageLaod_Data.ShipToDD != undefined) {
                if (PageLaod_Data.ShipToDD.length > 0) {
                    let shipLat = "";
                    let shiplong = ""
                    // val.LATITUDE, val.LONGITUDE
                    if (Defaultship != "0" && Defaultship != "" && Defaultship != " " && Defaultship != null && Defaultship != undefined) {
                        let DefaultLocation = PageLaod_Data.ShipToDD.filter((val, idx) => (val.CUSTID == Defaultship))
                        shipLat = DefaultLocation[0].LATITUDE;
                        shiplong = DefaultLocation[0].LONGITUDE

                    }
                    else {
                        shipLat = localStorage.getItem("BilltoStoreLocationLat")
                        shiplong = localStorage.getItem("BilltoStoreLocationLong")
                    }
                    if (shipLat != null && shiplong != null) {
                        this.setState({ shiptoLat: shipLat, shiptoLong: shiplong })
                    }


                    PageLaod_Data.ShipToDD.map((val, index) => {
                        if (index == 0) {
                            let defaultvalue = {
                                value: "0",
                                label: "--Select Ship To--"
                            }
                            ShiptoValue.push(defaultvalue)
                        }
                        let localArray = {
                            value: val.CUSTID,
                            label: val.LOCNAME
                        }
                        let country = localStorage.getItem("Country")
                        if (val.CUSTID == Defaultship) {
                            if (!this.state.isValidWO) {
                                PerferedShipto = localArray
                            }
                            if (country != undefined && country != null && country != "") {
                                if (country.toUpperCase() == val.COUNTRY.toUpperCase()) {
                                    PerferedShipto = localArray
                                } else {
                                    locCountryMatch = false;
                                }
                            }



                        }
                        ShiptoValue.push(localArray)
                    });
                }
            }
            let bill = {};
            let billtostore = "";
            if (localStorage.getItem("StoreValue") != undefined || localStorage.getItem("StoreValue") != null) {
                billtostore = localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1);
            }
            /*[01/06/22, PC_SC_23,WW-283], Priyanka D*/
            let curlat = 0;
            let curlong = 0;
            let Shipto = [];
            let localArray = {};
            let billstore = localStorage.getItem("BiltoStoreValue");
            let billtostoreenable = false //WW-774_PC_04 -Aparna
            if (localStorage.getItem("WONum") != null) {
                ShiptoValue.map((val) => {
                    if (val.value == billtostore) {
                        bill = val;
                    }
                })
                /*[01/06/22, PC_SC_23,WW-283], Priyanka D*/
                if (localStorage.getItem("BilltoStoreLocationLat") != undefined && localStorage.getItem("BilltoStoreLocationLong") != undefined) {
                    curlat = localStorage.getItem("BilltoStoreLocationLat");
                    curlong = localStorage.getItem("BilltoStoreLocationLong");
                }
                if (localStorage.getItem("Country") != undefined && localStorage.getItem("Country") != null) {
                    if (localStorage.getItem("Country").toUpperCase() == "PRI") {
                        ShiptoValue = PageLaod_Data.ShipToDD.filter((item, index) => item.COUNTRY == "PRI");
                    } else {
                        ShiptoValue = PageLaod_Data.ShipToDD.filter((item, index) => item.COUNTRY != "PRI");
                    }
                    //ShiptoValue.map((val, index) => {
                    //    let localArray = {
                    //        value: val.CUSTID,
                    //        label: val.LOCNAME
                    //    }
                    //    ShiptoddValue.push(localArray)
                    //})
                } else if (ShiptoValue.length > 0) {
                    ShiptoValue = PageLaod_Data.ShipToDD
                }

                /*[04/11/22], A1QA-163, Priyanka D */
                let homestore = ""
                let BilltoStoreVal = ""
                /*[05/16/22, PC_WW-243_01]Priyanka D-Distance calculation method change for shipto*/
                const CurrentLocation = { lat: curlat, long: curlong };
                if (ShiptoValue != null && ShiptoValue != undefined) {
                    if (ShiptoValue.length > 0) {
                        ShiptoValue.map((val, index) => {
                            /*[05/16/22, PC_WW-243_01]Priyanka D-Distance calculation method change for shipto*/
                            //let dis = Math.round(this.distanceCalculation(curlat, curlong, val.LATITUDE, val.LONGITUDE, "KM") * 0.62);
                            let distance = DistanceCalculator.calculate(CurrentLocation, { lat: val.LATITUDE, long: val.LONGITUDE })
                            let dis = (distance * 0.00062137).toFixed(2)
                            localArray = {
                                value: val.CUSTID,
                                label: val.LOCNAME + "-" + dis + " " + "miles"
                            }
                            Shipto.push(localArray);
                            /*[04/26/22,PC_WW-365], Priyanka D */
                            if (localStorage.getItem("StoreValue") != undefined || localStorage.getItem("StoreValue") != null) {
                                BilltoStoreVal = localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1)
                            }
                            let country = localStorage.getItem("Country")
                            if (val.CUSTID == BilltoStoreVal && (Defaultship == undefined || Defaultship == " ")) {
                                homestore = localArray
                                PerferedShipto = homestore;
                            } else if (val.CUSTID == Defaultship && (Defaultship != undefined || Defaultship != " ")) {
                                if (country != undefined && country != null && country != "") {
                                    if (country.toUpperCase() == val.COUNTRY.toUpperCase()) {
                                        PerferedShipto = localArray;
                                    }
                                    else {
                                        locCountryMatch = false;
                                    }
                                }


                            }


                        });
                    }
                }
                enableshipto = false //SCO_PC_14
                //WW-774_PC_04 -Aparna
                //WW-774_PC_04 -Aparna
                if (isRefrigerantInCart[0]) {
                    billtostoreenable = false // to disable the bill to store checkbox if the cart contains refrigerant -Aparna
                }
                else {
                    billtostoreenable = false
                }
                this.setState({ ShipToDDValue: Shipto, workorderclick: true, BilltoStore: bill, isCountryMatch: locCountryMatch }); //EnableShipTo: false,BilltostoreEnable: true,
                $("#OLWorkOrderTB").addClass("disabledbutton");
                $('#OLWorkOrderTB').val(localStorage.getItem("WONum").substring(1, localStorage.getItem("WONum").length - 1));
            }

            let haldisplay = false;
            if (localStorage.getItem("HalVendors") != null) {
                let HalVendors = JSON.parse(localStorage.getItem("HalVendors"))
                let cartitemdetails = this.state.CartitemList
                let halvendorcount = 0;
                if (HalVendors.length != 0 && HalVendors.length != 0 && CartitemList.length != 0) {
                    HalVendors.forEach((val, index) => {

                        CartitemList.forEach((x, index) => {
                            if ((x.SupplierID == val.VENDOR_ID && val.VNDR_FIELD_C30_F == 'HAL')) {
                                halvendorcount += 1;



                            }



                        })
                    })
                    let cartitemcount = CartitemList.length;
                    if (cartitemcount == halvendorcount && isRefrigerantInCart[0] == false) {
                        this.setState({ Haldisplay: "HAL" })
                    }
                    else {
                        $(`#fedexhal`).prop('disabled', true)
                        this.setState({ Haldisplay: "", displayFedexDrop: false, HalLocationChecked: false, Halloc: [], HalLocationSelected: [], HalSelectedOphrs: [] })
                    }


                }
            }

            let pickuploc = "";
            let loclowesitem = false;
            let CartItemQuantity = []
            let puchoutcount = 0;

            let checkedbillto = true
            if (CartitemList != null && CartitemList != undefined) {
                if (CartitemList.length > 0) {
                    CartitemList.map((val, index) => {
                        let localitem = {
                            Itemid: val.Itemid,
                            Quantity: val.Quantity,
                            UniqNum: val.UniqNum,
                        }
                        if (val.PaintColor == "PUNCHOUT" && val.SupplierID == "W000000091") {
                            puchoutcount = puchoutcount + 1;
                        }
                        CartItemQuantity.push(localitem)
                    })
                    if (CartitemList.length == puchoutcount) {
                        /*If the cartitem count is 0, then the pickupcheckbox should be unchecked*/
                        if (this.state.CartCOunt == "0") {
                            //$("#pickupcheck").prop("checked", false);
                            pickuploc = false
                        } else {
                            // $("#pickupcheck").prop("checked", true);
                            pickuploc = true
                            loclowesitem = true;
                            // enableshipto = true; //WW-673_PC_BL_02
                            checkedbillto = false;
                        }
                    }
                    //WW-774_PC_04 -Aparna
                    else if (isRefrigerantInCart[0]) {
                        //enableshipto = true
                        // let isSingleSupplier = CartitemList.filter((v, i, a) => a.findIndex(t => (t.SupplierID === v.SupplierID)) === i).length == 1 ? true : false;
                        if (isRefrigerantInCart[1] && this.state.isValidWO) {
                            pickuploc = true
                            this.Bindpickupstore()
                        }

                    }
                    else {
                        // $("#pickupcheck").prop("checked", false);
                        pickuploc = false
                    }
                }
                else {
                    // $("#pickupcheck").prop("checked", false);
                    pickuploc = false
                }
            }
            /***********NEW*******(pickup)wal-158********/

            let cartdata = CartitemList;
            let pickupdata = PageLaod_Data.Pickup_VendorList;
            let pickupcount = 0;
            let pickupcheckbox = false;
            let pickupvendor = "";
            let pickupvendorid = "";
            console.log("pickupdata", pickupdata)
            let isSingleSupplier = false
            if (pickupdata.length != 0 && cartdata.length != 0) {
                pickupdata.forEach((val, index) => {
                    //A1QA-150_PC_01 (3/25/2022)-Aparna
                    CartitemList.filter((x) => x.SupplierID == CartitemList[0].SupplierID && val.VENDOR_ID == x.SupplierID && val.BUSINESS_UNIT_OM == "I0W01").map((i) => { pickupcount += 1; })
                })
                //CartitemList.map((val, index) => {
                //    pickupdata.map((itm,index) => {
                //        if (itm.VENDOR_ID == val.SupplierID) {
                //            pickupcount += 1;
                //        }
                //    });
                //});
                //if (isRefrigerantInCart[0]) {
                //     isSingleSupplier = CartitemList.filter((v, i, a) => a.findIndex(t => (t.SupplierID === v.SupplierID)) === i).length == 1 ? true : false;
                //}
                if (PageLaod_Data.CartItems.length == pickupcount || isRefrigerantInCart[2]) { //WW-774_PC_04 -Aparna || isRefrigerantInCart
                    ////
                    pickupcheckbox = true;
                    pickupdata.map((val, index) => {
                        if (val.VENDOR_ID == cartdata[0].SupplierID) {
                            ////
                            pickupvendor = val.NAME1;
                            pickupvendorid = val.VENDOR_ID;

                        }
                    });
                }
            }
            let pickupstore = [];
            if (PageLaod_Data.Pickup_store_tbl && pickupvendor != "") {
                PageLaod_Data.Pickup_store_tbl.map((storeval, index) => {
                    if (storeval.NAME1.toUpperCase() == pickupvendor.toUpperCase()) {
                        let localArray = {
                            ADDRESS3: storeval.ADDRESS3,
                            VNDR_LOC: storeval.VNDR_LOC,
                            ADDRESS1: storeval.ADDRESS1,
                            CITY: storeval.CITY,
                            STATE: storeval.STATE,
                            POSTAL: storeval.POSTAL,
                            PHONE: storeval.PHONE,
                            NAME1: storeval.NAME1,
                            LATITUDE: storeval.LATITUDE,
                            LONGITUDE: storeval.LONGITUDE
                        }
                        pickupstore.push(localArray)
                    }
                })
            }

            //[1/7/22], PC_SC_01, WW-286, Dhevanesam R
            CartitemList.forEach((value, index) => {
                ////
                value.hasCoreCharge = false;
                if (value.ItemDescription.includes("Core Charges")) {
                    value.hasCoreCharge = true;
                }
            });
            //[2/10/22, PC_SC_04, WW-330, Dhevanesm R]
            let PickEnBenStoreVal
            let WillCallboolVal = false
            if (CartitemList.length > 0) {
                CartitemList.forEach((value, index) => {
                    value.hasInvSupplierID = false;
                    if (value.SupplierID == "W999999999") {
                        value.hasInvSupplierID = true;
                    }
                });
            }
            let CartitemListArrBen = CartitemList.filter((x) => x.hasInvSupplierID == true)
            if (CartitemListArrBen.length == CartitemList.length) {
                PickEnBenStoreVal = true
            }
            else {
                PickEnBenStoreVal = false
            }
            console.log("sampledata", CookieService.getLocalStorageValues("Session_StoreLocBen"))
            this.BentonvilleStore_Check()
            //if (WillCallBenVal && PickEnBenStoreVal) {
            //    ////
            //    pickupcheckbox = true
            //    WillCallboolVal = false
            //}
            //else {
            //    if (pickupcheckbox) {
            //        ////
            //        WillCallBenVal = true
            //        PickEnBenStoreVal = true
            //        WillCallboolVal = true
            //    }
            //}
            let StoreLat = ""
            let StoreLong = ""
            let secpickupbooleanVal = false
            let sethalboolenval = false
            if (this.state.isValidWO) {
                secpickupbooleanVal = true
            }
            if (localStorage.getItem("BilltoStoreLocationLat") != null && localStorage.getItem("BilltoStoreLocationLong") != null) {
                ////

                StoreLat = JSON.parse(localStorage.getItem("BilltoStoreLocationLat"))
                StoreLong = JSON.parse(localStorage.getItem("BilltoStoreLocationLong"))

                if (StoreLat != undefined && StoreLong != undefined) {
                    //secpickupbooleanVal = true
                    //if (this.state.pickupcheck == "PU") {
                    //    secpickupbooleanVal = true
                    //}

                    if (this.state.Haldisplay == "HAL" && isRefrigerantInCart[0] == false) { //WW-774_PC_04 -Aparna
                        sethalboolenval = true
                    }
                    if (this.state.Haldisplay == "" && this.state.isWorkToStoreValid) {
                        sethalboolenval = false
                    }
                    //if (this.state.pickupcheck == "" && this.state.isWorkToStoreValid) {
                    //    secpickupbooleanVal = false
                    //}
                    //if (this.state.supplier == "W000000036" && this.state.PaintColor == "PUNCHOUT") {
                    //    secpickupbooleanVal = false
                    //}
                    //else if (this.state.PaintColor == "PUNCHOUT") {
                    //    secpickupbooleanVal = false
                    //}
                    //else {
                    //}
                }
            }
            console.log("secpickupbooleanVal", secpickupbooleanVal)
            //[2/28/22], PC_IC_02, WW-316, Dhevanesam R
            this.PageItemSuggestionLoad(CartitemList);
            //[2/16/22], WW-330, Dhevanesam R
            let checkqty = false
            CartitemList.forEach((value, index) => {
                value.hasBenItemVal = "";
                value.pickupcheck = false;
            });
            //////
            // if (localStorage.getItem("StoreValue") != undefined || localStorage.getItem("StoreValue") != null) {
            //BenStoreVal = JSON.parse(localStorage.getItem("StoreValue"));
            let warehouse_item = CartitemList.filter((x) => x.SupplierID == "W999999999")
            let loacalloc = JSON.parse(localStorage.getItem("StoreValue"))
            if (warehouse_item.length > 0) {
                checkqty = true;
            }
            if (checkqty) {
                let itemids = []
                warehouse_item.map((val, index) => {
                    ////
                    itemids.push(val.Itemid)
                });
                if (itemids.length > 0) {
                    ////
                    let BO = {
                        shipto_id: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",// loacalloc,'WAL-767 -Aparna
                        supplier_part_number: itemids,
                        User_Id: CookieService.getLocalStorageValues("Session_UserID")
                    }
                    ////
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ShoppingCartAction.WarehouseIconCheck(BO)
                }
            }
            //}
            //WAL-541_PC_14-Aparna
            let autoCompleteDataRes = []
            let locordcat = []
            let locordcatSGG = []
            let suggestionsStr = CookieService.getLocalStorageValues("FavOrder_Category")
            console.log("order category", suggestionsStr)
            if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
                suggestionsStr.forEach((sugg, index) => {
                    //autoCompleteDataRes.push({ label: sugg.ORDER_CATEGORY, value: sugg.ORDER_CATEGORY });
                    if (sugg.ORDER_CATEGORY != null) {
                        locordcat.push({ label: sugg.ORDER_CATEGORY, value: sugg.ORDER_CATEGORY });
                    }
                });
            }
            if (locordcat.length > 0) {
                locordcatSGG = locordcat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.label != null && t.label != " ")) === i)
                locordcatSGG = locordcatSGG.sort((a, b) =>
                    a.value > b.value ? 1 : -1,
                );
            }
            console.log("locordcatSGG", locordcatSGG)
            let locCat = []
            let locCatSGG = []
            let catsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
            console.log("Fav_Item_SubCat", catsuggestion)
            if (catsuggestion != null && catsuggestion != "" && catsuggestion != undefined) {
                catsuggestion.forEach((sugg, index) => {
                    //WW-516_PC_04  (9/30/2022)-Aparna
                    if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                        locCat.push({ label: sugg.ISA_FAVS_CATEGORY.toUpperCase(), value: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                    }

                });
            }
            if (locCat.length > 0) {
                locCatSGG = locCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.label != null && t.label != " ")) === i)
                locCatSGG = locCatSGG.sort((a, b) =>
                    a.value > b.value ? 1 : -1,
                );
            }
            //WW-368_SuggestionCat_for_favItem_PC_05 -Aparna

            let locSubCat = []
            let locSubCatSGG = []
            let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
            console.log("Fav_Item_SubCat", subcatsuggestion)
            if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
                subcatsuggestion.forEach((sugg, index) => {
                    //WW-516_PC_04  (9/30/2022)-Aparna
                    if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                        locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), category: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                    }

                });
            }
            if (locSubCat.length > 0) {
                locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.category === v.category && t.label != null && t.label != " ")) === i)
                locSubCatSGG = locSubCatSGG.sort((a, b) =>
                    a.value > b.value ? 1 : -1,
                );
            }
            let locOrdSubCat = []
            let locOrdSubCatSGG = []
            let Ordsubcatsuggestion = CookieService.getLocalStorageValues("FavOrder_Category")
            console.log("Fav_Item_SubCat", Ordsubcatsuggestion)
            if (Ordsubcatsuggestion != null && Ordsubcatsuggestion != "" && Ordsubcatsuggestion != undefined) {
                Ordsubcatsuggestion.forEach((sugg, index) => {
                    //WW-516_PC_04  (9/30/2022)-Aparna
                    if (sugg.ORDER_SUB_CATEGORY != null) {
                        locOrdSubCat.push({ label: sugg.ORDER_SUB_CATEGORY.toUpperCase(), value: sugg.ORDER_SUB_CATEGORY.toUpperCase(), category: sugg.ORDER_CATEGORY.toUpperCase() });
                    }

                });
            }
            if (locOrdSubCat.length > 0) {
                locOrdSubCatSGG = locOrdSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.category === v.category && t.label != null && t.label != " ")) === i)
                locOrdSubCatSGG = locOrdSubCatSGG.sort((a, b) =>
                    a.value > b.value ? 1 : -1,
                );
            }

            // this.setState({ autocompleteData: autoCompleteDataRes });
            console.log("locordcatSGG", locOrdSubCatSGG)
            //WW-687_PC_03 (4/19/2023)-Aparna
            this.supplierCollection(CartitemList, PageLaod_Data.Pickup_VendorList, PageLaod_Data.Pickup_store_tbl, PerferedShipto)
            /*******END********/
            //WW-1321 Set Default Item View to "Expanded" on page load of cart - Nandhini L
            $('.supplierH').addClass('accordion-arrow-change');
            $('.supplierC').removeClass('d-none');
            this.setState({
                OnlyCatalogItem: OnlyCatalogitemdata,
                startDate: today,
                OLDueDateVal: dateOL,
                hdfChangeLineNum: hdfChangeLineNumLocal,
                hdfZeusNonCata: hdfZeusNonCataLocal,
                OLEmplyIdLabel: OLEmplyIdLabelLocal,
                WordOrderNoLength: WordOrderNoLengthLocal,
                PagelaodCartValue: CartItemQuantity,
                CartItems: CartitemList,
                EmployeeCC: employidDropDown,
                /*[01/06/22, PC_SC_23,WW-283], Priyanka D*/
                ShipToDDValue: (localStorage.getItem("WONum") != undefined ? Shipto : ShiptoValue),
                TypeTable: PageLaod_Data.TypeDD,
                FavMenu: filteredFavmenuDD,
                FavMenuSub: PageLaod_Data.FavSubMenu,
                MachineTable: machinenumdata,
                SiteCurrencyTable: SiteCurrency,
                OLShipToIdLabel: OLShipToIdLabelLocal,
                defaultShipto: PerferedShipto.value === "W09301" || PerferedShipto.value === "W02409" ? { value: "0", label: "-- Select Ship To --" } : PerferedShipto,
                ItemMachinePartNum: PageLaod_Data.MachinePartNo,
                SearchKey: QS_src,
                CartCOunt: PageLaod_Data.CartItems.length,
                pickup_vendor: PageLaod_Data.Pickup_VendorList,
                isAllItem_are_Pickup: pickupcheckbox,
                //PreferedEmployee: preferedemployee,
                PickupStore: pickupstore,
                displayPickDrop: isRefrigerantInCart[0] && isRefrigerantInCart[1] ? true : false,
                sethalboolenval: sethalboolenval,
                pickupstore_tbl: PageLaod_Data.Pickup_store_tbl,
                PickupVendor: pickupvendor, pickupcheck: pickuploc, lowesitem: loclowesitem, PickupVendorID: pickupvendorid,
                shiptoDropdown: PageLaod_Data.ShipToDD,/*[11/22/21, PC_SC_02, WW-282], Priyanka D//set State the value of shiptovalue from backend to the state variable*/
                isAllItem_are_Inv: PickEnBenStoreVal,
                isPickup: secpickupbooleanVal,
                WillCallbool: WillCallboolVal,
                autocompleteData: locordcatSGG, //WAL-541_PC_14 -Aparna
                autocompleteItemData: locCatSGG, //WW-368_SuggestionCat_for_favItem_PC_ -Aparna
                subCategory: locSubCatSGG, FavOrdsubCategory: locOrdSubCatSGG,
                autocompleteItemDataRstl: locCatSGG, autocompleteDataRstl: locordcatSGG, subCategoryResults: [], FavOrdsubCategoryResults: [], WNA: notAvailItem//
                , Checkedbillto: checkedbillto, EnableShipTo: enableshipto, //WW-673_PC_BL_02
                isRefrigerantItemInCart: isRefrigerantInCart[0], BilltostoreEnable: billtostoreenable

            });
            if (isRefrigerantInCart[0] && isRefrigerantInCart[1] && this.state.isValidWO) {

                this.Bindpickupstore()
            }
            //[9/23/22], CR - 2695 - Shopping cart_ "Insufficient privilege for adding to cart" validation text should be replaced as "Insufficient privilege to view cart", Dhevanesam R
            if (ShoppingCartPrilg.length == 0) {
                //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Insufficient privileges to view cart"
                });
                // alert("Insufficient privileges for adding to cart");
                this.props.history.push({
                    pathname: "/HomePage",
                });
            }
            else {
                if (!checkqty) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
            let tradeMismatchItems = [];

            //pc-676-100 to 105 equipment trade mismatch S.Sanjay 12/2/2024
            let workOrderTrade = CookieService.getLocalStorageValues('Trade');
            if (workOrderTrade != "" && workOrderTrade != null && workOrderTrade != undefined) {
                CartitemList.forEach(item => {
                    if (item.ISA_WBS_ELMNT === "Equipment") {
                        // Check if item's Trade attribute exists and is different from workOrderTrade
                        if (item.WO_TRADE.toUpperCase() !== workOrderTrade.toUpperCase()) {
                            // Push ItemId to tradeMismatchItems if the condition is met
                            tradeMismatchItems.push(item.Itemid);
                        }
                    }

                });
            }

            if (tradeMismatchItems.length > 0) {
                // Set state with tradeMismatchItems and show modal
                this.setState({ tradeMismatchItems });
                $(`#tradeMismatchPopup`).modal('show');
            } else if (localStorage.getItem("WONum") != undefined && localStorage.getItem("WONum") != null && localStorage.getItem("WONum") != "" && localStorage.getItem("WONum") != " ") {
                if (this.state.IsInteractiveNonCat != false && WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
                    $('#IntNonCatRemovePopup').modal('show');
                }
            }
        }
        //WW-1231 WO State Restriction -Vishwa S
        else {
            this.setState({ WNA: notAvailItem })
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#loaderMessage').text('');
            if (!this.state.submitbtn && !this.state.Choose_Delivery_Btn_Click) {
                if (this.state.isValidWO && this.state.WO_Parts != undefined && this.state.WO_Parts != null) {
                    if (this.state.WO_Parts.length > 0) {
                        if (this.state.Choose_Delivery_Btn_Click == false) {
                            $('#WO_Parts_Popup').modal('show');
                        }
                        else {
                            if (this.state.OrderEmpyId == " ") {
                                $('#WO_Parts_Popup').modal('show');
                            }
                        }
                    }
                }
            }

            if (this.state.submitbtn) {
                WOBtnClick = false;
                this.submitOrder_Btn_Click()
            }
            else if (this.state.Choose_Delivery_Btn_Click) {         //WW-687_PC_20 (4/19/2023)-Aparna
                this.ChooseDeliveryOption_Btn_Click()
            }
        }


    }
    /**
     * WW-774_PC_03 -Aparna
     * to check the refrigerant item in cart
     * */

    isRefrigerantItemInCart = (CartitemList) => {
        let isSingleRefrigerantSupplier = false
        let isSingleSupplier = CartitemList.filter((v, i, a) => a.findIndex(t => (t.SupplierID === v.SupplierID)) === i).length == 1 ? true : false;
        let isRefrigerantInCart = CartitemList.filter((x) => x.shipping_specs == "PUO ONLY").length > 0 ? true : false;
        if (isSingleSupplier && isRefrigerantInCart) {
            //this.Bindpickupstore()
            isSingleRefrigerantSupplier = true
        }
        return [isRefrigerantInCart, isSingleSupplier, isSingleRefrigerantSupplier];
    }

    //[2/16/22], WW-330, Dhevanesam R
    WarehouseIconresponse = () => {
        ////
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Workorderresponse = JSON.parse(ShoppingCartStore.WarehouseIcon);
        let local = Workorderresponse.Table
        let st = []
        let GridArrResponse = this.state.CartItems
        if (local.length > 0) {
            ////
            local.forEach((x) => {
                ////
                if (x.QTY != null) {
                    console.log("hasBenItemVal", x.QTY.slice(-1))
                    GridArrResponse.forEach((value, index) => {
                        if (GridArrResponse[index].Itemid == x.INV_ITEM_ID) {
                            value.hasBenItemVal = x.QTY.slice(-1);
                        }
                    });
                }
            })
        }
        this.setState({
            CartItems: GridArrResponse
        })
        ////
        console.log("GridArrResponseCribFavItem", GridArrResponse)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //[2/28/22], PC_IC_02, WW-316, Dhevanesam R
    PageItemSuggestionLoad = (CartitemList) => {
        ////
        var imgBO = {}
        CartitemList.forEach((value, index) => {
            ////
            imgBO[CartitemList[index].Itemid] = CartitemList[index].SupplierID
        });
        console.log("d", imgBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ItemDetailNewAction.GetRecommendedItems(imgBO);
        if (CartitemList.length == 0) {
            this.setState({ ImgResponseVal: [], ImgCssVal: "" });
        }
    }
    //[2/28/22], PC_IC_03, WW-316, Dhevanesam R
    GetRecommendedItemsResposne = () => {
        ////
        let ImgCss;
        let Imgresponse = JSON.parse(ItemDetailNewStore.GetRecommendedItems);
        if (Imgresponse != undefined && Imgresponse != null) {
            let Imgres = Imgresponse.filter((ele, ind) => ind === Imgresponse.findIndex(elem => elem.ItemID === ele.ItemID))
            console.log("ImgresVal", Imgres)
            if (Imgres.length == 4) {
                ////
                ImgCss = "owl-stage" + " " + "owl-stageFour"
            }
            else if (Imgres.length == 3) {
                ////
                ImgCss = "owl-stage" + " " + "owl-stageThree"
            }
            else if (Imgres.length == 2) {
                //
                ImgCss = "owl-stage" + " " + "owl-stageTwo"
            }
            else if (Imgres.length == 1) {
                //
                ImgCss = "owl-stage" + " " + "owl-stageOne"
            }
            else {
                //
                ImgCss = "owl-stage"
            }
            this.setState({ ImgResponseVal: Imgres, ImgCssVal: ImgCss });
        }
        else {
            this.setState({ ImgResponseVal: [], ImgCssVal: "" });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //[2/28/22], PC_IC_07, WW-316, Dhevanesam R
    BindImageGrid = () => {
        //
        console.log("ImgResponseVal", this.state.ImgResponseVal);
        return this.state.ImgResponseVal.map((val, index) => {
            let IMGURL
            //console.log("GridArray2", this.state.GridArray);
            if (val.ImgURL == "\\N") {
                IMGURL = "Images/noimage_new.png"
            }
            else {
                IMGURL = val.ImgURL
            }
            return (
                <div className="owl-item cloned col-md-4 col-lg-2 mb-3">
                    <a href="#"><img className="mb-2 img-width-height" src={IMGURL} onClick={(e) => this.ImageClick(val, e)} alt={val.ItemID} /></a>
                    <h5 className="card-title catalog-label-title ">{val.MfgPartNum}</h5>
                    {/* <p className="card-text">{val.ItemID}</p>*/}
                    <p className="card-text">{val.ShortDesc}</p>
                </div>
            );
        })
    };
    //[2/28/22], PC_IC_08, WW-316, Dhevanesam R
    ImageClick = (value, e) => {
        //
        e.preventDefault();
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.props.history.push({
            pathname: `\itemdetailnew`,
            search: `?ItemId=${value.ItemID}&ManufacturePartNumber=${value.MfgPartNum}&ManufactureName=${value.MfgName}&SupplierID=${value.VendorID}&QTY=""`,
            state: { WO: JSON.parse(localStorage.getItem("WONum")), Suggesstions: true, ItemId: value.ItemID, ManufacturePartNumber: value.MfgPartNum, ManufactureName: value.MfgName, SupplierID: value.VendorID, QTY: "1", Orgin: "ShoppingCart" }
        });
    }
    /*
     * Handle change method for favorite page checkbox
     */
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Shopping Cart",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ShoppingCartAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ShoppingCartAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /*[12/13/21, PC_SC_08], Priyanka D//Miles calculation for ShipTo*/
    distanceCalculation = (lat1, lon1, lat2, lon2, unit) => {
        var p = 0.017453292519943295;    //This is  Math.PI / 180
        var c = Math.cos;
        var a = 0.5 - c((lat2 - lat1) * p) / 2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p)) / 2;
        var R = 6371; //  Earth distance in km so it will return the distance in km
        var dist = 2 * R * Math.asin(Math.sqrt(a));
        return dist
    }
    distance = (lat1, lon1, lat2, lon2, unit) => {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit == "K") { dist = dist * 1.609344 }
        if (unit == "M") { dist = dist * 0.8684 }
        return dist
    }
    /*
     * Listener method for loading favorite page icon
     */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ShoppingCartStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    /*
    * Listener method for the response of Save/Delete favorite page
    */
    updateFavPageResponse = () => {
        if (ShoppingCartStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ShoppingCartStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ShoppingCartStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    /*
     * RF No: SC_PC_26
     * Bindind the favorite menu parent events.
     * */
    BuildFavMenu() {
        if (this.state.FavMenu.length > 0) {
            return this.state.FavMenu.map((val, index) => {
                let Favmenuvalue = val.FavText == "Not Classified" ? " " : val.FavText
                let childItems = this.state.FavMenuSub.filter((item, index) => item.Fav_Catagory.trim().toUpperCase() == Favmenuvalue.trim().toUpperCase());
                if (index < 4) {
                    return (<li className="dropdown-submenu" key={val.FavText + index}>
                        <a className="dropdown-item">{val.FavText != " " ? val.FavText.length > 15 ? `${val.FavText.toUpperCase().substring(0, 15)}...` : val.FavText.toUpperCase() : `-`}<span className="fav-right-arrow float-right" />
                        </a><div className="dropdown-menu custom-welcome-dropdown item-box" aria-labelledby="navbarDropdown-myfav-order">
                            {this.bindFavSubItem(childItems)}
                            {childItems.length > 5 ? <label className="dropdown-submenu text-center w-100">
                                <button className="btn btn-primary custom-btn-showall primary-btn col-md-10 mt-2" onClick={(event) => this.headerRedirect(event, "/favorites")}>Show All</button>
                            </label> : null}
                        </div>
                    </li>)
                }
                else if (index == 4 && childItems.length < 5) {
                    return (<li className="dropdown-submenu" key={val.FavText + index}>
                        <a className="dropdown-item">{val.FavText != " " ? val.FavText.length > 15 ? `${val.FavText.toUpperCase().substring(0, 15)}...` : val.FavText.toUpperCase() : `-`}<span className="fav-right-arrow float-right" />
                        </a><div className="dropdown-menu custom-welcome-dropdown item-box" aria-labelledby="navbarDropdown-myfav-order">
                            {this.bindFavSubItem(childItems)}
                            {childItems.length > 5 ? <label className="dropdown-submenu text-center w-100">
                                <button className="btn btn-primary custom-btn-showall primary-btn col-md-10 mt-2" onClick={(event) => this.headerRedirect(event, "/favorites")}>Show All</button>
                            </label> : null}
                        </div>
                    </li>)
                }
                else if (index == 4 && childItems.length == 5) {
                    return (<li className="dropdown-submenu" key={val.FavText + index}>
                        <a className="dropdown-item">{val.FavText.toUpperCase()}<span className="fav-right-arrow float-right" />
                        </a><div className="dropdown-menu custom-welcome-dropdown item-box Fav-last-Item-4" aria-labelledby="navbarDropdown-myfav-order">
                            {this.bindFavSubItem(childItems)}
                            {childItems.length > 5 ? <label className="dropdown-submenu text-center w-100">
                                <button className="btn btn-primary custom-btn-showall primary-btn col-md-10 mt-2" onClick={(event) => this.headerRedirect(event, "/favorites")}>Show All</button>
                            </label> : null}
                        </div>
                    </li>)
                }
                else if (index == 4 && childItems.length > 5) {
                    return (<li className="dropdown-submenu" key={val.FavText + index}>
                        <a className="dropdown-item">{val.FavText.toUpperCase()}<span className="fav-right-arrow float-right" />
                        </a><div className="dropdown-menu custom-welcome-dropdown item-box Fav-last-Item" aria-labelledby="navbarDropdown-myfav-order">
                            {this.bindFavSubItem(childItems)}
                            {childItems.length > 5 ? <label className="dropdown-submenu text-center w-100">
                                <button className="btn btn-primary custom-btn-showall primary-btn col-md-10 mt-2" onClick={(event) => this.headerRedirect(event, "/favorites")}>Show All</button>
                            </label> : null}
                        </div>
                    </li>)
                }
            });
        }
    }
    /*
     * Bindind the favorite menu Child events.
     * */
    bindFavSubItem = (childItems) => {
        /*[04/07/22WW-243] Regression bug-Cannot able to add an item from quick item entryPriyanka D */
        return childItems.map((SubItem, I) => {
            if (I < 5) {
                return (<label id={SubItem.CUSTOMERITEMID} className="dropdown-item" key={SubItem.CUSTOMERITEMID + I} onClick={(e) => this.quickItemClick(e.target.id, "2", SubItem, true)} data-backdrop="static" data-keyboard="false" data-toggle="tooltip" title={SubItem.DROPDOWNTEXTFIELDS}>{SubItem.DROPDOWNTEXTFIELDS}</label>
                )
            }
        });
    }
    /*
     * RF No: SC_PC_54
     * In this method the cart item table is binded with the values in the state CartItems.
     * */
    CheckBillToStore = () => {
        //;
        this.setState({ submitbtn: false });
        if (this.state.isWorkToStoreValid == false) {
            let shiptoLat = "";
            let shiptoLong = "";
            let billstore = localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1);
            let defaultshiptotemp = this.state.ShipToDDValue.filter((item, index) => item.value == billstore);

            this.state.shiptoDropdown.filter((item, index) => item.CUSTID == billstore).map((i) => {
                shiptoLat = i.LATITUDE;
                shiptoLong = i.LONGITUDE;
            });

            if (this.state.HalLocationChecked == true) {
                this.BindHAL(shiptoLat, shiptoLong)

            }
            this.setState({ defaultShipto: this.state.BilltoStore, shiptoLat: shiptoLat, shiptoLong: shiptoLong, isWorkToStoreValid: true, isPickup: false })
            $("#OLShipTo").addClass("disabledbutton");
        } else {
            let defaultshipto = [];
            let shiptoLat = "";
            let shiptoLong = "";
            document.getElementById('StatusMsgbilltostore').innerText = ""

            if (CookieService.getLocalStorageValues("Session_ISAShipToID") != null && CookieService.getLocalStorageValues("Session_ISAShipToID") != "" && CookieService.getLocalStorageValues("Session_ISAShipToID") != undefined && CookieService.getLocalStorageValues("Session_ISAShipToID") != " " && this.state.BilltoStore != undefined) {
                /*[05/13/22,WW-243]Pickup Issue, Priyanka D */
                let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
                let defaultshiptotemp = this.state.ShipToDDValue.filter((item, index) => item.value == Defaultship);
                defaultshipto = defaultshiptotemp[0];

                this.state.shiptoDropdown.filter((item, index) => item.CUSTID == Defaultship).map((i) => {
                    shiptoLat = i.LATITUDE;
                    shiptoLong = i.LONGITUDE;

                });
                if (this.state.HalLocationChecked == true) {
                    this.BindHAL(shiptoLat, shiptoLong)

                }

            }
            else {
                /*[05/13/22,WW-243]Pickup Issue, Priyanka D */
                let billstore = localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1);
                let defaultshiptotemp = this.state.ShipToDDValue.filter((item, index) => item.value == billstore);
                defaultshipto = defaultshiptotemp[0];
                this.state.shiptoDropdown.filter((item, index) => item.CUSTID == billstore).map((i) => {
                    shiptoLat = i.LATITUDE;
                    shiptoLong = i.LONGITUDE;
                });
            }
            let ispikcuploc = true
            if (this.state.HalLocationChecked) {
                ispikcuploc = false
            }


            this.setState({ defaultShipto: defaultshipto ? defaultshipto.value === "W09301" || defaultshipto.value === "W02409" ? { value: "0", label: "-- Select Ship To --" } : defaultshipto : { value: "0", label: "-- Select Ship To --" }, shiptoLat: shiptoLat, shiptoLong: shiptoLong, isWorkToStoreValid: false, isPickup: ispikcuploc ? ispikcuploc : "" });
            $("#OLShipTo").removeClass("disabledbutton");
        }

    }

    //let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
    //if (Defaultship != undefined || Defaultship != "" || Defaultship != " ") {
    //this.setState({ isWorkToStoreValid: false, secpickupboolean: true });

    //    if (this.state.ShipToDDValue != null && this.state.ShipToDDValue != undefined) {
    //        if (this.state.ShipToDDValue.length > 0) {
    //            this.state.ShipToDDValue.map((val, index) => {
    //                if (val.value == Defaultship) {
    //                    homestore = val
    //                }
    //                this.setState({ defaultShipto: homestore })
    //            });
    //        }
    //    }
    //    else {
    //        this.setState({
    //            defaultShipto: this.state.BilltoStore
    //        });
    //    }


    //WW-398_PC_05 -Aparna
    linepickupcheck = (val, index) => {
        let { CartItems } = this.state;

        CartItems.forEach((x, ind) => {
            if (x.SupplierID == "W999999999" && this.state.Bentonville_WO) {
                CartItems[ind].pickupcheck = CartItems[ind].pickupcheck == true ? false : true;
            }

        })

        this.setState({ CartItems });
    }
    RedirectToItemDetail = (event, val, FavItem) => {

        //
        event.preventDefault()
        let Itemtypevalue = val.Itemid.indexOf("NONCAT") > -1 ? "NONCAT" : "CAT";

        CookieService.updateLocalStorageValues("Session_Noncat", Itemtypevalue);
        CookieService.updateLocalStorageValues("ItemDetail_ItemId", val.Itemid);
        CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", val.Manufacturerpartnumber);
        CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", val.Manufacturer);
        CookieService.updateLocalStorageValues("ItemDetail_SupplierID", val.SupplierID);
        let ItemData = {
            vendor_id: val.SupplierID,
            ItemPrice: val.Price,
            txtDesc: val.ItemDescription

        }
        if (Itemtypevalue != "NONCAT" && val.ISA_WBS_ELMNT != "Equipment") {
            $('#splitDelivery_Popup').modal('hide')
            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: `?ItemId=${val.Itemid}&ManufacturePartNumber=${val.Manufacturerpartnumber}&ManufactureName=${val.Manufacturer}&SupplierID=${val.SupplierID}`,
                state: { ItemData: ItemData, origin: 'shoppingcart', IsFav: FavItem, Suggesstions: true, ItemId: val.Itemid, ManufacturePartNumber: val.Manufacturerpartnumber, ManufactureName: val.Manufacturer, SupplierID: val.SupplierID, QtyAdj: val.Quantity, Orgin: "ShoppingCart"}
            });
        }
    }
    //WW-600_PC_05 (1/25/2023)
    IsRefrigerantInCart = (Type) => {
        //e.preventDefault()
        //debugger;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let RefrigerentItem = ""
        let Refrigerentxt = ""
        let RefrigerentCount = 0
        this.state.CartItems.forEach((x) => {
            if (x.shipping_specs != undefined && x.shipping_specs != null) {
                if (x.shipping_specs.toUpperCase() == "PUO ONLY") {
                    if (RefrigerentItem == "") {
                        RefrigerentItem = x.Manufacturerpartnumber
                    }
                    else {
                        RefrigerentItem += ", " + x.Manufacturerpartnumber
                    }
                    RefrigerentCount = RefrigerentCount + 1
                }
            }
        }
        )
        //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        if (Type != "QUOTE") {
            if (RefrigerentCount > 0) {
                if (this.state.pickupcheck != true) {
                    if (RefrigerentCount > 1) {
                        Refrigerentxt = " These items are refrigerant and only available for pickup"
                    }
                    else {
                        Refrigerentxt = "This item is a refrigerant and only available for pickup"
                    }
                    this.setState({ RefrigerantTxt: Refrigerentxt, hasRefrigerant: true, RefrigerantItem: RefrigerentItem })
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    displayExtraLoader = false;
                    $('#Refrigerant-popup').modal('show');
                    // return false
                }
                else {
                    this.setState({ RefrigerantTxt: "", hasRefrigerant: false, RefrigerantItem: "" })
                    //return true
                    this.ReorderCheck()
                }
            }
            else {
                this.setState({ RefrigerantTxt: "", hasRefrigerant: false, RefrigerantItem: "" })
                //return true
                this.ReorderCheck()
            }
        }
        else {
            this.setState({ RefrigerantTxt: "", hasRefrigerant: false, RefrigerantItem: "" })
            this.ReorderCheck()
        }

        //return Refrigerentxt
    }
    RefrigerantPopup = () => {
        $('#Refrigerant-popup').modal('show');
    }
    onAccordianClickSupplier = (event, index) => {

        // let classname = document.getElementById(`contentrow-${index}`).className;
        //if (classname.includes("d-none")) {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#Supplier-${index}`).toggleClass('d-none');
        //$('.header-arrow').addClass('accordion-arrow-change');
        //$('.content-row').removeClass('d-none');
        //$('.header-arrow').removeClass('accordion-arrow-change');
        //$('.content-row').addClass('d-none');
        // }



    };
    /***
     * WW-920_PC_05 -Aparna
     * to navigate to form
     * */


    FormNavigation = (multipleForm, index) => {
        let FormItemList = []
        let EnersysList = []
        if (multipleForm) {
            $('#FormItem_Popup').modal('hide')
            this.state.CartItems.map((val) => {
                if (val.FormAttribute != " " && val.FormAttribute != null && parseInt(val.RTI_QTY ? val.RTI_QTY : 0, 10) < parseInt(val.Quantity ? val.Quantity : 0, 10)) {
                    if (val.FormAttribute != undefined && val.FormAttribute != null) {
                        //if (val.FormAttribute.indexOf('BATTERY') > -1 || val.FormAttribute.indexOf('CHARGER') > -1) {
                        //    EnersysList.push({
                        //        SupplierPartNumber: val.SupplierPartNumber,
                        //        ManufacturerPartNumber: val.Manufacturerpartnumber,
                        //        Qty: val.Quantity,
                        //        LineItem: val.UniqNum,
                        //        FormName: val.FormAttribute,
                        //        product: val.FormAttribute
                        //    })
                        //} else {
                        FormItemList.push({
                            SupplierPartNumber: val.SupplierPartNumber,
                            ManufacturerPartNumber: val.Manufacturerpartnumber,
                            LineItem: val.UniqNum,
                            Qty: val.Quantity,
                            FormName: val.FormAttribute,
                            RTI_QTY: val.RTI_QTY
                        })
                        //   }
                    }
                    else {
                        FormItemList.push({
                            SupplierPartNumber: val.SupplierPartNumber,
                            ManufacturerPartNumber: val.Manufacturerpartnumber,
                            LineItem: val.UniqNum,
                            Qty: val.Quantity,
                            FormName: val.FormAttribute,
                            RTI_QTY: val.RTI_QTY
                        })
                    }
                }
            })
            if (EnersysList.length > 0) {
                return;
                //this.props.history.push({
                //    pathname: "/EnersysForm",
                //    state: { pagename: "shoppingcart", form: CookieService.getLocalStorageValues("EnersysForm"), EnersysList: EnersysList, FormList: FormItemList }
                //});
            } else if (FormItemList.length > 0) {
                this.props.history.push({
                    pathname: "/forms",
                    state: { pagename: "shoppingcart", FormList: FormItemList, EnersysList: EnersysList }
                });

            }


        } else {
            if (this.state.CartItems[index].FormAttribute != undefined && this.state.CartItems[index].FormAttribute != null) {
                //if (this.state.CartItems[index].FormAttribute.indexOf('BATTERY') > -1 || this.state.CartItems[index].FormAttribute.indexOf('CHARGER') > -1) {
                //    EnersysList.push({
                //        SupplierPartNumber: this.state.CartItems[index].SupplierPartNumber,
                //        ManufacturerPartNumber: this.state.CartItems[index].Manufacturerpartnumber,
                //        Qty: this.state.CartItems[index].Quantity,
                //        LineItem: this.state.CartItems[index].UniqNum,
                //        FormName: this.state.CartItems[index].FormAttribute,
                //        product: this.state.CartItems[index].FormAttribute
                //    })
                //    return;
                //    //this.props.history.push({
                //    //    pathname: "/EnersysForm",
                //    //    state: { pagename: "shoppingcart", form: CookieService.getLocalStorageValues("EnersysForm"), EnersysList: EnersysList, FormList:[]}
                //    //});
                //}
                //else {
                FormItemList.push({
                    SupplierPartNumber: this.state.CartItems[index].SupplierPartNumber,
                    ManufacturerPartNumber: this.state.CartItems[index].Manufacturerpartnumber,
                    Qty: this.state.CartItems[index].Quantity,
                    LineItem: this.state.CartItems[index].UniqNum,
                    FormName: this.state.CartItems[index].FormAttribute,
                    RTI_QTY: this.state.CartItems[index].RTI_QTY
                })
                this.props.history.push({
                    pathname: "/forms",
                    state: { pagename: "shoppingcart", FormName: this.state.CartItems[index].FormAttribute, FormList: FormItemList, EnersysList: [] }
                });
                //  }
            }
            else {
                FormItemList.push({
                    SupplierPartNumber: this.state.CartItems[index].SupplierPartNumber,
                    ManufacturerPartNumber: this.state.CartItems[index].Manufacturerpartnumber,
                    Qty: this.state.CartItems[index].Quantity,
                    LineItem: this.state.CartItems[index].UniqNum,
                    FormName: this.state.CartItems[index].FormAttribute,
                    RTI_QTY: this.state.CartItems[index].RTI_QTY
                })
                this.props.history.push({
                    pathname: "/forms",
                    state: { pagename: "shoppingcart", FormName: this.state.CartItems[index].FormAttribute, FormList: FormItemList, EnersysList: [] }
                });
            }
        }
    }
    bindSuppliers = () => {
        return this.state.supplierList.map((val, index) => {
            return (
                <>
                    <tr className="">
                        <td

                            aria-controls="Gustave-acc"
                            className="accordion-toggle align-items-center pl-0 "
                            onClick={e => this.onAccordianClickSupplier(e, index)}
                        >
                            <span className="accordion-arrow supplierH " />
                        </td>
                        <td>
                            <span className="font-16 mb-0 sdi-category-title pl-2">
                                {val.supplier_Name}
                            </span>
                        </td>
                        <td className="text-right pr-0">
                            <label className="font-16  mb-0">#Items : {val.itemCount}</label>
                        </td>
                    </tr>
                    <tr className="accordian-body py-1 d-none supplierC " id={`Supplier-${index}`} >
                        <td colSpan={12} className="pl-lg-4 pl-0 pr-0 pt-0 pb-0">
                            {this.bindSuppliersItem(val.supplier_ID)}
                        </td>
                    </tr>
                </>)
        })
    }
    bindSuppliersItem = (supplier_ID) => {
        CookieService.updateLocalStorageValues('kenstancount', 0);
        return this.state.CartItems.map((val, index) => {
            if (val.SupplierID == supplier_ID) {
                let favicondisplay = true;
                if (val.PaintColor == "PUNCHOUT" || val.PaintColor == "WNST" || val.PaintColor == "WCAT") {
                    favicondisplay = false;
                }
                //Removing heart icon for unavail item
                this.state.WNA.map((x, index) => {
                    if (val.Itemid == x.item) {
                        favicondisplay = false
                    }
                })

                //******END********
                if (val.Manufacturer != null && val.Manufacturer != undefined) {
                    if (val.Manufacturer.includes('KENSTAN')) {
                        CookieService.updateLocalStorageValues('kenstancount', CookieService.getLocalStorageValues('kenstancount') + 1);
                    }
                }
                //WW-398_PC_04 (5/5/2022) -Aparna
                let linePickUp = false;
                //console.log("BentonvilleStore", this.state.BentonvilleStore)
                if (val.SupplierID == "W999999999" && this.state.Bentonville_WO && val.hasBenItemVal == "C") {
                    linePickUp = true;
                }
                let imagePath = "";
                if (val.Image == "Images\noimage_new.png") {
                    imagePath = `/Images/noimage_new.png`;
                }
                else if (val.Image) {
                    val.Image = val.Image.replace('\\', '/');
                    if (val.Image.toLowerCase().indexOf("http") >= 0) {
                        //pc-WW-1088-03 s.sanjay 07/11/2024
                        let spliturl = val.Image.split('|');
                        imagePath = spliturl[0];
                    } else {
                        imagePath = val.Image.lastIndexOf(`/`) >= 0 ? val.Image.substring(val.Image.lastIndexOf("/") + 1, val.Image.length) : "noimage_new.png";
                        if (imagePath) {
                            //pc-WW-1088-04 s.sanjay 07/11/2024
                            let spliturl = val.Image.split('|');
                            imagePath = this.state.apiURL + `Images/${spliturl[0]}`;
                        }
                    }
                }

                else {
                    imagePath = `/Images/noimage_new.png`;
                }
                let msg = ""
                let labeldot;
                let graingerboolean = false;
                if (this.state.PickupVendor != "" && this.state.PickupVendor != undefined && this.state.PickupVendor != null) {
                    if (this.state.PickupVendor.toUpperCase() == "W W GRAINGER" && this.state.pickupcheck == true) {
                        if (this.state.PickupStoreSelected != "" && this.state.PickupStoreSelected != undefined && this.state.PickupStoreSelected != null) {
                            let graingermsg = this.state.GraingerQTY.filter((x) => val.Itemid == x.itemId && x.branchId == this.state.PickupStoreSelected.value)
                            let graingerstr = this.state.GraingerStore.filter((x) => x.branchId == this.state.PickupStoreSelected.value)
                            if (graingerstr.length > 0) {
                                labeldot = graingerstr[0].availablity
                                // console.log("color", labeldot)
                            }
                            if (graingermsg.length > 0) {
                                msg = graingermsg[0].msg
                                graingerboolean = true
                            }
                        }
                    }
                }
                let NonCat = val.Itemid.slice(0, 6)
                let ShowPOLNField = true
                if (CookieService.getLocalStorageValues("Session_SITEBU") != "SDM00") {
                    ShowPOLNField = false
                }
                let SupplierId = false
                if (val.SupplierID != null && val.SupplierID != "") {
                    SupplierId = true
                }
                let Pricevalue = val.Price
                if (NonCat == "NONCAT" && Pricevalue == "Price on Request") {
                    SupplierId = false
                }
                let RemoveKey = "  Remove"
                let Showmachinepart = CookieService.getLocalStorageValues("Session_PARTLIST")
                let OrderQuantity = val.Quantity
                let itemNum = index + 1;
                let formateddate = this.convertdate(val.UDueDate)
                let ItemMachinePart = []
                ItemMachinePart = this.state.ItemMachinePartNum.filter((item, index) => item.ItemId == val.Itemid)
                // let EmployName = this.state.OrderEmpyId 
                /*[01/04/21, PC_01,1893], Priyanka D*/
                let EmployName = "";
                if (this.state.OrderEmpyId != undefined) {
                    EmployName = this.state.OrderEmpyId.value
                }
                if (val.EmpChgCode != null) {
                    EmployName = val.EmpChgCode
                }

                const style = {
                    image: {
                        position: 'sticky',
                        display: 'block',
                        left: '0px !important',
                        top: '0px !important',
                    },
                }
                //let FavItem = this.state.FavMenuSub.filter((item, index) => item.CUSTOMERITEMID == val.Itemid || (item.CLIENT_MFG_PART == val.Manufacturerpartnumber && item.MANUFACTURER == val.Manufacturer)).length > 0 ? true : false;
                let FavItem = false
                let RecSuppStr = "";
                let ItemDescValid = "";
                let supplierstr = "";
                let valitemdesc = val.ItemDescription;
                //WW-381 Description With Recommended Supplier and Supplier has to be Removed-Deepthi
                if (val.Itemid.toUpperCase().includes("NONCAT")) {
                    if (val.PaintColor != undefined & val.PaintColor != null && val.PaintColor != "" && val.PaintColor != " ") {
                        if (!val.PaintColor.toUpperCase().includes("PUNCHOUT")) {
                            RecSuppStr = val.LineNo;
                        } else {
                            supplierstr = val.SUPPLIERNAME.toUpperCase();
                        }
                    } else {
                        RecSuppStr = val.LineNo;
                    }
                }
                else {
                    supplierstr = val.SUPPLIERNAME.toUpperCase();
                }
                if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                    let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                    let recind = val.ItemDescription.indexOf(":");
                    RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                    let lastlen = val.ItemDescription.length;
                    let removedreco = val.ItemDescription.slice(0, ind);
                    valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;
                    ItemDescValid = removedreco;
                }
                else if (val.ItemDescription.toUpperCase().includes("SUPPLIER:")) {
                    let ind = val.ItemDescription.toUpperCase().indexOf("SUPPLIER");
                    let supind = val.ItemDescription.indexOf(":");
                    supplierstr = val.ItemDescription.substring(supind + 1, val.ItemDescription.length);
                    let lastlen = val.ItemDescription.length;
                    let removedreco = val.ItemDescription.slice(0, ind);
                    valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                    ItemDescValid = removedreco;
                }

                this.state.FavMenuSub.map((item, index) => {
                    let CLIENT_MFG_PART = item.CLIENT_MFG_PART == null || item.CLIENT_MFG_PART == undefined || item.CLIENT_MFG_PART == "" ? " " : item.CLIENT_MFG_PART
                    let CUSTOMERITEMID = item.CUSTOMERITEMID == null || item.CUSTOMERITEMID == undefined || item.CUSTOMERITEMID == "" ? " " : item.CUSTOMERITEMID
                    let MANUFACTURER = item.MANUFACTURER == null || item.MANUFACTURER == undefined || item.MANUFACTURER == "" ? " " : item.MANUFACTURER
                    let Manufacturer1 = val.Manufacturer == null || val.Manufacturer == undefined || val.Manufacturer == "" ? " " : val.Manufacturer
                    let ItemidFav = val.Itemid == null || val.Itemid == undefined || val.Itemid == "" ? " " : val.Itemid
                    let Manufacturerpartnumber = val.Manufacturerpartnumber == null || val.Manufacturerpartnumber == undefined || val.Manufacturerpartnumber == "" ? " " : val.Manufacturerpartnumber
                    let price = item.PRICE == null || item.PRICE == undefined || item.PRICE == "" || item.PRICE == " " ? " " : item.PRICE
                    let des = item.DESCR == null || item.DESCR == undefined || item.DESCR == "" || item.DESCR == " " || item.DESCR == "-" ? "-" : item.DESCR.toUpperCase()
                    let UnitPrice = 0.00
                    let indexes = des.indexOf("RECOMMENDED SUPPLIER");
                    let last = des.length;
                    valitemdesc = val.ItemDescription;
                    if (valitemdesc != null && valitemdesc != undefined) {
                        valitemdesc = valitemdesc.includes("''") ? valitemdesc.replaceAll("''", "'") : valitemdesc
                    }
                    Manufacturer1 = Manufacturer1.replace("''", "'");
                    let removedrecommend = des.slice(0, indexes);
                    if (des.includes("RECOMMENDED SUPPLIER")) {
                        des = removedrecommend;
                    }

                    if (val.Itemid.toUpperCase().includes("NONCAT")) {
                        if (val.PaintColor != undefined & val.PaintColor != null && val.PaintColor != "" && val.PaintColor != " ") {
                            if (!val.PaintColor.toUpperCase().includes("PUNCHOUT")) {
                                RecSuppStr = val.LineNo;
                            } else {
                                supplierstr = val.SUPPLIERNAME.toUpperCase();
                            }
                        } else {
                            RecSuppStr = val.LineNo.toUpperCase();
                        }

                    }
                    else {
                        supplierstr = val.SUPPLIERNAME.toUpperCase();
                    }
                    if (val.ItemDescription.toUpperCase().includes("-INVITEMICON-")) {
                        valitemdesc = val.ItemDescription.split("-INVITEMICON-")
                        valitemdesc = valitemdesc[0].includes("''") ? valitemdesc[0].replaceAll("''", "'") : valitemdesc[0];// BUG-2628 for the description (9/9/2022)-Aparna; ;
                    }
                    if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                        let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                        let recind = val.ItemDescription.indexOf(":");
                        RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                        let lastlen = val.ItemDescription.length;
                        let removedreco = val.ItemDescription.slice(0, ind);
                        valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                        ItemDescValid = removedreco;
                    }
                    else if (val.ItemDescription.toUpperCase().includes("SUPPLIER:")) {
                        let ind = val.ItemDescription.toUpperCase().indexOf("SUPPLIER");
                        let supind = val.ItemDescription.indexOf(":");
                        supplierstr = val.ItemDescription.substring(supind + 1, val.ItemDescription.length);
                        let lastlen = val.ItemDescription.length;
                        let removedreco = val.ItemDescription.slice(0, ind);
                        valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                        ItemDescValid = removedreco;
                    }
                    UnitPrice = parseFloat(item.PRICE) ? parseFloat(item.PRICE) : 0
                    if (NonCat == "NONCAT") {
                        if (CUSTOMERITEMID.toUpperCase() == ItemidFav.toUpperCase() || (CLIENT_MFG_PART.toUpperCase() == Manufacturerpartnumber.toUpperCase()
                            && MANUFACTURER.toUpperCase() == Manufacturer1.toUpperCase())) {
                            if (NonCat == "NONCAT" && Pricevalue == "Price on Request") {
                                if (des.toUpperCase().trim() == valitemdesc.toUpperCase().trim()) {
                                    FavItem = true
                                }
                            }
                            else {
                                FavItem = true
                            }
                        }
                    }
                    else if (CUSTOMERITEMID.toUpperCase() == ItemidFav.toUpperCase() && (CLIENT_MFG_PART.toUpperCase() == Manufacturerpartnumber.toUpperCase()
                        && MANUFACTURER.includes("''") ? item.MANUFACTURER.replace("''", "'") : item.MANUFACTURER.toUpperCase() == Manufacturer1.toUpperCase() && item.SUPPLIER_ID == val.SupplierID)) {
                        FavItem = true
                    }
                })
                //  PC_WW-243_06 -Aparna
                if (val.ItemDescription != null || val.ItemDescription != undefined) {
                    if (val.ItemDescription.toUpperCase().includes("-INVITEMICON-")) {
                        valitemdesc = val.ItemDescription.split("-INVITEMICON-");
                        valitemdesc = valitemdesc[0].includes("''") ? valitemdesc[0].replaceAll("''", "'") : valitemdesc[0];// BUG-2628 for the description (9/9/2022)-Aparna
                    }

                } //exception handling
                let mfg_kenstan = false
                if (val.Manufacturer != null && val.Manufacturer != undefined) {
                    if (val.Manufacturer.includes('KENSTAN')) {
                        mfg_kenstan = true
                    }
                }
                let Supplierpartnum = val.Itemid
                if (val.Itemid.toUpperCase().includes("NONCAT")) {
                    Supplierpartnum = val.SupplierPartNumber

                }

                //Bug-5507 -Vishwa S
                let hasBenItemValLoc = val.hasBenItemVal;
                let coreRefItem = this.state.CartItems.filter((x) => val.SupplierID == x.SupplierID && val.SupplierPartNumber == x.SupplierPartNumber && !x.hasCoreCharge);
                if (val.hasCoreCharge) {
                    hasBenItemValLoc = coreRefItem[0].hasBenItemVal
                }

                return (
                    <div className="row mx-0 mb-3 p-3 item-box align-items-center " >
                        {/* 16/08/2023, 4006 - restricted RedirectToItemDetail for onClick() of core charge item's image, Divis Kumar R K */}
                        <div className="col-lg-2 col-md-5 mb-2" style={{ cursor: "Pointer" }} onClick={(e) => val.hasCoreCharge == false ? this.RedirectToItemDetail(e, val, FavItem) : null}>
                            <Image
                                id={`Img${val.Itemid}${val.Manufacturerpartnumber}id`}
                                src={imagePath}
                                width={120}
                                height={130}
                                style={style.image}
                                noImageSrc="/Images/noimage_new.png"

                            />
                        </div>
                        <div className="col-lg-10 col-md-12">
                            <div className="row align-items-center">
                                <div className="col-md-12 fav-maintence mb-3">
                                    <div className="row d-flex justify-content-between pl-2">
                                        <div className="d-flex align-items-center">
                                            <h5 className="page-title border-0">{val.hasCoreCharge ? "Core-" : ""} {val.Manufacturerpartnumber + "  " + itemNum}    {hasBenItemValLoc == "C" ? <span class="i-circlegridBlue">C</span> : hasBenItemValLoc == "T" ? <span class="i-circlegridYellow">T</span> : val.SupplierID == "W999999999" ? < span class="i-circlegrid">w</span> : null}</h5>
                                            {favicondisplay && NonCat != "NONCAT" && !mfg_kenstan && val.hasCoreCharge == false && val.ISA_WBS_ELMNT != "Equipment" && (val.FilePath != undefined && val.FilePath != " " && val.FilePath != null ? !val.FilePath[0].toUpperCase().includes('FORM')
                                                : true) && (val.FormAttribute != " " && val.FormAttribute != undefined ? false : true) ? <div className="fav-item-maintenance-icon mt-1">
                                                    <input type="checkbox" id={'checkbox-' + index} className="checknow" checked={FavItem} onChange={() => this.LinelevelFavEdit(FavItem, val.UniqNum, val.Itemid, val)} data-backdrop="static" data-keyboard="false" />
                                                    <label htmlFor={'checkbox-' + index}>
                                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                                </g>
                                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                                </g>
                                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                                </g>
                                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                                </g>
                                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                                </g>
                                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                                </g>
                                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </label>
                                                </div> : null}
                                            {/*WW-920_PC_03 -Aparna**/}
                                            {val.FormAttribute != " " && val.FormAttribute != null && refOrderNo == "" && parseInt(val.RTI_QTY ? val.RTI_QTY : 0, 10) < Number(val.Quantity ? val.Quantity : 0) ? <span className="font-12 font-medium batch-style py-1 px-2  ml-2 mb-2">Yet to fill form</span> : null}
                                        </div>

                                        <div className="d-flex align-items-center">

                                            {val.hasCoreCharge == false ? <div className="align-items-center qty-alignment mt-3">
                                                <span className="float-left">Qty : </span>
                                                {(val.ItemAttribute != undefined && val.ItemAttribute != "" && val.ItemAttribute != " " && val.ItemAttribute != null) ?
                                                    <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                        {/*[02/01/22, PC_EF_35, Priyanka.D]*/}
                                                        {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/}
                                                        {/*[12/21/22, PC_WW-552_FE_29], Dhevanesam R*/}
                                                        {refOrderNo == "" ? <input type="button" value="-" disabled={(val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1) || val.Quantity == 1 || val.FormAttribute != " " && val.FormAttribute} class="minus" onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}
                                                        <input type="number" disabled={(val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1) || refOrderNo == "" || val.FormAttribute != " " && val.FormAttribute} step={val.MIN_ORD_QTY} class="minus" min={val.MIN_ORD_QTY} name="quantity" name="Quantityvalue" value={val.Quantity} id={'Quantity' + val.CoreSeq} title="Qty" size="4" pattern="" inputmode="" style={{ "width": "73%", "borderLeft": "0" }} />
                                                        {refOrderNo == "" ? <input type="button" disabled={(val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1 || val.Quantity == 99999) || val.FormAttribute != " " && val.FormAttribute} value="+" class="plus" onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}                                                    </div> :
                                                    <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                        {/*[02/01/22, PC_EF_35, Priyanka.D]*/}
                                                        {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/}
                                                        {refOrderNo == "" ? <input type="button" value="-" class="minus" disabled={val.Quantity == 1} onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}
                                                        <input type="number" disabled={refOrderNo == ""} step={val.MIN_ORD_QTY} class="minus" min={val.MIN_ORD_QTY} name="quantity" name="Quantityvalue" value={val.Quantity} id={'Quantity' + val.CoreSeq} title="Qty" size="4" pattern="" inputmode="" style={{ "width": "73%", "borderLeft": "0" }} />
                                                        {refOrderNo == "" ? <input type="button" value="+" class="plus" disabled={val.Quantity >= 99999} onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}                                                    </div>}
                                                {/*<input type="text" value={val.Quantity} id={'Quantity' + val.UniqNum} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.QuantityOnchange(val.UniqNum, val.Itemid, e)} onBlur={(e) => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "Quantity", "", e)} />*/}
                                            </div> : null}
                                            {val.MinOrdMsg != "" ? <div className="w-100 float-left">
                                                <div className="float-right">
                                                    <span className="float-left mt-2">{val.MinOrdMsg}</span>
                                                </div>
                                            </div> : null}
                                        </div>
                                    </div>
                                    {val.shipping_specs != undefined && val.shipping_specs != null ? val.shipping_specs.toUpperCase() == "PUO ONLY" ?
                                        //WW-1162-02 changing the name refridgerent to pick-up only S.Sanjay
                                        <div className="row col-md-12 pl-2"> <label className="col-md-4 item-details-value  Refrigerent-styles mb-0 p-0">(Pick-up only)</label></div>
                                        : null : null}
                                </div>
                                <div className="col-md-12 col-lg-12">
                                    <p className="w-100 textbreakwrap">{valitemdesc}{(NonCat == "NONCAT" && SupplierId == false) || (val.PaintColor == "WNST" || val.PaintColor == "WCAT") ? <a className="edit-icon ml-2" onClick={() => this.LinelevelDescpEdit(val.Itemid, val.UniqNum, valitemdesc)} data-backdrop="static" data-keyboard="false" /> : null}</p>
                                </div>
                                <div className="col-md-12 col-lg-4 d-flex align-items-center mb-3">
                                    <label className=" catalog-label sp-catalog-label mb-0  ">Supplier part # :</label>
                                    <label className="item-details-value pl-1 mb-0" style={{ overflowWrap: "anywhere" }}>{Supplierpartnum}</label>
                                    {/*WW-600_PC_01 (1/25/2023)**/}


                                </div>
                                {/* <div className="col-md-12 col-lg-4 d-flex align-items-center mb-3">
                                    <label className=" catalog-label sp-catalog-label mb-0  ">MFG Part #:</label>
                                    <label className="item-details-value pl-1 mb-0">{val.Manufacturerpartnumber}</label>
                                   
                                </div>*/}
                                <div className="col-md-12 col-lg-4 d-flex align-items-center mb-3">
                                    <label className=" catalog-label sp-catalog-label mb-0  ">UOM :</label>
                                    <label className="item-details-value pl-1 mb-0">{val.UOM}</label>
                                </div>
                                {/*<div className="col-md-12 col-lg-4 d-flex align-items-center mb-2">
                                    <label className=" catalog-label sp-catalog-label mb-0  ">Supplier : </label>
                                    <label className="item-details-value pl-1 mb-0">Gustave</label>
                                </div>*/}
                                {RecSuppStr != "" && RecSuppStr != null && RecSuppStr != undefined ? <div className="col-md-12 col-lg-4 d-flex align-items-center mb-2">
                                    <label className="catalog-label sp-catalog-label mb-0 "><Trans>recommended</Trans><span> </span><Trans>Supplier</Trans><span> :</span></label>
                                    <label className="item-details-value pl-1 mb-0" id={`RecSup${val.Itemid}${val.Manufacturerpartnumber}id`}>{RecSuppStr}</label>
                                </div> : null}
                                <div className="col-md-12 col-lg-4 d-flex align-items-center mb-2">
                                    <label className=" catalog-label sp-catalog-label  " id={`Man${val.Itemid}${val.Manufacturerpartnumber}id`}> Manufacturer:</label>
                                    <label className="item-details-value pl-1">{val.Manufacturer}</label>
                                </div>
                                <div className="col-md-12 col-lg-4 d-flex align-items-center mb-2">
                                    <label className=" catalog-label sp-catalog-label text-nowarp mb-0 text-nowrap  " htmlFor="asset-tag-1">
                                        Asset Tag ID :
                              </label>{this.state.MachineTable.length > 0 ? <select className="form-control" id={'MachineNo' + val.UniqNum} defaultValue={val.MachineRow} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "MachineNo", "")}>
                                        <option>Select</option>
                                        {this.BuildMachineDD()}
                                    </select> :
                                        <input type="text" className="form-control sp-form-ctrl ml-1" id={'MachineNo' + val.UniqNum} placeholder="Enter Asset ID" maxLength="20" defaultValue={val.MachineRow} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "MachineNo", "")} />}
                                </div>
                                <div className="col-md-12 col-lg-4 d-flex align-items-center mb-2">
                                    <label className=" catalog-label sp-catalog-label text-nowarp mb-0 text-nowrap   " htmlFor="notes-1">
                                        Notes :
                              </label>
                                    <input type="text" className="form-control sp-form-ctrl ml-1" id={'Notes' + val.UniqNum} placeholder="Enter Notes" defaultValue={val.UNotes} maxLength="254" onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "Notes", "")} />
                                </div>
                                <div className="col-md-12 col-lg-4 d-flex align-items-center mb-2">
                                    <div className="d-flex sdi-category-title">
                                        Is this Priority ?{" "}
                                        <input type="checkbox" className="sdi-checkbox ml-2" defaultValue={val.UPriority} defaultChecked={val.UPriority == "R" ? true : false} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "Priority", "")} />
                                    </div>
                                </div>



                                {NonCat == "NONCAT" ? <div className="col-md-6 col-lg-4 mb-2 OLDatepicker">
                                    <div className="row">
                                        <label className="col-lg-4 col-md-4 catalog-label form-label pr-0 Delivery-date"><Trans>Delivery Date</Trans></label>
                                        <div className="col-lg-8 col-md-8">
                                            <DatePicker className="form-control"
                                                id={'DueDate' + val.UniqNum}
                                                fixedHeight
                                                placeholderText="MM/DD/YYYY"
                                                dateFormat="MM/dd/yyyy"
                                                showMonthDropdown
                                                showYearDropdown
                                                //dropdownMode="select"
                                                minDate={new Date()}
                                                selected={formateddate}
                                                onChange={(value, e) => this.handleChangeItem(value, e, val.Itemid, val.UniqNum)}
                                            />
                                            {/*<input type="text" id={'DueDate' + val.UniqNum} className="form-control datepicker" data-provide="datepicker" placeholder="Select Date" defaultValue={val.UDueDate} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "DueDate")} />*/}
                                            <span className="calendar-icon-Line" onClick={() => $('#DueDate' + val.UniqNum).focus()} />
                                        </div>
                                    </div>
                                </div> : null}
                                {NonCat == "NONCAT" ? <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-lg-4 col-md-4 catalog-label form-label Mobile-Attasho"><Trans>attachment_key</Trans></label>
                                        <div className="col-md-8 col-lg-8">
                                            <button id={val.UniqNum} className="btn custom-btn-primary primary-btn w-75" data-toggle="modal" data-target="#addattachment" onClick={() => this.LinelevelAtthEdit(val.Itemid, val.UniqNum)} data-backdrop="static" data-keyboard="false"> Browse
                                            </button>
                                        </div>
                                    </div>
                                </div> : null}
                                {graingerboolean ?
                                    <div className="col-md-12 fav-maintence">
                                        {labeldot == "Orange" ?
                                            <span className="cart-count" data-toggle="tooltip" style={la} title={msg}></span> : <span className="cart-count" data-toggle="tooltip" style={lal} title={msg} ></span>}
                                        <span className="errorspan1" style={txt}>{msg}</span>
                                    </div> : null}
                                <div className="col-md-12 col-lg-12 mt-3">
                                    {val.FormAttribute != " " && val.FormAttribute != null && refOrderNo == "" && parseInt(val.RTI_QTY ? val.RTI_QTY : 0, 10) < Number(val.Quantity ? val.Quantity : 0) ? <a className="complete-form-style font-medium font-12" onClick={(e) => this.FormNavigation(false, index)}><img src="Images/form-icon.svg" className="mr-1 mb-1" alt="form" />Complete Form</a> : null}
                                    {val.hasCoreCharge == false ? <button className="btn remove-order" data-toggle="modal" data-target="#Cancel-confirmation" onClick={() => this.DeleteItem(val.Itemid, val.UniqNum)} data-backdrop="static" data-keyboard="false">
                                        <img src="Images/remove-order.svg" className="removeorder-icon" alt="Remove Order" />
                                        <Trans>{RemoveKey}</Trans>
                                    </button> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        })
    }
    BindCart = () => {
        CookieService.updateLocalStorageValues('kenstancount', 0);
        console.log("FavMenuSub", this.state.FavMenuSub)
        console.log("CartItems", this.state.CartItems)
        return this.state.CartItems.map((val, index) => {
            //
            //**********NEW*********wal-158***
            let favicondisplay = true;
            if (val.PaintColor == "PUNCHOUT") {
                favicondisplay = false;
            }
            //Removing heart icon for unavail item
            this.state.WNA.map((x, index) => {
                if (val.Itemid == x.item) {
                    favicondisplay = false
                }
            })

            //******END********
            if (val.Manufacturer != null && val.Manufacturer != undefined) {
                if (val.Manufacturer.includes('KENSTAN')) {
                    CookieService.updateLocalStorageValues('kenstancount', CookieService.getLocalStorageValues('kenstancount') + 1);
                }
            }
            //WW-398_PC_04 (5/5/2022) -Aparna
            let linePickUp = false;
            //console.log("BentonvilleStore", this.state.BentonvilleStore)
            if (val.SupplierID == "W999999999" && this.state.Bentonville_WO && val.hasBenItemVal == "C") {
                linePickUp = true;
            }
            let imagePath = "";
            if (val.Image == "Images\noimage_new.png") {
                imagePath = `/Images/noimage_new.png`;
            }
            else if (val.Image) {
                val.Image = val.Image.replace('\\', '/');
                if (val.Image.toLowerCase().indexOf("http") >= 0) {
                    imagePath = val.Image;
                } else {
                    imagePath = val.Image.lastIndexOf(`/`) >= 0 ? val.Image.substring(val.Image.lastIndexOf("/") + 1, val.Image.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = this.state.apiURL + `Images/${imagePath}`;
                    }
                }
            }

            else {
                imagePath = `/Images/noimage_new.png`;
            }
            let msg = ""
            let labeldot;
            let graingerboolean = false;
            if (this.state.PickupVendor != "" && this.state.PickupVendor != undefined && this.state.PickupVendor != null) {
                if (this.state.PickupVendor.toUpperCase() == "W W GRAINGER" && this.state.pickupcheck == true) {
                    if (this.state.PickupStoreSelected != "" && this.state.PickupStoreSelected != undefined && this.state.PickupStoreSelected != null) {
                        let graingermsg = this.state.GraingerQTY.filter((x) => val.Itemid == x.itemId && x.branchId == this.state.PickupStoreSelected.value)
                        let graingerstr = this.state.GraingerStore.filter((x) => x.branchId == this.state.PickupStoreSelected.value)
                        if (graingerstr.length > 0) {
                            labeldot = graingerstr[0].availablity
                            // console.log("color", labeldot)
                        }
                        if (graingermsg.length > 0) {
                            msg = graingermsg[0].msg
                            graingerboolean = true
                        }
                    }
                }
            }
            let NonCat = val.Itemid.slice(0, 6)
            let ShowPOLNField = true
            if (CookieService.getLocalStorageValues("Session_SITEBU") != "SDM00") {
                ShowPOLNField = false
            }
            let SupplierId = false
            if (val.SupplierID != null && val.SupplierID != "") {
                SupplierId = true
            }
            let Pricevalue = val.Price
            if (NonCat == "NONCAT" && Pricevalue == "Price on Request") {
                SupplierId = false
            }
            let RemoveKey = "  Remove"
            let Showmachinepart = CookieService.getLocalStorageValues("Session_PARTLIST")
            let OrderQuantity = val.Quantity
            let itemNum = index + 1;
            let formateddate = this.convertdate(val.UDueDate)
            let ItemMachinePart = []
            ItemMachinePart = this.state.ItemMachinePartNum.filter((item, index) => item.ItemId == val.Itemid)
            // let EmployName = this.state.OrderEmpyId 
            /*[01/04/21, PC_01,1893], Priyanka D*/
            let EmployName = "";
            if (this.state.OrderEmpyId != undefined) {
                EmployName = this.state.OrderEmpyId.value
            }
            if (val.EmpChgCode != null) {
                EmployName = val.EmpChgCode
            }
            //let EmployName = {}; 
            //let filteremp = {};
            //if (val.EmpChgCode != null && val.EmpChgCode != "" && val.EmpChgCode != undefined) {
            //    filteremp=this.state.Employeelist.filter((i, index) => i.value == val.EmpChgCode)
            //    EmployName = filteremp
            //    //val.EmpChgCode = "";
            //}
            //else {
            //    //filteremp = this.state.Employeelist.filter((i, index) => i.value == this.state.PreferedEmployee)
            //    EmployName= this.state.PreferedEmployee
            //}
            //**NEW***ADDED(1/21/2021)*****
            //if (EmployName != null && EmployName != undefined && EmployName != "") {
            //    console.log("empname", EmployName)
            //   // EmployName = EmployName.toUpperCase()
            //}
            //*****END***********
            const style = {
                image: {
                    position: 'sticky',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                },
            }
            //let FavItem = this.state.FavMenuSub.filter((item, index) => item.CUSTOMERITEMID == val.Itemid || (item.CLIENT_MFG_PART == val.Manufacturerpartnumber && item.MANUFACTURER == val.Manufacturer)).length > 0 ? true : false;
            let FavItem = false
            let RecSuppStr = "";
            let ItemDescValid = "";
            let supplierstr = "";
            let valitemdesc = val.ItemDescription;
            //WW-381 Description With Recommended Supplier and Supplier has to be Removed-Deepthi
            if (val.Itemid.toUpperCase().includes("NONCAT")) {
                if (val.PaintColor != undefined & val.PaintColor != null && val.PaintColor != "" && val.PaintColor != " ") {
                    if (!val.PaintColor.toUpperCase().includes("PUNCHOUT")) {
                        RecSuppStr = val.LineNo;
                    } else {
                        supplierstr = val.SUPPLIERNAME.toUpperCase();
                    }
                } else {
                    RecSuppStr = val.LineNo;
                }
            }
            else {
                supplierstr = val.SUPPLIERNAME.toUpperCase();
            }
            if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                let recind = val.ItemDescription.indexOf(":");
                RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                let lastlen = val.ItemDescription.length;
                let removedreco = val.ItemDescription.slice(0, ind);
                valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;
                ItemDescValid = removedreco;
            }
            else if (val.ItemDescription.toUpperCase().includes("SUPPLIER:")) {
                let ind = val.ItemDescription.toUpperCase().indexOf("SUPPLIER");
                let supind = val.ItemDescription.indexOf(":");
                supplierstr = val.ItemDescription.substring(supind + 1, val.ItemDescription.length);
                let lastlen = val.ItemDescription.length;
                let removedreco = val.ItemDescription.slice(0, ind);
                valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                ItemDescValid = removedreco;
            }

            this.state.FavMenuSub.map((item, index) => {
                let CLIENT_MFG_PART = item.CLIENT_MFG_PART == null || item.CLIENT_MFG_PART == undefined || item.CLIENT_MFG_PART == "" ? " " : item.CLIENT_MFG_PART
                let CUSTOMERITEMID = item.CUSTOMERITEMID == null || item.CUSTOMERITEMID == undefined || item.CUSTOMERITEMID == "" ? " " : item.CUSTOMERITEMID
                let MANUFACTURER = item.MANUFACTURER == null || item.MANUFACTURER == undefined || item.MANUFACTURER == "" ? " " : item.MANUFACTURER
                let Manufacturer1 = val.Manufacturer == null || val.Manufacturer == undefined || val.Manufacturer == "" ? " " : val.Manufacturer
                let ItemidFav = val.Itemid == null || val.Itemid == undefined || val.Itemid == "" ? " " : val.Itemid
                let Manufacturerpartnumber = val.Manufacturerpartnumber == null || val.Manufacturerpartnumber == undefined || val.Manufacturerpartnumber == "" ? " " : val.Manufacturerpartnumber
                let price = item.PRICE == null || item.PRICE == undefined || item.PRICE == "" || item.PRICE == " " ? " " : item.PRICE
                let des = item.DESCR == null || item.DESCR == undefined || item.DESCR == "" || item.DESCR == " " || item.DESCR == "-" ? "-" : item.DESCR.toUpperCase()
                let UnitPrice = 0.00
                let indexes = des.indexOf("RECOMMENDED SUPPLIER");
                let last = des.length;
                valitemdesc = val.ItemDescription;
                if (valitemdesc != null && valitemdesc != undefined) {
                    valitemdesc = valitemdesc.includes("''") ? valitemdesc.replaceAll("''", "'") : valitemdesc
                }
                Manufacturer1 = Manufacturer1.replace("''", "'");
                let removedrecommend = des.slice(0, indexes);
                if (des.includes("RECOMMENDED SUPPLIER")) {
                    des = removedrecommend;
                }

                if (val.Itemid.toUpperCase().includes("NONCAT")) {
                    if (val.PaintColor != undefined & val.PaintColor != null && val.PaintColor != "" && val.PaintColor != " ") {
                        if (!val.PaintColor.toUpperCase().includes("PUNCHOUT")) {
                            RecSuppStr = val.LineNo;
                        } else {
                            supplierstr = val.SUPPLIERNAME.toUpperCase();
                        }
                    } else {
                        RecSuppStr = val.LineNo.toUpperCase();
                    }

                }
                else {
                    supplierstr = val.SUPPLIERNAME.toUpperCase();
                }
                if (val.ItemDescription.toUpperCase().includes("-INVITEMICON-")) {
                    valitemdesc = val.ItemDescription.split("-INVITEMICON-")
                    valitemdesc = valitemdesc[0].includes("''") ? valitemdesc[0].replaceAll("''", "'") : valitemdesc[0];// BUG-2628 for the description (9/9/2022)-Aparna; ;
                }
                if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                    let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                    let recind = val.ItemDescription.indexOf(":");
                    RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                    let lastlen = val.ItemDescription.length;
                    let removedreco = val.ItemDescription.slice(0, ind);
                    valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                    ItemDescValid = removedreco;
                }
                else if (val.ItemDescription.toUpperCase().includes("SUPPLIER:")) {
                    let ind = val.ItemDescription.toUpperCase().indexOf("SUPPLIER");
                    let supind = val.ItemDescription.indexOf(":");
                    supplierstr = val.ItemDescription.substring(supind + 1, val.ItemDescription.length);
                    let lastlen = val.ItemDescription.length;
                    let removedreco = val.ItemDescription.slice(0, ind);
                    valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                    ItemDescValid = removedreco;
                }
                UnitPrice = parseFloat(item.PRICE) ? parseFloat(item.PRICE) : 0
                if (NonCat == "NONCAT") {
                    if (CUSTOMERITEMID.toUpperCase() == ItemidFav.toUpperCase() || (CLIENT_MFG_PART.toUpperCase() == Manufacturerpartnumber.toUpperCase()
                        && MANUFACTURER.toUpperCase() == Manufacturer1.toUpperCase())) {
                        if (NonCat == "NONCAT" && Pricevalue == "Price on Request") {
                            if (des.toUpperCase().trim() == valitemdesc.toUpperCase().trim()) {
                                FavItem = true
                            }
                        }
                        else {
                            FavItem = true
                        }
                    }
                }
                else if (CUSTOMERITEMID.toUpperCase() == ItemidFav.toUpperCase() && (CLIENT_MFG_PART.toUpperCase() == Manufacturerpartnumber.toUpperCase()
                    && MANUFACTURER.includes("''") ? item.MANUFACTURER.replace("''", "'") : item.MANUFACTURER.toUpperCase() == Manufacturer1.toUpperCase() && item.SUPPLIER_ID == val.SupplierID)) {
                    FavItem = true
                }
            })
            //  PC_WW-243_06 -Aparna
            if (val.ItemDescription != null || val.ItemDescription != undefined) {
                if (val.ItemDescription.toUpperCase().includes("-INVITEMICON-")) {
                    valitemdesc = val.ItemDescription.split("-INVITEMICON-");
                    valitemdesc = valitemdesc[0].includes("''") ? valitemdesc[0].replaceAll("''", "'") : valitemdesc[0];// BUG-2628 for the description (9/9/2022)-Aparna
                }

            } //exception handling
            let mfg_kenstan = false
            if (val.Manufacturer != null && val.Manufacturer != undefined) {
                if (val.Manufacturer.includes('KENSTAN')) {
                    mfg_kenstan = true
                }
            }

            console.log("valitemdesc", valitemdesc)
            console.log("recsupplier", val.ItemDescription);
            return (<div className="row mx-0 mb-3 py-3 item-box" key={val.Itemid + index}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-1 custom-fav-image pr-0 Image-ShoppingCart" style={{ cursor: "Pointer" }} onClick={(e) => this.RedirectToItemDetail(e, val, FavItem)}>
                            <Image
                                id={`Img${val.Itemid}${val.Manufacturerpartnumber}id`}
                                src={imagePath}
                                width={120}
                                height={130}
                                style={style.image}
                                noImageSrc="/Images/noimage_new.png"

                            />
                            {/* <img src={imagePath} alt="fav_item" />*/}
                        </div>
                        <div className="col-md-11 custom-fav-container">
                            <div className="row">
                                <div className="col-md-12 col-lg-9 Shopping-Cart-itemdiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span className="fav-item-title"><span className="float-left mt-2">{val.Manufacturerpartnumber + "  " + itemNum}</span>
                                                {/*[1/7/22], PC_SC_01, WW-286, Dhevanesam R*/}
                                                {/*[02/09/22, PC_01,WW-318], Priyanka D,Hiding Fav Icon for Enersys Item*/}
                                                {/*[12/21/22, PC_WW-552_FE_29], Dhevanesam R*/}
                                                {favicondisplay && NonCat != "NONCAT" && !mfg_kenstan && val.hasCoreCharge == false && val.ISA_WBS_ELMNT != "Equipment" && (val.FilePath != undefined ? !val.FilePath[0].toUpperCase().includes('FORM')
                                                    : true) ? <div className="fav-item-maintenance-icon" style={{ height: "20px" }}>
                                                        <input type="checkbox" id={'checkbox-' + index} className="checknow" checked={FavItem} onChange={() => this.LinelevelFavEdit(FavItem, val.UniqNum, val.Itemid, val)} data-backdrop="static" data-keyboard="false" />
                                                        <label htmlFor={'checkbox-' + index}>
                                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                                    </g>
                                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                                    </g>
                                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                                    </g>
                                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                                    </g>
                                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                                    </g>
                                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                                    </g>
                                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </label>
                                                    </div> : null}
                                            </span>
                                        </div>
                                        {/*WW-600_PC_01 (1/25/2023)**/}
                                        {val.shipping_specs != undefined && val.shipping_specs != null ? val.shipping_specs.toUpperCase() == "PU ONLY" ? <div className="col-md-12">
                                            <label className="col-md-12 item-details-value w-100 p-0 Refrigerent-styles">(Refrigerant)</label>
                                        </div> : null : null}
                                        <label className="col-md-12 item-details-value w-100 Mobile-descrip">{valitemdesc}{NonCat == "NONCAT" && SupplierId == false ? <a className="edit-icon ml-2" onClick={() => this.LinelevelDescpEdit(val.Itemid, val.UniqNum, valitemdesc)} data-backdrop="static" data-keyboard="false" /> : null}</label>

                                        {/*[12/22/21], PC_SC_01, WW-286, Dhevanesam R*/}


                                        <div className="col-md-6 fav-maintence">
                                            <label className="catalog-label"><Trans>Manufacturer</Trans><span> :</span></label>
                                            <label className="item-details-value ml-2" id={`Man${val.Itemid}${val.Manufacturerpartnumber}id`}>{val.Manufacturer}</label>
                                        </div>
                                        <div className="col-md-6 fav-maintence">
                                            <label className="catalog-label">Supplier Part# :</label>
                                            <label className="item-details-value ml-2" id={`Item${val.Itemid}${val.Manufacturerpartnumber}id`}>{val.Itemid}</label>
                                            {/*[2/16/22], WW-330, Dhevanesam R*/}
                                            {val.hasBenItemVal == "C" ? <span class="i-circlegridBlue">C</span> : val.hasBenItemVal == "T" ? <span class="i-circlegridYellow">T</span> : val.SupplierID == "W999999999" ? < span class="i-circlegrid">w</span> : null}                                        </div>
                                        <div className="col-md-6 fav-maintence">
                                            <label className="catalog-label">UOM :</label>
                                            <label className="item-details-value ml-2" id={`Uom${val.Itemid}${val.Manufacturerpartnumber}id`}>{val.UOM}</label>
                                        </div>

                                        {/*WW-243 Can't open shopping Cart while reordering this 4CES-6-2DU-1D Item - Deepthi */}
                                        {RecSuppStr != "" && RecSuppStr != null && RecSuppStr != undefined ? <div className="col-md-6 fav-maintence">
                                            <label className="catalog-label"><Trans>recommended</Trans><span> </span><Trans>Supplier</Trans><span> :</span></label>
                                            <label className="item-details-value ml-2" id={`RecSup${val.Itemid}${val.Manufacturerpartnumber}id`}>{RecSuppStr}</label>
                                        </div> : null}
                                        {supplierstr != "" && supplierstr != null && supplierstr != undefined ? <div className="col-md-6 fav-maintence">
                                            <label className="catalog-label"><Trans>Supplier</Trans><span> :</span></label>
                                            <label className="item-details-value ml-2" id={`Supp${val.Itemid}${val.Manufacturerpartnumber}id`}>{supplierstr}</label>
                                        </div> : null}
                                        {val.RFQReq != null && val.RFQReq != undefined && val.RFQReq != "" ? <div className="col-md-6 fav-maintence">
                                            <label className="catalog-label">RFQ :</label>
                                            <label className="item-details-value ml-2" id={`RFQ${val.Itemid}${val.Manufacturerpartnumber}id`}>{val.RFQReq}</label>
                                        </div> : null}

                                        {/*{val.CORE_CHARGE != "" && val.CORE_CHARGE != " " && val.CORE_CHARGE != null ? <div className="col-md-6 fav-maintence">
                                                    <label className="catalog-label" style={{ "color": "#4995f2" }}><Trans>Core Charge</Trans></label>
                                                </div> : null}*/}
                                        {graingerboolean ?
                                            <div className="col-md-12 fav-maintence">
                                                {labeldot == "Orange" ?
                                                    <span className="cart-count" data-toggle="tooltip" style={la} title={msg}></span> : <span className="cart-count" data-toggle="tooltip" style={lal} title={msg} ></span>}
                                                <span className="errorspan1" style={txt}>{msg}</span>
                                            </div> : null}
                                        <div className="col-md-12">
                                            {val.hasCoreCharge == false ? <a href="#" onClick={(e) => this.onAccordianClickitemlevel(e, index)}><Trans>More Details</Trans></a> : null}
                                            {val.hasCoreCharge == false ? <button className="btn remove-order" data-toggle="modal" data-target="#Cancel-confirmation" onClick={() => this.DeleteItem(val.Itemid, val.UniqNum)} data-backdrop="static" data-keyboard="false">
                                                <img src="Images/remove-order.svg" className="removeorder-icon" alt="Remove Order" />
                                                <Trans>{RemoveKey}</Trans>
                                            </button> : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-3 OSPD-prices">
                                    <div className="float-right">
                                        <div className="w-100 float-left mb-2 ">
                                            {val.hasCoreCharge == false ? <div className="align-items-center qty-alignment mt-3">
                                                <span className="float-left">Qty : </span>
                                                {(val.ItemAttribute != undefined && val.ItemAttribute != "" && val.ItemAttribute != " " && val.ItemAttribute != null) ?
                                                    <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                        {/*[02/01/22, PC_EF_35, Priyanka.D]*/}
                                                        {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/}
                                                        {/*[12/21/22, PC_WW-552_FE_29], Dhevanesam R*/}
                                                        {refOrderNo == "" ? <input type="button" value="-" disabled={(val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1) || refOrderNo == "" || val.FormAttribute != " " && val.FormAttribute} class="minus" onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}
                                                        <input type="number" disabled={(val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1) || refOrderNo == "" || val.FormAttribute != " " && val.FormAttribute} step={val.MIN_ORD_QTY} class="minus" min={val.MIN_ORD_QTY} name="quantity" name="Quantityvalue" value={val.Quantity} id={'Quantity' + val.CoreSeq} title="Qty" size="4" pattern="" inputmode="" style={{ "width": "73%", "borderLeft": "0" }} />
                                                        {refOrderNo == "" ? <input type="button" disabled={(val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1 || val.Quantity >= 99999) || refOrderNo == "" || val.FormAttribute != " " && val.FormAttribute} value="+" class="plus" onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}                                                    </div> :
                                                    <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                        {/*[02/01/22, PC_EF_35, Priyanka.D]*/}
                                                        {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/}
                                                        {refOrderNo == "" ? <input type="button" value="-" class="minus" disabled={val.Quantity == 1} onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}
                                                        <input type="number" disabled={refOrderNo == ""} step={val.MIN_ORD_QTY} class="minus" min={val.MIN_ORD_QTY} name="quantity" name="Quantityvalue" value={val.Quantity} id={'Quantity' + val.CoreSeq} title="Qty" size="4" pattern="" inputmode="" style={{ "width": "73%", "borderLeft": "0" }} />
                                                        {refOrderNo == "" ? <input type="button" value="+" class="plus" disabled={val.Quantity >= 99999} onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} /> : null}  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}                                                    </div>}
                                                {/*<input type="text" value={val.Quantity} id={'Quantity' + val.UniqNum} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.QuantityOnchange(val.UniqNum, val.Itemid, e)} onBlur={(e) => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "Quantity", "", e)} />*/}
                                            </div> : null}
                                            {val.MinOrdMsg != "" ? <div className="w-100 float-left">
                                                <div className="float-right">
                                                    <span className="float-left mt-2">{val.MinOrdMsg}</span>
                                                </div>
                                            </div> : null}
                                        </div>
                                        {this.state.showprice != "0" ? <div className="w-100 float-left d-none">
                                            <div className="float-right">
                                                <label className="float-left mt-2"><span>Ext </span><Trans>Price</Trans><span> :</span></label>
                                                <span className="float-left mt-2 price-rate shopping-ext">{val.Price}</span>
                                            </div>
                                        </div> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 pt-3 mt-2 border-top accordian-body d-none" id={'order-row-' + index}>
                    <div className="row">
                        <div className="col-md-12 col-lg-12 moredetail-content">
                            <div className="row">
                                {NonCat == "NONCAT" ? <div className="col-md-6 col-lg-4 mb-2 OLDatepicker">
                                    <div className="row">
                                        <label className="col-lg-4 col-md-4 catalog-label form-label pr-0 Delivery-date"><Trans>Delivery Date</Trans></label>
                                        <div className="col-lg-8 col-md-8">
                                            <DatePicker className="form-control"
                                                id={'DueDate' + val.UniqNum}
                                                fixedHeight
                                                placeholderText="MM/DD/YYYY"
                                                dateFormat="MM/dd/yyyy"
                                                showMonthDropdown
                                                showYearDropdown
                                                //dropdownMode="select"
                                                minDate={new Date()}
                                                selected={formateddate}
                                                onChange={(value, e) => this.handleChangeItem(value, e, val.Itemid, val.UniqNum)}
                                            />
                                            {/*<input type="text" id={'DueDate' + val.UniqNum} className="form-control datepicker" data-provide="datepicker" placeholder="Select Date" defaultValue={val.UDueDate} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "DueDate")} />*/}
                                            <span className="calendar-icon-Line" onClick={() => $('#DueDate' + val.UniqNum).focus()} />
                                        </div>
                                    </div>
                                </div> : null}
                                {NonCat == "NONCAT" ? <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-lg-4 col-md-4 catalog-label form-label Mobile-Attasho"><Trans>attachment_key</Trans></label>
                                        <div className="col-md-8 col-lg-8">
                                            <button id={val.UniqNum} className="btn custom-btn-primary primary-btn w-75" data-toggle="modal" data-target="#addattachment" onClick={() => this.LinelevelAtthEdit(val.Itemid, val.UniqNum)} data-backdrop="static" data-keyboard="false"> Browse
                                            </button>
                                        </div>
                                    </div>
                                </div> : null}
                                <div className="col-md-6 col-lg-4 mb-3 d-none">
                                    <div className="row">
                                        <label className="catalog-label form-label pl-3 Delivery-date"><Trans>Employee</Trans><Trans>ID</Trans></label>
                                        <div className="col-lg-7 col-md-7 col-12">
                                            <select id={'EmpDD' + val.UniqNum} className="form-control EmployeCC" value={EmployName} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "EmployeeCC", "")}>
                                                <option value="0">Select</option>
                                                {this.BindEmpCCToItem()}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {Showmachinepart == "Y" ? <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-lg-4 col-md-4 catalog-label form-label">Part #</label>
                                        <div className="col-lg-8 col-md-8">
                                            {ItemMachinePart ? <select className="form-control" id={'MachinePart' + val.UniqNum} defaultValue={val.MachineNo} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "MachinePart", "")}>
                                                <option>Select</option>
                                                {this.BuildMachinePart(ItemMachinePart)}
                                            </select> : <input type="text" className="form-control" id={'MachinePart' + val.UniqNum} placeholder="Enter Part No" maxLength="20" defaultValue={val.MachineNo} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "MachinePart", "")} />}
                                        </div>
                                    </div>
                                </div> : null}
                                {Showmachinepart == "Y" && ItemMachinePart == null && ItemMachinePart.length == 0 && NonCat == "NONCAT" ? <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-lg-4 col-md-4 catalog-label form-label">Part #</label>
                                        <div className="col-lg-8 col-md-8">
                                            <input type="text" className="form-control" id={'MachinePart' + val.UniqNum} placeholder="Enter Part No" maxLength="20" defaultValue={val.MachineNo} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "MachinePart", "")} />
                                        </div>
                                    </div>
                                </div> : null}
                                <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-lg-6 col-md-6 catalog-label form-label"><Trans>Asset Tag ID</Trans></label>
                                        <div className="col-lg-6 col-md-6">
                                            {/*<select id={val.UniqNum} className="form-control">
                                                <option>Select</option>
                                                <option>Option</option>
                                            </select>*/}
                                            {this.state.MachineTable.length > 0 ? <select className="form-control" id={'MachineNo' + val.UniqNum} defaultValue={val.MachineRow} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "MachineNo", "")}>
                                                <option>Select</option>
                                                {this.BuildMachineDD()}
                                            </select> : <input type="text" className="form-control" id={'MachineNo' + val.UniqNum} placeholder="Enter Asset Tag ID" maxLength="20" defaultValue={val.MachineRow} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "MachineNo", "")} />}
                                        </div>
                                    </div>
                                </div>
                                {ShowPOLNField ? <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-lg-6 col-md-6 catalog-label form-label">PO #</label>
                                        <div className="col-lg-6 col-md-6">
                                            <input type="text" id={'PO' + val.UniqNum} className="form-control" placeholder="Enter value" maxLength="20" defaultValue={val.PO} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "PO", "")} />
                                        </div>
                                    </div>
                                </div> : null}
                                {ShowPOLNField ? <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-lg-6 col-md-6 catalog-label form-label">LN #</label>
                                        <div className="col-lg-6 col-md-6">
                                            <input type="text" id={'LN' + val.UniqNum} className="form-control" placeholder="Enter value" maxLength="20" defaultValue={val.LN} onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "LN", "")} />
                                        </div>
                                    </div>
                                </div> : null}
                                <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">

                                        <label className="col-md-6 col-lg-6 col-12 catalog-label"><Trans>Is This Priority?</Trans></label>
                                        <div className="col-lg-6 col-md-6 custom-control custom-checkbox mb-2 item-custom-control mx-0 mt-0">
                                            <input type="checkbox" className="custom-control-input" id={'customCheck-16a' + val.UniqNum} name="example" defaultValue={val.UPriority} defaultChecked={val.UPriority == "R" ? true : false} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "Priority", "")} />
                                            <label className="custom-control-label ml-3" htmlFor={'customCheck-16a' + val.UniqNum} />
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 mb-3 d-none">{/***NEW*** wal-158**(d-none) added**/}
                                    <div className="row">
                                        <label className="col-md-6 col-lg-6 catalog-label "><Trans>Tax Exempt</Trans></label>
                                        <div className="col-lg-6 col-md-6 custom-control custom-checkbox mb-2 item-custom-control mx-0 mt-0">
                                            <input type="checkbox" className="custom-control-input" id={'customCheck-4' + val.UniqNum} name="example1" defaultValue={val.TaxFlag} defaultChecked={val.TaxFlag == "Y" ? true : false} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "TaxFlag", "")} />
                                            <label className="custom-control-label " htmlFor={'customCheck-4' + val.UniqNum} />
                                        </div>
                                    </div>
                                </div>
                                {linePickUp ?
                                    <div className="col-md-6 col-lg-4 mb-3">
                                        <div className="row">
                                            <label className="col-md-6 col-lg-6 catalog-label">Pickup</label>
                                            <div className="col-lg-6 col-md-6 custom-control custom-checkbox mb-2 item-custom-control mx-0 mt-0">
                                                <input type="checkbox" className="custom-control-input" id={'customCheck-5' + val.UniqNum} name="example2" checked={val.pickupcheck} onChange={() => this.linepickupcheck(val, index)} />
                                                <label className="custom-control-label" htmlFor={'customCheck-5' + val.UniqNum} />
                                            </div>
                                        </div>
                                    </div> : null}

                                {/**NEW***(shopping cart)Wal-158*****
                                        {NonCat == "NONCAT" ? <div className="col-md-4 col-lg-4">
                                            <label className="catalog-label float-left mt-1">Add Item to Catalog</label>
                                            <div className="custom-control custom-checkbox mb-3 mt-0 item-custom-control ml-4 float-left">
                                                <input type="checkbox" className="custom-control-input" id={'customCheck-5' + val.UniqNum} name="example2" defaultChecked={val.AddToCtlgFlag == "1" ? true : false} onChange={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "AddToCtg", "")} />
                                                <label className="custom-control-label" htmlFor={'customCheck-5' + val.UniqNum} />
                                            </div>
                                        </div> : null}*****END******/}


                            </div>
                        </div>
                        <div className="col-md-12 col-lg-12 moredetail-content">
                            <div className="row">
                                <div className="col-md-6 col-lg-4 mb-3">
                                    <div className="row">
                                        <label className="col-md-6 col-lg-6 catalog-label"><Trans>Notes</Trans></label>
                                        <div className="col-md-6 col-lg-6">
                                            <textarea id={'Notes' + val.UniqNum} className="form-control custom-textarea" defaultValue={val.UNotes} maxLength="254" onBlur={() => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "Notes", "")} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>





            </div>)
        });
    }
    /*
     * RF No: SC_PC_22
     * In this method employee drop down is binded.
     * 
     * */
    //BindEmpCCToItem = () => {
    //    this.state.EmployeeCC.map((val, index) => {
    //        if (val != null && val != undefined) {
    //            //return (<option key={iresult.EMP_ID} value={iresult.EMP_ID}>{iresult.ISA_EMPLOYEE_NAME}</option>)
    //            let employeevalue = []
    //            let preferedemployee = {
    //                value: "0",
    //                label: "--Select Ship To--"
    //            }
    //            if (index == 0) {
    //                let defaultvalue = {
    //                    value: "0",
    //                    label: "--Select Ship To--"
    //                }
    //                employeevalue.push(defaultvalue)
    //            }
    //            let localArray = {
    //                value: val.EMP_ID,
    //                label: val.ISA_EMPLOYEE_NAME
    //            }
    //            if (val.EMP_ID == this.state.Employeevalue) {
    //                preferedemployee = localArray
    //            }
    //            employeevalue.push(localArray);
    //        }
    //    })
    //        }
    BindEmpCCToItem = () => {
        return this.state.EmployeeCC.map((iresult, index) => {
            if (iresult != null && iresult != undefined) {
                let EmpNameEmail = iresult.ISA_EMPLOYEE_NAME + "   " + iresult.ISA_EMPLOYEE_EMAIL;
                return (<option key={iresult.EMP_ID} value={iresult.EMP_ID}>{iresult.ISA_EMPLOYEE_NAME}   {iresult.ISA_EMPLOYEE_EMAIL}</option>)
            }
        });
    }
    /************NEW****(Pick Up Order Submission)wal-158***/
    Bindpickupstore = () => {

        let curlat = 0;
        let curlong = 0;
        let Pick = []
        let billtostore = this.state.BilltoStoreLocation;
        let billstore = this.state.BilltoStore.value;
        //
        if (billstore != "" && billstore != undefined) {
            if (billstore.substring(0, 2) == "WT") {
                curlat = this.state.curtrucklat;
                curlong = this.state.curtrucklong;
            }
        }
        let values = this.state.Pick;
        values.forEach((val) => {
            values.splice(val);
        })
        this.setState({
            Pick: values
        });
        if ((CurrentLatitude == null || CurrentLongitude == null) && this.state.PickupVendorID == "W999999999") {
            //swal({
            //    allowOutsideClick: false,
            //    closeOnClickOutside: false,
            //    text: "Please Enable your location or Use Zipcode"
            //});
            return
        }
        if ((this.state.PickupVendor.toUpperCase() == "W W GRAINGER" && this.state.pickupcheck == true) || this.state.Choose_Delivery_Btn_Click) { //WW-687_PC_16 (4/19/2023)-Aparna
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            if (this.state.GraingerStore.length > 0) {
                /*[03/10/22, PC_02,A1QA-145], Priyanka D */
                //const CurrentLocation = { lat: CurrentLatitude, long: CurrentLongitude };
                /*[04/04/22,A1QA-145],Binding distance from the zipcode response, Priyanka D */
                console.log("GraingerStore", this.state.GraingerStore);
                let graingerdetail = this.state.GraingerStore.sort((a, b) =>
                    a.distance > b.distance ? 1 : -1).map((iresult, index) => {
                        if (iresult != null && iresult != undefined) {
                            //WW-452_PC_04 pickup bind N/A Pavithra R
                            let colr = ""
                            if (iresult.availablity == "Green") {
                                colr = "Green"
                            }
                            else if (iresult.availablity == "Orange") {
                                colr = "Orange"
                            }
                            let arr1 = ""
                            if (iresult.distance != null) {
                                arr1 = iresult.address1 + "," + iresult.state + "~" + iresult.distance + " " + "miles"
                            }
                            else {
                                arr1 = iresult.address1 + "," + iresult.state + "~" + " " + "N/A"
                            }
                            let val = iresult.branchId
                            let localArray = {
                                value: val,
                                label: arr1,
                                color: colr
                            }
                            Pick.push(localArray);
                            //}
                        }
                    });
                this.setState({
                    Pick: Pick
                })
                if (this.state.Choose_Delivery_Btn_Click) { //WW-687_PC_16 (4/19/2023)-Aparna

                    let ind = this.state.supplier_PageNo - 1
                    let { supplierList } = this.state
                    supplierList[ind].pickupStore = this.state.Pick
                    this.setState({ supplierList })
                }
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Pickup is not availble for these items"
                });
                // alert("Pickup is not availble for these items");
                // $("#pickupcheck").prop("checked", false);
                this.setState({ pickupcheck: false });
            }
        }
        else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            if (this.state.PickupStore) {
                let curlat = 0;
                let curlong = 0;
                let billtostore = this.state.BilltoStoreLocation;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(getLatLon);
                    function getLatLon(position) {
                        curlat = position.coords.latitude;
                        curlong = position.coords.longitude;
                    }
                } else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please allow the website to access your location!!"
                    });
                    // alert("Please allow the website to access your location!!")
                    return;
                }
                if (billstore != "" && billstore != undefined) {
                    if (billstore.substring(0, 2) == "WT") {
                        curlat = this.state.curtrucklat;
                        curlong = this.state.curtrucklong;
                    }
                }
                let values = this.state.Pick;
                values.forEach((val) => {
                    values.splice(val);
                })
                this.setState({
                    Pick: values
                });
                /*[03/10/22, PC_02,A1QA-145], Priyanka D */
                const CurrentLocation = { lat: CurrentLatitude, long: CurrentLongitude };
                //WW-718_PC_02 -Aparna
                let goLocalObject = [];
                if (this.state.PickupVendorID == "W999999999") {
                    this.state.PickupStore.sort((a, b) =>
                        (DistanceCalculator.calculate(CurrentLocation, { lat: a.LATITUDE, long: a.LONGITUDE }) * 0.00062137) > (DistanceCalculator.calculate(CurrentLocation, { lat: b.LATITUDE, long: b.LONGITUDE }) * 0.00062137) ? 1 : -1).map((iresult, index) => {
                            if (iresult != null && iresult != undefined) {

                                let arr1 = ""
                                if (iresult.LATITUDE != null && iresult.LATITUDE != undefined && iresult.LONGITUDE != null && iresult.LONGITUDE != undefined && CurrentLatitude != null && CurrentLongitude != null) {
                                    let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.LATITUDE, long: iresult.LONGITUDE })

                                    let dis = (dis1 * 0.00062137).toFixed(2)
                                    if (dis <= 200) {
                                        arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + dis + " " + "miles"

                                        let val = iresult.VNDR_LOC
                                        let localArray = {
                                            value: val,
                                            label: arr1,
                                            color: "Beige"
                                        }
                                        if (arr1.toUpperCase().startsWith("GO LOCAL")) {
                                            goLocalObject.push(localArray)
                                        } else {
                                            Pick.push(localArray);
                                        }
                                    }

                                }

                            }

                        });

                    if (goLocalObject != undefined && goLocalObject != null) {
                        if (goLocalObject.length > 0) {
                            Pick = [...goLocalObject, ...Pick]
                            this.setState(Pick);
                        } else {
                            this.setState({
                                Pick: Pick
                            })
                        }

                    } else {
                        this.setState({
                            Pick: Pick
                        })
                    }



                    if (Pick.length == 0) {
                        document.getElementById('StatusMsg1').innerText = "No Pick-up location available within 200 miles for your location"
                        document.getElementById('StatusMsg').innerText = "No Pick-up location available within 200 miles for your location"
                        this.setState({ PickupStoreSelected: "" });
                    }


                }



                else {
                    this.state.PickupStore.sort((a, b) =>
                        (DistanceCalculator.calculate(CurrentLocation, { lat: a.LATITUDE, long: a.LONGITUDE }) * 0.00062137) > (DistanceCalculator.calculate(CurrentLocation, { lat: b.LATITUDE, long: b.LONGITUDE }) * 0.00062137) ? 1 : -1).map((iresult, index) => {
                            let arr1 = ""
                            if ((iresult.LATITUDE == null || iresult.LATITUDE == undefined) && (iresult.LONGITUDE == null || iresult.LONGITUDE == undefined) || (CurrentLatitude == null && CurrentLongitude == null)) {
                                arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + " " + "N/A"

                            } //[28/08/2022 WW-452_PC_04] PickupBind Pavithra R 
                            else {
                                let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.LATITUDE, long: iresult.LONGITUDE })
                                let dis = (dis1 * 0.00062137).toFixed(2)
                                arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + dis + " " + "miles"
                            }

                            /*[09/02/22,WW-452_PC_05], Priyanka D */
                            let val = iresult.VNDR_LOC
                            let localArray = {
                                value: val,
                                label: arr1,
                                color: "Beige"
                            }

                            //WW-718_PC_02 -Aparna
                            if (arr1.toUpperCase().startsWith("GO LOCAL")) {
                                goLocalObject.push(localArray)
                            } else {
                                Pick.push(localArray);
                            }
                            //return (<option key={iresult.VNDR_LOC} value={iresult.ADDRESS3}>{`${iresult.ADDRESS1},${iresult.STATE} ${dis} miles`}</option>)
                            //     //



                        });


                    //WW-718_PC_02-Aparna
                    if (goLocalObject != undefined && goLocalObject != null) {
                        if (goLocalObject.length > 0) {
                            Pick = [...goLocalObject, ...Pick]
                            this.setState(Pick);
                        } else {
                            this.setState({
                                Pick: Pick
                            })
                        }

                    } else {
                        this.setState({
                            Pick: Pick
                        })
                    }
                }
            }

        }
        return Pick

    }



    BindHALResponse = () => {
        let hallocation = ShoppingCartStore.HALLocData;
        console.log("hallocation", hallocation)
        if (hallocation.includes("error") || hallocation == undefined) {

            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $("#fedexhal").prop("checked", false);
            // $(`#pickupcheck`).prop('disabled', false);

            if (hallocation.includes("404") || hallocation.includes("400") || hallocation == "") {

                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No Hold At Location found"
                });
                this.setState({ HalLocationSelected: "", EnableShipTo: false, submitbtn: false, displayFedexDrop: false, Radiolocation: false, Radiopincode: false, isPickup: true });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Error Occured Please Try Again Later"
                });
            }
            this.setState({ HalLocationSelected: "", EnableShipTo: false, submitbtn: false, displayFedexDrop: false, Radiolocation: false, Radiopincode: false, isPickup: true });
        }

        else {

            let HalLocationArray = JSON.parse(hallocation);
            let CountryValidate = false;
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            MenuAction.HALMessage();
            let result = HalLocationArray.output.locationDetailList;

            let countrycode = result[0].contactAndAddress.address.countryCode;
            if (localStorage.getItem("HALCountryCode") != null) {
                let HALcountrycode = JSON.parse(localStorage.getItem("HALCountryCode"))

                HALcountrycode.map((val, index) => {
                    if (countrycode == val.COUNTRY_2CHAR) {

                        CountryValidate = true
                    }

                });
            }
            if (CountryValidate == false) {


                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Country Code is not valid"
                });

                $("#fedexhal").prop("checked", false);
                //$(`#pickupcheck`).prop('disabled', false);
                this.setState({ HalLocationSelected: "", EnableShipTo: false, submitbtn: false, displayFedexDrop: false, Radiolocation: false, Radiopincode: false, isPickup: true });
            }
            $(`#${SDIConstants.SDILoader}`).addClass('hide');

            let storetiming = [];
            let locationcapability = [];
            let storedetails = HalLocationArray.output

            let displayFedexDrop = false
            let halstorehours = [];
            let store = "";
            if (result != null) {
                let haladdress = [];
                result.map((val, index) => {
                    locationcapability = val.locationCapabilities;
                    let position = [];
                    let Showaddress = false;
                    locationcapability.map((loc, index) => {
                        if (loc.transferOfPossessionType.includes("HOLD_AT_LOCATION")) {
                            Showaddress = true;

                        }


                    })

                    if (haladdress.length < 5 && Showaddress == true && CountryValidate == true) {
                        storetiming = val.storeHours
                        let storehours = [];

                        let storename = val.contactAndAddress.addressAncillaryDetail.building;
                        if (storename == "" || storename == undefined) {
                            store = "STORE" + " " + ":" + " " + "Not Available" + " ";
                        }
                        else {

                            store = "STORE" + " " + ":" + " " + storename + "  ";
                        }

                        storetiming.map((time, index) => {

                            let day = time.dayOfWeek;
                            let operationalHoursType = time.operationalHoursType;

                            let operationalHours = time.operationalHours;

                            if (operationalHours == "" || operationalHours == undefined) {


                                halstorehours = day + "  " + "~" + "  " + "Currently Closed" + " ";
                            }
                            else {
                                let begins = operationalHours.begins;
                                let ends = operationalHours.ends;
                                halstorehours = day + " " + "-" + "  " + begins + " " + "-" + " " + ends + " ";
                            }
                            storehours.push(halstorehours)
                        })



                        //let storehours = val.contactAndAddress;

                        let city = val.contactAndAddress.address.city;

                        let postalcode = val.contactAndAddress.address.postalCode;
                        let residential = val.contactAndAddress.address.residential;
                        let statecode = val.contactAndAddress.address.stateOrProvinceCode;
                        let unit = val.distance.units;
                        let storephonenumber = val.contactAndAddress.contact.phoneNumber;
                        let value = val.distance.value;
                        let locationid = val.locationId;
                        let streetlines = val.contactAndAddress.address.streetLines[0];
                        let halocations = streetlines + "," + statecode + "~" + " " + value + " " + unit;
                        //      this.state.tooltip =countrycode
                        haladdress.push(halocations)

                        let localarr = {

                            value: streetlines, storehours, store,
                            label: (<div className="d-flex align-items-center sdi-items">
                                <label id="hallocations" className="text-truncate sdi-fedexdropdown"><Trans>{halocations}</Trans></label>
                                <span className="fav-item-title">
                                    <span className="info-container ml-2">
                                        <img className="ml-3" src="Images/info-icon.png" />
                                        <span className="Grid-info-icon text-left sdi-fede-tooltip"><span className="d-block"> Operational Hours </span><p className="mb-2 mt-2">{store} </p>  {storehours}</span>
                                    </span>
                                </span>

                            </div>
                            )


                        }
                        let locHalArr = this.state.Halloc;
                        locHalArr.push(localarr);
                        displayFedexDrop = true
                        this.setState({
                            displayFedexDrop: displayFedexDrop, hallocaddress: result, halocations: halocations, halstorehours: storehours, HalStore: storename, Halloc: locHalArr
                        })



                    }
                });
            }

        }

    }
    BindHAL = (shiptoLat, shiptoLong) => {

        let shiptoLatitude = shiptoLat;
        let shiptoLongitude = shiptoLong;
        console.log("SHIPTOLAT", shiptoLatitude, shiptoLongitude)
        let address = {
            address: {
                countryCode: "  "
            },
            longLat: {
                latitude: shiptoLatitude,
                longitude: shiptoLongitude,

            }
        }

        let distance = {
            distance: {
                units: "",
                value: 0,
            }
        }


        this.setState(
            { Halloc: [], HalLocationSelected: [], HalSelectedOphrs: [] });



        let GetLocBO = {
            "locationsSummaryRequestControlParameters": distance,
            "locationSearchCriterion": "GEOGRAPHIC_COORDINATES",
            "location": address,

        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ShoppingCartAction.BindHALocations(GetLocBO);


    }
    //FedexOnChange = (e, type) => {
    //    switch (type) {
    //        case "location": {
    //            if (navigator.geolocation) {
    //                navigator.geolocation.getCurrentPosition(getLatLon);
    //                function getLatLon(position) {
    //                    CurrentLatitude = position.coords.latitude;
    //                    CurrentLongitude = position.coords.longitude;
    //                }
    //            }
    //            if ((CurrentLatitude == 0 || CurrentLatitude == undefined) && (CurrentLatitude == 0
    //                || CurrentLatitude == undefined)) {
    //                document.getElementById("HOLDATLOC").innerText = "Please Allow to access your location"

    //            }
    //            else {
    //                $('#Holdatlocation').modal('hide');
    //                this.BindHAL()
    //                $("#OLWorkOrderTB").addClass("disabledbutton");
    //                $(`#pickupcheck`).prop('disabled', true);
    //                document.getElementById('StatusMsg').innerText = ""
    //                document.getElementById('StatusMsg1').innerText = ""

    //                this.setState({ Checkedbillto: false, EnableShipTo: true, submitbtn: false, Radiolocation: true, Radiopincode: false })
    //                    ;
    //            }
    //            break;

    //        }
    //        case "pincode": {
    //            $('#Holdatlocation').modal('hide');
    //            $(`#${SDIConstants.SDILoader}`).addClass('hide');
    //            $(`#pickupcheck`).prop('disabled', true);
    //            $("#OLWorkOrderTB").addClass("disabledbutton");
    //            this.setState({ Checkedbillto: false, EnableShipTo: true, submitbtn: false, Radiopincode: true, Radiolocation: false, countrycode: "", zipCode: "" })
    //            $('#Zipcodeno').val('');


    //            document.getElementById("HOLDATLOC").innerText = ""
    //            document.getElementById("PostalCodeErrorId").innerText = ""
    //            document.getElementById("CountrycodeErrorId").innerText = ""
    //            $('#PostalCode').modal('show');
    //            break;
    //        }
    //    }
    //}



    HoldatlocationOnClick = (e) => {

        if (e.target.checked) {
            let shiptoLat = this.state.shiptoLat;
            let shiptoLong = this.state.shiptoLong

            this.BindHAL(shiptoLat, shiptoLong)
            // $(`#pickupcheck`).prop('disabled', true)
            this.setState({ HalLocationChecked: true, isPickup: false })
        }
        else {
            if (document.getElementById('StatusMsg1') != undefined) {
                document.getElementById('StatusMsg1').innerText = ""
            }
            if (document.getElementById('StatusMsg') != undefined) {
                document.getElementById('StatusMsg').innerText = ""
            }
            let CartItemsValue = this.state.CartItems;
            let cartdata = CartItemsValue;
            let pickupdata = this.state.pickup_vendor;
            let pickupcount = 0;
            let pickupcheckbox = false;
            let pickupvendor = "";
            let pickupvendorid = "";
            if (pickupdata.length != 0 && cartdata.length != 0) {
                pickupdata.forEach((val, index) => {
                    //A1QA-150_PC_02 (3/25/2022)-Aparna
                    CartItemsValue.filter((x) => x.SupplierID == CartItemsValue[0].SupplierID && val.VENDOR_ID == x.SupplierID && val.BUSINESS_UNIT_OM == "I0W01").map((i) => { pickupcount += 1; })
                })

                if (CartItemsValue.length == pickupcount) {
                    //  $(`#pickupcheck`).prop('disabled', false)
                    //
                    pickupcheckbox = true;
                    pickupdata.map((val, index) => {
                        if (val.VENDOR_ID == cartdata[0].SupplierID) {
                            //
                            pickupvendor = val.NAME1;
                            pickupvendorid = val.VENDOR_ID;
                        }
                    });
                }
            }

            let pickuploc = "";
            let loclowesitem = false;
            let punchoutcount = 0;
            let checkedbillto = true; //WW-673_PC_BL_02
            let enableshipto = false;
            if (this.state.CartItems != undefined && this.state.CartItems != null) {
                if (this.state.CartItems.length > 0) {
                    this.state.CartItems.map((val, index) => {
                        if (val.PaintColor == "PUNCHOUT" && val.SupplierID == "W000000091") {
                            // $("#pickupcheck").prop("checked", true);
                            punchoutcount = punchoutcount + 1;
                        }
                    });
                    if (this.state.CartItems.length == punchoutcount) {
                        //$("#pickupcheck").prop("checked", true);
                        pickuploc = true
                        loclowesitem = true;
                        checkedbillto = false;//WW-673_PC_BL_02
                        enableshipto = true;
                    }
                    else {
                        // $("#pickupcheck").prop("checked", false);
                        pickuploc = false
                    }
                }
                if (this.state.CartItems.length == 0) {
                    // $("#pickupcheck").prop("checked", false);
                    pickuploc = true
                }
            }
            let locispickupcheck = true
            if (this.state.isWorkToStoreValid) {
                locispickupcheck = false
            }

            let pickupstore = [];
            if (this.state.pickupstore_tbl && pickupvendor != "") {
                this.state.pickupstore_tbl.map((storeval, index) => {
                    if (storeval.NAME1.toUpperCase() == pickupvendor.toUpperCase()) {
                        let localArray = {
                            ADDRESS3: storeval.ADDRESS3,
                            VNDR_LOC: storeval.VNDR_LOC,
                            ADDRESS1: storeval.ADDRESS1,
                            CITY: storeval.CITY,
                            STATE: storeval.STATE,
                            POSTAL: storeval.POSTAL,
                            PHONE: storeval.PHONE,
                            NAME1: storeval.NAME1,
                            LATITUDE: storeval.LATITUDE,
                            LONGITUDE: storeval.LONGITUDE/*[05/04/22,WW-243-Pickup miles is binded as Nan], Priyanka D */
                        }
                        pickupstore.push(localArray)
                    }
                })
            }

            //[2/10/22], PC_SC_04, WW-330, Dhevanesam R
            let PickEnBenStoreVal
            let WillCallboolVal = false
            let CartitemListArrBen = CartItemsValue.filter((x) => x.hasInvSupplierID == true)
            if (CartitemListArrBen.length == CartItemsValue.length) {
                //
                PickEnBenStoreVal = true
            }
            else {
                PickEnBenStoreVal = false
            }
            this.BentonvilleStore_Check()
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            this.setState({
                HalLocationChecked: false, HalLocationSelected: "", PickupStore: pickupstore, pickupcheck: pickuploc, lowesitem: loclowesitem, isAllItem_are_Inv: PickEnBenStoreVal,
                PickupVendor: pickupvendor, PickupVendorID: pickupvendorid, isAllItem_are_Pickup: pickupcheckbox, EnableShipTo: false, submitbtn: false, Halloc: [], displayFedexDrop: false, PickupStoreSelected: "", pickupcheck: false,
                Radiopincode: false, Radiolocation: false, hallocaddress: [], Checkedbillto: checkedbillto, EnableShipTo: enableshipto, isPickup: locispickupcheck//WW-673_PC_BL_02
            });
            // $(`#pickupcheck`).prop('disabled', false)


        }
    }


    pickupchange = (e) => {
        //
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let isRefrigerantInCart = this.isRefrigerantItemInCart(this.state.CartItems)
        if (e.target.checked) {
            let pickupcheckVal = ""
            let values = this.Bindpickupstore()
            $(`#fedexhal`).prop('disabled', true)
            this.setState({ displayFedexDrop: false })
            // let values = this.state.Pick;
            if (values != [] && values != "" && values != undefined && values != null) {
                let filterArray = values.filter((ele, ind) => ind === values.findIndex(elem => elem.label === ele.label))
                this.setState({
                    Pick: filterArray
                });
            }
            let billstore = this.state.BilltoStore.value;

            //
            $("#OLWorkOrderTB").addClass("disabledbutton");
            if (this.state.PickupVendor != "" && this.state.PickupVendor != undefined) {
                if (this.state.PickupVendor.toUpperCase() == "W W GRAINGER" || this.state.truckstore == true) {
                    $('#ZipCode').modal('show');
                    $('#ZipCode_no').val('');
                    pickupcheckVal = "PU"
                    this.setState({ pickupcheck: true, Checkedbillto: false, EnableShipTo: false, submitbtn: false }); {/*EnableShipTo: false*/ }
                }
                else {
                    //if ($(`#OLWorkOrderTB`).val() != "" && $(`#OLWorkOrderTB`).val() != undefined) {
                    //    this.Newpickupchange();
                    //}
                    pickupcheckVal = "PU"
                    this.setState({ pickupcheck: true, Checkedbillto: false, EnableShipTo: false, submitbtn: false });
                }
                if (billstore != "" && billstore != undefined && billstore != null) {
                    if (billstore.substring(0, 2) == "WT") {
                        $('#ZipCode').modal('show');
                        $('#ZipCode_no').val('');
                    }
                }
            }
            else {
                if (this.state.Bentonville_WO == true && this.state.isAllItem_are_Inv == true) {
                    pickupcheckVal = "PU"
                    this.setState({ pickupcheck: true });
                }
                else {
                    pickupcheckVal = ""
                    this.setState({ pickupcheck: false });
                }
            }

            let shiptoLat = "";
            let shiptoLong = "";
            let defaultshipto = [];
            if (CookieService.getLocalStorageValues("Session_ISAShipToID") != null && CookieService.getLocalStorageValues("Session_ISAShipToID") != "" && CookieService.getLocalStorageValues("Session_ISAShipToID") != undefined && CookieService.getLocalStorageValues("Session_ISAShipToID") != " ") {
                /*[05/13/22,WW-243]Pickup Issue, Priyanka D */



                if (this.state.ShipToDDValue != null && this.state.ShipToDDValue != undefined) {
                    if (this.state.ShipToDDValue.length > 0) {
                        this.state.ShipToDDValue.filter((item, index) => item.value == CookieService.getLocalStorageValues("Session_ISAShipToID")).map((i) => {

                            let localArray = {
                                value: i.value,
                                label: i.label,
                            }
                            defaultshipto = localArray


                        })


                    }
                    if (this.state.shiptoDropdown != null && this.state.shiptoDropdown != undefined) {
                        if (this.state.shiptoDropdown.length > 0) {
                            this.state.shiptoDropdown.filter((item, index) => item.CUSTID == CookieService.getLocalStorageValues("Session_ISAShipToID")).map((i) => {
                                shiptoLat = i.LATITUDE;
                                shiptoLong = i.LONGITUDE;

                            })


                        }
                    }
                }
            }

            else {
                defaultshipto = this.state.BilltoStore
                if (localStorage.getItem("BilltoStoreLocationLat") != undefined && localStorage.getItem("BilltoStoreLocationLong") != undefined) {
                    shiptoLat = localStorage.getItem("BilltoStoreLocationLat");
                    shiptoLong = localStorage.getItem("BilltoStoreLocationLong");
                }
            }


            //
            let displayPickDropVal = false
            let EnableShipToVal = false
            let CheckedbilltoVal = false
            let BenPickLblVal = ""
            if (pickupcheckVal == "PU" && this.state.lowesitem == false) {
                EnableShipToVal = false
                CheckedbilltoVal = false
                //
                if (this.state.Bentonville_WO == false && this.state.isAllItem_are_Inv == false) {
                    displayPickDropVal = true
                }
                else if (this.state.Bentonville_WO == true && this.state.isAllItem_are_Inv == false) {
                    displayPickDropVal = true
                }
                else if (this.state.Bentonville_WO == false && this.state.isAllItem_are_Inv == true) {
                    displayPickDropVal = true
                }
                else if (this.state.Bentonville_WO == true && this.state.isAllItem_are_Inv == true) {
                    displayPickDropVal = false
                    if (CookieService.getLocalStorageValues("Bentonville_Address") != null && this.state.WONUM != "") {
                        //BenPickLblVal = JSON.parse(localStorage.getItem("BenPickLbl"))
                        //
                        BenPickLblVal = CookieService.getLocalStorageValues("Bentonville_Address")
                    }
                }
                //    if ((CurrentLatitude == null || CurrentLongitude == null) && this.state.PickupVendorID == "W999999999") {

                //}

                this.setState({ displayPickDrop: displayPickDropVal, defaultShipto: defaultshipto, shiptoLat: shiptoLat, shiptoLong: shiptoLong, EnableShipTo: EnableShipToVal, Checkedbillto: CheckedbilltoVal, submitbtn: false, BenPickLbl: BenPickLblVal });
            }
        }
        else {
            // this.setState({ });
            if (isRefrigerantInCart[0]) {
                this.setState({ pickupcheck: false, Checkedbillto: false, EnableShipTo: false, submitbtn: false, displayPickDrop: false, BenPickLbl: "" });
            } else {
                this.setState({ PickupStoreSelected: "", pickupcheck: false, Checkedbillto: true, EnableShipTo: false, submitbtn: false, displayPickDrop: false, BenPickLbl: "" });
                $(`#fedexhal`).prop('disabled', false)
                if (document.getElementById('StatusMsg1') != undefined) {
                    document.getElementById('StatusMsg1').innerText = ""
                }
                if (document.getElementById('StatusMsg') != undefined) {
                    document.getElementById('StatusMsg').innerText = ""
                }
                //if (this.state.isWorkToStoreValid == false) {
                //    $("#OLWorkOrderTB").removeClass("disabledbutton");
                //}
            }

        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    Newpickupchange = () => {
        let OLWorkOrder = $('#OLWorkOrderTB').val();
        let THIRDPARTY_COMP_ID = ""
        if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
            THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
        }
        let BO = {
            workOrder: OLWorkOrder,
            Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
            User_Type: CookieService.getLocalStorageValues("Session_SDIEMP") //WW-336 - PC_02 CBRE WO# validation is not working for SDI Users(1/ 18 / 2022)  -Aparna
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ShoppingCartAction.WorkOrderCheck(BO);
    }
    distancebind = (lat, long) => {
        let billtostore = this.state.BilltoStoreLocation;
        let curlat
        let curlong
        //if (lat != undefined && long != undefined) {
        //    curlat = lat;
        //    curlong = long;
        //}
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getLatLon);
            function getLatLon(position) {
                curlat = position.coords.latitude;
                curlong = position.coords.longitude;
            }
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please allow the website to access your location!!"
            });
            //alert("Please allow the website to access your location!!")
            return;
        }
        //navigator.geolocation.getCurrentPosition(function (position) {
        //    curlat = position.coords.latitude;
        //    curlong = position.coords.longitude;
        //});

        if (this.state.PickupVendor.toUpperCase() == "W W GRAINGER" && this.state.pickupcheck == true) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            if (this.state.GraingerStore.length > 0) {
                /*[03/10/22, PC_02,A1QA-145], Priyanka D */
                //const CurrentLocation = { lat: CurrentLatitude, long: CurrentLongitude };
                /*[04/04/22,A1QA-145],Binding distance from the zipcode response, Priyanka D */
                return this.state.GraingerStore.sort((a, b) =>
                    a.distance > b.distance ? 1 : -1).map((iresult, index) => {
                        if (iresult != null && iresult != undefined) {
                            if (iresult != null && iresult != undefined) {
                                //let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.latitude, long: iresult.longitude })
                                //let dis = (dis1 * 0.00062137).toFixed(2)
                                let colr = ""
                                if (iresult.availablity == "Green") {
                                    colr = "Green"
                                }
                                else if (iresult.availablity == "Orange") {
                                    colr = "Orange"
                                }
                                let arr1 = iresult.address1 + "," + iresult.state + "~" + iresult.dis + " " + "miles"
                                let val = iresult.branchId
                                let localArray = {
                                    value: val,
                                    label: arr1,
                                    color: colr
                                }
                                this.state.Pick.push(localArray);
                            }
                        }
                    });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Pickup is not availble for these items"
                });
                // alert("Pickup is not availble for these items");
                // $("#pickupcheck").prop("checked", false);
                this.setState({ pickupcheck: false });
            }
        }
        else {
            if (this.state.PickupStore) {
                let curlat = 0;
                let curlong = 0;
                let billtostore = this.state.BilltoStoreLocation;
                //if (lat != undefined && long != undefined) {
                //    curlat = lat;
                //    curlong = long;
                //}
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(getLatLon);
                    function getLatLon(position) {
                        curlat = position.coords.latitude;
                        curlong = position.coords.longitude;
                    }
                } else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please allow the website to access your location!!"
                    });
                    //  alert("Please allow the website to access your location!!")
                    return;
                }
                let values = this.state.Pick;
                values.forEach((val) => {
                    values.splice(val);
                })
                //this.setState({
                //    Pick: values
                //});
                /*[03/10/22, PC_02,A1QA-145], Priyanka D */
                const CurrentLocation = { lat: CurrentLatitude, long: CurrentLongitude };
                return this.state.PickupStore.sort((a, b) =>
                    (DistanceCalculator.calculate(CurrentLocation, { lat: a.LATITUDE, long: a.LONGITUDE }) * 0.00062137) > (DistanceCalculator.calculate(CurrentLocation, { lat: b.LATITUDE, long: b.LONGITUDE }) * 0.00062137) ? 1 : -1).map((iresult, index) => {
                        if (iresult != null && iresult != undefined) {
                            let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.LATITUDE, long: iresult.LONGITUDE })
                            let dis = (dis1 * 0.00062137).toFixed(2)
                            let arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + dis + " " + "miles"

                            /*[09/02/22,WW-452_PC_05], Priyanka D */
                            let val = iresult.VNDR_LOC
                            let localArray = {
                                value: val,
                                label: arr1,
                                color: "Beige"
                            }
                            this.state.Pick.push(localArray);
                            //return (<option key={iresult.VNDR_LOC} value={iresult.ADDRESS3}>{`${iresult.ADDRESS1},${iresult.STATE} ${dis} miles`}</option>)
                            //     //
                            console.log("pick", this.state.Pick)
                        }
                    });
                //this.setState({
                //    Pick: values
                //});
            }
        }
    }
    //HalPostalClick = () => {

    //    let HalPostalCode = this.state.zipCode
    //    let CountryCode = this.state.countrycode.value
    //    if (HalPostalCode != "" && HalPostalCode.length == 5 && CountryCode != "" && CountryCode != undefined && HalPostalCode != undefined) {

    //        document.getElementById("PostalCodeErrorId").innerText = ""


    //        document.getElementById("CountrycodeErrorId").innerText = ""
    //        $('#PostalCode').modal('hide')
    //        if (this.state.Haldisplay == "HAL") {


    //            let location = {
    //                address: {
    //                    postalCode: HalPostalCode,
    //                    countryCode: CountryCode
    //                },

    //            }
    //            let GetPostalLocBO = {
    //                "location": location,
    //            }

    //            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    //            ShoppingCartAction.BindPostalCodeHALocations(GetPostalLocBO)
    //        }
    //    }




    //    else {
    //        if (HalPostalCode == "" || HalPostalCode.length <= 4 || HalPostalCode == undefined) {

    //            document.getElementById("PostalCodeErrorId").innerText = "Please Enter a valid Zip Code"
    //        }
    //        else {
    //            document.getElementById("PostalCodeErrorId").innerText = ""
    //        }

    //        if (CountryCode == "" || CountryCode == null || CountryCode == undefined) {
    //            document.getElementById("CountrycodeErrorId").innerText = "Please select the Country Code"
    //        }
    //        else {
    //            document.getElementById("CountrycodeErrorId").innerText = ""
    //        }


    //    }

    //}
    //holdatlocclose = () => {

    //    $('#Holdatlocation').modal('hide');
    //    this.setState({ HalLocationSelected: "", Checkedbillto: true, EnableShipTo: false, submitbtn: false, displayFedexDrop: false, Radiolocation: false, Radiopincode: false, PickupStoreSelected: "", pickupcheck: "" });
    //    $(`#pickupcheck`).prop('disabled', false)

    //    document.getElementById("HOLDATLOC").innerText = ""
    //    $("#fedexhal").prop("checked", false);
    //}

    ZipCodeClick = (zipcode) => {
        //
        let postal_code = "" //WW-687_PC_14 (4/19/2023)-Aparna
        if (this.state.Choose_Delivery_Btn_Click) {
            if (zipcode != undefined && zipcode != null && zipcode != "") {
                postal_code = zipcode
            }
            else {
                postal_code = $('#suplidelivery_zipcode').val();
            }
        } else {
            postal_code = $('#ZipCode_no').val();
        }
        if (postal_code != "") {
            $('#ZipCode').modal('hide');
            if ((this.state.PickupVendor.toUpperCase() == "W W GRAINGER" && this.state.pickupcheck == true) || this.state.Choose_Delivery_Btn_Click) {//WW-687_PC_14 (4/19/2023)-Aparna
                let graingeritem = [];
                this.state.CartItems.map((storeval, index) => {
                    if (storeval.SupplierID == "W000000036") { //WW-687_PC_14 (4/19/2023)-Aparna
                        let localArray = {
                            /*[02/18/22, PC_01 WW-356], Priyanka D, Passing Supplierpartnumber to ItemId*/
                            GraingerItemID: storeval.SupplierPartNumber,
                            GraingerQuantity: storeval.Quantity
                        }
                        graingeritem.push(localArray)
                    }
                });
                let graingerBO = {
                    postalCode: postal_code,
                    graingerItems: graingeritem
                }
                if (this.state.Choose_Delivery_Btn_Click) {
                    $(`#splitDelivery_Loader`).removeClass('d-none');
                    $(`#splitDelivery_BodyContent`).addClass('d-none');

                } else {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                }

                ShoppingCartAction.GraingerItem(graingerBO);
            }
            else if (this.state.BilltoStore.value != "" && this.state.BilltoStore.value != null && this.state.BilltoStore.value != undefined) {
                if (this.state.BilltoStore.value.substring(0, 2) == "WT") {
                    let zipcodeBO = {
                        ZipCode: postal_code
                    }
                    ShoppingCartAction.Gettrucklatlong(zipcodeBO);
                }
                //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
                //
                // this.Bindpickupstore()
            }
        }
        else {
            // $("#pickupcheck").prop("checked", false);
            this.setState({ pickupcheck: false });
            document.getElementById("ZipCodeErrorId").innerText = "Please Enter a valid Zip Code"
        }

    }
    //OnHandleCountryCode = (values) => {

    //    //const re = SDIConstants.CountryCodereg;
    //    //if (re.test(e.target.value) || e.target.value === ' ' || e.target.value === '') {
    //    this.setState({ countrycode: values })
    //    //}
    //}
    //OnHandleZipCode = (e) => {
    //    const re = SDIConstants.zipcodeRegEx;
    //    if (re.test(e.target.value) || e.target.value === ' ' || e.target.value === '') {
    //        this.setState({ zipCode: e.target.value })
    //    }
    //}

    ZipCodeClose = () => {
        if (this.state.userZipCode) {
            document.getElementById("ZipCodeErrorId").innerText = ""
            $('#ZipCode_no').val('');
        } else {
            document.getElementById("ZipCodeErrorId").innerText = ""
            // $(`#pickupcheck`).prop('disabled', false)
            // $("#pickupcheck").prop("checked", false);
            $("#fedexhal").prop("checked", false);
            this.setState({ pickupcheck: false, EnableShipTo: false, Checkedbillto: true, Radiopincode: false, Radiolocation: false, isPickup: true, userZipCode: false });//A1QA-150_PC_01(when we close zipcode popup the shipto dropdown still in disable mode) -Aparna
        }

    }
    operationalpopclose = () => {
        $('#operationalhrs').modal('hide');
    }
    handleStoreChange = (values) => {
        //
        //let sample= $("#pickupstore_DD option:selected").text();
        console.log("checking grainger", this.state.PickupVendor);
        console.log("GraingerStore", this.state.GraingerStore);
        console.log("GraingerQTY", this.state.GraingerQTY);
        console.log("GraingerQTY value", values);
        //if (this.state.PickupVendor != "" && this.state.PickupVendor != undefined && this.state.PickupVendor != null) {
        //    if (this.state.PickupVendor.toUpperCase() == "W W GRAINGER") {
        //        let 
        //        this.setState({ Graingermsg})
        //    }
        //}
        document.getElementById('StatusMsg1').innerText = ""
        this.setState({ PickupStoreSelected: values });
    }
    handleHalLocationChange = (values, storetime) => {
        let HalLocationSelected = [];
        let localarray = {
            label: values.value,
            value: values.value
        }
        HalLocationSelected.push(localarray)
        this.setState({ HalLocationSelected: HalLocationSelected, HalSelectedOphrs: values });
        if (document.getElementById('StatusMsg1') != undefined) {
            document.getElementById('StatusMsg1').innerText = ""
        }
        if (document.getElementById('StatusMsg') != undefined) {
            document.getElementById('StatusMsg').innerText = ""
        }
        let storetiming = [];



        this.operationalhrs()


    }

    operationalhrs = () => {

        $('#operationalhrs').modal('show');


    }

    Graingerdata = () => {
        let response = JSON.parse(ShoppingCartStore.graingerdata);

        let errormsg = "Grainger stores are updated based on the entered zipcode"
        let ind = this.state.supplierList.findIndex((x) => x.supplier_ID == "W000000036")

        if (response == "") {
            if (this.state.Choose_Delivery_Btn_Click) {  //WW-687_PC_16 (4/19/2023)-Aparna

                // document.getElementById(`splitdelivery_Zipcode_Error-${ind}`).innerText = "Please enter a valid zip code"

                $(`#splitDelivery_Loader`).addClass('d-none');

                $(`#splitDelivery_BodyContent`).removeClass('d-none');

                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                let { supplierList } = this.state;

                let supplierPickupStoreUpdate = supplierList.find(x => x.supplier_ID == "W000000036")

                supplierPickupStoreUpdate.pickupStore = []

                supplierPickupStoreUpdate.pickupLocation = []

                this.setState({ supplierList, splitdelivery_Zipcode_Error: "Please enter a valid zip code" })

            } else {

                document.getElementById("ZipCodeErrorId").innerText = "Please enter a valid zip code"

                window.stop()

                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                $('#ZipCode').modal('show');

            }

        }



        else if (response == "Failure") {

            if (this.state.Choose_Delivery_Btn_Click) {  //WW-687_PC_16 (4/19/2023)-Aparna

                //  document.getElementById(`splitdelivery_Zipcode_Error-${ind}`).innerText = "Please enter a valid zip code"

                //this.setState({ splitdelivery_Zipcode_Error: "Please enter a valid zip code" })

                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                $(`#splitDelivery_Loader`).addClass('d-none');

                $(`#splitDelivery_BodyContent`).removeClass('d-none');

                let { supplierList } = this.state;

                let supplierPickupStoreUpdate = supplierList.find(x => x.supplier_ID == "W000000036")

                supplierPickupStoreUpdate.pickupStore = []

                supplierPickupStoreUpdate.pickupLocation = []

                this.setState({ supplierList, splitdelivery_Zipcode_Error: "Please enter a valid zip code" })

            } else {

                document.getElementById("ZipCodeErrorId").innerText = "Error in processing zip code"

                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                // $(`#splitDelivery_Loader`).addClass('d-none');

                $('#ZipCode').modal('show');

            }

        } else {

            let PickupList = [];

            let GraingerQTY = [];

            let GraingerStore = []

            PickupList = JSON.parse(response);

            // document.getElementById(`splitdelivery_Zipcode_Error-${ind}`).innerText = ""

            if (this.state.isGraingerrZipCodeChange) {

                this.setState({ splitdelivery_Zipcode_Error: errormsg })

            } else {

                this.setState({ splitdelivery_Zipcode_Error: "" })

            }

            PickupList.Pickup.map((i) => {

                if (i.branch != null && i.branch != "") { //WW-595_PC_01 (1/23/2023)-Aparna

                    if (i.allAvailable == "Y") {

                        i.items.map((j) => {

                            let graingerqty = {

                                branchId: i.branchId,

                                itemId: j.itemId,

                                quantityRequested: j.quantityRequested,

                                quantityAvailable: j.quantityAvailable,

                                msg: j.rtaMessage

                            }

                            GraingerQTY.push(graingerqty);

                        });

                        let graingerStore = {

                            branchId: i.branchId,

                            address1: i.branch.branchAddress.address1,

                            city: i.branch.branchAddress.city,

                            postalcode: i.branch.branchAddress.postalcode,

                            state: i.branch.branchAddress.state,

                            latitude: i.branch.latitude,

                            longitude: i.branch.longitude,

                            availablity: "Green",

                            distance: i.branch.distance

                        }

                        GraingerStore.push(graingerStore);

                    }

                    //***********(loc)*********

                    else {

                        let checkqty = true;

                        i.items.map((j) => {

                            //if (j.quantityAvailable > 0) {



                            let graingerqty = {

                                branchId: i.branchId,

                                itemId: j.itemId,

                                quantityRequested: j.quantityRequested,

                                quantityAvailable: j.quantityAvailable,

                                msg: j.rtaMessage

                            }

                            GraingerQTY.push(graingerqty);

                            // }

                        });

                        let graingerStore = {

                            branchId: i.branchId,

                            address1: i.branch.branchAddress.address1,

                            city: i.branch.branchAddress.city,

                            postalcode: i.branch.branchAddress.postalcode,

                            state: i.branch.branchAddress.state,

                            latitude: i.branch.latitude,

                            longitude: i.branch.longitude,

                            availablity: "Orange",

                            distance: i.branch.distance

                        }

                        GraingerStore.push(graingerStore);

                    }

                }

                //***************END********************

            });

            if (GraingerStore.length != 0) {

                this.setState({ GraingerStore: GraingerStore, GraingerQTY: GraingerQTY });

                //

                // $("#pickupcheck").prop("checked", true);

                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                this.Bindpickupstore()

                if (this.state.Choose_Delivery_Btn_Click) { //WW-687_PC_16 (4/19/2023)-Aparna

                    let ind = this.state.supplier_PageNo - 1

                    let { supplierList } = this.state

                    supplierList[ind].pickupStore = this.state.Pick

                    this.setState({ supplierList })



                    //document.getElementById(`splitdelivery_Zipcode_Error-${ind}`).innerText = ""

                    if (this.state.isGraingerrZipCodeChange) {

                        this.setState({ splitdelivery_Zipcode_Error: errormsg })

                    } else {

                        this.setState({ splitdelivery_Zipcode_Error: "" })

                    }

                    $(`#${SDIConstants.SDILoader}`).addClass('hide');

                    $(`#splitDelivery_Loader`).addClass('d-none');

                    $(`#splitDelivery_BodyContent`).removeClass('d-none');

                } else {

                    document.getElementById("ZipCodeErrorId").innerText = ""

                }



            }

            else {

                document.getElementById("ZipCodeErrorId").innerText = "Please Enter a valid Zip Code"

                window.stop()

                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                $('#ZipCode').modal('show');





            }

        }

        //WW-401_PC_01 Grainger puchout pickup (7/29/2022)-Aparna

        if (this.state.Pick.length == 0) {

            document.getElementById("ZipCodeErrorId").innerText = "Please Enter a valid Zip Code"

            window.stop()

            $(`#${SDIConstants.SDILoader}`).addClass('hide');

            if (!this.state.Choose_Delivery_Btn_Click) {

                $('#ZipCode').modal('show');

            }



        }

        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    workorderfail = () => {
        ////;
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (this.state.submitbtn == true) {

            document.getElementById('StatusMsg').innerText = "Enter Valid Work Order #"
            document.getElementById('StatusMsg1').innerText = "Enter Valid Work Order #"
            document.getElementById('StatusMsgbilltostore').innerText = " "
            this.setState({ submitbtn: false, isValidWO: false, WONUM: "" }) //WAL-1034_PC_34 -Aparna
        } else {

            this.setState({ isWorkToStoreValid: false, submitbtn: false, isValidWO: false, WONUM: "" });//WAL-1034_PC_35 -Aparna
            $("#OLWorkOrderTB").removeClass("disabledbutton");
            document.getElementById('StatusMsgbilltostore').innerText = "Enter Valid Work Order #"
            document.getElementById('StatusMsg1').innerText = " "
            //[9/26/22], Bug - 2664 - To remove validation msg when the work order is valid, Dhevanesam R
            document.getElementById('StatusMsg').innerText = " "

        }
        window.scrollTo(0, 0)
        //this.setState({ ShowOrderDetails:1})
        this.onAccordianClick(0)
    }


    /**********END*************/
    /*
     * RF No: SC_PC_24
     * In this method Ship to drop down is binded.
     * 
     * */
    BuildShipToDD = () => {
        let Defaultship = this.state.defaultShipto;
        let ShiptoText = ""
        let PerferedShipto = this.state.defaultShipto;
        return this.state.ShipToDDValue.map((iresult, index) => {
            //if (iresult != null && iresult != undefined && this.state.ShipToDDValue.length > 1) {
            //    return (<option key={iresult.CUSTID} value={iresult.CUSTID}>{iresult.LOCNAME}</option>)

            //}
            if (this.state.ShipToDDValue.length < 2) {
                // if (CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" || this.state.defaultShipto == undefined) {
                if (this.state.WONUM != "" && localStorage.getItem("StoreValue") != null && localStorage.getItem("StoreValue") != undefined && localStorage.getItem("StoreValue") != "" && localStorage.getItem("StoreValue") != " ") {
                    ShiptoText = iresult.label;
                    console.log("ShiptoText", ShiptoText)
                }
                //} else if (this.state.defaultShipto!=undefined) {
                //    ShiptoText = this.state.defaultShipto.label
                //}
                return (<input type="text" key="1" className="form-control" placeholder="Enter Location" id="ShiptoText" value={ShiptoText} readOnly />)
                //$("#OLShipTo").attr("disabled", "disabled"); 
            }
            // this.setState({ defaultShipto: ShiptoText });
        });

        if (Defaultship != "" && Defaultship != null) {
            $('#OLShipTo').val(Defaultship);
            //document.getElementById("OLShipTo"). = true
        }
        let billtoStore = this.state.BilltoStore;
        if (billtoStore != "" && billtoStore != null) {
            $('#OLShipTo').val(billtoStore);
            this.setState({ defaultShipto: billtoStore });
        }
        //this.setState({ ShiptoText: ShiptoText})
    }
    /*
     * RF No: SC_PC_25
     * In this method Machine drop down is binded.
     * 
     * */
    BuildMachineDD = () => {

        return this.state.MachineTable.map((iresult, index) => {
            if (iresult != null && iresult != undefined && this.state.MachineTable.length > 0) {
                return (<option key={iresult.ISA_MACHINE_NO + " " + iresult.ISA_MACHINE_NO} value={iresult.ISA_MACHINE_NO}>{iresult.ISA_MACHINE_NO}</option>)

            }

        });
    }
    BuildMachinePart = (MachinePart = []) => {
        if (MachinePart.length > 0) {
            return MachinePart.map((iresult, index) => {
                if (iresult != null && iresult != undefined && MachinePart.length > 0) {
                    return (<option key={iresult.ISA_MACHINE_NO} value={iresult.ISA_MACHINE_NO}>{iresult.ISA_MACHINE_NO}</option>)

                }

            });
        }
    }
    BuildTypeDD = () => {

        return this.state.TypeTable.map((iresult, index) => {
            if (iresult != null && iresult != undefined && this.state.TypeTable.length > 0) {
                return (<option key={iresult.ORDER_TYPE} value={iresult.ORDER_TYPE}>{iresult.ORDER_DESC}</option>)

            }

        });
    }
    /*
     * RF No: SC_PC_39
     * In this method edit description pop up is shown with the binded value.
     * 
     * */
    LinelevelDescpEdit = (ItemIDE, UniqIDE, Descrip) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ EditDescPopUp: true, ItemId: ItemIDE, UniqId: UniqIDE, Description: Descrip });
        let ExistDescp = $('#DespNewValue').val();
        $('#DespNewValue').val(Descrip);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#Edit-description').modal('show');
    }
    /*
     * RF No: SC_PC_30 && SC_PC_31 && SC_PC_32 && SC_PC_33 && SC_PC_34 && SC_PC_35 && SC_PC_36 && SC_PC_37 && SC_PC_38 && SC_PC_39
     * In this method all the item level field update is done by using action UpdateItemDesp.
     * 
     * */
    //[1/7/22], PC_SC_01, WW-286, Dhevanesam R
    LinelevelEmyEdit = (ItemIDE, LineNo, fliedTitle, DueDateValue, event) => {
        //
        let UpdateItemDetails;
        let DueIndex;
        let filetoupdate = "";
        let targetval = "";
        let Quantityvalidate = 0
        let LineNoCount = 0
        let Attachmentfilevalidation = true
        let { CartItems } = this.state;
        let cartitemsloc = this.state.CartItems;
        let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.CoreSeq == LineNo);
        if (this.state.AddAttachPUp == true) {
            document.getElementById("AttachError").innerText = ""
        }
        switch (fliedTitle) {
            case "DESCR254": {
                targetval = $('#DespNewValue').val();
                if (targetval != "" && targetval != null) {
                    filetoupdate = "DESCR254"
                    ItemIDE = this.state.ItemId;
                    LineNo = this.state.UniqId;
                    let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                    LineNoCount = CartItems[index].UniqNum
                    document.getElementById("DescriptionValidMsg").innerText = ""
                }
                else {
                    document.getElementById("DescriptionValidMsg").innerText = "Description required for the NSTK item."
                }
                break;
            }
            case "EmployeeCC": {
                let id = "#EmpDD" + LineNo;
                targetval = $(id).val();
                //targetval = event.value;
                filetoupdate = "EMP_CHG_CODE";
                CartItems[index].EmpChgCode = targetval
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = CartItems[index].UniqNum
                // this.setState(CartItems);
                this.setState(CartItems);
                //this.setState({ CartItems: cartitemsloc });
                //this.setState({ CartItems: cartitemsloc});
                break;
            }
            case "DueDate": {
                targetval = DueDateValue;
                filetoupdate = "DUE_DATE";
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "MachineNo": {
                let id = "MachineNo" + LineNo;
                targetval = $('#' + id).val();
                filetoupdate = "MACHINE_ROW";
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = CartItems[index].UniqNum
                //$('#' + id).val(targetval)
                break;
            }
            case "MachinePart": {
                let id = "MachinePart" + LineNo;
                targetval = $('#' + id).val();
                filetoupdate = "ISA_USER_DEFINED_1";
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "PO": {
                let id = "PO" + LineNo;
                targetval = $('#' + id).val();
                filetoupdate = "PO_ID";
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "LN": {
                let id = "LN" + LineNo;
                targetval = $('#' + id).val();
                filetoupdate = "PO_LINE";
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "Notes": {
                //
                let id = "Notes" + LineNo;
                targetval = $('#' + id).val();
                filetoupdate = "ISA_CUST_NOTES";
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "Quantity": {
                //
                //Quantityvalidate = 1
                let id = "Quantity" + LineNo;
                {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/ }
                let tar = 0;
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.CoreSeq == LineNo);
                let MinOrdQty;
                if (CartItems[index].MIN_ORD_QTY == undefined || CartItems[index].MIN_ORD_QTY == "" || CartItems[index].MIN_ORD_QTY == null) {
                    MinOrdQty = "1";
                }
                else {
                    MinOrdQty = CartItems[index].MIN_ORD_QTY;
                }
                tar = $('#' + id).val()
                if (event.currentTarget.value == "+") {
                    tar = parseInt(tar) + parseInt(MinOrdQty);
                } else if (event.currentTarget.value == "-") {
                    tar = parseInt(tar) - parseInt(MinOrdQty);
                }
                targetval = tar;
                LineNoCount = CartItems[index].UniqNum
                filetoupdate = "QUANTITY";
                if (targetval == null || targetval == "") {
                    //targetval = CartItems[index].Quantity
                    let QuantityExit = this.state.PagelaodCartValue[index].Quantity
                    filetoupdate = ""
                    CartItems[index].Quantity = QuantityExit
                    this.setState(CartItems);
                }
                //else {
                //}
                //this.setState(CartItems);
                break;
            }
            case "Priority": {
                //
                let id = "customCheck-16a" + LineNo;
                let { CartItems } = this.state;
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                let ExistValue = CartItems[index].UPriority;
                filetoupdate = "PRIORITY";
                targetval = ExistValue != "R" ? "R" : " ";
                LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "TaxFlag": {
                let { CartItems } = this.state;
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                let ExistValue = CartItems[index].TaxFlag;
                filetoupdate = "TAX_FLAG";
                targetval = ExistValue != "Y" ? "Y" : "0";
                LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "AddToCtg": {
                let { CartItems } = this.state;
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                let ExistValue = CartItems[index].AddToCtlgFlag;
                filetoupdate = "ADD_TO_CTLG";
                targetval = ExistValue != "1" ? "1" : "0";
                LineNoCount = CartItems[index].UniqNum
                break;
            }
            case "Attachment": {
                ItemIDE = this.state.ItemId;
                LineNo = this.state.UniqId;
                let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.UniqNum == LineNo);
                LineNoCount = CartItems[index].UniqNum
                let attachmentStr = "";
                filetoupdate = "FILE_PATH"
                if (this.state.attachmentPathArr != null && this.state.attachmentPathArr != undefined) {
                    if (this.state.attachmentPathArr.length > 0) {
                        attachmentStr = this.state.attachmentPathArr.map(e => e.FilePath).join("|");
                        if (attachmentStr.length > 254) {
                            Attachmentfilevalidation = false
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names."
                            });
                            // alert("You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names.")
                        }
                        else {
                            targetval = attachmentStr
                        }
                    }
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "No file is selected"
                    });
                    // alert("No file is selected")
                }
            }
        }
        if (filetoupdate != "" && Quantityvalidate == 0 && Attachmentfilevalidation == true) {
            UpdateItemDetails = {
                userID: this.state.Login_UserId,
                userBU: this.state.Login_UserBU,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                fldToUpdate: filetoupdate,
                ItemID: ItemIDE,
                LineNum: LineNoCount,
                newValue: targetval
            }
            ShoppingCartAction.UpdateItemDesp(UpdateItemDetails);
            {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/ }
            //if (filetoupdate != "QUANTITY") {
            if (this.state.Choose_Delivery_Btn_Click == false) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            }
            else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
            //}
            //
            if (filetoupdate == "QUANTITY") {
                this.setState({ ItemId: ItemIDE, UniqId: LineNo, ActiveFieldToUpdate: fliedTitle })
            }
            else {
                //
                this.setState({ ItemId: ItemIDE, UniqId: LineNoCount, ActiveFieldToUpdate: fliedTitle })
            }
        }
    }
    QuantityOnchange = (LineNo, ItemIDE, event) => {
        //
        let Quantityvalidate = 1
        //let targetval = "";
        //let id = "Quantity" + LineNo;
        let { CartItems } = this.state;
        let index = CartItems.findIndex(x => x.Itemid == ItemIDE && x.CoreSeq == LineNo);
        // targetval = $('#' + id).val();
        const re = SDIConstants.quantityRegEX;

        let MinOrdQty;
        if (CartItems[index].MIN_ORD_QTY == undefined || CartItems[index].MIN_ORD_QTY == "" || CartItems[index].MIN_ORD_QTY == null) {
            MinOrdQty = "1";
        }
        else {
            MinOrdQty = CartItems[index].MIN_ORD_QTY;
        }
        let MaxOrdQty = "" + ((parseInt(CartItems[index].MIN_ORD_QTY)) + (parseInt(CartItems[index].MIN_ORD_QTY)));
        let IncDecVal;
        //
        if (event.target.value == "-") {
            IncDecVal = ((parseInt($(`#Quantity${index + 1}`).val())) - (parseInt(MinOrdQty)));
            if (IncDecVal < MinOrdQty) {
                IncDecVal = $(`#Quantity${index + 1}`).val();
            }
        }
        else {
            let test = (parseInt($(`#Quantity${index + 1}`).val()))
            IncDecVal = ((parseInt($(`#Quantity${index + 1}`).val())) + (parseInt(MinOrdQty)));
            if (IncDecVal < MaxOrdQty && IncDecVal > MaxOrdQty) {
                IncDecVal = $(`#Quantity${index + 1}`).val();
            }
        }
        if (IncDecVal === '' || re.test(IncDecVal)) {
            if (IncDecVal != "0") {
                Quantityvalidate = 0
            }
        }
        if (Quantityvalidate == 0) {
            CartItems[index].Quantity = IncDecVal;
            //filetoupdate = "QUANTITY";
            this.setState(CartItems);
        }

        $(`#splitDeliveryQty_Loader`).removeClass('d-none');
        $(`#splitDelivery_BodyContent`).addClass('d-none');

        /******NEW*********wal-158****/
        //WW-673 A1QA bug fixed (only for W W Grainger we uncheck the pickup checkbox when there is a change in qty) -Aparna
        if (this.state.PickupVendorID != undefined && this.state.PickupVendorID != null) {
            if (this.state.PickupVendorID == "W000000036") {
                if (this.state.pickupcheck == true) {
                    //  $("#pickupcheck").prop("checked", false);
                    this.setState({ pickupcheck: false });
                }
            }
        }
        /*****END***************/
    }
    /*
     * RF No : SC_PC_27
     * This is emit method invoked by the compouentwillmount when action emit UpdateStatus.
     * Cart item data is update and rebinded.
     * */
    UpdateItemStatus = () => {
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        let { CartItems } = this.state;
        let { ItemId } = this.state;
        let { UniqId } = this.state;
        let { ActiveFieldToUpdate } = this.state;
        let index
        //
        if (ActiveFieldToUpdate == "Quantity") {
            $(`#splitDeliveryQty_Loader`).addClass('d-none');
            $(`#splitDelivery_BodyContent`).removeClass('d-none');
            index = CartItems.findIndex(x => x.Itemid == ItemId && x.CoreSeq == UniqId);
        }
        else {
            index = CartItems.findIndex(x => x.Itemid == ItemId && x.UniqNum == UniqId);
        }
        switch (ActiveFieldToUpdate) {
            case "DESCR254":
                {
                    let Nvalue = $('#DespNewValue').val();
                    let ExistValue = CartItems[index].ItemDescription;
                    CartItems[index].ItemDescription = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                    this.setState(CartItems);
                    $('#Edit-description').modal('hide');
                    break;
                }
            case "EmployeeCC": {
                let id = "EmpDD" + UniqId;
                let Nvalue = $('#' + id).val();
                let ExistValue = CartItems[index].EmpChgCode;
                CartItems[index].EmpChgCode = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "DueDate": {
                let id = "DueDate" + UniqId;
                let Nvalue = this.state.ItemDate
                let ExistValue = CartItems[index].UDueDate;
                CartItems[index].UDueDate = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "MachineNo": {
                let id = "MachineNo" + UniqId;
                let Nvalue = $('#' + id).val();
                let ExistValue = CartItems[index].MachineRow;
                CartItems[index].MachineRow = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "MachinePart": {
                let id = "MachinePart" + UniqId;
                let Nvalue = $('#' + id).val();
                let ExistValue = CartItems[index].MachineNo;
                CartItems[index].MachineNo = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "PO": {
                let id = "PO" + UniqId;
                let Nvalue = $('#' + id).val();
                let ExistValue = CartItems[index].PO;
                CartItems[index].PO = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "LN": {
                let id = "LN" + UniqId;
                let Nvalue = $('#' + id).val();
                let ExistValue = CartItems[index].LN;
                CartItems[index].LN = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "Notes": {
                //
                let id = "Notes" + UniqId;
                let Nvalue = $('#' + id).val();
                let ExistValue = CartItems[index].UNotes;
                CartItems[index].UNotes = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "Quantity": {
                if (index > -1) {
                    let id = "Quantity" + UniqId;
                    let { PagelaodCartValue } = this.state;
                    let Nvalue = $('#' + id).val();
                    if (Nvalue == null || Nvalue == "") {
                        Nvalue = CartItems[index].Quantity
                    }
                    let ExistValue = CartItems[index].Quantity;
                    CartItems[index].Quantity = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                    PagelaodCartValue[index].Quantity = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                    this.setState({ CartItems: CartItems, PagelaodCartValue: PagelaodCartValue, ItemId: "" });

                }
                else {
                    this.setState({ CartItems: CartItems, PagelaodCartValue: this.state.PagelaodCartValue });
                }
                break;
            }
            case "Priority": {
                //
                let Nvalue = " ";
                let ExistValue = CartItems[index].UPriority;
                if (ExistValue != "R") {
                    Nvalue = "R"
                }
                CartItems[index].UPriority = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "TaxFlag": {
                let Nvalue = "0";
                let ExistValue = CartItems[index].TaxFlag;
                if (ExistValue != "Y") {
                    Nvalue = "Y"
                }
                CartItems[index].TaxFlag = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "AddToCtg": {
                let Nvalue = "0";
                let ExistValue = CartItems[index].AddToCtlgFlag;
                if (ExistValue != "1") {
                    Nvalue = "1"
                }
                CartItems[index].AddToCtlgFlag = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState(CartItems);
                break;
            }
            case "Attachment": {
                let Attachments = [];
                if (this.state.attachmentPathArr != null && this.state.attachmentPathArr != undefined) {
                    this.state.attachmentPathArr.map((value, I) => {
                        Attachments.push(value.FilePath)
                    });
                }
                let Nvalue = Attachments//.map(e => e.FilePath).join("|");
                let ExistValue = CartItems[index].FilePath;
                if (this.state.removeattach != null && this.state.removeattach != undefined) {
                    if (this.state.removeattach.length > 0) {
                        this.state.removeattach.map((val, index) => {
                            let removeBO = {
                                filePath: val.FilePath
                            }
                            ShoppingCartAction.removeAttachment(removeBO);
                        })
                    }
                }
                CartItems[index].FilePath = ShoppingCartStore.UpdateMessage.Update_Success != "" ? Nvalue : ExistValue;
                this.setState({ CartItems, removeattach: [] });
                break;
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
     * RF No: SC_PC_43 
     * In this method the order level Duedate or employecc is updated to the unfilled item DUedate and employee.
     * */
    BindEmpCCToItemOL = (FieldType, DueDateOL, value) => {
        //
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let empstr = value;
        console.log("empid", empstr);
        let childItems;
        let newvalueFilled;
        let ItemDetailBo = [];
        let UpdateOrderBO;
        let filetoupdate
        let newEmployeePrefered = "";
        switch (FieldType) {
            case "EmplyCCOL": {
                //WW-1038-03 order status label change s.sanjay  08/05/2024
                childItems = this.state.CartItems;
                //this.setState({ PreferedEmployee: value});
                //newvalueFilled = this.state.PreferedEmployee.label;
                newvalueFilled = empstr.value;
                filetoupdate = "EMP_CHG_CODE";
                DueDateOL = this.state.OLDueDateVal
                //WW-1010 -Employee ID drop down issue. Pulling up SDI Employee Users. - Deepthi N H
                document.getElementById('StatusMsg').innerText = ""
                document.getElementById('StatusMsg1').innerText = ""
                break;
            }
            case "OLDueDate": {
                childItems = this.state.CartItems.filter((item, index) => item.UDueDate == null || item.UDueDate == "");
                newvalueFilled = DueDateOL;
                filetoupdate = "DUE_DATE";
                break;
            }
        }
        if (childItems.length > 0) {
            childItems.map((SubItem, I) => {
                ItemDetailBo[I] = {
                    ItemID: SubItem.Itemid,
                    LineNum: SubItem.UniqNum,
                    newValue: newvalueFilled
                }
            });
            UpdateOrderBO = {
                userID: this.state.Login_UserId,
                userBU: this.state.Login_UserBU,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                fldToUpdate: filetoupdate,
                Session_CARTFAIL: CookieService.getLocalStorageValues("Session_CARTFAIL"),
                LineItemData: ItemDetailBo
            }
            ShoppingCartAction.UpdateCartEmpCC(UpdateOrderBO)
            this.setState({ ActiveFieldToUpdate: FieldType, OrderEmpyId: empstr, OLDueDateVal: DueDateOL })
        }
        else {
            this.setState({ OrderEmpyId: empstr, OLDueDateVal: DueDateOL });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    }
    /*
    * This method is invoked when the UpdateCartEmpCC() action response is emitted.
    * */
    UpdateitemStatusOL = () => {
        let { CartItems } = this.state;
        let UpdateStatusArray = JSON.parse(ShoppingCartStore.UpdateMessageOL)
        if (UpdateStatusArray != []) {
            UpdateStatusArray.map((SubItem, I) => {
                console.log("employeee", this.state.OrderEmpyId)
                let index = CartItems.findIndex(x => x.Itemid == SubItem.ItemId);
                //let id = "EmpDD" + CartItems[index].UniqNum;
                if (index != -1) {
                    switch (this.state.ActiveFieldToUpdate) {
                        case "EmplyCCOL": {
                            CartItems.map((val, index) => {
                                let Nvalue = this.state.OrderEmpyId  // ** (10/15/2021) WAL-572 **$('#OLEmplyDD').val();
                                console.log("employeee map", this.state.OrderEmpyId)
                                let ExistValue = CartItems[index].EmpChgCode;
                                CartItems[index].EmpChgCode = SubItem.Update_Success != null ? Nvalue : ExistValue;
                                let id = "EmpDD" + CartItems[index].UniqNum;
                                $('#' + id).val(SubItem.Update_Success != null ? Nvalue : ExistValue)
                            });
                        }
                        case "OLDueDate": {
                            let Nvalue = this.state.OLDueDateVal;
                            let ExistValue = CartItems[index].UDueDate;
                            CartItems[index].UDueDate = SubItem.Update_Success != null ? Nvalue : ExistValue;
                            let id = "DueDate" + CartItems[index].UniqNum;
                            $('#' + id).val(SubItem.Update_Success != null ? this.state.startDate : "");
                        }
                    }
                }
            });
            this.setState({ CartItems: CartItems });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
     * In this method the react datepicker is binded to the order level.
     * */
    ShowDatePicker = () => {
        return (
            <DatePicker className="form-control place"
                id="OLDueDate"
                fixedHeight
                placeholderText="MM/DD/YYYY"
                dateFormat="MM/dd/yyyy"
                showMonthDropdown
                showYearDropdown
                minDate={new Date()}
                selected={this.state.startDate}
                onChange={this.handleChange}
            />
        )
    }
    /*
     * This method is invoke when the order due date is changed.
     * */
    handleChange = (date) => {
        this.setState({
            startDate: date
        });
        let dateOL = ""
        if (date != null) {
            dateOL = this.handledate(date);
            //OLDueDateVal = dateOL;
            this.BindEmpCCToItemOL("OLDueDate", dateOL, this.state.OrderEmpyId);
        }
        else {
            this.setState({ OLDueDateVal: dateOL })
        }
    };
    /*
     *This method is invoked when the item level due date is changed. 
     * */
    handleChangeItem = (value, e, Itemid, UniqNum) => {
        let dateOL = ""
        if (value != null) {
            dateOL = this.handledate(value);
        }
        this.setState({
            ItemDate: dateOL
        });
        //
        this.LinelevelEmyEdit(Itemid, UniqNum, "DueDate", dateOL)
    }
    /*
     * This method is used to format the datepicker value to the required date format.
     * */
    handledate = (date) => {
        return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
    }
    /*
     * This method is used to format the date to the datepicker select format, so that it can be binded to the datepicker.
     * */
    convertdate = (date) => {
        var dateConverted;
        if (date != null && date != "" && date != " ") {
            var dateString = date;
            var dataSplit = "";
            /*[06/16/22,Issue with Site loading], Priyanka D */
            if (dateString.includes("/")) {
                dataSplit = dateString.split('/');
            } else if (dateString.includes("-")) {
                dataSplit = dateString.split('-');
            }

            if (dataSplit[2].split(" ").length > 1) {
                var hora = dataSplit[2].split(" ")[1].split(':');
                dataSplit[2] = dataSplit[2].split(" ")[0];
                dateConverted = new Date(dataSplit[2], dataSplit[0] - 1, dataSplit[1], hora[0], hora[1]);
            } else {
                dateConverted = new Date(dataSplit[2], dataSplit[0] - 1, dataSplit[1]);
            }
        }
        return (dateConverted)
    }
    //BugID-5804 - To restrict mixed cart -Vishwa S
    handleEquipmentYes = () => {
        $('#ShoppingMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        if (this.state.QuickItemObj) {
            this.quickItemClick(this.state.QuickItemObj.eventID, this.state.QuickItemObj.type, this.state.QuickItemObj.SubItem, this.state.QuickItemObj.IsFav);
        }
    };

    handleEquipmentNo = () => {
        $('#ShoppingMixedOrderConfirmPopup').modal('hide');
        cartDelete = false;
    };

    //Quick Item 
    /*
     *This method is reused form the non catalog require page.
     * To check the item id for quick item is valid or not.
     * */
    /*[04/07/22WW-243] Regression bug-Cannot able to add an item from quick item entryPriyanka D */
    quickItemClick = (eventId, type, SubItem, IsFav) => {
        //
        //event.preventDefault()
        //$('#Fav-Menu-Ul').addClass('hide'); 
        let txtItemIDValue = ""
        //BugID-5804 - to restrict mixed cart -Vishwa S
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
            if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                let locQuickItemObj = {
                    eventID: eventId,
                    type: type,
                    SubItem: SubItem,
                    IsFav: IsFav
                }
                $('#ShoppingMixedOrderConfirmPopup').modal('show');
                this.setState({ QuickItemObj: locQuickItemObj, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
            else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) {
                let locQuickItemObj = {
                    eventID: eventId,
                    type: type,
                    SubItem: SubItem,
                    IsFav: IsFav
                }
                $('#ShoppingMixedOrderConfirmPopup').modal('show');
                this.setState({ QuickItemObj: locQuickItemObj, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
        }
        //$('#Quickitemmenu').css('display', 'none');
        $("Quickitemmenu").removeAttr("style");
        if (type == 1) {
            txtItemIDValue = $('#QuickItem').val();
            if (txtItemIDValue) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                $('#quickconfirm').modal('show');
                this.setState({ strCplusitemid: "1", txtItemID: txtItemIDValue, QuickitemEnabled: true, SelectedQuickItem: SubItem, IsFav: IsFav })
                //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No Item Number entered for Quick Item Entry"
                });
                //alert("No Item Number entered for Quick Item Entry")
            }
        }
        else {
            if (eventId != "") {
                txtItemIDValue = eventId
                $('#QuickItem').val(txtItemIDValue);
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                $('#quickconfirm').modal('show');
                this.setState({ strCplusitemid: "1", txtItemID: txtItemIDValue, QuickitemEnabled: false, SelectedQuickItem: SubItem })
            }
        }
        if (txtItemIDValue) {
            this.state.CartItems.map((val, index) => {
                if (val.Itemid == txtItemIDValue && txtItemIDValue.slice(0, 6) == "NONCAT") {
                    AlreadyInCart = 1
                    QuickItemId = txtItemIDValue
                }
            })
        }
        //let txtItemIDValue = $('#QuickItem').val();
        //if (event.target.id != "") {
        //    txtItemIDValue = event.target.id
        //    $('#QuickItem').val(txtItemIDValue);
        //}
        //if (type != 1) {
        //    if (txtItemIDValue != "") {
        //        let quickItemBO = {
        //            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        //            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
        //            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
        //            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
        //            txtItemID: txtItemIDValue.trim(),
        //            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
        //            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
        //            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE")
        //        };
        //        ShoppingCartAction.QuickItemCheck(quickItemBO);
        //    }
        //}
        //$('#Fav-Menu-Ul').removeClass('hide');
    }
    keyPress = (e) => {
        if (e.keyCode == 13) {
            this.quickItemClick(e.target.id, 1, false);
        }
    };
    /*
     * This is the response mwthod for quick item check.
     * Quick item pop up is shown.
     * */
    loadQuickItem = () => {
        let quickItemChkRes = JSON.parse(ShoppingCartStore.quickItemcheck)[0];
        qckKeycounter = qckKeycounter + 1;
        let txtItemIDValue = $('#QuickItem').val();
        if (quickItemChkRes.strCplusitemid != "0") {
            $('#quickconfirm').modal('show');
            this.setState({ strCplusitemid: quickItemChkRes.strCplusitemid, txtItemID: txtItemIDValue })
        } else {
            this.setState({ strCplusitemid: "0", txtItemID: "" });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Invalid Item Number entered for Quick Item Entry"
            });
            //  alert("Invalid Item Number entered for Quick Item Entry");
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //WAL-1034_PC_04
    WO_Parts_ButtonClick = () => {
        $('#WO_Parts_Popup').modal('show');
    }
    //WAL-1034_PC_06
    WO_Parts_Close = () => {
        $('#WO_Parts_Popup').modal('hide');
    }
    /*
     * This method is used to close the quick item pop up.
     * */
    closePopup = (message) => {
        $('#quickconfirm').modal('hide');
        if (this.state.QuickitemEnabled == false) {
            $('#QuickItem').val("")
        }
        this.setState({ strCplusitemid: "0", txtItemID: "" });
        if (message == 1) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Item has been added to cart"
            });
            //alert("Item has been added to cart");
            this.refreshMenu();
            this.LoadCartItem();
        } else if (message == 2) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Invalid Item Number entered for Quick Item Entry"
            });
            // alert("Invalid Item Number entered for Quick Item Entry");
        };
    };
    /*
     * This method is used to refresh the menu bar.
     * */
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true
        };
        MenuAction.getMasterData(masterBO);
    };
    // Add item to Fav
    /*
     * RF No: SC_PC_40
     * This method is invoke when the fav icon in the level is clicked.
     * */
    DelFavItem = () => {
        //
        //swal({
        //    allowOutsideClick: false,
        //    closeOnClickOutside: false,
        //    text: "Item Successfully Removed From Favorites" 
        //});
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: "Item Successfully Removed From Favorites"
        }).then(function () {
            window.location.reload();
        });
        //alert("Item Successfully Removed From Favorites");

    }
    /*start*/
    noRemovalClick = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ isPageloadIsValidWO: true }); //WW-1231 WO State Restriction -Vishwa S
        this.LoadCartItem();
    }
    RemoveFromFav = (Itemid, UniqID, favUnavailItems) => {
        //
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#add-fav-popup').modal('hide');
        /*[11/25/22, PC_WAL-926_13], Priyanka D */

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let favUnAvailItemdetails = []
        let favItems = favUnavailItems
        if (favItems != undefined && favItems != null && favItems != "" && favItems != " ") {
            favItems.map((x) => {
                let loc = {
                    UnAvailItemid: x.CUSTOMERITEMID,
                    UnAvailItemDes: x.ITEMDESCRIPTION,
                    UnAvailMFG: x.MANUFACTURER,
                    UnAvailMfgPart: x.CLIENT_MFG_PART,
                    UnAvailSupplierID: x.SUPPLIER_ID
                }
                favUnAvailItemdetails.push(loc)
            })
        } else {
            let { CartItems } = this.state;
            let index = CartItems.findIndex(x => x.Itemid == Itemid && x.UniqNum == UniqID);
            let filteredCartItems = CartItems[index]

            let loc = {
                UnAvailItemid: filteredCartItems.Itemid,
                UnAvailItemDes: filteredCartItems.ItemDescription,
                UnAvailMFG: filteredCartItems.Manufacturer,
                UnAvailMfgPart: filteredCartItems.Manufacturerpartnumber,
                UnAvailSupplierID: filteredCartItems.SupplierID
            }
            favUnAvailItemdetails.push(loc)

        }
        let deleteFavBO = {
            userID: this.state.Login_UserId,
            userBU: this.state.Login_UserBU,
            favUnAvailItemdetails: favUnAvailItemdetails,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ShoppingCartAction.DeletFavItem(deleteFavBO);
    }
    /*end*/
    LinelevelFavEdit = (ItemChecked, UniqID, ItemId, val) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let { CartItems } = this.state;
        let index = CartItems.findIndex(x => x.Itemid == ItemId && x.UniqNum == UniqID && x.Manufacturer == val.Manufacturer
            && x.Manufacturerpartnumber == val.Manufacturerpartnumber && x.SupplierID == val.SupplierID);
        let AddToFavItemBO = {
            userID: this.state.Login_UserId,
            userBU: this.state.Login_UserBU,
            ItemID: ItemId,
            Item_Description: CartItems[index].ItemDescription,
            Item_MFG: CartItems[index].Manufacturer,
            Item_MFGPartNum: CartItems[index].Manufacturerpartnumber,
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            CurrentPage_Url: "/SDIXZEUS/ShoppingCart",
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_CARTFAIL: "N",
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Favitemprice: CartItems[index].Price == " " || CartItems[index].Price.toLowerCase() == "price on request" || CartItems[index].Price == "-" ? "" : CartItems[index].Price,
            Supplier_ID: CartItems[index].SupplierID
        };
        if (ItemChecked == true) {
            this.RemoveFromFav(ItemId, UniqID)
        }
        else {
            ShoppingCartAction.GetAddFavItemDetail(AddToFavItemBO);
        }
        let FavPopTitle = ItemChecked == true ? "Edit Favourites" : "Add Favorites";
        this.setState({ FavorPopUptitle: FavPopTitle, CategoryErr: false, SubCategoryErr: false })
    }
    /*
     * Favorite item pop up is shown with  item value. choosen for favorite.
     * */
    BindAddFavPopUp = () => {
        let FavItemDetailsAry = JSON.parse(ShoppingCartStore.FavItemDetailsAry);
        let Update_Session = FavItemDetailsAry.Update_Session;
        if (Update_Session != null && Update_Session != "") {
            if (Update_Session.length > 0) {
                if (Update_Session[0].Session_TESTMODE != null && Update_Session[0].Session_TESTMODE != "") {
                    CookieService.updateLocalStorageValues("Session_TESTMODE", Update_Session[0].Session_TESTMODE);
                }
                if (Update_Session[0].Session_Desc != null && Update_Session[0].Session_Desc != "") {
                    CookieService.updateLocalStorageValues("Session_Desc", Update_Session[0].Session_Desc);
                }
                if (Update_Session[0].dtCM != null && Update_Session[0].dtCM != "") {
                    CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
                }
                if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                    CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
                }
                if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                    CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
                }
                if (Update_Session[0].Session_Category != null && Update_Session[0].Session_Category != "") {
                    CookieService.updateLocalStorageValues("Session_Category", Update_Session[0].Session_Category);
                }
            }
        }
        let FavItemDetails = FavItemDetailsAry.FavItemDetails;
        if (FavItemDetails != []) {
            let FavSDICatg = FavItemDetails[0].SDI_Catagory == " - " || FavItemDetails[0].SDI_Catagory == null || FavItemDetails[0].SDI_Catagory == "" || FavItemDetails[0].SDI_Catagory == " " ? "UnClassified" : FavItemDetails[0].SDI_Catagory;
            let FavYourCatg = FavItemDetails[0].Your_Catagory == "" ? "" : FavItemDetails[0].Your_Catagory;
            let FavYourDescrip = FavItemDetails[0].Your_Description == "" ? "" : FavItemDetails[0].Your_Description;
            let FavItemImage = FavItemDetails[0].IMAGE_NAME;
            $('#FavYourDescrip').val(FavYourDescrip);
            $('#FavYourCatg').val(FavYourCatg);
            this.setState({
                AddFavPUp: true, FavItemIdPopUp: FavItemDetails[0].ItemID, FavSDICatgPopUp: FavSDICatg, FavYourCatgPopUp: FavYourCatg.trim(),
                FavItemDescripPopUp: FavItemDetails[0].Item_Description, FavYourDescripPopUp: FavYourDescrip, FavMFGPopUp: FavItemDetails[0].MFG, FavSupplierPopUp: FavItemDetails[0].Supplier,
                FavMFGPartNUMPopUp: FavItemDetails[0].MFG_PartNumber, txtUOMHidePopUp: FavItemDetails[0].txtUOMHide, txtMfgItemidHidePopUp: FavItemDetails[0].MFG_PartNumber,
                txtItemidHidePopUp: FavItemDetails[0].txtItemidHide, txtMFGHidePopUp: FavItemDetails[0].txtMFGHide, FavSAP: FavItemDetails[0].FavSAP, Favsupplierid: FavItemDetails[0].txtMfgItemidHide, FavMFGpart: FavItemDetails[0].MFG_PartNumber,
                FavItemImage: FavItemImage
            })
            console.log("FavItemDetails[0].txtMfgItemidHide", FavItemDetails[0].txtMfgItemidHide)
            //document.getElementById("txtUOMHide").hidden = true
            //document.getElementById("txtMfgItemidHide").hidden = true
            //document.getElementById("txtItemidHide").hidden = true
            //document.getElementById("txtMFGHide").hidden = true
            this.setState({ imgAttachment: true })
            $('#add-fav-popup').modal('show');
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
     * This method is invoke when an add button in the favorite pop up is clicked.
     * */
    BindFavForm = () => {
        $('#add-fav-popup').modal('show');
    }
    AddFavItem = (ImgNo) => {
        //
        //if (!(this.state.FavItemImage.includes(".jpg") || (this.state.FavItemImage.includes(".JPG"))) & this.state.ImagePathArr.length == 0 && ImgNo != true) {
        //    this.setState({ imgAttachment: false })
        //    $('#add-fav-popup').modal('hide');
        //    $('#add-fav-Img').modal('show');
        //    return
        //} else {
        let FavDescrip = $('#FavYourDescrip').val()
        let FavCatg = this.state.FavYourCatgPopUp //$('#FavYourCatg').val()
        let FavSubCatg = this.state.FavSubCategory
        //*NEW(1/27/2021)*ADDED*(for favitemmain when catotgrie is not filled***************
        //WW -516_PC_20
        if (FavCatg != null && FavCatg != undefined && FavSubCatg != null && FavSubCatg != undefined) {
            if (FavCatg.trim() != "" && FavSubCatg.trim() != "") {
                //BUG-2689 (9/21/2022)-Aparna
                if ((!(this.state.FavItemImage.includes(".png") || (this.state.FavItemImage.includes(".PNG"))) && !(this.state.FavItemImage.includes(".jpeg") || (this.state.FavItemImage.includes(".JPEG"))) && !(this.state.FavItemImage.includes(".jpg") || (this.state.FavItemImage.includes(".JPG")))) && this.state.ImagePathArr.length == 0 && ImgNo != true) {
                    this.setState({ imgAttachment: false, CategoryErr: false, SubCategoryErr: false })
                    $('#add-fav-popup').modal('hide');
                    $('#add-fav-Img').modal('show');
                    return
                }
                else {
                    let AddToFavItemBO = {
                        Session_BUSUNIT: this.state.Login_UserBU,
                        Session_USERID: this.state.Login_UserId,
                        Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                        Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                        Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                        Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                        Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                        Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                        Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                        Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                        Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                        Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                        Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                        Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                        Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                        Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                        Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                        ItemId: this.state.FavItemIdPopUp,
                        YourDesc: FavDescrip != " " ? FavDescrip.toUpperCase() : "",
                        YourCat: FavCatg != " " ? FavCatg.toUpperCase() : "",
                        YourSubCat: FavSubCatg != " " ? FavSubCatg.toUpperCase() : "",
                        SDI_Catagory: this.state.FavSDICatgPopUp,
                        txtItemidHide: this.state.txtItemidHidePopUp,
                        txtMFGHide: this.state.txtMFGHidePopUp,
                        txtUOMHide: this.state.txtUOMHidePopUp,
                        txtMfgItemidHide: this.state.txtMfgItemidHidePopUp,
                        SupplierID: this.state.Favsupplierid,
                        SAP: this.state.FavSAP,
                        Manufacturer: this.state.FavMFGPopUp,
                        WorkOrder: localStorage.getItem("WONum") != null ? localStorage.getItem("WONum") : null,
                        ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ", // localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "", WAL-767 -Aparna
                        ImgByteCode: (this.state.ImagePathArr[0] != undefined ? this.state.ImagePathArr[0].FilePath : null),
                        IsWeb: true,
                        FileNameCode: (this.state.ImagePathArr[0] != undefined ? this.state.ImagePathArr[0].FilePath : null),
                        ISCoreCharge: this.state.ISCoreChargePopUp
                    };
                    SearchResultsAction.srchcatfavItem(AddToFavItemBO);
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    this.setState({ imgAttachment: false, CategoryErr: false, SubCategoryErr: false, ImagePathArr: [] });//SCO_PC_15 
                }
            }
            else {
                this.setState({ CategoryErr: FavCatg.trim() == "" ? true : false, SubCategoryErr: FavSubCatg.trim() == "" ? true : false });
            }
        }
        else {
            this.setState({ CategoryErr: FavCatg == null || FavCatg == undefined ? true : false, SubCategoryErr: FavSubCatg == null || FavSubCatg == undefined ? true : false });
        }
        //*********END****************
        //   }
    }
    /*
     * This method is called when the action updateFavsMenu emits the response.
     * Close the favorite pop up
     * */
    closeFavPopup = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let FavItemUpdateAry = JSON.parse(ShoppingCartStore.FavItemUpdateAry);
        let StatusArray = FavItemUpdateAry.AlertMessage
        let FavmenuDD = FavItemUpdateAry.FavMenu
        //let FavmenuDD = PageLaod_Data.FavMenu
        let filteredFavmenuDD = []
        if (FavmenuDD != null && FavmenuDD != undefined) {
            if (FavmenuDD.length > 0) {
                filteredFavmenuDD = FavmenuDD.filter((v, i, a) => a.findIndex(t => (t.FavText.trim().toUpperCase() === v.FavText.trim().toUpperCase())) === i)
            }
        }
        let FavSubMenu = FavItemUpdateAry.FavSubMenu
        if (StatusArray[0].Success_Message != "" || StatusArray[0].Success_Message != null) {
            this.setState({ FavMenu: FavmenuDD, FavMenuSub: FavSubMenu, AddFavPUp: false });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Item successfully added to the favorite list"
            });
            //alert("Item successfully added to the favorite list");
            $('#add-fav-popup').modal('hide');
            MenuAction.refreshMasterData()
            this.BuildFavMenu();
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Due to technical Issue item is not added to the favorite list.Try after sometime."
            });
            // alert("Due to technical Issue item is not added to the favorite list.Try after sometime.");
            this.setState({ AddFavPUp: false });
            $('#add-fav-popup').modal('hide');
        }
    }
    /*
     * RF No: SC_PC_41
     * Show the delete item confirmation pop up.
     * */
    DeleteItem = (ItemId, UniqID) => {
        //
        this.setState({ ItemId: ItemId, UniqId: UniqID, RemoveItemPUp: true });
        $('#Cancel-confirmation').modal('show');
        /*[02/09/22, PC_01,WW-318], Priyanka D,Removing item from Enersys List */
    }
    /*
     * RF No: SC_PC_47
     * This method is called when Delete confirmation button in delete pop up is clicked 
     * */
    DeleteItemConfirmed = () => {
        //
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let { CartItems } = this.state;
        let { ItemId } = this.state;
        let { UniqId } = this.state;
        let index = CartItems.findIndex(x => x.Itemid == ItemId && x.UniqNum == UniqId);
        let filepath = CartItems[index].FilePath;
        let DeleteItemID = this.state.ItemId;
        let DeleteUniqId = this.state.UniqId;
        let DeleteItemBO = {
            userID: this.state.Login_UserId,
            userBU: this.state.Login_UserBU,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            FilePath: filepath,
            ItemID: DeleteItemID,
            LineNum: DeleteUniqId,
            DeleteFlag: true
        };
        //[1/11/23, WW-552, Dhevanesam R]
        if (ItemId != null && ItemId != undefined && filepath != null && filepath != undefined) {
            if (filepath[0].toUpperCase().includes('FORM')) {

                let formList = CookieService.getLocalStorageValues('FormList')
                if (formList.indexOf(ItemId) > -1) {
                    let index = formList.indexOf(ItemId)
                    formList.splice(index)
                    CookieService.updateLocalStorageValues("FormList", formList);
                }
            }
        }
        //4051-Remove the work order error message when clicking 'Remove item' as 'Yes' - Nandhini L
        document.getElementById('StatusMsg1').innerText = "";
        document.getElementById('StatusMsg').innerText = "";

        ShoppingCartAction.DeleteCartItem(DeleteItemBO);
        this.setState({ RemoveItemPUp: false });
        //window.location.reload();
    }
    /*RF No: SC_PC_51
     * This method is called when the DeleteCartItem action response is emitted.
     * */
    DeleteItemStatus = () => {
        //
        let deleteItemAry = JSON.parse(ShoppingCartStore.deleteItemAry);
        $(`#tradeMismatchPopup`).modal('hide');
        if (deleteItemAry != "" || deleteItemAry != null) {
            let CartItemsValue = this.state.CartItems;
            let PagelaodCart = this.state.PagelaodCartValue;
            let { ItemId } = this.state;
            let { UniqId } = this.state;
            let { WNA } = this.state;
            let Cartcountvalue = 0
            let localbilltostore = this.state.BilltostoreEnable
            let index = CartItemsValue.findIndex(x => x.Itemid == ItemId && x.UniqNum == UniqId);
            console.log("NAYFlag", this.state.NAYFlag)
            if (index != -1) {
                //[1/7/22], PC_SC_01, WW-286, Dhevanesam R
                //CartItemsValue.splice(index, 1)
                //PagelaodCart.splice(index, 1)
                let findIndex = WNA.findIndex(X => X.item == ItemId);
                if (CartItemsValue[index].CORE_CHARGE == "" || CartItemsValue[index].CORE_CHARGE == " " || CartItemsValue[index].CORE_CHARGE == null || CartItemsValue[index].CORE_CHARGE == "\N" || CartItemsValue[index].CORE_CHARGE == "\\N" || CartItemsValue[index].CORE_CHARGE == undefined) {
                    CartItemsValue.splice(index, 1)
                    PagelaodCart.splice(index, 1)
                }
                else {
                    CartItemsValue.splice(index + 1, 1)
                    CartItemsValue.splice(index, 1)
                    PagelaodCart.splice(index + 1, 1)
                    PagelaodCart.splice(index, 1)
                }
                if (CartItemsValue != null && CartItemsValue != undefined) {
                    if (CartItemsValue.length > 0) {
                        Cartcountvalue = CartItemsValue.length
                    }
                }
                if (findIndex > -1) {
                    WNA.splice(findIndex, 1)
                    this.setState({ WNA: WNA })
                }
            }
            else if (this.state.NAYFlag == true) {
                //window.location.reload();
                let deleted = this.state.NADeleteItemID
                let { CartItems } = this.state.CartItems
                //
                let unAvailitems = this.state.WNA
                deleted.forEach((x) => {
                    let ind
                    let WNAIndex = unAvailitems.findIndex(y => y.Itemid == x.item);
                    ind = CartItemsValue.findIndex(y => y.Itemid == x.ItemId && y.UniqNum == x.UniqNum);
                    unAvailitems.splice(WNAIndex, 1)
                    CartItemsValue.splice(ind, 1)
                    PagelaodCart.splice(ind, 1)
                })
                this.setState({ WNA: unAvailitems })
                if (CartItemsValue != null && CartItemsValue != undefined) {
                    if (CartItemsValue.length > 0) {
                        Cartcountvalue = CartItemsValue.length
                    }
                }
                let loc = [];
                let DeleteItemID = []
                if (unAvailitems.length > 0) {
                    unAvailitems.map((x) => {
                        if (x.label.includes("qty")) {
                            let index = CartItemsValue.findIndex(y => y.Itemid == x.item);
                            let uni = CartItemsValue[index].UniqNum
                            let qt = CartItemsValue[index].Quantity
                            loc = {
                                ItemId: x.item,
                                UniqNum: uni,
                                Qty: qt,
                                mfgpart: x.mfgpart

                            }
                            DeleteItemID.push(loc)
                        }
                    })
                }
                if (DeleteItemID.length > 0) {
                    let UpdateItemDetails = {
                        userID: this.state.Login_UserId,
                        userBU: this.state.Login_UserBU,
                        Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                        fldToUpdate: "Quantity",
                        NAItemFlag: true,
                        ItemIdList: DeleteItemID,
                    }
                    ShoppingCartAction.UpdateItemDesp(UpdateItemDetails);
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                } else {
                    if (this.state.favUnavailItems.length > 0) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        $('#RemoveFav').modal('show');
                    }
                }
                // this.LinelevelEmyEdit("Quantity")
            }
            else {
                /*[11/25/22, PC_WAL-926_11], Priyanka D */
                let deleted = this.state.NADeleteItemID
                let { CartItems } = this.state.CartItems
                let unAvailitems = this.state.WNA
                deleted.forEach((x) => {
                    let ind
                    ind = CartItemsValue.findIndex(y => y.Itemid == x.ItemId && y.UniqNum == x.UniqNum);
                    if (unAvailitems != null && unAvailitems != undefined) {
                        if (unAvailitems.length > 0) {
                            let WNAIndex = unAvailitems.findIndex(y => y.Itemid == x.item);
                            unAvailitems.splice(WNAIndex, 1)
                        }
                    }
                    CartItemsValue.splice(ind, 1)
                    PagelaodCart.splice(ind, 1)
                    $('#NonCat_Popup').modal('hide')
                })
                this.setState({ WNA: unAvailitems })
                if (this.state.favUnavailItems.length > 0) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    $('#RemoveFav').modal('show');
                }
            }
            if (CartItemsValue != null && CartItemsValue != undefined) {
                if (CartItemsValue.length > 0) {
                    var l = 0


                    for (l = 0; l < CartItemsValue.length; l++) {
                        if (CartItemsValue[l].EmpChgCode == null || CartItemsValue[l].EmpChgCode == "" || CartItemsValue[l].EmpChgCode == "0") {
                            CartItemsValue[l].EmpChgCode = this.state.OrderEmpyId.value
                        }
                    }


                    this.setState({
                        supplier: CartItemsValue[0].SupplierID,
                        PaintColor: CartItemsValue[0].PaintColor
                    })
                }
            }
            /***********NEW*******(pickup)wal-158********/
            let cartdata = CartItemsValue;
            let pickupdata = this.state.pickup_vendor;
            let pickupcount = 0;
            let pickupcheckbox = false;
            let pickupvendor = "";
            let pickupvendorID = "";
            //WW-774_PC_05 -Aparna
            let isRefrigerantInCart = this.isRefrigerantItemInCart(cartdata)
            //  let isSingleSupplier=false
            //if (isRefrigerantInCart[0]) {
            //    isSingleSupplier = cartdata.filter((v, i, a) => a.findIndex(t => (t.SupplierID === v.SupplierID)) === i).length == 1 ? true : false;
            //}
            if (pickupdata.length != 0 && cartdata.length != 0) {
                pickupdata.forEach((val, index) => {
                    //A1QA-150_PC_02 (3/25/2022)-Aparna
                    CartItemsValue.filter((x) => x.SupplierID == CartItemsValue[0].SupplierID && val.VENDOR_ID == x.SupplierID && val.BUSINESS_UNIT_OM == "I0W01").map((i) => { pickupcount += 1; })
                })
                //pickupdata.map((val, index) => {
                //    CartItemsValue.map((itm, index) => {
                //        if (val.VENDOR_ID == itm.SupplierID) {
                //            pickupcount += 1;
                //        }
                //    });
                //});
                if (CartItemsValue.length == pickupcount && this.state.HalLocationChecked != true || isRefrigerantInCart[2]) { //WW-774_PC_05 -Aparna
                    //
                    pickupcheckbox = true;
                    pickupdata.map((val, index) => {
                        if (val.VENDOR_ID == cartdata[0].SupplierID) {
                            //
                            pickupvendor = val.NAME1;
                            pickupvendorID = val.VENDOR_ID;
                        }
                    });
                }
            }

            let haldisplay = false;
            if (localStorage.getItem("HalVendors") != null) {
                let HalVendors = JSON.parse(localStorage.getItem("HalVendors"))
                //  let cartitemdetails = this.state.CartitemList
                let halvendorcount = 0;
                if (HalVendors.length != 0 && HalVendors.length != 0 && CartItemsValue.length != 0) {
                    HalVendors.forEach((val, index) => {

                        CartItemsValue.forEach((x, index) => {
                            if ((x.SupplierID == val.VENDOR_ID && val.VNDR_FIELD_C30_F == 'HAL')) {
                                halvendorcount += 1;



                            }



                        })
                    })
                    let cartitemcount = CartItemsValue.length;
                    if (cartitemcount == halvendorcount && isRefrigerantInCart[0] == false) {
                        this.setState({ Haldisplay: "HAL" })
                    }
                    else {
                        $(`#fedexhal`).prop('disabled', true)
                        this.setState({ Haldisplay: "" })
                    }


                }
                else {
                    $(`#fedexhal`).prop('disabled', true)
                    this.setState({ Haldisplay: "", displayFedexDrop: false })
                }
            }
            else {
                $(`#fedexhal`).prop('disabled', true)
                this.setState({ Haldisplay: "", displayFedexDrop: false })
            }


            let pickuploc = "";
            let loclowesitem = false;
            let punchoutcount = 0;
            let checkedbillto = true;//WW-673_PC_BL_02
            let enableshipto = false;
            if (this.state.CartItems != undefined && this.state.CartItems != null) {
                if (this.state.CartItems.length > 0) {
                    this.state.CartItems.map((val, index) => {
                        if (val.PaintColor == "PUNCHOUT" && val.SupplierID == "W000000091") {
                            // $("#pickupcheck").prop("checked", true);
                            punchoutcount = punchoutcount + 1;
                        }
                    });
                    if (this.state.CartItems.length == punchoutcount) {
                        //$("#pickupcheck").prop("checked", true);
                        pickuploc = true
                        loclowesitem = true;
                        checkedbillto = false;//WW-673_PC_BL_02
                        enableshipto = false;
                    }
                    //WW-774_PC_04 -Aparna
                    else if (isRefrigerantInCart[0]) {
                        enableshipto = false
                        // let isSingleSupplier = cartdata.filter((v, i, a) => a.findIndex(t => (t.SupplierID === v.SupplierID)) === i).length == 1 ? true : false;
                        if (isRefrigerantInCart[1] && this.state.isValidWO) {
                            pickuploc = true
                        }

                    }
                    else {
                        //  $("#pickupcheck").prop("checked", false);
                        pickuploc = false
                    }
                }
                if (this.state.CartItems.length == 0) {
                    // $("#pickupcheck").prop("checked", false);
                    pickuploc = false
                }
            }
            let pickupstore = [];
            if (this.state.pickupstore_tbl && pickupvendor != "") {
                this.state.pickupstore_tbl.map((storeval, index) => {
                    if (storeval.NAME1.toUpperCase() == pickupvendor.toUpperCase()) {
                        let localArray = {
                            ADDRESS3: storeval.ADDRESS3,
                            VNDR_LOC: storeval.VNDR_LOC,
                            ADDRESS1: storeval.ADDRESS1,
                            CITY: storeval.CITY,
                            STATE: storeval.STATE,
                            POSTAL: storeval.POSTAL,
                            PHONE: storeval.PHONE,
                            NAME1: storeval.NAME1,
                            LATITUDE: storeval.LATITUDE,
                            LONGITUDE: storeval.LONGITUDE/*[05/04/22,WW-243-Pickup miles is binded as Nan], Priyanka D */
                        }
                        pickupstore.push(localArray)
                    }
                })
            }
            //[2/10/22], PC_SC_04, WW-330, Dhevanesam R
            let PickEnBenStoreVal
            let WillCallboolVal = false
            let CartitemListArrBen = CartItemsValue.filter((x) => x.hasInvSupplierID == true)
            if (CartitemListArrBen.length == CartItemsValue.length) {
                //
                PickEnBenStoreVal = true
            }
            else {
                PickEnBenStoreVal = false
            }

            let sethalboolenval = false
            let secpickupbooleanVal = false
            if (localStorage.getItem("BilltoStoreLocationLat") != null && localStorage.getItem("BilltoStoreLocationLong") != null) {
                //

                let StoreLat = JSON.parse(localStorage.getItem("BilltoStoreLocationLat"))
                let StoreLong = JSON.parse(localStorage.getItem("BilltoStoreLocationLong"))

                if (StoreLat != undefined && StoreLong != undefined) {

                    secpickupbooleanVal = true
                    if (this.state.pickupcheck == true) {
                        secpickupbooleanVal = true
                    }
                    //WW-774_PC_05 -Aparna
                    if (this.state.Haldisplay == "HAL" && isRefrigerantInCart[0] == false) {
                        sethalboolenval = true
                    }
                    if (this.state.Haldisplay == "" && this.state.isWorkToStoreValid) {
                        sethalboolenval = false
                    }

                    //if (this.state.pickupcheck == "" && this.state.isWorkToStoreValid) {
                    //    secpickupbooleanVal = false
                    //}
                    //if (this.state.supplier == "W000000036" && this.state.PaintColor == "PUNCHOUT") {
                    //    secpickupbooleanVal = false
                    //}
                    //else if (this.state.PaintColor == "PUNCHOUT") {
                    //    secpickupbooleanVal = false
                    //}
                    //else {
                    //}
                }
            }

            //
            let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
            let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";

            console.log("sampledata", CookieService.getLocalStorageValues("Session_StoreLocBen"))
            //
            if (isRefrigerantInCart[0]) {
                localbilltostore = true
            } else {
                localbilltostore = false
            }
            if (CartItemsValue.length > 0) {
                if (this.state.IsInteractiveNonCat != false && WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
                    $('#IntNonCatRemovePopup').modal('show');
                }
            }
            this.BentonvilleStore_Check()
            /*******END********/
            //WW-243 - When we add two items to the cart and then remove one of them, we cannot change the quantity of the remaining item - Deepthi
            let FinalCartValues = CartItemsValue;
            FinalCartValues.forEach((value, index) => {
                value.CoreSeq = index + 1;
            });
            this.PageItemSuggestionLoad(FinalCartValues);
            this.supplierCollection(this.state.CartItems, this.state.pickup_vendor, this.state.pickupstore_tbl, this.state.defaultShipto)
            this.setState({
                CartItems: FinalCartValues, CartCOunt: Cartcountvalue, PagelaodCartValue: PagelaodCart, isAllItem_are_Pickup: pickupcheckbox, sethalboolenval: sethalboolenval,
                PickupStore: pickupstore, PickupVendor: pickupvendor, PickupVendorID: pickupvendorID, pickupcheck: pickuploc, isPickup: secpickupbooleanVal, lowesitem: loclowesitem, NAYFlag: false, NADeleteItemID: [],
                isAllItem_are_Inv: PickEnBenStoreVal, Checkedbillto: checkedbillto, EnableShipTo: enableshipto,//WW-673_PC_BL_02
                displayPickDrop: isRefrigerantInCart[0] && isRefrigerantInCart[1] ? true : false, isRefrigerantItemInCart: isRefrigerantInCart[0], BilltostoreEnable: localbilltostore,//WW-774_PC_ -Aparna
            })
            if (isRefrigerantInCart[0] && isRefrigerantInCart[1] && this.state.isValidWO) {

                this.Bindpickupstore()
            }
            //this.LoadCartItem();
            this.refreshMenu();
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue.Try after sometime."
            });
            //  alert("Technical issue.Try after sometime.")
        }
        //this.BindCart();
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
     * This method is used to calculate the order total.
     * */
    OrderTotalCal = () => {
        let SiteCurrency = this.state.SiteCurrencyTable;
        let ItemTotal = 0;
        let OrderTotal = 0;
        let cartcount = this.state.CartItems.length;
        return this.state.CartItems.map((val, index) => {
            let uniteprice = parseFloat(val.Price) ? parseFloat(val.Price) : 0
            let QuantityAvail = parseFloat(val.Quantity) ? parseFloat(val.Quantity) : 0
            if (uniteprice != NaN && QuantityAvail != NaN && uniteprice != 0 && QuantityAvail != 0) {
                ItemTotal = uniteprice * QuantityAvail;
            }
            OrderTotal = OrderTotal + ItemTotal;
            let loopindex = index + 1;
            if (loopindex == cartcount) {
                let roundOffvalue = OrderTotal.toFixed(2)
                return (SiteCurrency[0].Symbol + " " + roundOffvalue);
            }
        });
    }
    /*
     * RF No: SC_PC_42
     * Show Attachment pop up.
     * */
    LinelevelAtthEdit = (ItemId, UniqID) => {
        let { CartItems } = this.state
        let index = CartItems.findIndex(x => x.Itemid == ItemId && x.UniqNum == UniqID);
        let attachmentPathArrLocal = []
        if (CartItems[index].FilePath != null && CartItems[index].FilePath != undefined) {
            if (CartItems[index].FilePath.length < 0) {
                attachmentPathArrLocal = CartItems[index].FilePath.split("|")
            }
            else {
                attachmentPathArrLocal = CartItems[index].FilePath
            }
        }
        let FilePathArray = []
        if (attachmentPathArrLocal != null && attachmentPathArrLocal != undefined) {
            if (attachmentPathArrLocal.length > 0) {
                attachmentPathArrLocal.map((attachment, index) => {
                    let url = attachment;
                    let filename = url.substring(21);
                    //alert(filename);
                    let localArray = {
                        FileName: filename,
                        FilePath: url
                    }
                    FilePathArray.push(localArray)
                });
            }
        }
        this.setState({ ItemId: ItemId, UniqId: UniqID, AddAttachPUp: true, attachmentPathArr: FilePathArray });
        $('#addattachment').modal('show');
    }
    /*
     * RF No: SC_PC_48
     * Validation is checked.
     * */
    //SC_PC_01 - WW-349 Notification for Multiple Suppliers - Deepthi N H
    ReorderCheck = () => {
        //if (validationFalg) {
        let cartlist = this.state.CartItems
        let LineItemslist = []
        if (cartlist.length > 0) {
            cartlist.map((val, index) => {
                LineItemslist.push({
                    MfgPartNo: val.Manufacturerpartnumber != null ? val.Manufacturerpartnumber : "",
                    MfgName: val.Manufacturer != null ? val.Manufacturer : "",
                    QTY: val.Quantity,
                    ItemId: val.Itemid,
                    VendorId: val.SupplierID != null ? val.SupplierID : "",
                    Description: val.ItemDescription != null ? val.ItemDescription : ""
                })
            });
        }
        let locWO = $('#OLWorkOrderTB').val();
        let ReorderBO = {
            WorkOrder: CookieService.getLocalStorageValues("Session_CARTWOREQ") == 'N' && locWO == "" ? " " : locWO,
            EmployeeID: CookieService.getLocalStorageValues("Session_UserID"),
            BusinessUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            LineItemBOs: LineItemslist
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ShoppingCartAction.Reorder(ReorderBO);
        //}
    }

    /*
     * RF No: SC_PC_55
     * Increment line item pop up is shown.
     * */
    //******NEW(1/25/2021)***********ADDED
    //[12/22/21], PC_SC_06, WW-286, Dhevanesam R
    incrementLineNo = (State) => {
        this.setState({
            FavOrderConfPUp: true, chkLineNumFlag: State == 1 ? "True" : "False"
        });
        let hasEquipmentItem = [];
        let { CartItems } = this.state;
        if (CartItems) {
            hasEquipmentItem = CartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');

        }
        /*[04/01/22,PC_DF,WW-371],Check for cart contains Door item Priyanka D */
        //[1/11/23, WW-552, Dhevanesam R]
        if ((CookieService.getLocalStorageValues("FormList") != undefined ? CookieService.getLocalStorageValues("FormList").length > 0 : false) || hasEquipmentItem.length > 0) {
            this.AddFavOrder("False")
        }
        else {
            $('#Fav-confirmation').modal('show');
        }
    }
    /***************NEW*******wal-158**/
    /****NEW**(catalog search)WAL-158***/
    calcWorkingDays = (shipwithin) => {
        let count = 0;
        let today = new Date()
        while (count < shipwithin) {
            today.setDate(today.getDate() + 1);
            if (today.getDay() != 0 && today.getDay() != 6) // Skip weekends
                count++;
        }
        let td = this.handledate(today);
        return td
    }
    calcWorkingDaysdrop = (shipwithin) => {
        let count = 0;
        let today = new Date()
        while (count < shipwithin) {
            today.setDate(today.getDate() + 1);
            if (today.getDay() != 0 && today.getDay() != 6) // Skip weekends
                count++;
        }
        return today
    }
    /*******************END**************/
    /*
     * RF No: SC_PC_49
     * This method is invoked when the fav order pop up button is clicked.
     * */
    AddFavOrder = (status) => {
        //
        let date = this.state.startDate;
        let OLDueDate = this.state.OLDueDateVal;
        let halstore = this.state.HalSelectedOphrs.value;
        let OLEmployeeCC = this.state.OrderEmpyId;
        let OLShipTo = "";

        if (this.state.pickupcheck != true && this.state.defaultShipto != undefined && this.state.defaultShipto != null) {
            OLShipTo = this.state.defaultShipto.value;
        }
        else if (this.state.pickupcheck == true) {
            if (OLShipTo == "" || OLShipTo == null || OLShipTo == {} || OLShipTo == " ") {
                if (this.state.ShipToDDValue.length < 2) {
                    let ShipToDDValue = this.state.ShipToDDValue
                    OLShipTo = ShipToDDValue[0].value;
                }
                else if (this.state.defaultShipto != undefined) {
                    OLShipTo = this.state.defaultShipto.value;
                }
            }
        }
        //if (this.state.defaultShipto.value != undefined) {
        //    OLShipTo = this.state.defaultShipto.value;
        //} else {
        //    OLShipTo = this.state.defaultShipto[0].value;
        //}
        //if (OLShipTo == "" || OLShipTo == null || OLShipTo == {} || OLShipTo == " ") {
        //    if (this.state.ShipToDDValue.length < 2) {
        //        let ShipToDDValue = this.state.ShipToDDValue
        //        OLShipTo = ShipToDDValue[0].label;
        //    }
        //    else {
        //        OLShipTo = this.state.defaultShipto.value;
        //    }
        //}
        //***********NEW**********wal-158***
        let var_pickupcheck = this.state.pickupcheck;
        let UserChar1 = this.state.USER_CHAR1;
        //[2/10/22], PC_SC_05, WW-330, Dhevanesam R
        let var_vendor
        if (this.state.Bentonville_WO && this.state.isAllItem_are_Inv && this.state.pickupcheck == true) {
            var_vendor = "C0W10"
        }
        else {
            var_vendor = this.state.pickupcheck == true && this.state.PickupStoreSelected != "" ? this.state.PickupStoreSelected.value : ""
        }
        //WW-718_PC_03 -Aparna
        //if (this.state.pickupcheck == true ) {
        //    UserChar1 = "PU";
        //    var_vendor = this.state.PickupStoreSelected.value
        //}
        //************END**********
        let OLWorkOrder = $('#OLWorkOrderTB').val();
        let OLOrderNum = $('#OrderNum').val();
        let OLMachineNo = $('#OLMachDD').val();
        let OLNotes = $('#CusNotes').val();
        let OLCustomerRef = "";
        let OLType = this.state.TypeTable.length > 0 ? $('#OLTyeDD').val() : "";
        let OLPriorityOrder = $('#customCheckOP7').is(":checked") ? "True" : "False" //{/*NEW*** (1/25/20201)**CHANGED***(id)** customCheck7--> customCheckOP7***/}
        let { chkLineNumFlag } = this.state
        /*[03/16/22,WAL-721_PC_13,WAL-721], Priyanka D */
        let listBO = [];
        if (this.state.reorderitems != undefined) {
            if (this.state.reorderitems.length > 0) {
                this.state.reorderitems.forEach((x) => {
                    listBO.push({
                        ITM_ID_VNDR: x.ITM_ID_VNDR,
                        DESCR254: x.DESCR254,
                        MFG_ITM_ID: x.MFG_ITM_ID,
                        ISA_MFG_FREEFORM: x.ISA_MFG_FREEFORM,
                        VENDOR_ID: x.VENDOR_ID
                    })
                })
            }
        }

        let haldetailBO = "";

        this.state.hallocaddress.forEach((x) => {
            let streetlines = x.contactAndAddress.address.streetLines[0]
            if (streetlines == halstore) {
                haldetailBO = {

                    BusinessUnit: this.state.Login_UserBU,
                    NAME1: CookieService.getLocalStorageValues("Session_USERNAME"),
                    Address1: x.contactAndAddress.address.streetLines[0],
                    Address2: " ",
                    City: x.contactAndAddress.address.city,
                    State: x.contactAndAddress.address.stateOrProvinceCode,
                    Country: x.contactAndAddress.address.countryCode,
                    Postal: x.contactAndAddress.address.postalCode,
                    ISA_FDX_HAL: "Y",
                    Location2: x.locationId,
                    Store_Loc: x.contactAndAddress.addressAncillaryDetail.building,

                }
            }


        })

        //WW-398_PC_06 (5/5/2022) -Aparna
        let LinePickupBO = []
        let cartItemTot = this.state.CartItems.length
        let Userchar2count = 0
        let refrigerantList = [] //WW-600_RC1_PC_01 (2/10/2023)-Aparna
        this.state.CartItems.forEach((x) => {
            if (x.pickupcheck) {
                LinePickupBO.push({
                    ItemId: x.Itemid,
                    Location2: "C0W01"
                })
            }

            if (x.shipping_specs != undefined && x.shipping_specs != null) {
                if (x.shipping_specs.toUpperCase() == "PUO ONLY") {
                    refrigerantList.push({ RefItem: x.Itemid })
                }
            }

            //if (x.SupplierID == "W999999999" && this.state.BentonvilleStore) {
            //    Userchar2count++;
            //}
        })
        console.log("Userchar2count", Userchar2count)
        console.log("Userchar2count", cartItemTot)
        //if (Userchar2count == cartItemTot) {
        //    var_pickupcheck = "PU"
        //}
        console.log("console", this.state.attachmentPathArrImg != "" && this.state.attachmentPathArrImg != undefined && this.state.attachmentPathArrImg != null ? this.state.attachmentPathArrImg[0].FilePath : "")
        //;
        let BillTOStore = []
        let ISA_USERS2 = []
        if (this.state.BilltoStore.label != undefined && this.state.BilltoStore.label != null) {
            BillTOStore = this.state.BilltoStore.label.split('-')
        }
        if (BillTOStore.length > 1) {
            ISA_USERS2 = BillTOStore[0] + '-' + BillTOStore[1]
        }
        else {
            ISA_USERS2 = CookieService.getLocalStorageValues("WO_Address") + '-' + JSON.parse(localStorage.getItem("StoreValue")); // When ship to not set for the billTOStore variable - Divis Kumar R K - WW-921,
        }

        //WW-687_PC_24 (4/19/2023)-Aparna
        let supplierDetail = []
        let pikcuplocation = " "

        if (this.state.Choose_Delivery_Btn_Click) {
            this.state.supplierList.forEach((x) => {
                if (x.pickupLocation != undefined && x.pickupLocation != null) {
                    if (x.pickupLocation == "C0W10") {
                        pikcuplocation = x.pickupLocation
                    } else if (x.pickupLocation == "LOWES") {
                        pikcuplocation = " "
                    }
                    else {
                        pikcuplocation = x.pickupLocation.value
                    }
                } else {
                    pikcuplocation = " "
                }
                let shipToDetails = {
                    supplier_ID: x.supplier_ID != null ? x.supplier_ID : " ",
                    ShipTo: x.shipTo.value,
                    USER_CHAR2: x.deliveryMethod == "Pickup" ? "PU" : " ",
                    Location: pikcuplocation
                }
                supplierDetail.push(shipToDetails)
            })
        }
        let PlaceOrderBo = {
            /*[06/24/22, PC_WW-390_24]Priyanka D*/
            Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
            SOURCE: "WEB",
            Session_UserID: this.state.Login_UserId,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_MANORDNO: CookieService.getLocalStorageValues("Session_MANORDNO"),
            Session_ORDERPREFIX: CookieService.getLocalStorageValues("Session_ORDERPREFIX"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            punchinSessionID: "",
            Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
            Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),//***NEW**CHANGED(cookieservice)***(1/21/2021)**Session_UserName-->Session_USERNAME
            Session_TestMode: CookieService.getLocalStorageValues("Session_TESTMODE"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            CurrentPage_Url: "/SDIXZEUS/ShoppingCart",
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_CARTFAIL: CookieService.getLocalStorageValues("Session_CARTFAIL"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ISABudgetaryLimit: CookieService.getLocalStorageValues("Session_ISABudgetaryLimit"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_ValidateWorkOrder: CookieService.getLocalStorageValues("Session_ValidateWorkOrder"),
            Validation_Status: "True",
            chkLineNumFlag: chkLineNumFlag,
            Session_ShowPrice: CookieService.getLocalStorageValues("Session_ShowPrice"),
            Session_PHONE: CookieService.getLocalStorageValues("Session_PHONE"),
            Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
            Session_RFQSITE: CookieService.getLocalStorageValues("Session_RFQSite"),
            Session_ISACstVendor: CookieService.getLocalStorageValues("Session_ISACstVendor"),
            Session_ISACstPrice: CookieService.getLocalStorageValues("Session_ISACstPrice"),
            Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
            Order_WorkOrder: CookieService.getLocalStorageValues("Session_CARTWOREQ") == 'N' && OLWorkOrder == "" ? " " : OLWorkOrder,
            Order_OrderNO: OLOrderNum,
            Order_DueDate: OLDueDate,
            Order_Customer_Notes: OLNotes,
            Order_EmployeeCC: OLEmployeeCC.value,
            Order_MachineNum: OLMachineNo,
            Order_Type: OLType,
            Order_Customer_Reference: OLCustomerRef,
            Order_ShipTo: (OLShipTo == '0' || OLShipTo == '' || OLShipTo == undefined) && this.state.BilltoStore != undefined ? this.state.BilltoStore.value : OLShipTo,
            Order_PriorityOrder: OLPriorityOrder,
            AddToFav_Order: status,
            Location2: var_vendor,
            USER_CHAR2: var_pickupcheck ? "PU" : "",
            ISA_USER2: ISA_USERS2,
            USER_CHAR1: UserChar1,
            OrderCategory: this.state.FavOrdCat,//WAL-541_PC_04 -Aparna
            OrderSubCategory: this.state.FavOrdSubCat,//WAL-541_PC_04 -Aparna
            OrderDescription: this.state.FavOrdDes, //WAL-541_PC_04 -Aparna
            ReorderReason: (this.state.reordervalue != null ? this.state.reordervalue[0].value : null),
            ReorderNotes: (document.getElementById("decreasoncmt").value != null ? document.getElementById("decreasoncmt").value : ""),
            reorderitems: listBO,
            //WW-375 Ability to add Image to Fav Order -Deepthi
            ImageFileName: this.state.attachmentPathArrImg != "" && this.state.attachmentPathArrImg != undefined && this.state.attachmentPathArrImg != null ? this.state.attachmentPathArrImg[0].FilePath : "",
            ImageFileBytes: this.state.attachmentPathArrImg != "" && this.state.attachmentPathArrImg != undefined && this.state.attachmentPathArrImg != null ? this.state.attachmentPathArrImg[0].FilePath : "",
            IsWeb: true,
            Pickuplist: LinePickupBO,
            haldetailBO: haldetailBO,
            NTE: CookieService.getLocalStorageValues("NTEAmount"),
            //WW-500-Pass the value of trade from Work order response to ISA_USERS4
            Trade: CookieService.getLocalStorageValues("Trade"),
            RefrigerantList: refrigerantList,
            isSplitDelivery: this.state.Choose_Delivery_Btn_Click,//WW-687_PC_24 (4/19/2023)-Aparna
            DeliveryDetail: supplierDetail, //WW-687_PC_24 (4/19/2023)-Aparna
            Order_WOCategory: CookieService.getLocalStorageValues("WO_CAT_DESC") == "" || CookieService.getLocalStorageValues("WO_CAT_DESC") == undefined || CookieService.getLocalStorageValues("WO_CAT_DESC") == null ? "" : CookieService.getLocalStorageValues("WO_CAT_DESC"),
            WO_Type: CookieService.getLocalStorageValues("WO_Type") == "" || CookieService.getLocalStorageValues("WO_Type") == undefined || CookieService.getLocalStorageValues("WO_Type") == null ? 'WALMART' : CookieService.getLocalStorageValues("WO_Type"),
            ISA_QUOTE_REF: isQuoteOrderSubmit ? "Quote" : "",
            RefOrderNo: refOrderNo,

        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ShoppingCartAction.SubmitOrder(PlaceOrderBo);
        this.setState({ FavOrder: status })
        // $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /*[03/16/22,WAL-721_PC_16,WAL-721], Priyanka D */
    reasonSubmitClick = () => {
        //;
        //let dec = document.getElementById("#decreasoncmt").value;
        let resonerr = "";
        if (this.state.reordervalue[0].value == "OTH" && document.getElementById("decreasoncmt").value == "") {
            resonerr = ". Please enter Comment!"
            this.setState({ resonerr: resonerr });
        } else {
            /*[04/06/22WW-370] Reorder popup should come after the Multiple supplier popup Priyanka D */
            if (this.state.hdfChangeLineNum == "Y") {
                this.setState({ LineIncrePUp: true });
                $('#line-increment').modal('show');
            } else {
                let punchoutcheck = false;
                let nonpunchout = false;
                let SrcNCCheck = false;
                let Equipment = false;
                //[1/11/23, WW-552, Dhevanesam R]
                let cartFormItems = [];
                let { CartItems } = this.state
                CartItems.forEach((x) => {
                    /*[06/09/22,WW-401, Only for Lowes punchout item, fav order popup should not be shown], Priyanka D */
                    if (x.PaintColor == "PUNCHOUT") {
                        punchoutcheck = true;
                    }
                    if (x.PaintColor == "WCAT" || x.PaintColor == "WNST") {
                        SrcNCCheck = true;
                    }
                    if (x.ISA_WBS_ELMNT === "Equipment") {
                        Equipment = true;
                    }
                })
                CartItems.map((val, index) => {
                    if (val.FilePath != undefined && val.FilePath != null && val.FilePath != "" && val.FilePath != " ") {
                        if (val.FilePath[0].toLowerCase().includes('form')) {
                            cartFormItems.push(val)
                        }
                    }
                })
                if (punchoutcheck || SrcNCCheck || isQuoteOrderSubmit || Equipment) {  //WW-1221 Preventive work order -Vishwa S
                    this.AddFavOrder("False")
                }

                else {
                    if (cartFormItems.length > 0) {
                        this.AddFavOrder("False")
                    }
                    else {
                        this.setState({ FavOrderConfPUp: true });
                        $('#Fav-confirmation').modal('show');
                    }
                }
                $('#reorderreason').modal('hide');
            }
        }
    }
    /*[03/16/22,WAL-721_PC_15,WAL-721], Priyanka D */
    handlereorderChange = (event) => {
        //
        let ROWArr = []
        this.state.reoderOptions.map((item, index) => {
            if (item.label == event.label && item.value == event.value) {
                let obj = {
                    label: event.label,
                    value: event.value,
                }
                ROWArr.push(obj);
            }
        });
        if (event.value == "OTH") {
            $('#comments').addClass('mandatory-after');
        } else if (document.getElementById("comments").className == "catalog-label d-block mandatory-after") {
            $('#comments').removeClass('mandatory-after');
        }
        this.setState({ reordervalue: ROWArr });
    }
    /*
     * RF No:SC_PC_52
     * This method is invoked when the action method SubmitOrder emits the response.
     * */
    OrderPlacedStatus = () => {
        //
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let OrderStatus = JSON.parse(ShoppingCartStore.PlaceOrderMsge);
        let Update_Session = OrderStatus.update_Session;
        if (Update_Session != null && Update_Session != "") {
            if (Update_Session.length > 0) {
                if (Update_Session[0].Session_SCbIsLyonsProcessing != null && Update_Session[0].Session_SCbIsLyonsProcessing != "") {
                    CookieService.updateLocalStorageValues("Session_SCbIsLyonsProcessing", Update_Session[0].Session_SCbIsLyonsProcessing);
                }
                if (Update_Session[0].Session_SCbIsWithPricedItems != null && Update_Session[0].Session_SCbIsWithPricedItems != "") {
                    CookieService.updateLocalStorageValues("Session_SCbIsWithPricedItems", Update_Session[0].Session_SCbIsWithPricedItems);
                }
                if (Update_Session[0].xmlToUrl != null && Update_Session[0].xmlToUrl != "") {
                    CookieService.updateLocalStorageValues("xmlToUrl", Update_Session[0].xmlToUrl);
                }
                if (Update_Session[0].PunchINxml != null && Update_Session[0].PunchINxml != "") {
                    CookieService.updateLocalStorageValues("PunchINxml", Update_Session[0].PunchINxml);
                }
                if (Update_Session[0].ARRParams != null && Update_Session[0].ARRParams != "") {
                    CookieService.updateLocalStorageValues("ARRParams", Update_Session[0].ARRParams);
                }
            }
        }
        let Remove_Session = OrderStatus.Remove_Session;
        if (Remove_Session != null && Remove_Session != "") {
            if (Remove_Session.length > 0) {
                if (Remove_Session[0].SUBMIT != null && Remove_Session[0].SUBMIT != "") {
                    CookieService.updateLocalStorageValues("Session_SUBMIT", "");
                }
                if (Remove_Session[0].gotStock != null && Remove_Session[0].gotStock != "") {
                    CookieService.updateLocalStorageValues("Session_gotStock", "");
                }
                if (Remove_Session[0].gotNSTK != null && Remove_Session[0].gotNSTK != "") {
                    CookieService.updateLocalStorageValues("Session_gotNSTK", "");
                }
            }
        }
        let Errortable = OrderStatus.ErrorTable;
        let OrderNum = OrderStatus.OrderNumber;
        if (Errortable.length > 0) {
            if (Errortable[0].WorkOrder_Validation != null && Errortable[0].WorkOrder_Validation != "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Errortable[0].WorkOrder_Validation
                });
                //alert(Errortable[0].WorkOrder_Validation)
            }
            if (Errortable[0].OrderNum_Validation != null && Errortable[0].OrderNum_Validation != "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Errortable[0].OrderNum_Validation
                });
                //  alert(Errortable[0].OrderNum_Validation)
            }
            if (Errortable[0].No_EnterPrise_Found != null && Errortable[0].No_EnterPrise_Found != "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Errortable[0].No_EnterPrise_Found
                });
                //alert(Errortable[0].No_EnterPrise_Found)
            }
            if (Errortable[0].ExideErrorHandling != null && Errortable[0].ExideErrorHandling != "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Errortable[0].ExideErrorHandling
                });
                //alert(Errortable[0].ExideErrorHandling)
            }
            if (Errortable[0].Serialize_Alert_Message != null && Errortable[0].Serialize_Alert_Message != "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Errortable[0].Serialize_Alert_Message
                });
                //   alert(Errortable[0].Serialize_Alert_Message)
            }
            if (Errortable[0].ReqId_DB_Error != null && Errortable[0].ReqId_DB_Error != "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Errortable[0].ReqId_DB_Error
                });
                // alert(Errortable[0].ReqId_DB_Error)
            }
            else {
                if (OrderNum.length > 0) {
                    if (OrderNum[0].NONSTOCK != null && OrderNum[0].NONSTOCK != "" && OrderNum[0].NONSTOCK != undefined) {
                        let OrderSuccessmessage = this.state.FavOrder == "True" ? "Your order placed successfully and added to favorites order" : OrderNum[0].NONSTOCK.startsWith('WQ') ? "Your order quoted successfully!" : "Your order placed successfully!"
                        this.setState({
                            /*'[10/04/22,WW-521_07-Saving Order count and ques], Priyanka D */
                            OrderPlacedstatus: OrderSuccessmessage, FavOrder: false, PricedOrderNum: OrderNum[0].sReqIdPriced, OrderCount: OrderNum[0].OrderCount, SurveyQues: OrderStatus.SurveyQues,
                            NonCataOrderNum: OrderNum[0].NONSTOCK
                        })
                        $('#Order-Placed').modal('show');
                    }
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Techincal Issue Contact SDI Customer Care"
                    });
                }
                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                // alert("Techincal Issue Contact SDI Customer Care");
            }
        }
        else {
            //let PdforderNum = "";
            if (OrderNum.length > 0) {
                if (OrderNum[0].NONSTOCK != null && OrderNum[0].NONSTOCK != "" && OrderNum[0].NONSTOCK != undefined) {
                    let OrderSuccessmessage = this.state.FavOrder == "True" ? "Your order placed successfully and added to favorites order" : OrderNum[0].NONSTOCK.startsWith('WQ') ? "Your order quoted successfully!" : "Your order placed successfully!"
                    this.setState({
                        /*'[10/04/22,WW-521_07-Saving Order count and ques], Priyanka D */
                        OrderPlacedstatus: OrderSuccessmessage, FavOrder: false, PricedOrderNum: OrderNum[0].sReqIdPriced, OrderCount: OrderNum[0].OrderCount, SurveyQues: OrderStatus.SurveyQues,
                        NonCataOrderNum: OrderNum[0].NONSTOCK
                    })
                    $('#Order-Placed').modal('show');
                }
            }
            $(`#${SDIConstants.SDILoader}`).addClass('hide');

        }
    }
    OrderPlaced = () => {
        if (this.state.IsInteractiveNonCat == false) {
            CookieService.updateLocalStorageValues("Shipment_Method", false)
            //[1/11/23, WW-552, Dhevanesam R]
            CookieService.updateLocalStorageValues("FormList", "")
            localStorage.removeItem("StoreValue");
            localStorage.removeItem("WONum");
            localStorage.removeItem("ShipToID")
            localStorage.removeItem("WO_Parts")//BUG:3618 -Aparna
            //WW -452_PC_01 WW-452 TEST SUPPLIERS PICKUP  Pavithra R
            localStorage.removeItem("BilltoStoreLocationLat")
            localStorage.removeItem("BilltoStoreLocationLong")
            //[10/18/22, WAL - 785 Getting Asset Tag and storing in a cookie value, Dhevanesam R
            CookieService.updateLocalStorageValues("AssetTag", "");
            CookieService.updateLocalStorageValues("AssetID", "");
            CookieService.updateLocalStorageValues("Trade", "");
            CookieService.updateLocalStorageValues("Category", "");
            CookieService.updateLocalStorageValues("Make", "");
            CookieService.updateLocalStorageValues("Model", "");
            //CookieService.updateLocalStorageValues("WO_Parts", "");//BUG:3618 -Aparna
            CookieService.updateLocalStorageValues("WO_Address", "");
            let ReqIdPriced = this.state.PricedOrderNum;
            let NonstockONum = this.state.NonCataOrderNum;

            //PdforderNum = ReqIdPriced != null && ReqIdPriced != "" ? ReqIdPriced : NonstockONum;
            //if (NonstockONum != null && NonstockONum != "") {
            //    let cartFileBo = {
            //        Session_UserID: this.state.Login_UserId,
            //        Session_BUSUNIT: this.state.Login_UserBU,
            //        OrderNO: NonstockONum,//"NY00446489",
            //        fileName: ""
            //    }
            //    //ShoppingCartAction.OrderPdf(cartFileBo)
            //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //}
            //else if (ReqIdPriced != null && ReqIdPriced != "") {
            //    let cartFileBo = {
            //        Session_UserID: this.state.Login_UserId,
            //        Session_BUSUNIT: this.state.Login_UserBU,
            //        OrderNO: ReqIdPriced,//"NY00446489",
            //        fileName: ""
            //    }
            //    //ShoppingCartAction.OrderPdf(cartFileBo)
            //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //}

            //else {

            //    this.props.history.push({
            //        pathname: `\HomePage`,
            //    });
            //}
            this.props.history.push({
                pathname: `\HomePage`,
            });
            //if (NonstockONum != null && NonstockONum != "") {
            //    let cartFileBo = {
            //        Session_UserID: this.state.Login_UserId,
            //        Session_BUSUNIT: this.state.Login_UserBU,
            //        OrderNO: NonstockONum,//"NY00446489",
            //        fileName: ""
            //    }
            //    ShoppingCartAction.OrderPdf(cartFileBo)
            //    $(`#${SDIConstants.SDILoader}`).addClass('hide');
            //}
            //if (this.state.base64URL == "") {
            //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //}
            //this.setState({ ShowPdf: true })
            //this.OrderPDFShow(true)
            //this.props.history.push({
            //    pathname: `\HomePage`,
            //});
        }
        else {
            this.props.history.push({
                pathname: `\WalmartRFQEntry`,
            });
        }
    }

    //WW-1163 Impaqx Noncatalog item remove -Vishwa S
    removeInteractiveNonCat = () => {
        let cancelorderBo = {
            userID: this.state.Login_UserId,
            userBU: this.state.Login_UserBU,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            Interactive: true
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $('#IntNonCatRemovePopup').modal('hide');
        WALNonCatalogAction.DeleteCartItem(cancelorderBo);
    }

    //WW-1163 Impaqx Noncatalog item remove response -Vishwa S
    removeItemResponse = () => {
        let deleteItem = JSON.parse(WALNonCatalogStore.deleteItem);
        let status = deleteItem.deleteStatusTable

        //WW-1231 WO State Restriction -Vishwa S
        if (status[0].deleteStatus == "True") {
            this.setState({ IsInteractiveNonCat: false })
            if (!this.state.isPageloadIsValidWO) {
                if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' && CookieService.getLocalStorageValues("Session_STATE") != CookieService.getLocalStorageValues("Session_WO_STATE")) {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    $('#loaderMessage').text('Validating Work Order# for the cart items...');
                    this.LoadCartItem(false)
                }
                else {
                    if (this.state.isValidWO && this.state.WO_Parts != undefined && this.state.WO_Parts != null) {
                        if (this.state.WO_Parts.length > 0) {
                            $('#WO_Parts_Popup').modal('show');
                        }
                    }
                }
            }
            else {
                if (this.state.isValidWO && this.state.WO_Parts != undefined && this.state.WO_Parts != null) {
                    if (this.state.WO_Parts.length > 0) {
                        $('#WO_Parts_Popup').modal('show');
                    }
                }
                //if (this.state.submitbtn) {
                //    this.submitOrder_Btn_Click()
                //}
                //else {
                //    $('#WO_Parts_Popup').modal('show');
                //}
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue -- Contact SDI"
            });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    /*'[10/04/22,WW-521_08-Determing whether feedback popup should be shown], Priyanka D */
    FeedbackPopup = () => {
        let SurveyQuesList = [];
        let IsFeedbackPopup = false;
        let IsRateNow = true;
        let QuesNo = 0;
        if (this.state.SurveyQues != undefined && this.state.SurveyQues.length > 0) {
            this.state.SurveyQues.map((val, index) => {
                let localArray = {
                    value: val.QUESTIONNO,
                    label: val.QUESTION
                }
                SurveyQuesList.push(localArray)

            });
            if (SurveyQuesList.length > 0) {
                IsFeedbackPopup = true
                QuesNo = 0;
            }
            if (SurveyQuesList.length > 1) {
                IsRateNow = false;
            }
            this.setState({ SurveyQuesList: SurveyQuesList, IsFeedbackPopup: IsFeedbackPopup, IsRateNow: IsRateNow, QuesNo: 0 })
            if (SurveyQuesList.length > 0) {
                $('#FeedbackPopup').modal('show');
            } else {
                this.OrderPlaced();
            }
        } else {
            this.OrderPlaced();
        }
    }
    /*'[10/04/22,WW-521_11-Invoked in the onchange of ratings in feedback popup], Priyanka D */
    Rating = (value) => {
        this.setState({ StarRating: value })
    }
    /*'[10/04/22,WW-521_10-Invoked in the onchange of comments in feedback popup], Priyanka D */
    HandleComments = (e) => {
        this.setState({ Comments: e.target.value })

    }
    /*'[10/04/22,WW-521_10-Invoked when Rate now.Next is clicked in feedback popup], Priyanka D */
    HandleNextQues = (type) => {
        let FeedbackList = [];
        let SurveyFeedback = this.state.SurveyFeedback;
        if (type == 1) {
            if ((this.state.StarRating != 0) || (this.state.Comments != "" && this.state.Comments != " " && this.state.Comments != null && this.state.Comments != undefined) || SurveyFeedback.length > 0) {
                SurveyFeedback.push({
                    QUESTIONNO: this.state.SurveyQuesList[this.state.QuesNo].value,
                    SCORE: this.state.StarRating,
                    COMMENTS: this.state.Comments

                });
                this.setState({ SurveyFeedback: SurveyFeedback })
                this.RatingSubmission(SurveyFeedback)
            } else {
                $('#FeedbackPopup').modal('hide');
                this.OrderPlaced();
            }

        } else if (type == 2) {
            if ((this.state.StarRating != 0 && this.state.StarRating != undefined && this.state.StarRating != null) || (this.state.Comments != "" && this.state.Comments != " " && this.state.Comments != null && this.state.Comments != undefined) || SurveyFeedback.length > 0) {
                SurveyFeedback.push({
                    QUESTIONNO: this.state.SurveyQuesList[this.state.QuesNo].value,
                    SCORE: this.state.StarRating,
                    COMMENTS: this.state.Comments,
                });
                if (this.state.SurveyQuesList.length == this.state.QuesNo + 2) {
                    this.setState({ IsRateNow: true, Comments: "", StarRating: 0, QuesNo: this.state.QuesNo + 1, SurveyFeedback: SurveyFeedback })
                } else if (this.state.SurveyQuesList.length > this.state.QuesNo + 1) {
                    this.setState({ IsRateNow: false, QuesNo: this.state.QuesNo + 1, Comments: "", StarRating: 0, SurveyFeedback: SurveyFeedback })
                }
            } else {
                if (this.state.SurveyQuesList.length == this.state.QuesNo + 2) {
                    this.setState({ IsRateNow: true, Comments: "", StarRating: 0, QuesNo: this.state.QuesNo + 1, SurveyFeedback: SurveyFeedback })
                } else if (this.state.SurveyQuesList.length > this.state.QuesNo + 1) {
                    this.setState({ IsRateNow: false, QuesNo: this.state.QuesNo + 1, Comments: "", StarRating: 0, SurveyFeedback: SurveyFeedback })
                }
            }
        }
    }
    /*'[10/04/22,WW-521_13], Priyanka D */
    Maybelater = () => {
        /*  if (this.state.SurveyFeedback.length > 0) {
              this.RatingSubmission(this.state.SurveyFeedback)
          } else {
              $('#FeedbackPopup').modal('hide');
              this.OrderPlaced();
          }*/

        /********-PC_01 WW-575 May Be later Insertion-(12/20/2022-Pavithra R)***********/

        let SurveyFeedback = this.state.SurveyFeedback;
        let SurveyQuesList = this.state.SurveyQuesList;
        let SurveyFeedbackList = this.state.SurveyFeedback;

        SurveyQuesList.forEach((x) => {
            let questno = x.value
            if (SurveyFeedback.length == 0) {
                SurveyFeedbackList.push({
                    QUESTIONNO: questno,
                    SCORE: 0,
                    COMMENTS: 'Selected Maybe Later'

                });
            } else {

                // SurveyFeedback.forEach((y) => {
                let IsNotRated = SurveyFeedback.filter((y) => x.value == y.QUESTIONNO)
                if (IsNotRated.length == 0) {
                    SurveyFeedbackList.push({
                        QUESTIONNO: questno,
                        SCORE: 0,
                        COMMENTS: 'Selected Maybe Later'

                    });


                }
                // })
            }
        });
        console.log("SurveyFeedbackList", SurveyFeedbackList);
        this.setState({ SurveyFeedback: SurveyFeedbackList })
        this.RatingSubmission(SurveyFeedbackList)

    }
    /********-PC_01 WW-575 May Be later Insertion(12/20/2022-Pavithra R)-**********/







    /*'[10/04/22,WW-521_12-Rating Submission], Priyanka D */
    RatingSubmission = (SurveyFeedback) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $('#FeedbackPopup').modal('hide');
        let RatingSubmissionBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            SurveyFeedback: SurveyFeedback
        };
        ShoppingCartAction.RatingSubmission(RatingSubmissionBO);
    }
    /*'[10/04/22,WW-521_10-Show the toast message and the PDF], Priyanka D */
    FeedbackResponse = () => {
        $('#FeedbackPopup').modal('hide');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#FeedbackResponse').modal('show');

    }
    /*
     * This method is invoke the action OrderPdf emit the response.
     * */
    OrderPDFShow = () => {
        OrderSuccessCOunt = OrderSuccessCOunt + 1
        let OrderPdf = ShoppingCartStore.OrderPDFMsge;
        //if ((hidden == true || this.state.ShowPdf == true) && (this.state.base64URL != "" || OrderPdf != "")) {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#pdfPreview').modal('show');
        // }
        this.setState({ base64URL: OrderPdf, PricedOrderNum: "", NonCataOrderNum: "" })
        //let win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1005,height=500,top=" + (window.screen.height - 200) + ", left = " + (window.screen.width - 300));
        //
        //win.document.body.innerHTML = '<iframe width = "100%" height = "100%" src = "' + OrderPdf + '"></iframe>';
    }
    /*
     * Reused from the non catalog require page.
     * To check the length of the attached file name.
     * */
    FavItemhandleImgAttachment = (event) => {
        //
        this.setState({ imgAttachment: true })
        let files = event.target.files;
        console.log("event", files);
        if (this.state.ImagePathArr != undefined) {
            if (this.state.ImagePathArr.length < 1) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                /*[03/23/22,WW-373], Priyanka D, Invoke addAttachment in ShoppingCartAction instead of invoking from NonCatalogAction*/
                ShoppingCartAction.addAttachment(files);
            } else {
                let lblerror = "You can choose only one Image"
                document.getElementById("lblerror").innerText = lblerror;
            }
        } else {
            document.getElementById("lblerror").innerText = "";
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            /*[03/23/22,WW-373], Priyanka D, Invoke addAttachment in ShoppingCartAction instead of invoking from NonCatalogAction*/
            ShoppingCartAction.addAttachment(files);
        }
    };
    handleAttachment = (event) => {
        document.getElementById("AttachError").innerText = ""
        let files = event.target.files;
        let Attachments = this.state.attachmentPathArr
        let filesvalue = []
        let removevalue = this.state.removeattach
        if (files.length > 0) {
            if (this.state.attachmentPathArr != null && this.state.attachmentPathArr != undefined) {
                if (this.state.attachmentPathArr.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        let isDuplicate = this.state.attachmentPathArr.filter((attach) => attach.FileName == files[i].name).length > 0 ? true : false;
                        if (isDuplicate) {
                            document.getElementById("AttachError").innerText = "Selected file is already attached, please try again"
                            this.setState({ attachmentErrormsg: "Selected file is already attached, please try again" });
                            return false;
                        }
                        if (removevalue != null && removevalue != undefined) {
                            if (removevalue.length > 0) {
                                this.state.removeattach.map((val, index) => {
                                    if (val.FileName == files[i].name) {
                                        Attachments.push(val)
                                        removevalue.splice(index, 1);
                                    }
                                    else {
                                        filesvalue.push(files[i])
                                    }
                                });
                            }
                            else {
                                filesvalue.push(files[i])
                            }
                        }
                        else {
                            filesvalue.push(files[i])
                        }
                    }
                }
                else {
                    for (let i = 0; i < files.length; i++) {
                        if (removevalue != null && removevalue != undefined) {
                            if (removevalue.length > 0) {
                                this.state.removeattach.map((val, index) => {
                                    if (val.FileName == files[i].name) {
                                        Attachments.push(val)
                                        removevalue.splice(index, 1);
                                    }
                                    else {
                                        filesvalue.push(files[i])
                                    }
                                });
                            }
                            else {
                                filesvalue.push(files[i])
                            }
                        }
                        else {
                            filesvalue.push(files[i])
                        }
                    }
                }
                let filepathlength = ""
                //let filearray = Attachments
                //if (filesvalue != null && filesvalue != undefined) {
                //    if (filesvalue.length != 0) {
                //        for (let j = 0; i < filesvalue.length; j++) {
                //            filearray.push(Attachments[0])
                //        }
                //    }
                //}
                if (Attachments != null && Attachments != undefined) {
                    for (let i = 0; i < Attachments.length; i++) {
                        filepathlength = filepathlength + Attachments[i].FilePath + "|"
                    }
                }
                if (filesvalue != null && filesvalue != undefined) {
                    for (let j = 0; j < filesvalue.length; j++) {
                        filepathlength = filepathlength + filesvalue[j].name + "|"
                    }
                }
                let Vlauelength = filepathlength.length
                let lengthvalidate = filepathlength.length > 254 ? 1 : 0
                if (lengthvalidate == 1) {
                    document.getElementById("AttachError").innerText = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                    return
                }
                else {
                    document.getElementById("AttachError").innerText = ""
                }
                if (lengthvalidate != 1) {
                    if (filesvalue != null && filesvalue != undefined) {
                        if (filesvalue.length > 0) {
                            ShoppingCartAction.addAttachment(filesvalue);
                        }
                    }
                    this.setState({ attachmentPathArr: Attachments, removeattach: removevalue })
                }
                $("#ShopCartcustomFile").val('');
            }
        }
    };
    /*
     * Reused from the non catalog require page.
     * Download attach file.
     * */
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        ShoppingCartAction.downloadAttachment(downloadBO);
    };
    /*
     * Reused from the non catalog require page.
     * Remove the attachment file.
     * */
    removeAttachmentsImg = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }
    FavOrderRemoveAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ShoppingCartAction.FavOrderRemoveAttachments(removeBO);
    }
    removeAttachments = (filepath, index) => {
        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let tempAttachments = this.state.attachmentPathArr;
        let RemoveAtt = tempAttachments[index]
        let removeattachL = []
        removeattachL.push(RemoveAtt)
        tempAttachments.splice(index, 1);
        this.setState({ attachmentPathArr: tempAttachments, removeattach: removeattachL });
        let filepathlength = ""
        for (let i = 0; i < tempAttachments.length; i++) {
            filepathlength = filepathlength + tempAttachments[0].FilePath + "|"
        }
        let lengthvalidate = filepathlength.length > 254 ? 1 : 0
        if (lengthvalidate == 1) {
            document.getElementById("AttachError").innerText = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
        }
        else {
            document.getElementById("AttachError").innerText = ""
        }
        //rmvAttachindex = index
        //let removeBO = {
        //    filePath: filepath
        //}
        //ShoppingCartAction.removeAttachment(removeBO);
    }
    //removeAttachments = (filepath, index) => {
    //    //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
    //    let tempAttachments = this.state.attachmentPathArr;
    //    let RemoveAtt = tempAttachments[index]
    //    let removeattachL = []
    //    removeattachL.push(RemoveAtt)
    //    tempAttachments.splice(index, 1);
    //    this.setState({ attachmentPathArr: tempAttachments, removeattach: removeattachL });
    //    let filepathlength = ""
    //    for (let i = 0; i < tempAttachments.length; i++) {
    //        filepathlength = filepathlength + tempAttachments[0].FilePath + "|"
    //    }
    //    let lengthvalidate = filepathlength.length > 254 ? 1 : 0
    //    if (lengthvalidate == 1) {
    //        document.getElementById("AttachError").innerText = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
    //    }
    //    else {
    //        document.getElementById("AttachError").innerText = ""
    //    }
    //    //rmvAttachindex = index
    //    //let removeBO = {
    //    //    filePath: filepath
    //    //}
    //    //ShoppingCartAction.removeAttachment(removeBO);
    //}
    ///*
    //* Reused from the non catalog require page.
    //* Bind from the attachment pop up. attachmentPathArrImg
    //* */
    bindAttachments = () => {
        console.log("attachmentPathArr", this.state.attachmentPathArr)
        if (this.state.imgAttachment == true) {
            return this.state.ImagePathArr.map((attachment, index) => {
                return (
                    <div className="w-100 mt-2" key={index}>
                        <a href="#" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                        <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachmentsImg(attachment.FilePath, index)}>X</span>
                    </div>
                );
            });
        } else {
            let atatchmentdata = this.state.attachmentPathArr
            if (atatchmentdata != null && atatchmentdata != undefined && atatchmentdata != "" && atatchmentdata != " ") {
                if (atatchmentdata.length > 0) {
                    return atatchmentdata.map((attachment, index) => {
                        return (
                            <div className="w-100 mt-2" key={index}>
                                <a href="#" onClick={(e) => this.downloadAttachment(e, attachment)} data-toggle="tooltip" title={attachment.FileName}>{attachment.FileName}</a>
                                <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X  </span>
                            </div>
                        );
                    });
                }
            }
        }
    };
    bindAttachmentsImg = () => {
        console.log("attachmentPathArrImg", this.state.attachmentPathArrImg)
        {/* if (this.state.imgAttachment == true) {
            return this.state.ImagePathArr.map((attachment, index) => {
                return (
                    <span className="attachment-file-name pl-0 my-2 pr-3 d-inline-block" key={index}>
                        <a className="noncat-Attachment-overflow" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                        <span className="attachment-remove-icon ml-1" onClick={() => this.FavOrderRemoveAttachments(attachment.FilePath, index)}>X</span>
                    </span>
                );
            });
        } else {*/}
        let atatchmentdata = this.state.attachmentPathArrImg
        if (atatchmentdata != null && atatchmentdata != undefined) {
            if (atatchmentdata.length > 0) {
                return this.state.attachmentPathArrImg.map((attachment, index) => {
                    console.log("attachmentPathArrImg", attachment.FilePath)
                    return (
                        <div className="attachment-file-name mt-2 col-md-4 p-0" style={{ width: "147%", marginTop: "45px" }} key={index}>
                            <a href="#" className="Attachment-overflow col-4 p-0" onClick={(e) => this.downloadAttachment(e, attachment)} data-toggle="tooltip" title={attachment.FileName}>{attachment.FileName}</a>
                            <span className="attachment-remove-icon ml-1" onClick={() => this.FavOrderRemoveAttachments(attachment.FilePath, index)}>X  </span>

                        </div>
                    );
                });
            }
        }
        {/*}*/ }
    };
    /*
     * Reused from the non catalog require page.
     * Load attachment.
     * */
    loadAttachments = () => {
        //
        if (this.state.imgAttachment == true) {
            //document.getElementById("AttachError").innerText = ""
            let tempAttachments = ""
            let isValid = ShoppingCartStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
            $("#ShopCartcustomFile").val('');
            if (isValid) {
                /*[03/23/22,PC_32,WAL-511], Priyanka D */
                let attachmentResponse = JSON.parse(ShoppingCartStore.attachmentResponse);
                if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "You can choose only the Image files!!"
                    });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    //alert("You can choose only the Image files!!")
                    return;
                }
                tempAttachments = this.state.ImagePathArr;
                if (tempAttachments != null) {
                    tempAttachments = tempAttachments.concat(attachmentResponse);
                }
                else {
                    tempAttachments = attachmentResponse;
                }
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names"
                });
                //  alert("You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names");
                document.getElementById("AttachError").innerText = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                this.setState({
                    attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                });
            }
            this.setState({ ImagePathArr: tempAttachments })
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        } else {
            //document.getElementById("AttachError").innerText = ""
            let tempAttachments = ""
            let isValid = ShoppingCartStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
            $("#ShopCartcustomFile").val('');
            if (isValid) {
                let attachmentResponse = JSON.parse(ShoppingCartStore.attachmentResponse);
                //BUG 2421 CANNOT ABLE TO ADD MUTIPLE FILES  Pavithra R
                tempAttachments = this.state.attachmentPathArr;
                if (tempAttachments != null) {
                    tempAttachments = tempAttachments.concat(attachmentResponse);
                }
                else {
                    tempAttachments = attachmentResponse;
                }
                this.setState({ attachmentPathArr: tempAttachments })
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names"
                });
                // alert("You have exceeded the length of total file names.\nPlease adjust your entry or remove longer file names");
                document.getElementById("AttachError").innerText = "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                this.setState({
                    attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                });
            }
            // this.setState({ attachmentPathArr: tempAttachments })
        }
    };
    /*
     * Reused from the non catalog require page.
     * Remove attachment response.
     * 
     * */
    removeAttachmentResponse = () => {
        if (this.state.imgAttachment == true) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
            if (isValid) {
                document.getElementById("lblerror").innerText = "";
                let tempAttachments = this.state.ImagePathArr;
                tempAttachments.splice(rmvAttachindex, 1);
                this.setState({ ImagePathArr: tempAttachments });
                rmvAttachindex = -1;
            } else {
                let isValid = ShoppingCartStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
                if (isValid) {
                    //let tempAttachments = this.state.attachmentPathArr;
                    //tempAttachments.splice(rmvAttachindex, 1);
                    //this.setState({ attachmentPathArr: tempAttachments });
                    //rmvAttachindex = -1;
                }
            }
        }
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
    };
    FavOrderremoveAttachmentResponse = () => {
        //  if (this.state.imgAttachment == true) {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = ShoppingCartStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            //document.getElementById("lblerror").innerText = "";
            //let tempAttachments = this.state.attachmentPathArrImg;
            //tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ attachmentPathArrImg: [] });
            document.getElementById("Favlblerror").innerText = "";
            //rmvAttachindex = -1;
        } else {
            let isValid = ShoppingCartStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
            if (isValid) {
                //let tempAttachments = this.state.attachmentPathArr;
                //tempAttachments.splice(rmvAttachindex, 1);
                //this.setState({ attachmentPathArr: tempAttachments });
                //rmvAttachindex = -1;
            }
        }
        //}
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
    };
    /*
     * RF No: SC_PC_50
     * Cancel order button click.
     * */
    CancelOrder = () => {
        let cancelorderBo = {
            Session_UserID: this.state.Login_UserId,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            Interactive: false  //WW-1163 additional key to differentiate Impaqx Noncatalog item remove from shoppingcart -Vishwa S
        }
        ShoppingCartAction.CancelOrderItem(cancelorderBo);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //[1/11/23, WW-552, Dhevanesam R]
        CookieService.updateLocalStorageValues("FormList", "")
    }
    /*
     * RF No: SC_PC_50
     * This method is invoke when the CancelOrderItem response is emitted.
     * */
    COStatus = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let CancelResponse = JSON.parse(ShoppingCartStore.CancelOrderMsge);
        if (CancelResponse == null || CancelResponse == "" || CancelResponse == " ") {
            this.refreshMenu();
            this.props.history.push({
                pathname: "/HomePage",
            });
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue -- Contact SDI"
            });
            //  alert("Technical Issue -- Contact SDI")
        }
    }
    BacktoSearh = (Type) => {
        //let searchvalue = CookieService.getLocalStorageValues("Session_SearchValue")

        if (Type == 2) {
            let searchkeyvalue = Searchkeywoed.replace(/&/g, "%26") //WW-875_PC_01
            searchkeyvalue = searchkeyvalue.replace(/#/g, "%23")
            this.props.history.push({
                pathname: `\searchresults`,
                search: `?key=${searchkeyvalue}`
            });
        }
        else if (Type == 3) {
            this.props.history.push({
                pathname: "/HomePage",
            });
        }
        else {
            this.props.history.push({
                pathname: `\Favorites`,
            });
        }
    }
    onAccordianClick = (Status) => {
        $('#order-row1').toggleClass('d-none');
        $('tr').removeClass('tr-border');
        //$('#order-row2').addClass('tr-border');
        let SHowOrder = Status
        if (SHowOrder == 0) {
            SHowOrder = 1
            $('#order-row2').toggleClass('accordion-arrow-change1');
            let ClassAvailable = document.getElementById('order-row2').className;
            if (ClassAvailable == "accordion-arrow1 float-left accordion-arrow-change1") {
                $('#order-row2').removeClass('accordion-arrow-change1')
            }
            $('#order-row1').removeClass('d-none');
        }
        else {
            SHowOrder = 0
            $('#order-row2').toggleClass('accordion-arrow-change1');
            $('#order-row1').addClass('d-none');
        }
        this.setState({ ShowOrderDetails: SHowOrder })
    };
    clearAttaValid = () => {
        $("#ShopCartcustomFile").val('');
        document.getElementById("AttachError").innerText = ""
    }
    expandAll = () => {
        let { CartItems } = this.state
        let l = 0
        if (this.state.isExpand == false) {
            this.setState({ isExpand: true });
            $('.supplierH').removeClass('accordion-arrow-change');
            $('.supplierC').addClass('d-none');
            $('.supplierH').addClass('accordion-arrow-change');
            $('.supplierC').removeClass('d-none');
        } else {
            this.setState({ isExpand: false });
            $('.supplierH').addClass('accordion-arrow-change');
            $('.supplierC').removeClass('d-none');
            $('.supplierH').removeClass('accordion-arrow-change');
            $('.supplierC').addClass('d-none');


        }
        //if (this.state.isExpand == false) {
        //    this.setState({ isExpand: true });
        //    $('.header-arrow').removeClass('accordion-arrow-change');
        //    $('.content-row').addClass('d-none');
        //    $('.header-arrow').addClass('accordion-arrow-change');
        //    $('.content-row').removeClass('d-none');
        //} else {
        //    this.setState({ isExpand: false });
        //    $('.header-arrow').addClass('accordion-arrow-change');
        //    $('.content-row').removeClass('d-none');
        //    $('.header-arrow').removeClass('accordion-arrow-change');
        //    $('.content-row').addClass('d-none');

        //}
    }
    onAccordianClickitemlevel = (event, index) => {
        if (event) {
            event.preventDefault();
        }
        let itemid = "order-row-" + index;
        let itemidvalue = "#order-row-" + index;
        let ClassAvailable = document.getElementById(itemid).className;
        if (ClassAvailable == "col-md-12 pt-3 mt-2 border-top accordian-body d-none") {
            $(itemidvalue).removeClass('d-none');
        }
        else {
            $(itemidvalue).addClass('d-none');
        }
    };
    headerRedirect = (event, pageName) => {
        let queryParamindex = pageName.indexOf("?");
        let pagePath = pageName;
        let queryParams = "";
        if (queryParamindex > 0) {
            pagePath = pageName.substring(0, queryParamindex);
            queryParams = pageName.substring(queryParamindex, pageName.length);
        };
        event.preventDefault();
        this.props.history.push({
            pathname: pagePath,
            search: queryParams
        });
    };
    /*[11/25/22, PC_WAL-926_16], Priyanka D */

    handleChangeShipto = (values) => {
        let ShipToSelected = []
        let shiptoValue = ""

        if (values != undefined && values != null) {
            document.getElementById('StatusMsg1').innerText = " "
            document.getElementById('StatusMsg').innerText = " "
        }
        if (values.label != undefined && values.label != null) {
            if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                ShipToSelected = values.label.split("-")
                if (ShipToSelected != undefined && ShipToSelected != null && ShipToSelected.length > 1) {
                    shiptoValue = ShipToSelected[2].replace("miles", "")
                }
                if (shiptoValue > 100 && this.state.Choose_Delivery_Btn_Click == false) {

                    this.setState({ largerMilesShipto: values })
                    $('#GreaterThan100Miles').modal('show');

                } else {
                    let bool = false
                    let shiptoDD = this.state.shiptoDD
                    let shiptoLat = "";
                    let shiptoLong = "";

                    shiptoDD.filter((y) => y.CUSTID == values.value).map((i) => {

                        shiptoLat = i.LATITUDE;
                        shiptoLong = i.LONGITUDE

                    })

                    if (this.state.HalLocationChecked == true) {
                        this.BindHAL(shiptoLat, shiptoLong)

                    }
                    //if (values.value == "0") {
                    //    bool = true
                    //}
                    this.setState(
                        { defaultShipto: values, shiptoLat: shiptoLat, shiptoLong: shiptoLong, onchangeshipto: true });
                    if (this.state.Choose_Delivery_Btn_Click) {
                        this.suppliers_DeliveryMethod(values, shiptoValue)
                    }

                }
            }
            this.setState({ defaultShipto: values, onchangeshipto: true });


        }

    }
    /*[11/25/22, PC_WAL-926_17], Priyanka D */
    largerMilesClick = () => {
        let bool = false

        let largerMilesShipto = this.state.largerMilesShipto;
        //if (this.state.largerMilesShipto.value == "0") {
        //    bool = true
        //}

        let shiptoDD = this.state.shiptoDD
        let shiptoLat = "";
        let shiptoLong = "";

        shiptoDD.filter((y) => y.CUSTID == largerMilesShipto.value).map((i) => {

            shiptoLat = i.LATITUDE;
            shiptoLong = i.LONGITUDE

        })

        if (this.state.HalLocationChecked == true) {
            this.BindHAL(shiptoLat, shiptoLong)

        }

        this.setState({ defaultShipto: this.state.largerMilesShipto, shiptoLat: shiptoLat, shiptoLong: shiptoLong, Halloc: [], onchangeshipto: true })
    }




    //****************Warehouseresponse***************
    warehouseqtyresponse = () => {

        let lowescount = 0;
        let Workorderresponse = JSON.parse(ShoppingCartStore.workorderresponse);
        let str = "sysadm8.wal_item_inventory(inv_item_id,'" + LOCATION + "')"
        let local = Workorderresponse.Table
        let st
            ;
        /*[11/25/22, PC_WAL-926_09], Priyanka D */
        let notavail = this.state.WNA;
        let cartitem = this.state.CartItems.filter((x) => x.SupplierID == "W999999999" && x.PaintColor != "WNST" && x.PaintColor != "WCAT");
        if (local.length > 0) {
            local.forEach((x) => {
                if (x.QTY != null) {
                    //
                    st = x.QTY.split('^')[0];
                    cartitem.forEach((y) => {
                        let notAvailIndex = notavail.findIndex((x) => y.Itemid == x.item)
                        if (notAvailIndex == -1) {
                            if (x.INV_ITEM_ID == y.Itemid && parseInt(st) < parseInt(y.Quantity)) {
                                if (parseInt(st) == 0) {
                                    let loc = {
                                        item: x.INV_ITEM_ID,
                                        label: "Not Available",
                                        qty: "0",
                                        mfgpart: y.Manufacturerpartnumber
                                    }
                                    notavail.push(loc)
                                }
                                else {
                                    let loc = {
                                        item: x.INV_ITEM_ID,
                                        label: "Available qty: " + st,
                                        qty: st,
                                        mfgpart: y.Manufacturerpartnumber
                                    }
                                    notavail.push(loc)
                                }
                            }
                        } else {
                            if ((x.INV_ITEM_ID == y.Itemid) && (parseInt(st) == parseInt(y.Quantity))) {
                                notavail.splice(notAvailIndex, 1)

                            }
                        }
                    })
                }
                else {
                    let notAvailIndex = notavail.findIndex((y) => x.INV_ITEM_ID == y.item)
                    if (notAvailIndex == -1) {
                        let unAvailItem = this.state.CartItems.filter((y) => y.SupplierID == "W999999999" && y.Itemid == x.INV_ITEM_ID)
                        let loc = {
                            item: x.INV_ITEM_ID,
                            label: "Not Available",
                            qty: "0",
                            mfgpart: unAvailItem[0].Manufacturerpartnumber
                        }
                        notavail.push(loc)
                    }
                }
            })
        }
        //WW-459_PC_01 (for pushing the item which is not returned from store procedure) (8/26/2022)-Aparna
        if (local.length != cartitem.length) {
            cartitem.forEach((x) => {
                let notAvailIndex = notavail.findIndex((y) => x.Itemid == y.item)
                if (notAvailIndex != 0) {
                    let index = local.filter((y) => y.INV_ITEM_ID == x.Itemid)
                    if (index.length == 0 || index == undefined) {
                        let loc = {
                            item: x.Itemid,
                            label: "Not Available",
                            qty: "0",
                            mfgpart: x.Manufacturerpartnumber
                        }
                        notavail.push(loc)
                    }
                }
            })

        }


        //console.error("notavail", notavail);
        //WW-687_PC_21 (4/12/2023)-Aparna
        if (notavail == undefined || notavail.length == 0) {
            if (!this.state.Choose_Delivery_Btn_Click) {
                if (this.formItem_Check() || refOrderNo != "") {
                    if (!isQuoteOrderSubmit) {
                        if (this.is_Multiple_Supplier_Check()) {
                            //WW-600_PC_03 (1/26/2023)-Aparna
                            this.IsRefrigerantInCart()

                        } else {
                            $(`#${SDIConstants.SDILoader}`).addClass('hide');
                            //$('#splitDelivery_Popup').modal('show')
                            return false
                        }
                    }
                    else {
                        this.IsRefrigerantInCart("QUOTE")
                    }

                } else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    //$('#splitDelivery_Popup').modal('show')
                    return false
                }

            } else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                if (this.state.chooseDelivery_Submit_btn_Click) {
                    this.ReorderCheck()
                } else {
                    if (this.formItem_Check()) {
                        $('#splitDelivery_Popup').modal('show')
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    } else {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    }
                    //  $('#QTY-popup').modal('show');
                    // this.setState({ WNA: notavail, Choose_Delivery_Btn_Click: false, chooseDelivery_Submit_btn_Click:false })
                }
                // return false
            }

        }
        else {
            ;
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#QTY-popup').modal('show');
            this.setState({ WNA: notavail, Choose_Delivery_Btn_Click: false });//WW-687_PC_21 (4/12/2023)-Aparna
        }
    }
    NAItems = () => {
        //return this.state.WNA.map((val, ind) => {
        //        return (<>
        //            <label className="confirm-label d-block" style={{ fontSize: "15px", width: "50%", float: "left" }}>{`${val.item}(${val.label})`}</label>
        //        </>)
        //    })
        if (this.state.WNA != [] && this.state.WNA != undefined) {
            if (this.state.WNA.length > 1) {
                return this.state.WNA.map((val, ind) => {
                    return (<>
                        <label className="confirm-label d-block" style={{ fontSize: "15px", width: "50%", float: "left" }}>{`${val.mfgpart}(${val.label})`}</label>
                    </>)
                })
            }
            else {
                return this.state.WNA.map((val, ind) => {
                    return (<>
                        <label className="confirm-label d-block" style={{ fontSize: "15px" }}>{`${val.mfgpart}(${val.label})`}</label>
                    </>)
                })
            }
        }
    }
    //WW-375 Ability to add Image to Fav Order -Deepthi
    handleAttachmentImg = (event) => {
        //
        let files = event.target.files;
        console.log("event", files);
        //WW-375 Ability to add Image to Fav Order - Deepthi 
        let acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        if (acceptedImageTypes.includes(files[0].type)) {
            //if (files.length > 0) {

            //    this.setState({ attachmentErrormsg: "", ImageFileName: files[0].name });
            //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //    ShoppingCartAction.addAttachmentImg(files);
            //}
            if (this.state.attachmentPathArrImg != undefined) {

                if (this.state.attachmentPathArrImg.length == 0) {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ShoppingCartAction.addAttachmentImg(files);
                } else {

                    let lblerror = "You can choose only one Image"
                    document.getElementById("Favlblerror").innerText = lblerror;
                }

            } else {
                document.getElementById("Favlblerror").innerText = "";
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ShoppingCartAction.addAttachmentImg(files);
            }
        }
        //else {
        //    //WW-375 Ability to add Image to Fav Order - Deepthi 
        //    event.target.value = "";
        //    swal({
        //        allowOutsideClick: false,
        //        closeOnClickOutside: false,
        //        text: "Please choose only Image file "
        //    });
        //    //alert("Please choose only Image file ");
        //}
    };
    EmployeeDD = (employidDropDown) => {
        //
        let EmpDDValue = []
        if (employidDropDown.length > 0) {
            employidDropDown.map((val, index) => {
                let localArray = {
                    value: val.EMP_ID,
                    label: val.ISA_EMPLOYEE_NAME + "   " + val.ISA_EMPLOYEE_EMAIL
                }
                EmpDDValue.push(localArray)
                if (CookieService.getLocalStorageValues("Session_UserID") == val.EMP_ID) {
                    this.setState({ OrderEmpyId: localArray })
                }
            });
        }
        this.setState({ EmplyeeNameDD: EmpDDValue });
    };
    //HalCountryCodeDD = () => {
    //    if (localStorage.getItem("HALCountryCode") != null) {
    //        let HALcountrycode = JSON.parse(localStorage.getItem("HALCountryCode"))
    //        let CountryArray = []
    //        HALcountrycode.map((val, index) => {

    //            let localarray = {
    //                value: val.COUNTRY_2CHAR,
    //                label: val.COUNTRY_2CHAR
    //            }
    //            CountryArray.push(localarray)

    //        });

    //        this.setState({ HALCountryCodeDD: CountryArray })
    //    }
    //}
    QTYNA = (click) => {
        /*[11/25/22, PC_WAL-926_10], Priyanka D */

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let DeleteItemID = [];
        let favDetails = [];
        if (click == "1") {
            let locDeleteItemID = this.state.WNA;
            let CartitemList = this.state.CartItems
            locDeleteItemID.forEach((x) => {
                CartitemList.filter((y) => y.Itemid == x.item).map((i) => {
                    let loc = {
                        ItemId: i.Itemid,
                        UniqNum: i.UniqNum
                    }
                    DeleteItemID.push(loc)
                })
            })
            /*[11/25/22, PC_WAL-926_10], Priyanka D */

            locDeleteItemID.forEach((x) => {
                favDetails = this.state.FavMenuSub.filter((y) => y.CUSTOMERITEMID == x.item)
            })
            this.setState({ favUnavailItems: favDetails })
            let DeleteItemBO = {

                userID: this.state.Login_UserId,
                userBU: this.state.Login_UserBU,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                NAItemFlag: true,
                ItemIdList: DeleteItemID,
                DeleteFlag: true
            };
            ShoppingCartAction.DeleteCartItem(DeleteItemBO);
        }
        else if (click == "2") {
            let locDeleteItemID = this.state.WNA;
            let CartitemList = this.state.CartItems
            let { CartItems } = this.state;
            //let DeleteItemID = [];
            let index;
            locDeleteItemID.forEach((x) => {
                if (parseInt(x.qty) == 0) {
                    CartitemList.filter((y) => y.Itemid == x.item).map((i) => {
                        let loc = {
                            ItemId: i.Itemid,
                            UniqNum: i.UniqNum
                        }
                        DeleteItemID.push(loc)
                    })
                } else {
                    index = CartitemList.findIndex((y) => y.Itemid == x.item)
                    if (index != -1) {
                        CartItems[index].Quantity = x.qty;
                    }
                }
                locDeleteItemID.forEach((x) => {
                    favDetails = this.state.FavMenuSub.filter((y) => y.CUSTOMERITEMID == x.item)
                })
                this.setState({ favUnavailItems: favDetails })
            })
            if (DeleteItemID.length > 0) {
                let DeleteItemBO = {
                    userID: this.state.Login_UserId,
                    userBU: this.state.Login_UserBU,
                    Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                    NAItemFlag: true,
                    ItemIdList: DeleteItemID,
                    DeleteFlag: true
                };
                ShoppingCartAction.DeleteCartItem(DeleteItemBO);
            }
            // let loc = [];
            if (DeleteItemID.length == 0) {
                let qtychange = []
                if (this.state.WNA.length > 0) {
                    this.state.WNA.map((x) => {
                        if (x.label.includes("qty")) {
                            CartitemList.filter((y) => y.Itemid == x.item).map((i) => {
                                let loc = {
                                    ItemId: i.Itemid,
                                    UniqNum: i.UniqNum,
                                    Qty: x.qty
                                }
                                qtychange.push(loc)
                            })
                            //let index = CartItems.findIndex(y => y.Itemid == x.ItemId);
                            //let uni = CartItems[index].UniqNum
                            //let qt = CartItems[index].Quantity
                            //loc = {
                            //    ItemId: x.ItemId,
                            //    UniqNum: uni,
                            //    Qty: qt
                            //}
                            //qtychange.push(loc)
                        }
                    })
                }
                if (qtychange.length > 0) {
                    let UpdateItemDetails = {
                        userID: this.state.Login_UserId,
                        userBU: this.state.Login_UserBU,
                        Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                        fldToUpdate: "Quantity",
                        NAItemFlag: true,
                        ItemIdList: qtychange,
                    }
                    ShoppingCartAction.UpdateItemDesp(UpdateItemDetails);
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                }
            }
            this.setState({ CartItems, NAYFlag: true });
        }
        else if (click == "3") {
            let CartitemList = this.state.CartItems
            //PC_WW_1060_08 Vishwa S
            CartitemList.filter((val) => val.Itemid.toUpperCase().includes("NONCAT") && val.PaintColor != "WNST" && val.PaintColor != "WCAT" && val.PaintColor != "PUNCHOUT" && val.chkDelete != "IMPXN").map((i) => {
                let loc = {
                    ItemId: i.Itemid,
                    UniqNum: i.UniqNum
                }
                DeleteItemID.push(loc)
            })
            let DeleteItemBO = {

                userID: this.state.Login_UserId,
                userBU: this.state.Login_UserBU,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                NAItemFlag: true,
                ItemIdList: DeleteItemID,
                DeleteFlag: true
            };
            ShoppingCartAction.DeleteCartItem(DeleteItemBO);

        }//trademismatch equipments deleting the items 12/2/2024 S.Sanjay
        else if (click == "4") {
            $(`#tradeMismatchPopup`).modal('hide');
            let CartitemList = this.state.CartItems
            CartitemList.filter((val) =>
                this.state.tradeMismatchItems.filter(item => item.Itemid === val.Itemid)
            ).map((i) => {
                let loc = {
                    ItemId: i.Itemid,
                    UniqNum: i.UniqNum
                };
                DeleteItemID.push(loc);
            });


            let DeleteItemBO = {

                userID: this.state.Login_UserId,
                userBU: this.state.Login_UserBU,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                NAItemFlag: true,
                ItemIdList: DeleteItemID,
                DeleteFlag: true
            };
            // Perform an action like deleting an item or updating the cart, for instance:
            ShoppingCartAction.DeleteCartItem(DeleteItemBO);
        }
        this.setState({ NADeleteItemID: DeleteItemID })
    }
    WOClose = () => {
        $('#QTY-popup').modal('hide');
    }
    //WAL-541_PC_06 hiding popup (3/9/2022)-Aparna
    Fav_Order_Category_Close = () => {
        $('#Fav_Order_Category').modal('hide');
        this.setState({ FavOrdCat: "", FavOrdSubCat: "", FavOrdDes: "" });
    }
    //WAL-541_PC_05
    handleCatChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    //WAL-541_PC_08 (3/8/2022)-Aparna
    FavOrdCatPopup = () => {
        $('#Fav_Order_Category').modal('show')
        return;
    }
    //WAL-541_PC_07 (3/8/2022)-Aparna
    //WAL-541_PC_07 (3/8/2022)-Aparna
    FavOrdCatOK = () => {
        //
        let resultSubCat = false
        let resultCat = false
        if (this.state.FavOrdCat != null && this.state.FavOrdCat != undefined) {
            if (this.state.FavOrdCat.trim() != "") {
                if (this.state.FavOrdCat.length <= 50) {
                    resultCat = true
                    document.getElementById('favordcatid').innerHTML = ""
                    //this.FavOrdImageValidation();
                    //$('#Fav_Order_Category').modal('hide');
                }
                else {
                    document.getElementById('favordcatid').innerHTML = "Category should not exceed 50 character";
                    resultCat = false
                }

            }
            else {
                document.getElementById('favordcatid').innerHTML = "Please enter category"
                resultCat = false
            }
            //WW-375 Ability to add Image to Fav Order -Deepthi
            //this.AddFavOrder("True")
            //document.getElementById('favordcatid').innerHTML = ""
        }
        else {
            document.getElementById('favordcatid').innerHTML = "Please enter category"
            resultCat = false
        }
        if (this.state.FavOrdSubCat != null && this.state.FavOrdSubCat != undefined) {
            if (this.state.FavOrdSubCat.trim() != "") {
                if (this.state.FavOrdSubCat.length <= 50) {
                    resultSubCat = true
                    document.getElementById('favordsubcatid').innerHTML = ""
                }
                else {
                    document.getElementById('favordsubcatid').innerHTML = "Sub Category should not exceed 50 character";
                    resultSubCat = false
                }
            }
            else {
                document.getElementById('favordsubcatid').innerHTML = "Please enter subcategory"
                resultSubCat = false
            }
            //WW-375 Ability to add Image to Fav Order -Deepthi
            //this.AddFavOrder("True")
            //document.getElementById('favordcatid').innerHTML = ""
        }
        else {
            document.getElementById('favordsubcatid').innerHTML = "Please enter subcategory"
            resultSubCat = false
        }
        if (resultCat && resultSubCat) {
            this.FavOrdImageValidation();
            $('#Fav_Order_Category').modal('hide');
        }
    }
    FavOrdImageValidation = () => {
        let ImagetoFav = "Images\noimage_new.png";
        let Cartlist = this.state.CartItems;
        let imagePath = "";
        if (Cartlist[0].Image == "Images\noimage_new.png") {
            imagePath = `/Images/noimage_new.png`;
        }
        else if (Cartlist[0].Image) {
            //BUG-2689 adding png andjpeg (9/21/2022)-Aparna
            Cartlist[0].Image = Cartlist[0].Image.replace('\\', '/');
            if (Cartlist[0].Image.toLowerCase().indexOf("http") >= 0 && (Cartlist[0].Image.toLowerCase().includes(".jpg") || Cartlist[0].Image.toLowerCase().includes(".png") || Cartlist[0].Image.toLowerCase().includes(".jpeg"))) {
                imagePath = Cartlist[0].Image;
            } else {
                //imagePath = Cartlist[0].Image.lastIndexOf(`/`) >= 0 ? Cartlist[0].Image.substring(Cartlist[0].Image.lastIndexOf("/") + 1, Cartlist[0].Image.length) : "noimage_new.png";
                //if (imagePath) {
                //    imagePath = this.state.apiURL + `Images/${imagePath}`;
                //}
                imagePath = `/Images/noimage_new.png`;
            }
        }
        else {
            imagePath = `/Images/noimage_new.png`;
        }
        if (this.state.attachmentPathArrImg == "" || this.state.attachmentPathArrImg == []) {
            if (imagePath.includes("noimage")) {
                $('#Imagealertpopup').modal('show');
            }
            else {
                ImagetoFav = imagePath;
                this.AddFavOrder("True");
            }
        }
        else {
            ImagetoFav = this.state.ImageFileName;
            this.AddFavOrder("True");
        }
    }
    ImgYesClick = () => {
        $('#Imagealertpopup').modal('hide');
        $('#Fav_Order_Category').modal('show');
    }
    //WAL-541_PC_11
    // WW-368_SuggestionCat_for_shopping_PC_03
    onChange(e, name) {
        let val = e.target.value.toUpperCase()
        let result = [];
        let subcatresult = [];
        //WW-516_PC_15
        //1/25/2023, WW-542, Dhevanesam R
        let re = /^[a-zA-Z0-9_-\s\x20 &, :;=?@#|'<>.{}"*()%!`%^$+~[/\]\\]+$/;
        if (val === '' || re.test(val)) {
            if (name == "Cat") {
                if (e.target.value == "") {
                    // let result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
                    this.setState({
                        FavOrdCat: e.target.value, autocompleteDataRstl: this.state.autocompleteData, FavOrdsubCategoryResults: []
                    });
                }
                else if (val.length <= 50) {
                    let result = []
                    // handling exception
                    if (this.state.autocompleteData != null && this.state.autocompleteData != undefined) {
                        if (this.state.autocompleteData.length > 0) {
                            result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
                        }

                    }
                    if (e.target.value != "") {
                        this.state.FavOrdsubCategory.forEach((x, i) => {
                            if (e.target.value.toUpperCase() == x.category) {
                                subcatresult.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                    }
                    document.getElementById('favordcatid').innerHTML = ""
                    console.log("FavOrdsubCategory", this.state.FavOrdsubCategory)
                    this.setState({
                        FavOrdCat: e.target.value, autocompleteDataRstl: result, FavOrdsubCategoryResults: subcatresult
                    });
                }
            }
            else {
                if (e.target.value == "") {
                    // let result = this.state.FavOrdsubCategory.filter(name => name.label.toUpperCase().includes(val))
                    if (this.state.FavOrdCat != "") {
                        this.state.FavOrdsubCategory.forEach((x, i) => {
                            if (this.state.FavOrdCat.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                    }
                    this.setState({
                        FavOrdSubCat: e.target.value, FavOrdsubCategoryResults: result
                    });
                }
                else if (val.length <= 50) {
                    if (this.state.FavOrdCat != "") {
                        this.state.FavOrdsubCategory.forEach((x, i) => {
                            if (this.state.FavOrdCat.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                    }
                    // handling exception
                    if (this.state.FavOrdsubCategory != null && this.state.FavOrdsubCategory != undefined) {
                        if (this.state.FavOrdsubCategory.length > 0) {
                            result = result.filter(name => name.label.toUpperCase().includes(val))
                        }

                    }
                    document.getElementById('favordcatid').innerHTML = ""
                    this.setState({
                        FavOrdSubCat: e.target.value, FavOrdsubCategoryResults: result
                    });
                }
            }
        }
    }
    /**
  * Handle the remote request with the current text !
 */
    // WW-368_SuggestionCat_for_shopping_PC_03
    onChangeItem(e, name) {
        let val = e.target.value.toUpperCase()
        let len = e.target.value;
        let result = [];
        let subcatresult = [];
        let locSubCatSGG = this.getCategory()
        //WW-516_PC_19
        //1/25/2023, WW-542, Dhevanesam R
        let re = /^[a-zA-Z0-9_-\s\x20 &, :;=?@#|'<>.{}"*()%!`%^$+~[/\]\\]+$/;
        if (val === '' || re.test(val)) {
            if (name == "Cat") {
                if (e.target.value == "") {
                    //let result = this.state.autocompleteItemData.filter(name => name.label.toUpperCase().includes(val))

                    this.setState({
                        FavYourCatgPopUp: e.target.value, autocompleteItemDataRstl: this.state.autocompleteItemData, subCategoryResults: []
                    });
                }
                else if (len.length <= 40) {
                    if (locSubCatSGG != undefined && locSubCatSGG != null) {
                        if (locSubCatSGG.length != 0) {
                            result = locSubCatSGG.filter(name => name.label.toUpperCase().includes(val))
                            console.log("yourcat autocomplete", result)
                        }
                    }
                    if (e.target.value != "") {
                        locSubCatSGG.forEach((x, i) => {
                            if (e.target.value.toUpperCase() == x.category) {
                                subcatresult.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                    }
                    //let result = this.state.autocompleteItemData.filter(name => name.label.toUpperCase().includes(val))
                    this.setState({
                        FavYourCatgPopUp: e.target.value, autocompleteItemDataRstl: result, subCategoryResults: subcatresult, CategoryErr: false, autocompleteItemData: locSubCatSGG
                    });

                }
            }
            else {
                if (e.target.value == "") {
                    //let result = this.state.subCategory.filter(name => name.label.toUpperCase().includes(val))
                    if (this.state.FavYourCatgPopUp != "") {
                        locSubCatSGG.forEach((x, i) => {
                            if (this.state.FavYourCatgPopUp.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }
                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result
                    });
                }
                else if (len.length <= 40) {
                    if (this.state.FavYourCatgPopUp != "") {
                        locSubCatSGG.forEach((x, i) => {
                            if (this.state.FavYourCatgPopUp.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }

                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result, SubCategoryErr: false, subCategory: locSubCatSGG
                    });
                }
            }
        }
        /**
         * Handle the remote request with the current text !
         */
    }
    //WAL-541_PC_15-Aparna
    onSelect = (val, name) => {
        let result = [];
        if (name == "Cat") {
            if (val != "") {
                this.state.FavOrdsubCategory.forEach((x, i) => {
                    if (val.toUpperCase() == x.category) {
                        result.push({ label: x.value, value: x.value })
                    }
                }
                )
            }
            document.getElementById('favordcatid').innerHTML = ""
            this.setState({
                FavOrdCat: val, FavOrdsubCategoryResults: result
            });
        }
        //WW-516_PC_16
        else {
            document.getElementById('favordsubcatid').innerHTML = ""
            this.setState({
                FavOrdSubCat: val
            });
        }

    }
    // WW-368_SuggestionCat_for_shopping_PC_03
    onSelectItem = (val, name) => {
        let result = []
        let locSubCatSGG = this.getCategory()
        if (name == "Cat") {
            if (val != "") {
                locSubCatSGG.forEach((x, i) => {
                    if (val.toUpperCase() == x.category) {
                        result.push({ label: x.value, value: x.value })
                    }
                }
                )
            }
            this.setState({
                FavYourCatgPopUp: val, subCategoryResults: result, CategoryErr: false, subCategory: locSubCatSGG
            });
        }
        //WW-516_PC_17
        else {
            this.setState({
                FavSubCategory: val, SubCategoryErr: false
            });
        }
    }
    //WAL-541_PC-10
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );
    }
    //WAL-541_PC_09
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    //****WW-254****(26/10/2021)
    WorkOrderInputCheck = (isWOBtnClick) => {
        //if (this.state.WONUM == "") {
        //    this.setState({ ERRWO: true });
        //    return;
        //}
        //else {
        let THIRDPARTY_COMP_ID = ""
        if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
            THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
        }
        let BO = {
            workOrder: this.state.WONUM,
            Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
            User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"), //WW-336 - PC_04 CBRE WO# validation is not working for SDI Users(1/ 18 / 2022)  -Aparna
            is_WO_Parts_Needed: true
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //
        ShoppingCartAction.WorkOrderCheck(BO)
        if (isWOBtnClick == false) {
            this.setState({ submitbtn: true });
        }
        else {
            this.setState({ submitbtn: false });
        }

        // }
    }
    WONumChange = (e) => {
        //5708 - removing a validation mesg once user started to type i.e. onchange 4/21/2025 Nachiappan
        document.getElementById('StatusMsgbilltostore').innerText = ""
        //WW-742_PC_02 -Aparna
        const onlyNumbers = SDIConstants.quantityRegEX;
        if (e.target.value === '' || onlyNumbers.test(e.target.value)) {
            this.setState({ WONUM: e.target.value, EnableShipTo: true, isPickup: false, BilltostoreEnable: false }); // pickupcheck: false, removed 
        }
    }
    /*[04/22/22,PC_WW-365_04], Priyanka D */
    /*[04/22/22,PC_WW-365_04], Priyanka D */
    ClearWO = () => {
        //
        localStorage.removeItem('WONum')
        localStorage.removeItem('WOAssetID') /*[04/10/23, PC_4247_08 - To remove the localStorage Item "WOAssetID", Vishwa S]*/
        localStorage.removeItem('StoreValue')
        localStorage.removeItem('WOAssetTag')
        localStorage.removeItem('WO_Parts')//BUG:3618 -Aparna
        //[10/18/22, WAL - 785 Getting Asset Tag and storing in a cookie value, Dhevanesam R
        CookieService.updateLocalStorageValues("AssetTag", "");
        CookieService.updateLocalStorageValues("AssetID", "");
        CookieService.updateLocalStorageValues("Trade", "");
        CookieService.updateLocalStorageValues("Category", "");
        CookieService.updateLocalStorageValues("Make", "");
        CookieService.updateLocalStorageValues("Model", "");
        CookieService.updateLocalStorageValues("WO_Make", "");
        CookieService.updateLocalStorageValues("WO_Model", "");
        //CookieService.updateLocalStorageValues("WO_Parts", "");//BUG:3618 -Aparna
        CookieService.updateLocalStorageValues("WO_Address", "");
        CookieService.updateLocalStorageValues("Session_WO_STATE", ""); //WW-1231 WO State Restriction -Vishwa S
        document.getElementById('StatusMsg1').innerText = "";
        $(`#WONUM`).val('');
        $('#ShiptoText').val('');
        let PerferedShipto = [];
        if (CookieService.getLocalStorageValues("Session_ISAShipToID") != null && CookieService.getLocalStorageValues("Session_ISAShipToID") != "" && CookieService.getLocalStorageValues("Session_ISAShipToID") != undefined && CookieService.getLocalStorageValues("Session_ISAShipToID") != " " && this.state.BilltoStore != undefined) {
            /*[05/13/22,WW-243]Pickup Issue, Priyanka D */
            let defaultship = this.state.shiptoDropdown.filter((item, index) => item.CUSTID == CookieService.getLocalStorageValues("Session_ISAShipToID"));
            //PerferedShipto = PerferedShipto[0];
            defaultship.map((val, index) => {
                let localArray = {
                    value: val.CUSTID,
                    label: val.LOCNAME,
                }
                PerferedShipto.push(localArray)
                PerferedShipto = PerferedShipto[0]
            });
        }
        let locpickupchecked = false
        if (this.state.CartItems != undefined && this.state.CartItems != null) {
            if (this.state.CartItems.length > 0) { //Bug ID - 5492 -Vishwa S
                let lowesfilter = this.state.CartItems.filter(x => x.SupplierID == "W000000091").length
                if (lowesfilter == this.state.CartItems.length) {
                    locpickupchecked = true
                }
            }
        }
        if (PerferedShipto.length != 0) {
            this.setState({ defaultShipto: PerferedShipto.value === "W09301" || PerferedShipto.value === "W02409" ? { value: "0", label: "-- Select Ship To --" } : PerferedShipto })
        }
        else {
            let PerferedShipto = {
                value: "0",
                label: "--Select Ship To--"
            }
            this.setState({ defaultShipto: PerferedShipto })
        }
        let enableShipTo = false
        if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
            enableShipTo = true
        }
        this.setState({
            isValidWO: false, submitbtn: false, StoreValue: null, isCountryMatch: true, WONUM: "", Checkedbillto: true, HalLocationChecked: false, HalLocationSelected: "", Halloc: [], displayFedexDrop: false,
            Radiopincode: false, Radiolocation: false, EnableShipTo: enableShipTo, BilltostoreEnable: false, isPickup: false, Bentonville_WO: false, sethalboolenval: false, displayFedexDrop: false, pickupcheck: locpickupchecked, isWorkToStoreValid: false // SCO_PC_12to remove check of bill to store checkbox 
        })/*[05/12/22, PC_WW-243]Priyanka D Enable Pickup after clearing WO and again Validating*/ //WW-398 removing line level pickup when WO is removed -Aparna ,

        $("#OLWorkOrderTB").removeClass("disabledbutton");
    }
    //when we tried to add the same file for the second time its not inserting
    onInputClick = (event) => {
        event.target.value = ''
    }
    //*******END**********************
    /**
* SCO_PC_04
* to check the entered WO# is valid or not
* */
    WorkOrder_Validation = (isWOBtnClick) => {
        displayExtraLoader = true;
        if (this.state.isValidWO) {
            if (!isWOBtnClick) {
                //if (this.NonCatItem_Check()) {
                return true
                //} else {
                //    $('#NonCat_Popup').modal('show');
                //    displayExtraLoader = false;
                //    return false
                //}

            }
        } else {
            if (CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N') {
                if (this.state.WONUM != undefined && this.state.WONUM != null) {
                    if (this.state.WONUM.trim() != "") {
                        if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                            this.WorkOrderInputCheck(isWOBtnClick)
                            return false
                        }
                        else {
                            localStorage.setItem('WONum', this.state.WONUM);
                            $("#OLWorkOrderTB").addClass("disabledbutton");
                            document.getElementById('StatusMsg1').innerText = ""
                            document.getElementById('StatusMsg').innerText = ""
                            document.getElementById('StatusMsgbilltostore').innerText = ""
                            this.setState({ isValidWO: true, isPageloadIsValidWO: false, EnableShipTo: false });
                            return true;
                        }
                    }
                    else {
                        if (isWOBtnClick) {
                            document.getElementById('StatusMsgbilltostore').innerText = "Enter work order number"
                            displayExtraLoader = false;
                            return false
                        } else {
                            document.getElementById('StatusMsg1').innerText = "Enter work order number"
                            document.getElementById('StatusMsg').innerText = "Enter work order number"
                            displayExtraLoader = false;
                            return false
                        }
                    }

                } else {
                    if (isWOBtnClick) {
                        document.getElementById('StatusMsgbilltostore').innerText = "Enter work order number"
                        displayExtraLoader = false;
                        return false
                    } else {
                        document.getElementById('StatusMsg1').innerText = "Enter work order number"
                        document.getElementById('StatusMsg').innerText = "Enter work order number"
                        displayExtraLoader = false;
                        return false
                    }
                }
            }
            else {
                if (this.state.WONUM && this.state.WONUM.trim() != "") {
                    if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                        this.WorkOrderInputCheck(isWOBtnClick)
                        return false
                    }
                    else {
                        localStorage.setItem('WONum', this.state.WONUM);
                        $("#OLWorkOrderTB").addClass("disabledbutton");
                        document.getElementById('StatusMsg1').innerText = ""
                        document.getElementById('StatusMsg').innerText = ""
                        document.getElementById('StatusMsgbilltostore').innerText = ""
                        this.setState({ isValidWO: true, isPageloadIsValidWO: false, EnableShipTo: false  });
                        return true;
                    }
                }
                else {
                    this.setState({ isValidWO: true, isPageloadIsValidWO: false, EnableShipTo: false });
                    document.getElementById('StatusMsg1').innerText = ""
                    document.getElementById('StatusMsg').innerText = ""
                    document.getElementById('StatusMsgbilltostore').innerText = ""
                    return true;
                }
            }

        }
    }
    /**
     * 
     * 
     * */
    NonCatItem_Check = () => {
        //PC_WW_1060_07 Vishwa S
        let nonCatInCart = this.state.CartItems.filter((val) => val.Itemid.toUpperCase().includes("NONCAT") && val.PaintColor != "WNST" && val.PaintColor != "WCAT" && val.PaintColor != "PUNCHOUT" && val.chkDelete != "IMPXN").length > 0 ? true : false
        if (nonCatInCart) {
            // console.log("Session_THIRDPARTY_COMP_ID", CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"))
            // console.log("WO_Type", CookieService.getLocalStorageValues("WO_Type"))
            if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null && CookieService.getLocalStorageValues("WO_Type") != undefined && CookieService.getLocalStorageValues("WO_Type") != "WALMART") {
                return true
            }
            else {
                $('#NonCat_Popup').modal('show');
                displayExtraLoader = false;
                return false
            }
        }
        else {
            return true
        }
    }

    /**
* SCO_PC_09
* response from WO API
* */
    workOrder_Validation_Response = () => {
        localStorage.setItem('WONum', this.state.WONUM);
        let Workorderresponse = JSON.parse(ShoppingCartStore.workorderresponse);

        let validation = false;
        let localstore = "";
        let loacalloc = "";
        let LWOmsg = false;
        let locUSERCHAR = "";
        let localbilltostore = true;
        let localenableshipto = true;
        let locisPickup = this.state.isPickup;
        let locWOParts = [];
        let isIntNonCatRemovePopupShow = false;
        if (Workorderresponse.WOResponse.length > 0) {
            //5713 - Once workorder is validated then ship to is enable [4/21/2025] Nachiappan
            //localenableshipto = false;
            let loc = [];
            let loacalloc = Workorderresponse.WOResponse[0].LOCATION
            loacalloc = JSON.stringify(loacalloc);
            if (loacalloc != undefined && loacalloc != null) {
                let billstore = loacalloc.substring(1, loacalloc.length - 1)
                loc = this.state.shiptoDropdown.filter((item, index) => item.CUSTID == billstore)


            }
            if (loc != null && loc != undefined) {
                if (loc.length != 1) {

                    this.setState({ isWorkToStoreValid: false, submitbtn: false, isValidWO: false, WONUM: "" });//WAL-1034_PC_35 -Aparna
                    $("#OLWorkOrderTB").removeClass("disabledbutton");
                    document.getElementById('StatusMsgbilltostore').innerText = "Enter Valid Work Order #"
                    document.getElementById('StatusMsg1').innerText = " "
                    //[9/26/22], Bug - 2664 - To remove validation msg when the work order is valid, Dhevanesam R
                    document.getElementById('StatusMsg').innerText = " "
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    return
                }
                else {
                    /*[04/10/23, PC_4247_07 - To store AssetID in localStorage and setting AssetID value to the Asset Tag ID field, Vishwa S]*/
                    if (Workorderresponse.WOResponse[0].AssetID != "" && Workorderresponse.WOResponse[0].AssetID != null && Workorderresponse.WOResponse[0].AssetID != undefined && Workorderresponse.WOResponse[0].AssetID != " ") {
                        localStorage.setItem('WOAssetID', Workorderresponse.WOResponse[0].AssetID);

                        localStorage.setItem('WOAssetTag', Workorderresponse.WOResponse[0].AssetTag);

                        if (Workorderresponse.WOResponse[0].WO_Make != "" && Workorderresponse.WOResponse[0].WO_Make != null && Workorderresponse.WOResponse[0].WO_Make != undefined && Workorderresponse.WOResponse[0].WO_Make != " ") {
                            CookieService.updateLocalStorageValues("WO_Make", Workorderresponse.WOResponse[0].WO_Make);

                        } if (Workorderresponse.WOResponse[0].WO_Model != "" && Workorderresponse.WOResponse[0].WO_Model != null && Workorderresponse.WOResponse[0].WO_Model != undefined && Workorderresponse.WOResponse[0].WO_Model != " ") {
                            CookieService.updateLocalStorageValues("WO_Model", Workorderresponse.WOResponse[0].WO_Model);

                        }
                        $(`#OLMachDD`).val(Workorderresponse.WOResponse[0].AssetID);
                    }
                    document.getElementById('StatusMsg1').innerText = ""
                    document.getElementById('StatusMsg').innerText = ""
                    document.getElementById('StatusMsgbilltostore').innerText = ""
                    CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
                    /*[12/24/21, PC_SC_02], Priyanka D//Updating the Location storage*/
                    let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
                    CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
                    CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
                    localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
                    //WW-591_PC_02 -Aparna
                    CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
                    CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
                    CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
                    CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
                    CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
                    CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE); //WW-1231 WO State Restriction -Vishwa S
                    CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO);// Set stating the ship to location to the ISBlanketWO when the user selects the ship to location as W09301 and W02409.

                    //WW-1374 Update the WO logo, Problem code long and short description to cookie - Nandhini L 
                    CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
                    CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
                    CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

                    //WW-1163 to display request to source items remove confirmation popup -Vishwa S
                    let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
                    let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";
                    //pc-676-100 to 105 equipment trade mismatch S.Sanjay 12/2/2024
                    debugger
                    let tradeMismatchItems = [];

                    //pc-676-100 to 105 equipment trade mismatch S.Sanjay 12/2/2024
                    let workOrderTrade = Workorderresponse.WOResponse[0].Trade;
                    if (workOrderTrade != "" && workOrderTrade != null && workOrderTrade != undefined) {
                        this.state.CartItems.forEach(item => {
                            if (item.ISA_WBS_ELMNT === "Equipment") {
                                // Check if item's Trade attribute exists and is different from workOrderTrade
                                if (item.WO_TRADE.toUpperCase() !== workOrderTrade.toUpperCase()) {
                                    // Push ItemId to tradeMismatchItems if the condition is met
                                    tradeMismatchItems.push(item.Itemid);
                                }
                            }

                        });
                    }
                    //WAL-1034_PC_02 (WO parts)-Aparna
                    if (this.state.submitbtn == false && !WOBtnClick) {

                        if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                            if (Workorderresponse.WOParts.length > 0) {
                                // CookieService.updateLocalStorageValues("WO_Parts", JSON.stringify(Workorderresponse.WOParts));
                                localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts)) //BUG:3618 -Aparna
                                locWOParts = Workorderresponse.WOParts;
                                //WW-1163 to display request to source items remove confirmation popup -Vishwa S
                                if (tradeMismatchItems.length > 0) {
                                    // Set state with tradeMismatchItems and show modal
                                    this.setState({ tradeMismatchItems });
                                    $(`#tradeMismatchPopup`).modal('show');
                                } else if (this.state.IsInteractiveNonCat != false && WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
                                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                                    $('#IntNonCatRemovePopup').modal('show');
                                    isIntNonCatRemovePopupShow = true;
                                }
                                else {
                                    //WW-1038 SIT-Bug - WO list is not shown after clicking Edit Delivery Option - Deepthi N H
                                    if (this.state.Choose_Delivery_Btn_Click == false) {
                                        if (CookieService.getLocalStorageValues("Session_STATE") == Workorderresponse.WOResponse[0].STATE) { //WW-1231 WO State Restriction -Vishwa S
                                            $('#WO_Parts_Popup').modal('show');
                                        }
                                    }
                                    else {
                                        if (this.state.OrderEmpyId == " ") {
                                            if (CookieService.getLocalStorageValues("Session_STATE") == Workorderresponse.WOResponse[0].STATE) { //WW-1231 WO State Restriction -Vishwa S
                                                $('#WO_Parts_Popup').modal('show');
                                            }
                                        }
                                    }
                                }

                            }
                        }
                    }
                    else {//WW-1038 SIT-Bug - WO list is not shown after clicking Edit Delivery Option - Deepthi N H
                        if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                            if (Workorderresponse.WOParts.length > 0) {

                                localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts))
                                locWOParts = Workorderresponse.WOParts;
                            }
                        }
                    }
                    if (Workorderresponse.WOResponse[0].ADDRESS1 != "" && Workorderresponse.WOResponse[0].ADDRESS1 != null && Workorderresponse.WOResponse[0].ADDRESS1 != undefined && Workorderresponse.WOResponse[0].ADDRESS1 != " ") {
                        localstore = Workorderresponse.WOResponse[0].ADDRESS1
                        CookieService.updateLocalStorageValues("WO_Address", Workorderresponse.WOResponse[0].ADDRESS1);
                        LOCATION = loacalloc = Workorderresponse.WOResponse[0].LOCATION
                        localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                        validation = true;
                        if (Workorderresponse.WOResponse[0].Priority != "" && Workorderresponse.WOResponse[0].Priority != null && Workorderresponse.WOResponse[0].Priority != undefined) {
                            locUSERCHAR = Workorderresponse.WOResponse[0].Priority;
                        }

                    }
                    else {
                        validation = false;
                    }
                    if (validation) {
                        if (Workorderresponse.WOResponse[0].LATITUDE != undefined && Workorderresponse.WOResponse[0].LONGITUDE != undefined) {
                            /*pickup disable issue-Priyanka D*/
                            localStorage.setItem("BilltoStoreLocationLat", Workorderresponse.WOResponse[0].LATITUDE);
                            localStorage.setItem("BilltoStoreLocationLong", Workorderresponse.WOResponse[0].LONGITUDE);
                            if (this.state.pickupcheck == true) {
                                localbilltostore = true
                                localenableshipto = false
                                locisPickup = true
                                //  this.setState({ BilltostoreEnable: true, EnableShipTo: true, isPickup: true, })
                            }
                            if (this.state.Haldisplay == "HAL") {
                                this.setState({ sethalboolenval: true, })
                            }
                            if (this.state.Haldisplay == "" && this.state.isWorkToStoreValid) {
                                this.setState({ sethalboolenval: false, })
                            }
                            if (this.state.pickupcheck == true && this.state.isWorkToStoreValid) {
                                locisPickup = true
                                // this.setState({ isPickup: true })
                            }
                            else {
                                $("#bill-to-store").removeClass("disabledbutton");
                            }
                            let isRefrigerantInCart = this.isRefrigerantItemInCart(this.state.CartItems)
                            if (isRefrigerantInCart[0]) {
                                localbilltostore = true
                                localenableshipto = false
                                // this.Bindpickupstore()
                            }
                            this.setState({
                                shiptoLat: Workorderresponse.WOResponse[0].LATITUDE, shiptoLong: Workorderresponse.WOResponse[0].LONGITUDE,
                                BilltoStoreLocation: { lat: Workorderresponse.WOResponse[0].LATITUDE, long: Workorderresponse.WOResponse[0].LONGITUDE }, USER_CHAR1: locUSERCHAR,
                                BilltostoreEnable: localbilltostore, EnableShipTo: localenableshipto, isPickup: locisPickup
                            })
                            $("#OLWorkOrderTB").addClass("disabledbutton");
                            this.distancebind(Workorderresponse.WOResponse[0].LATITUDE, Workorderresponse.WOResponse[0].LONGITUDE)
                        } else {
                            this.setState({ truckstore: true })
                        }
                    }
                }
            }
        }
        let locpickupchecked = false
        if (this.state.CartItems != undefined && this.state.CartItems != null) {
            if (this.state.CartItems.length > 0) { //Bug ID - 5492 -Vishwa S
                let lowesfilter = this.state.CartItems.filter(x => x.SupplierID == "W000000091").length
                if (lowesfilter == this.state.CartItems.length) {
                    locpickupchecked = true
                }
            }
        }
        let isRefrigerant = this.isRefrigerantItemInCart(this.state.CartItems)
        if (isRefrigerant[0] && isRefrigerant[1]) {
            locpickupchecked = true
        }
        this.setState({ isValidWO: true, isPickup: true, pickupcheck: locpickupchecked, WO_Parts: locWOParts, isPageloadIsValidWO: false })
        this.BentonvilleStore_Check()
        this.set_ShiptoValue()
        //let { supplierList } = this.state
        //supplierList.forEach((x, i) => {
        //    let pickupstore = []
        //    let pickupstore1 = []
        //    pickupstore = this.getPickupStore(this.state.pickupstore_tbl, x.supplier_ID)
        //    if (x.SupplierID != "W000000091" && x.SupplierID != "W000000036") {
        //        if (x.SupplierID == "W999999999" && this.state.Bentonville_WO) {
        //            pickupstore1 = []
        //        } else {
        //            pickupstore1 = pickupstore
        //        }
        //    }
        //    x.pickupStore = pickupstore1
        //})
        //this.setState({ supplierList})
        this.supplierCollection(this.state.CartItems, this.state.pickup_vendor, this.state.pickupstore_tbl, this.state.defaultShipto)
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
        let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";
        //pc-676-100 to 105 equipment trade mismatch S.Sanjay 12/2/2024
        let tradeMismatchItems = [];

        //pc-676-100 to 105 equipment trade mismatch S.Sanjay 12/2/2024
        let workOrderTrade = Workorderresponse.WOResponse[0].Trade;
        if (workOrderTrade != "" && workOrderTrade != null && workOrderTrade != undefined) {
            this.state.CartItems.forEach(item => {
                if (item.ISA_WBS_ELMNT === "Equipment") {
                    // Check if item's Trade attribute exists and is different from workOrderTrade
                    if (item.WO_TRADE.toUpperCase() !== workOrderTrade.toUpperCase()) {
                        // Push ItemId to tradeMismatchItems if the condition is met
                        tradeMismatchItems.push(item.Itemid);
                    }
                }

            });
        }
        //WW-1231 WO State Restriction -Vishwa S
        if (!isIntNonCatRemovePopupShow) {
            if (this.state.submitbtn == false && !WOBtnClick) {
                if (tradeMismatchItems.length > 0) {
                    // Set state with tradeMismatchItems and show modal
                    this.setState({ tradeMismatchItems });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    $(`#tradeMismatchPopup`).modal('show');
                } else if (this.state.IsInteractiveNonCat != false && WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    $('#IntNonCatRemovePopup').modal('show');
                }
                else if (CookieService.getLocalStorageValues("Session_STATE") != Workorderresponse.WOResponse[0].STATE) {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    $('#loaderMessage').text('Validating Work Order# for the cart items...');
                    this.LoadCartItem(false)
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {
                        if (Workorderresponse.WOParts.length > 0) {
                            $('#WO_Parts_Popup').modal('show');
                        }
                    }
                }
            }
            else {

                if (this.state.submitbtn || WOBtnClick) {
                    if (tradeMismatchItems.length > 0) {
                        // Set state with tradeMismatchItems and show modal
                        this.setState({ tradeMismatchItems });
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        $(`#tradeMismatchPopup`).modal('show');
                    } else if (this.state.IsInteractiveNonCat != false && WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        $('#IntNonCatRemovePopup').modal('show');
                    }
                    else {
                        //this.submitOrder_Btn_Click()
                        if (WOBtnClick) {
                            this.setState({ submitbtn: true });
                        }
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        $('#loaderMessage').text('Validating Work Order# for the cart items...');
                        this.LoadCartItem(false)
                    }
                }
                else if (this.state.Choose_Delivery_Btn_Click) {
                    if (tradeMismatchItems.length > 0) {
                        // Set state with tradeMismatchItems and show modal
                        this.setState({ tradeMismatchItems });
                        $(`#tradeMismatchPopup`).modal('show');
                    }
                    else if (this.state.IsInteractiveNonCat != false && WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        $('#IntNonCatRemovePopup').modal('show');
                    }
                    else {
                        //this.ChooseDeliveryOption_Btn_Click()
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        $('#loaderMessage').text('Validating Work Order# for the cart items...');
                        this.LoadCartItem(false)
                    }
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }

    }
    /**
* SCO_PC_10
* to set the billtostore and default value
* */
    set_ShiptoValue = () => {
        let billstore = "";
        let billtostore = this.state.BilltoStoreLocation;
        let curlat = 0;
        let curlong = 0;
        let ShiptoValue = [];
        let Shipto = [];
        let localArray = {};
        let defaultshipto = [];
        let PerferedShipto = [];
        let locCountryMatch = true;
        let locDefaultShipto = ""
        //let locDefaultShipto = this.state.shiptoDropdown.filter(val => val.CUSTID === localStorage.getItem('Session_ISAShipToID'))[0];
        let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
        if (Defaultship != "0" && Defaultship != "" && Defaultship != " " && Defaultship != null && Defaultship != undefined) {
            locDefaultShipto = this.state.shiptoDropdown.filter(val => val.CUSTID == Defaultship)
        }
        let localenableshipto = this.state.EnableShipTo
        if (localStorage.getItem("StoreValue") != undefined && localStorage.getItem("StoreValue") != null) {
            billstore = localStorage.getItem("StoreValue").substring(1, localStorage.getItem("StoreValue").length - 1)
        }
        /*[12/15/21, PC_SC_12, WW-282], Priyanka D//Assigning the state variables to local variables*/
        if (billtostore.lat != undefined && billtostore.long != undefined) {
            curlat = billtostore.lat;
            curlong = billtostore.long;
        }
        if (billstore != "" && billstore != undefined) {
            if (billstore.substring(0, 2) == "WT") {
                curlat = this.state.curtrucklat;
                curlong = this.state.curtrucklong;
            }
        }
        /*[12/15/21, PC_SC_13, WW-282], Priyanka D//Check for PR users*/
        let loc = this.state.shiptoDropdown.filter((item, index) => item.CUSTID == billstore)
        if (loc != null && loc != undefined) {
            if (loc.length > 0) {
                localStorage.setItem("Country", loc[0].COUNTRY)
                if (loc[0].COUNTRY.toUpperCase() == "PRI") {
                    ShiptoValue = this.state.shiptoDropdown.filter((item, index) => item.COUNTRY == "PRI");
                } else {
                    ShiptoValue = this.state.shiptoDropdown.filter((item, index) => item.COUNTRY != "PRI");
                }
            }
        }
        /*[12/15/21, PC_SC_14, WW-282], Priyanka D//Calculating miles for shipto stores*/
        /*[05/16/22, PC_WW-243_01]Priyanka D-Distance calculation method change for shipto*/
        const CurrentLocation = { lat: curlat, long: curlong };
        if (ShiptoValue != null && ShiptoValue != undefined) {
            if (ShiptoValue.length > 0) {
                ShiptoValue.map((val, index) => {

                    let distance = DistanceCalculator.calculate(CurrentLocation, { lat: val.LATITUDE, long: val.LONGITUDE })
                    let dis = (distance * 0.00062137).toFixed(2)
                    localArray = {
                        value: val.CUSTID,
                        label: val.LOCNAME + "-" + dis + " " + "miles"
                    }
                    Shipto.push(localArray);
                });
            }
        }
        if (this.state.submitbtn) {
            /*[04/04/22,A1QA-163], Binding Install store as a default shipto if the user didn't set default shipto in user profile, Priyanka D */
            ////;
            if (this.state.defaultShipto != undefined) {
                if (this.state.defaultShipto.value == "0" && this.state.BilltoStore != undefined) {
                    /*[05/13/22,WW-243]Pickup Issue, Priyanka D */
                    let defaultshiptotemp = Shipto.filter((item, index) => item.value == billstore);
                    defaultshipto = defaultshiptotemp[0];
                } else if (this.state.defaultShipto.value != undefined) {
                    /*[05/13/22,WW-243]Pickup Issue, Priyanka D */
                    let defaultshiptotemp = Shipto.filter((item, index) => item.value == this.state.defaultShipto.value);
                    defaultshipto = defaultshiptotemp[0];
                } else {
                    let defaultshiptotemp = Shipto.filter((item, index) => item.value == this.state.BilltoStore.value);
                    defaultshipto = defaultshiptotemp[0];
                }
            } else {
                let defaultshiptotemp = Shipto.filter((item, index) => item.value == billstore);
                defaultshipto = defaultshiptotemp[0];
            }
            this.setState({ ShipToDDValue: Shipto, defaultShipto: defaultshipto });
        } else {
            if (Shipto != null && Shipto != undefined) { //this.state.ShipToDDValue
                if (Shipto.length > 0) {
                    Shipto.map((val, index) => {
                        if (val.value == billstore) {
                            PerferedShipto = val
                        }
                    });
                    if (this.state.pickupcheck == false && this.state.isWorkToStoreValid) {
                        this.setState({
                            defaultShipto: PerferedShipto
                        })
                        //  $('#OLShipTo').val(PerferedShipto);
                    }
                    localenableshipto = false
                    let isRefrigerantInCart = this.isRefrigerantItemInCart(this.state.CartItems)
                    if (isRefrigerantInCart[0]) {

                        localenableshipto = false
                        // this.Bindpickupstore()
                    }
                    this.setState({ BilltoStore: PerferedShipto, EnableShipTo: localenableshipto })
                }
            }
            let shiptoLat = "";
            let shiptoLong = "";
            if (this.state.defaultShipto != undefined) {
                let ShiptoDD = []
                if (this.state.shiptoDropdown != null && this.state.shiptoDropdown != undefined) {
                    if (this.state.shiptoDropdown.length > 0) {
                        this.state.shiptoDropdown.map((val, index) => {

                            let distance = DistanceCalculator.calculate(CurrentLocation, { lat: val.LATITUDE, long: val.LONGITUDE })
                            let dis = (distance * 0.00062137).toFixed(2)
                            localArray = {
                                value: val.CUSTID,
                                label: val.LOCNAME + "-" + dis + " " + "miles"
                            }
                            ShiptoDD.push(localArray);
                        });
                    }
                }
                let test = CookieService.getLocalStorageValues("Session_ISAShipToID")


                if (CookieService.getLocalStorageValues("Session_ISAShipToID") != null && CookieService.getLocalStorageValues("Session_ISAShipToID") != "" && CookieService.getLocalStorageValues("Session_ISAShipToID") != undefined && CookieService.getLocalStorageValues("Session_ISAShipToID") != " " && this.state.BilltoStore != undefined) {
                    /*[05/13/22,WW-243]Pickup Issue, Priyanka D */
                    if (locDefaultShipto != undefined && locDefaultShipto != null && locDefaultShipto != "") {
                        if (localStorage.getItem("Country").toUpperCase() == locDefaultShipto[0].COUNTRY.toUpperCase()) {
                            let defaultshiptotemp = ShiptoDD.filter((item, index) => item.value == test);
                            defaultshipto = defaultshiptotemp[0];
                            this.state.shiptoDropdown.filter((item, index) => item.CUSTID == test).map((i) => {
                                shiptoLat = i.LATITUDE;
                                shiptoLong = i.LONGITUDE;

                            });
                        } else {
                            locCountryMatch = false;
                            defaultshipto = {
                                value: "0",
                                label: "--Select Ship To--"
                            };
                        }
                    }
                    else {
                        locCountryMatch = false;
                        defaultshipto = {
                            value: "0",
                            label: "--Select Ship To--"
                        };
                    }

                }

                else {
                    /*[05/13/22,WW-243]Pickup Issue, Priyanka D */
                    let defaultshiptotemp = ShiptoDD.filter((item, index) => item.value == billstore);
                    defaultshipto = defaultshiptotemp[0];
                    this.state.shiptoDropdown.filter((item, index) => item.CUSTID == billstore).map((i) => {
                        shiptoLat = i.LATITUDE;
                        shiptoLong = i.LONGITUDE;

                    });
                }
            }
            //Cehcking if the default ship to value is equal to W09301 or W02409 then we are set stating then the ship to value to ISBlanketWo
            if (defaultshipto.value === CookieService.getLocalStorageValues("IsBlanketWO")) {
                defaultshipto = {
                    value: "0",
                    label: "--Select Ship To--"
                };
            }
            this.setState({ ShipToDDValue: Shipto, defaultShipto: defaultshipto.value === "W09301" || defaultshipto.value === "W02409" ? { value: "0", label: "-- Select Ship To --" } : defaultshipto, shiptoLat: shiptoLat, shiptoLong: shiptoLong, isCountryMatch: locCountryMatch });
            let { supplierList } = this.state
            supplierList.forEach((x) => {
                x.shipTo = defaultshipto
            })
            this.setState({ supplierList })
        }
    }
    /**
* SCO_PC_09
* to check the WO is bentonville or not
* */
    BentonvilleStore_Check = () => {
        //WW-398_PC_02 (5/5/2022) -Aparna
        let bentonvill = false;
        let benval = ""
        let bentonvillelist = CookieService.getLocalStorageValues("Session_StoreLocBen")
        if (bentonvillelist != null) {
            let store = JSON.parse(localStorage.getItem("StoreValue"))
            if (store != null && store != undefined) {
                benval = bentonvillelist.filter((x) => x.SESSION_STORELOCBEN == store)
            } else if (this.state.BilltoStore.value != null && this.state.BilltoStore.value != undefined) {
                benval = bentonvillelist.filter((x) => x.SESSION_STORELOCBEN == this.state.BilltoStore.value)
            }
            if (benval.length > 0) {
                this.setState({ Bentonville_WO: true })
            } else {
                this.setState({ Bentonville_WO: false })
            }
        }

    }
    /**
* SCO_PC_06
* to check the mandatory fields are entered
* */
    order_Field_Validation = () => {
        let validationFalg = true
        let OLWorkOrder = $('#OLWorkOrderTB').val();
        let OLDueDate = this.state.OLDueDateVal;
        let OLEmployeeCC = this.state.OrderEmpyId;
        //;
        let OLShipTo = "";
        if (this.state.defaultShipto != undefined && this.state.defaultShipto != null) {
            OLShipTo = this.state.defaultShipto.value;
        }
        else {
            if (OLShipTo == "" || OLShipTo == null || OLShipTo == {} || OLShipTo == " ") {
                if (this.state.ShipToDDValue.length < 2) {
                    let ShipToDDValue = this.state.ShipToDDValue
                    OLShipTo = ShipToDDValue[0].value;
                }
                else if (this.state.defaultShipto != undefined) {
                    OLShipTo = this.state.defaultShipto.value;
                }
            }
        }
        let { CartItems } = this.state
        let Employeevalidate = true
        let Duedatevalid = true
        if (CartItems.length == 0) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            displayExtraLoader = false;
            validationFalg = false
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Cart is empty"
            });
        }
        if (OLDueDate == "") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            displayExtraLoader = false;
            validationFalg = false
            document.getElementById('StatusMsg').innerText = "Please fill all item level delivery date"
            document.getElementById('StatusMsg1').innerText = "Please fill all item level delivery date"
        }
        else if ((OLWorkOrder == "" || OLWorkOrder == null) && CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N') {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            validationFalg = false
            displayExtraLoader = false;
            document.getElementById('StatusMsg').innerText = "Please fill all Mandatory Fields"
            document.getElementById('StatusMsg1').innerText = "Please fill all Mandatory Fields"
        }
        else if (Employeevalidate == false || (OLEmployeeCC == " " || OLEmployeeCC == "0")) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            validationFalg = false
            displayExtraLoader = false;
            document.getElementById('StatusMsg').innerText = "Please select Employee ID"
            document.getElementById('StatusMsg1').innerText = "Please select Employee ID"
        }
        else if (OLShipTo == "0" || OLShipTo == undefined || OLShipTo == "") {
            //;
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            validationFalg = false
            displayExtraLoader = false;
            document.getElementById('StatusMsg').innerText = "Please fill all Mandatory Fields"
            document.getElementById('StatusMsg1').innerText = "Please fill all Mandatory Fields"
        }
        //******************NEW***********wal-158***
        if (this.state.pickupcheck == true) {
            if (!isQuoteOrderSubmit) {
                if (this.state.PickupStoreSelected == "" || this.state.PickupStoreSelected == [] || this.state.PickupStoreSelected == null || this.state.PickupStoreSelected == undefined) {
                    if (this.state.lowesitem == false && this.state.displayPickDrop == true) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        validationFalg = false
                        displayExtraLoader = false;
                        if (this.state.Pick && this.state.Pick.length > 0) {
                            document.getElementById('StatusMsg').innerText = "Please select the pickup store"
                            document.getElementById('StatusMsg1').innerText = "Please select the pickup store"
                        } else {
                            if (CurrentLatitude == null && CurrentLongitude == null) {
                                document.getElementById('StatusMsg').innerText = "Please select the pickup store"
                                document.getElementById('StatusMsg1').innerText = "Please select the pickup store"
                            } else {
                                document.getElementById('StatusMsg').innerText = "No Pick-up location available within 200 miles for your location"
                                document.getElementById('StatusMsg1').innerText = "No Pick-up location available within 200 miles for your location"
                            }
                        }
                    }
                }
            }
        }
        else if (this.state.HalLocationChecked) {
            if (!isQuoteOrderSubmit) {
                if (this.state.HalLocationSelected == null || this.state.HalLocationSelected == undefined || this.state.HalLocationSelected == "" || this.state.HalLocationSelected == []) {
                    validationFalg = false
                    displayExtraLoader = false;
                    document.getElementById('StatusMsg').innerText = "Please select the hold at location"
                    document.getElementById('StatusMsg1').innerText = "Please select the hold at location"
                }
            }
        }
        if (validationFalg) {
            return true
        } else {
            return false
        }
    }
    /**
 * SCO_PC_07
 * to check the item qty available
 * */
    wareHouse_Qty_Check = () => {
        ;
        if (this.state.CartItems.length > 0) {
            let warehouse_item = this.state.CartItems.filter((x) => x.SupplierID == "W999999999" && x.PaintColor != "WNST" && x.PaintColor != "WCAT")
            let checkqty = false
            if (warehouse_item.length > 0) {
                let itemids = []
                warehouse_item.map((val, index) => {
                    itemids.push(val.Itemid)
                });
                // console.error("Test1", itemids);
                let BO = {
                    shipto_id: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//WAL-767 -Aparna
                    supplier_part_number: itemids,
                    User_Id: CookieService.getLocalStorageValues("Session_UserID")
                }
                ShoppingCartAction.WarehouseQTYCheck(BO)
                return false
            }
            else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                displayExtraLoader = false;
                if (this.state.WNA.length > 0) {
                    $('#QTY-popup').modal('show');
                    return false
                }
                else {
                    return true
                }
            }

        }
        else {
            return true
        }
    }
    /**
     * SCO_PC_03
     * to check the multiple supplier present in cart
     * */
    is_Multiple_Supplier_Check = () => {

        let lowescount = 0;
        let SupplierList = [];
        let RefrigerentItem = ""
        let RefrigerentCount = 0
        if (this.state.CartItems.length > 1) {
            this.state.CartItems.map((val, index) => {
                if (val.SupplierID == "W000000091") {
                    lowescount = lowescount + 1;
                }
                if (index == 0) {
                    if (val.SupplierID != null && val.SupplierID != "" && val.SupplierID != undefined) {
                        SupplierList.push(val.SupplierID);
                    }
                    else {
                        if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                            let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                            let recind = val.ItemDescription.indexOf(":");
                            let RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                            SupplierList.push(RecSuppStr);
                        }
                        else {
                            SupplierList.push(val.SupplierID);
                        }
                    }
                }
                else {
                    if (val.SupplierID != null && val.SupplierID != "" && val.SupplierID != undefined) {
                        if (SupplierList.indexOf(val.SupplierID) == -1) {
                            SupplierList.push(val.SupplierID);
                        }
                    }
                    else {
                        if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                            let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                            let recind = val.ItemDescription.indexOf(":");
                            let RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                            if (SupplierList.indexOf(RecSuppStr) == -1) {
                                SupplierList.push(RecSuppStr);
                            }
                        }
                        else {
                            SupplierList.push(val.SupplierID);
                        }
                    }
                }
            });
            if (SupplierList.length > 1) {
                /*[07/18/22, 2381-Lowe Item cannot be mixed with other vendor items], Priyanka D */
                //SC_PC_01 - WW-349 Notification for Multiple Suppliers - Deepthi N H
                if (lowescount != 0) {
                    //alert("Lowe's items cannot be mixed with other Catalog/Non-Catalog/Punchout items");
                    let IsMultipleSupplier = "Lowe's items cannot be mixed with other items";
                    this.setState({ IsMultipleSupplier: IsMultipleSupplier, IsOkbuttonshow: "", IsLowes: true })
                    $('#alertpopup').modal('show');
                    return false
                }
                else {
                    //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                    this.setState({ IsMultipleSupplier: "Shopping cart contains items from multiple suppliers.", IsOkbuttonshow: "Press OK to continue or Cancel to remove unwanted items.", IsLowes: false })
                    $('#alertpopup').modal('show');
                    return false
                }

            } else {
                return true

                // this.ReorderCheck()
            }
        }
        else {
            return true
        }


    }
    formItem_Check = () => {
        let filterFormItem = this.state.CartItems.filter(x => x.FormAttribute != " " && x.FormAttribute != null && parseInt(x.RTI_QTY ? x.RTI_QTY : 0, 10) < Number(x.Quantity ? x.Quantity : 0)).length > 0 ? true : false
        if (filterFormItem && refOrderNo == "") { //WW-1221 -Vishwa S
            $('#FormItem_Popup').modal('show')
            return false
        } else {
            return true
        }
    }

    /**
     * SCO_PC_02
     * submit button click
     * */

    submitClick = (Type) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        if (Type == "QUOTE") {
            isQuoteOrderSubmit = true;
        }
        this.submitOrder_Btn_Click(Type)
        if (displayExtraLoader == true) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
    }

    submitOrder_Btn_Click = (Type) => {
        this.setState({ submitbtn: true });
        let valid = true;
        WOBtnClick = true;
        if (this.state.isValidWO) {
            valid = false;
            WOBtnClick = false;
        }
        if (this.WorkOrder_Validation(valid)) {
            if (this.order_Field_Validation()) {
                if (this.NonCatItem_Check()) {
                    // return true

                    if (this.wareHouse_Qty_Check()) {
                        //WW-920_PC_01 -Aparna
                        if (this.formItem_Check() || refOrderNo != "") {
                            //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
                            if (Type != "QUOTE") {
                                if (this.is_Multiple_Supplier_Check()) {
                                    //WW-600_PC_03 (1/26/2023)-Aparna
                                    this.IsRefrigerantInCart()
                                } else {
                                    this.setState({ submitbtn: false });
                                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                                    return false
                                }
                            }
                            else {
                                this.IsRefrigerantInCart(Type)
                            }
                        }
                        else {
                            //this.setState({ submitbtn: false });
                            $(`#${SDIConstants.SDILoader}`).addClass('hide');
                            return false
                        }

                    } else {
                        //this.setState({ submitbtn: false });
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        return false
                    }
                } else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');

                    //displayExtraLoader = false;
                    return false
                }
            }
            else {
                this.setState({ submitbtn: false });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                return false
            }
        } else {
            //this.setState({ submitbtn: false });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return false;
        }
    }
    //WW-687_PC_13 (4/19/2023)-Aparna
    splitDelivery_ZipCode_OnChange = (event) => {
        let curlat = 0;
        let curlong = 0
        let zipcode = $('#suplidelivery_zipcode').val()
        if (event != undefined && event.target.value != null) {
            if (event.target.value.trim() != "") {
                if (zipcode.length == 5) {
                    this.setState({ splitDelivery_ZipCode: zipcode, isGraingerrZipCodeChange: false, splitdelivery_Zipcode_Error: "" })
                    this.ZipCodeClick(zipcode)
                    if (userDeniedLocation) {
                        //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
                        this.setState({ userZipCode_Text: zipcode, splitDelivery_userZipCode: true });
                        let Address = {
                            regionCode: "US",
                            addressLines: zipcode
                        }
                        let ZipcodeValidationBO = {
                            address: Address
                        }
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        ShoppingCartAction.ZipcodeValidation(ZipcodeValidationBO)
                        //this.ZipBasedPickup(zipcode);

                    }
                }
                else {
                    let { supplierList } = this.state;
                    let supplierPickupStoreUpdate = supplierList.find(x => x.supplier_ID == "W000000036")
                    supplierPickupStoreUpdate.pickupStore = []
                    supplierPickupStoreUpdate.pickupLocation = []

                    this.setState({ supplierList })
                }
            }
            else {
                let { supplierList } = this.state;
                let supplierPickupStoreUpdate = supplierList.find(x => x.supplier_ID == "W000000036")
                supplierPickupStoreUpdate.pickupStore = []
                supplierPickupStoreUpdate.pickupLocation = []

                this.setState({ supplierList })
            }
        } else {
            let { supplierList } = this.state;
            let supplierPickupStoreUpdate = supplierList.find(x => x.supplier_ID == "W000000036")
            supplierPickupStoreUpdate.pickupStore = []
            supplierPickupStoreUpdate.pickupLocation = []

            this.setState({ supplierList })


        }
        this.setState({ splitDelivery_ZipCode: event.target.value, isGraingerrZipCodeChange: false, splitdelivery_Zipcode_Error: "" })
    }

    //WW-687_PC_17 (4/19/2023)-Aparna
    SplitDelivery_Pagination_Click = (data) => {
        let pageNo = data.selected + 1
        let index = this.state.supplierList.findIndex(x => x.supplier_ID == "W000000036")
        if (index == pageNo - 1 && this.state.splitDelivery_ZipCode != this.state.userZipCode_Text && this.state.userZipCode_Text != null && this.state.userZipCode_Text != undefined && this.state.userZipCode_Text != "" && this.state.userZipCode_Text != " ") {
            if (this.state.userZipCode_Text.length == 5) {
                this.setState(
                    {
                        splitDelivery_ZipCode: this.state.userZipCode_Text,
                        supplier_PageNo: pageNo,
                        isGraingerrZipCodeChange: true
                    },
                    () => {
                        // After the state is updated, call the ZipCodeClick method
                        this.ZipCodeClick(this.state.userZipCode_Text);
                    }
                );
            } else {
                this.setState({ supplier_PageNo: pageNo, isGraingerrZipCodeChange: false })
            }

        } else {
            this.setState({ supplier_PageNo: pageNo, isGraingerrZipCodeChange: false })
        }
    }
    //WW-687_PC_29 (4/19/2023)-Aparna
    SplitDelivery_Next_Btn_Click = () => {
        this.setState({})
        let index = this.state.supplierList.findIndex(x => x.supplier_ID == "W000000036")
        if (index == this.state.supplier_PageNo - 1 && this.state.splitDelivery_ZipCode != this.state.userZipCode_Text && this.state.userZipCode_Text != null && this.state.userZipCode_Text != undefined && this.state.userZipCode_Text != "" && this.state.userZipCode_Text != " ") {
            if (this.state.userZipCode_Text.length == 5) {
                this.setState(
                    {
                        splitDelivery_ZipCode: this.state.userZipCode_Text,
                        supplier_PageNo: this.state.supplier_PageNo + 1,
                        isGraingerrZipCodeChange: true
                    },
                    () => {
                        // After the state is updated, call the ZipCodeClick method
                        this.ZipCodeClick(this.state.userZipCode_Text);
                    }
                );
            } else {
                this.setState({ supplier_PageNo: this.state.supplier_PageNo + 1, isGraingerrZipCodeChange: false })
            }
        } else {
            this.setState({ supplier_PageNo: this.state.supplier_PageNo + 1, isGraingerrZipCodeChange: false })
        }
    }
    //WW-687_PC_19 (4/20/2023)-Aparna
    suppliers_DeliveryMethod = (shiptoValue, shiptoValueMiles) => {
        let { supplierList } = this.state;
        supplierList.forEach((x) => {
            if (x.deliveryMethod == "ShipTo") {
                x.shipTo = shiptoValue
                if (shiptoValueMiles > 100) {
                    x.shipToWarrning = true
                } else {
                    x.shipToWarrning = false
                }
            }
        })
        this.setState({ supplierList })
    }
    //
    suppliers_PickupChange = (pickupvalue, index) => {
        let { supplierList } = this.state
        supplierList[index].pickupLocation = pickupvalue
        this.setState({ supplierList })
    }

    ChooseDelivery_Click = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ isEditingDeliveryOptions: true });
        this.ChooseDeliveryOption_Btn_Click()
        if (displayExtraLoader == true) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
    }
    //WW-687_PC_07 (4/19/2023)-Aparna
    ChooseDeliveryOption_Btn_Click = () => {
        this.setState({ Choose_Delivery_Btn_Click: true });
        $(`#splitDelivery_Loader`).addClass('d-none');
        
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (this.WorkOrder_Validation(false)) {
            //
            if (this.mandatoryField_Validation()) {
                if (this.NonCatItem_Check()) {
                    if (this.wareHouse_Qty_Check()) {
                        //WW-920_PC_06 -Aparna
                        if (this.formItem_Check()) {
                            $('#splitDelivery_Popup').modal('show')
                            this.setState({ isEditingDeliveryOptions: false });
                        } else {
                            $(`#${SDIConstants.SDILoader}`).addClass('hide');
                            return false
                        }
                    } else {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        return false
                    }
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    return false
                }
            } else {
                this.setState({ submitbtn: false });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                return false
            }

        } else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return false
        }
    }
    //WW-687_PC_26 (4/19/2023)-Aparna
    mandatoryField_Validation = () => {

        let OLDueDate = this.state.OLDueDateVal;
        let OLEmployeeCC = this.state.OrderEmpyId;
        let validation = true;
        let OLShipTo = "";
        if (this.state.defaultShipto != undefined && this.state.defaultShipto != null) {
            OLShipTo = this.state.defaultShipto.value;
        }
        else {
            if (OLShipTo == "" || OLShipTo == null || OLShipTo == {} || OLShipTo == " ") {
                if (this.state.ShipToDDValue.length < 2) {
                    let ShipToDDValue = this.state.ShipToDDValue
                    OLShipTo = ShipToDDValue[0].value;
                }
                else if (this.state.defaultShipto != undefined) {
                    OLShipTo = this.state.defaultShipto.value;
                }
            }
        }
        if (OLDueDate == "") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            validation = false
            displayExtraLoader = false
            document.getElementById('StatusMsg').innerText = "Select delivery date"
            document.getElementById('StatusMsg1').innerText = "Select delivery date"
        }
        else if (OLEmployeeCC == " " || OLEmployeeCC == "0") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            validation = false
            //WW-1010 -Employee ID drop down issue. Pulling up SDI Employee Users. - Deepthi N H
            displayExtraLoader = false
            document.getElementById('StatusMsg').innerText = "Please select Employee ID"
            document.getElementById('StatusMsg1').innerText = "Please select Employee ID"
        } else if (OLShipTo == "0" || OLShipTo == undefined || OLShipTo == "") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            validation = false
            displayExtraLoader = false;
            document.getElementById('StatusMsg').innerText = "Please select Ship to"
            document.getElementById('StatusMsg1').innerText = "Please select Ship to"
        }
        if (validation) {
            return true
        } else {
            return false
        }
    }
    //WW-687_PC_25 (4/19/2023)-Aparna
    splitDelivery_Close_Btn_Click = () => {
        this.setState({ Choose_Delivery_Btn_Click: false, supplier_PageNo: 1, chooseDelivery_Submit_btn_Click: false, splitdelivery_Zipcode_Error: "", splitdelivery_Delivery_Error: "", isClosedFrom: "" });
        //document.getElementById("splitdelivery_Delivery_Error").innerText = ""
        $('#splitDelivery_Popup').modal('hide')

    }

    //WW-687_PC_02 (4/19/2023)-Aparna
    supplierCollection = (CartItems, pickupvendorList, pickupStoreTot, defaultShipto) => {
        let supplierList = CartItems.filter((v, i, a) => a.findIndex(t => (t.SupplierID === v.SupplierID)) === i)
        let supplierDetail = []
        let pickupstore = []

        supplierList.forEach((val, index) => {
            let ispickupvendor = []
            if (pickupvendorList != undefined && pickupvendorList != null) {
                ispickupvendor = pickupvendorList.filter((x, index) => x.VENDOR_ID == val.SupplierID && x.BUSINESS_UNIT_OM == "I0W01")
            }
            let deliveryOption = []
            //let refrigerantCont = CartItems.filter((x) => x.shipping_specs == "PU ONLY" && x.SupplierID == val.SupplierID).length == CartItems.filter((x) => x.SupplierID == val.SupplierID).length ? true : false
            //WW-774_PC_02 -Aparna
            let refrigerantCont = CartItems.filter((x) => x.shipping_specs == "PUO ONLY" && x.SupplierID == val.SupplierID).length > 0 ? true : false
            if (ispickupvendor.length > 0 || val.SupplierID == "W000000091") {
                deliveryOption.push("Pickup")
            }
            if (val.SupplierID != "W000000091" && refrigerantCont == false) {
                deliveryOption.push("ShipTo")
            }

            pickupstore = this.getPickupStore(pickupStoreTot, val.SupplierID)

                ;
            let pickupstore2 = []
            if (val.SupplierID != "W000000091" && val.SupplierID != "W000000036") { //|| refrigerantCont (to get the pickup store in split delivery refrigerant item)  //WW-774_PC_02 -Aparna
                if (val.SupplierID == "W999999999" && this.state.Bentonville_WO) {//|| refrigerantCont
                    pickupstore2 = []
                } else {
                    pickupstore2 = pickupstore == undefined ? [] : pickupstore
                }
            }
            supplierDetail.push({
                supplier_ID: val.SupplierID,
                supplier_Name: val.SUPPLIERNAME == null || val.SUPPLIERNAME == undefined || val.SUPPLIERNAME == "" ? "NONCAT" : val.SUPPLIERNAME.toUpperCase(),
                shipTo: defaultShipto != undefined && defaultShipto != undefined ? defaultShipto : "",
                pickupLocation: val.SupplierID == "W000000091" ? "LOWES" : val.SupplierID == "W999999999" && this.state.Bentonville_WO ? "C0W10" : "",
                deliveryMethod: val.SupplierID != "W000000091" && refrigerantCont == false ? "ShipTo" : "Pickup",
                deliveryOptions: deliveryOption,
                itemCount: CartItems.filter((x) => x.SupplierID == val.SupplierID && val.hasCoreCharge == false).length,
                //pickupStore: val.SupplierID == "W000000091" || val.SupplierID == "W000000036" ? [] : (val.SupplierID != "W999999999" && this.state.Bentonville_WO == false) ? pickupstore : [],
                shipToWarrning: false,
                RefrigerantBadge: CartItems.filter((x) => x.shipping_specs == "PUO ONLY" && x.SupplierID == val.SupplierID).length > 0 ? true : false,
                warehouseBadge: false,
                centralWarehouseBadge: false,
                pickupStore: pickupstore2
            })
            //  supplierDetail[index].pickupStore = pickupstore1
        })
        this.setState({ supplierList: supplierDetail })
        console.log("supplierList", supplierDetail)
    }
    //WW-687_PC_27 (4/12/2023)-Aparna
    getPickupStore = (TotsupplierAdd, SupplierID) => {
        let pickupstore1 = []
        if (this.state.isValidWO || CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") == 'N') {
            if (SupplierID != null && SupplierID != undefined) {
                //this.getPickupStore(val.SUPPLIERNAME, pickupStoreTot, index, val.SupplierID)
                let curlat = 0;
                let curlong = 0;
                let billtostore = this.state.BilltoStoreLocation;
                let billstore = this.state.BilltoStore.value;

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(getLatLon);
                    function getLatLon(position) {
                        curlat = position.coords.latitude;
                        curlong = position.coords.longitude;
                    }
                } else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please allow the website to access your location!!"
                    });

                    return;
                }
                if (billstore != "" && billstore != undefined) {
                    if (billstore.substring(0, 2) == "WT") {
                        curlat = this.state.curtrucklat;
                        curlong = this.state.curtrucklong;
                    }
                }
                let pickupstoreDetails = [];
                if (TotsupplierAdd && SupplierID != "") {
                    TotsupplierAdd.map((storeval, index) => {
                        if (storeval.VENDOR_ID == SupplierID) {
                            let localArray = {
                                ADDRESS3: storeval.ADDRESS3,
                                VNDR_LOC: storeval.VNDR_LOC,
                                ADDRESS1: storeval.ADDRESS1,
                                CITY: storeval.CITY,
                                STATE: storeval.STATE,
                                POSTAL: storeval.POSTAL,
                                PHONE: storeval.PHONE,
                                NAME1: storeval.NAME1,
                                LATITUDE: storeval.LATITUDE,
                                LONGITUDE: storeval.LONGITUDE,
                                SUPPLIER_ID: storeval.VENDOR_ID
                            }
                            pickupstoreDetails.push(localArray)
                        }
                    })
                }
                const CurrentLocation = { lat: CurrentLatitude, long: CurrentLongitude };
                let goLocalObject = [];
                if (SupplierID == "W999999999") {
                    let pickupdet = pickupstoreDetails.sort((a, b) =>
                        (DistanceCalculator.calculate(CurrentLocation, { lat: a.LATITUDE, long: a.LONGITUDE }) * 0.00062137) > (DistanceCalculator.calculate(CurrentLocation, { lat: b.LATITUDE, long: b.LONGITUDE }) * 0.00062137) ? 1 : -1).map((iresult, index) => {
                            if (iresult != null && iresult != undefined) {

                                let arr1 = ""
                                if (iresult.LATITUDE != null && iresult.LATITUDE != undefined && iresult.LONGITUDE != null && iresult.LONGITUDE != undefined && CurrentLatitude != null && CurrentLongitude != null) {

                                    let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.LATITUDE, long: iresult.LONGITUDE })
                                    let dis = (dis1 * 0.00062137).toFixed(2)

                                    if (dis <= 200) {
                                        arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + dis + " " + "miles"


                                        /*[09/02/22,WW-452_PC_05], Priyanka D */
                                        let val = iresult.VNDR_LOC
                                        let localArray = {
                                            value: val,
                                            label: arr1,
                                            color: "Beige"
                                        }

                                        //WW-718_PC_01 -Aparna
                                        if (arr1.toUpperCase().startsWith("GO LOCAL")) {
                                            goLocalObject.push(localArray)
                                        } else {
                                            pickupstore1.push(localArray);
                                        }
                                    }
                                }
                            }

                        });
                    //WW-718_PC_01 -Aparna
                    if (goLocalObject != undefined && goLocalObject != null) {
                        pickupstore1 = [...goLocalObject, ...pickupstore1]

                    }


                }
                else {
                    let pickupdet = pickupstoreDetails.sort((a, b) =>
                        (DistanceCalculator.calculate(CurrentLocation, { lat: a.LATITUDE, long: a.LONGITUDE }) * 0.00062137) > (DistanceCalculator.calculate(CurrentLocation, { lat: b.LATITUDE, long: b.LONGITUDE }) * 0.00062137) ? 1 : -1).map((iresult, index) => {
                            if (iresult != null && iresult != undefined) {

                                let arr1 = ""
                                if ((iresult.LATITUDE == null || iresult.LATITUDE == undefined) && (iresult.LONGITUDE == null || iresult.LONGITUDE == undefined) || (CurrentLatitude == null && CurrentLongitude == null)) {
                                    arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + " " + "N/A"

                                } //[28/08/2022 WW-452_PC_04] PickupBind Pavithra R 
                                else {
                                    let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.LATITUDE, long: iresult.LONGITUDE })
                                    let dis = (dis1 * 0.00062137).toFixed(2)
                                    arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + dis + " " + "miles"
                                }

                                /*[09/02/22,WW-452_PC_05], Priyanka D */
                                let val = iresult.VNDR_LOC
                                let localArray = {
                                    value: val,
                                    label: arr1,
                                    color: "Beige"
                                }

                                //WW-718_PC_01 -Aparna
                                if (arr1.toUpperCase().startsWith("GO LOCAL")) {
                                    goLocalObject.push(localArray)
                                } else {
                                    pickupstore1.push(localArray);
                                }
                            }
                        });
                    //WW-718_PC_01 -Aparna
                    if (goLocalObject != undefined && goLocalObject != null) {
                        pickupstore1 = [...goLocalObject, ...pickupstore1]

                    }

                }
                if (pickupstore1 != [] && pickupstore1 != "" && pickupstore1 != undefined && pickupstore1 != null) {
                    pickupstore1 = pickupstore1.filter((ele, ind) => ind === pickupstore1.findIndex(elem => elem.label === ele.label))
                }
                return pickupstore1
            }
        }
    }
    splitDelivery_Validation = () => {
        let validation = true;
        let index = -1
        let vendorGrainger = false
        let graingerIndex = this.state.supplierList.findIndex(x => x.supplier_ID == "W000000036")
        this.state.supplierList.forEach((x, ind) => {
            if (x.deliveryMethod == "ShipTo") {
                if (this.state.defaultShipto == undefined || this.state.defaultShipto == null || this.state.defaultShipto == "" || this.state.defaultShipto.value == "0") {
                    index = ind
                    validation = false
                    vendorGrainger = false
                }
            } else {
                if ((x.pickupLocation != undefined && x.pickupLocation != null && x.pickupLocation != "")) {
                    if (x.supplier_ID == "W000000036") {
                        if (x.pickupLocation.value == undefined || x.pickupLocation.value == null || x.pickupLocation.value == "") {
                            index = ind
                            validation = false
                            vendorGrainger = true
                        }
                    }
                } else {
                    if (x.supplier_ID == "W000000036") {
                        index = ind
                        validation = false
                        vendorGrainger = true
                    } else {
                        if (x.pickupStore.length > 0) {
                            index = ind
                            validation = false
                            vendorGrainger = false
                        }
                        else if (x.supplier_ID == "W999999999") {
                            index = ind
                            validation = false
                            vendorGrainger = false
                        }
                    }
                }
            }
        })
        if (validation) {
            this.setState({ validationFailedIndex: -1 })
            return true
        } else {
            this.setState({ validationFailedIndex: index, supplier_PageNo: index + 1 })
            if (vendorGrainger) {
                if (graingerIndex > -1 && this.state.splitDelivery_ZipCode != this.state.userZipCode_Text && this.state.userZipCode_Text != null && this.state.userZipCode_Text != undefined && this.state.userZipCode_Text != "" && this.state.userZipCode_Text != " ") {
                    if (this.state.userZipCode_Text.length == 5) {
                        this.setState(
                            {
                                splitDelivery_ZipCode: this.state.userZipCode_Text,
                                isGraingerrZipCodeChange: true
                            },
                            () => {
                                // After the state is updated, call the ZipCodeClick method
                                this.ZipCodeClick(this.state.userZipCode_Text);
                            }
                        );
                    } else {
                        this.setState({ isGraingerrZipCodeChange: false })
                    }
                }

                if (this.state.splitDelivery_ZipCode == "" || this.state.splitDelivery_ZipCode == null || this.state.splitDelivery_ZipCode == undefined) {
                    this.setState({ splitdelivery_Zipcode_Error: "Please enter a valid zip code", splitdelivery_Delivery_Error: "" })
                    // document.getElementById("splitdelivery_Delivery_Error").innerText = ""
                } else {
                    //document.getElementById("splitdelivery_Delivery_Error").innerText = "Please select delivery address"
                    this.setState({ splitdelivery_Zipcode_Error: "", splitdelivery_Delivery_Error: "Please select delivery address" })
                }
            } else {
                this.setState({ splitdelivery_Zipcode_Error: "", splitdelivery_Delivery_Error: "Please select delivery address" })
                // document.getElementById("splitdelivery_Delivery_Error").innerText = "Please select delivery address"
            }
            return false
        }
    }
    //WW-687_PC_23 (4/19/2023)-Aparna
    splitDelivery_Submit_Click = () => {
        this.setState({ chooseDelivery_Submit_btn_Click: true })

        if (this.splitDelivery_Validation()) {
            this.setState({ splitdelivery_Delivery_Error: "" })
            //  document.getElementById("splitdelivery_Delivery_Error").innerText = ""
            $('#splitDelivery_Popup').modal('hide')
            if (this.wareHouse_Qty_Check()) {
                this.ReorderCheck()
            } else {
                //  $('#splitDelivery_Popup').modal('hide')
                // this.setState({ Choose_Delivery_Btn_Click:false })
            }

        } else {
            this.setState({ chooseDelivery_Submit_btn_Click: false })

            // document.getElementById("splitdelivery_Delivery_Error").innerText="Please select delivery address"
            //this.setState({ supplier_PageNo: this.state.validationFailedIndex + 1 })
        }
    }
    //WW-687_PC_28 (4/19/2023)-Aparna
    reOrderBtnClose = () => {
        this.setState({ Choose_Delivery_Btn_Click: false, submitbtn: false, chooseDelivery_Submit_btn_Click: false, supplier_PageNo: 1, reordervalue: "", resonerr: "" })
    }
    //WW-687_PC_11 (4/19/2023)-Aparna
    bind_SplitDelivery_options = (supplierList) => {
        return supplierList.map((val, index) => {
            return (<option value={val}>{val}</option>)
        })
    }
    //WW-687_PC_12 (4/20/2023)-Aparna
    onChange_DeliveryMethod = (e, supplier_ID, supplierIndex) => {
        let { supplierList } = this.state
        if (e.target.value == "Pickup") {
            supplierList[supplierIndex].deliveryMethod = "Pickup"
            if (supplier_ID == "W000000091") {
                supplierList[supplierIndex].pickupLocation = "LOWES"
            } else if (supplier_ID == "W999999999" && this.state.Bentonville_WO) {
                supplierList[supplierIndex].pickupLocation = "C0W10"
            }
            else if (supplier_ID == "W000000036" && this.state.userZipCode_Text != null && this.state.userZipCode_Text != undefined && this.state.userZipCode_Text != "") {
                this.ZipCodeClick(this.state.userZipCode_Text)
            }
        } else {
            supplierList[supplierIndex].deliveryMethod = "ShipTo"
        }
        if (this.state.userZipCode_Text != null && this.state.userZipCode_Text != undefined && this.state.userZipCode_Text != "" && this.state.userZipCode_Text != " ") {
            this.setState({ supplierList, splitDelivery_ZipCode: this.state.userZipCode_Text })
        } else {
            this.setState({
                supplierList
            })
        }
    }

    //WW-687_PC_09 (4/19/2023)-Aparna
    bindSuppliers_InPopup = () => {
        return this.state.supplierList.map((val, index) => {
            if (index < parseInt(this.state.supplier_PageNo) && index >= parseInt(this.state.supplier_PageNo - 1)) {
                return (<>
                    <div className="text-center d-none align-loader" style={{ alignSelf: "center" }} id="splitDeliveryQty_Loader">
                        <RotatingLines
                            strokeColor="#ffc107"
                            strokeWidth="5"
                            animationDuration="0.75"
                            width="70"
                            visible={true}
                        />
                    </div>
                    <div className="row" id="splitDelivery_BodyContent">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 border-right border-bottom popup-height" id="splitDeliveryQty_BodyContent" >
                            <h6 className="modal-inner-heading">Supplier Details</h6>
                            <p className="font-14 mt-3">
                                <span className="modal-inner-label">Supplier Name:</span>
                                <span className="pl-2">{val.supplier_Name}</span>
                            </p>
                            {val.RefrigerantBadge ? <p className="font-14 mt-3 text-align-right">
                                <span className="bg-indigo">P</span>
                                {/*WW-1162-01 changing the name refridgerent items pick-up only to pick-up only S.Sanjay */}
                                <span className="pl-2">
                                    Pick-up only.{" "}
                                </span>
                            </p> : null}
                            <div className="table-responsive split-delv-table-resp mb-3" style={{ height: "300px" }}>
                                <table className="table split-delv-table">
                                    <thead className="sticky-top">
                                        <tr>
                                            <th>Product Image</th>
                                            <th>Product Name</th>
                                            <th># Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.bindSuppliersItem_InPopup(val.supplier_ID)}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-12  col-sm-12  col-md-12 col-lg-6 border-bottom popup-height" id="splitDelivery_BodyContent3">

                            <h6 className="modal-inner-heading">Delivery Details</h6>
                            <div className="form-group row">
                                <label
                                    htmlFor="Delivery-Method-label"
                                    className="col-sm-4 col-form-label modal-inner-label"
                                >
                                    Delivery Method
                <span className="req-star">*</span>
                                </label>
                                <div className="col-sm-8">
                                    <select className="form-control" name="Delivery method" value={val.deliveryMethod} onChange={e => this.onChange_DeliveryMethod(e, val.supplier_ID, index)}>
                                        {this.bind_SplitDelivery_options(val.deliveryOptions)}
                                    </select>
                                </div>
                            </div>
                            {val.supplier_ID == "W000000036" && val.deliveryMethod == "Pickup" ? <div className="form-group row">
                                <label
                                    htmlFor="zipcode-label"
                                    className="col-sm-4 col-form-label modal-inner-label"
                                >
                                    Zip Code<span className="req-star">*</span>
                                </label>
                                <div className="col-sm-8">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="suplidelivery_zipcode"
                                        onChange={e => this.splitDelivery_ZipCode_OnChange(e)}
                                        value={this.state.splitDelivery_ZipCode}
                                        maxLength="5"
                                        placeholder="Enter zip code"
                                        style={{ WebkitAppearance: "none", MozAppearance: "textfield" }}
                                    />
                                    <span className="px-2 errorspan1 mt-3" style={{ textAlign: "start" }} id={`splitdelivery_Zipcode_Error-${index}`}>{this.state.splitdelivery_Zipcode_Error}</span>
                                </div>
                            </div> : null}
                            {val.supplier_ID != "W000000036" && val.deliveryMethod == "Pickup" && this.state.splitDelivery_userZipCode ? <div className="form-group row">
                                <label
                                    htmlFor="zipcode-label"
                                    className="col-sm-4 col-form-label modal-inner-label"
                                >
                                    Zip Code<span className="req-star">*</span>
                                </label>
                                <div className="col-sm-8">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="splitDelivery_userZipCodeID"
                                        onChange={e => this.handleZipcode(e, val.supplier_ID, index)}
                                        value={this.state.userZipCode_Text}
                                        maxLength="5"
                                        placeholder="Enter zip code"
                                        style={{ WebkitAppearance: "none", MozAppearance: "textfield" }}
                                    />
                                    {val.supplier_ID == "W999999999" && val.deliveryMethod == "Pickup" && this.state.splitDelivery_userZipCode && (this.state.userZipCode_Text != "" || this.state.userZipCode_Text != " " || this.state.userZipCode_Text.length != 5) ?
                                        <span className="px-2 errorspan1 mt-3" style={{ textAlign: "start" }} id={`userZipcode_Zipcode_Error-${index}`}>{this.state.inventry_zipcode_Error}</span>
                                        : null}


                                    <span className="px-2 errorspan1 mt-3" style={{ textAlign: "start" }} id={`userZipcode_Zipcode_Error-${index}`}>{this.state.userZipcode_Zipcode_Error}</span>
                                </div>

                            </div> : null}

                            <div className="form-group row">
                                {val.deliveryMethod == "ShipTo" ? <label htmlFor="pickup-label" className="col-sm-4 col-form-label modal-inner-label">
                                    Ship to<span className="req-star">*</span>
                                </label> :
                                    <>
                                        <label htmlFor="pickup-label" className="col-sm-4 col-form-label modal-inner-label">
                                            Pickup<span className="req-star">*</span>
                                        </label>  </>}
                                <div className="col-sm-8">
                                    {/*<input type="text" className="form-control" id="pickup-label" />*/}
                                    {val.deliveryMethod == "ShipTo" ? <> <Select
                                        id="OLShipTo"
                                        className={CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N' ? (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' && this.state.isWorkToStoreValid ? "DropDown-Font-Size disabled" : "DropDown-Font-Size") : "DropDown-Font-Size"}
                                        value={this.state.defaultShipto}
                                        onChange={(e) => this.handleChangeShipto(e)}
                                        options={this.state.ShipToDDValue}
                                        isDisabled={false}
                                    /> </> :
                                        <><Select
                                            id="splitdelivery_Pickup"
                                            className={val.pickupStore.length <= 0 ? "DropDown-Font-Size disabled" : "DropDown-Font-Size"}
                                            value={val.pickupLocation}
                                            onChange={(e) => this.suppliers_PickupChange(e, index)}
                                            options={val.pickupStore}
                                            isDisabled={false}
                                            styles={colourStyles}
                                        /></>}
                                    {val.shipToWarrning && val.deliveryMethod == "ShipTo" ? <p className="validation-miles d-flex align-items-center mt-2">
                                        <span className="mr-1">
                                            <img src="images/validation-danger.svg" />{" "}
                                        </span>{" "}
                                        Selected Ship To is greater than 100 miles.{" "}
                                    </p> : null}
                                </div>
                            </div>
                            {!this.state.isCountryMatch && val.deliveryMethod == "ShipTo" ? (
                                <div className="row">
                                    <div className="col-lg-4 col-md-12"></div>
                                    <div className="col-lg-8 col-md-12 col-12 ">
                                        <div style={{ display: "flex", alignItems: "start" }}>
                                            <img className="mr-2 align-top" src="Images/info-icon.png" style={{ display: "inline" }} alt="Info Icon" />
                                            <label className="confirm-content shipment-font" style={{ verticalAlign: "middle" }}>
                                                The default Ship-To's Country Code does not match the Work Order Store Country Code.</label>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            {this.state.Checkedbillto && val.deliveryMethod == "ShipTo" && CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N'? <div className="form-group row"><label for="pickup-label" className="col-sm-4 col-form-label modal-inner-label"></label>
                                <div className="col-sm-8 pl-22">
                                    <div className="col-lg-6 float-left mt-2 bill-to-store-padding custom-checkbox item-custom-control" id="bill-to-store">
                                        <input type="checkbox" className="custom-control-input " id="Billtostoreid" name="example4" checked={this.state.isWorkToStoreValid} onClick={() => this.CheckBillToStore()} />
                                        <label className={`custom-control-label catalog-label priority-checkbox ${this.state.isValidWO ? '' : 'custombtn-disabled'} `} htmlFor="Billtostoreid" for="Billtostoreid">Bill-to-Store</label>
                                    </div>
                                    <div className="col-lg-6 float-left mt-2 bill-to-store-padding custom-checkbox item-custom-control" id="bill-to-store">
                                        <input type="checkbox" className="custom-control-input " id="Billtostoreid" name="example4" checked={true} />
                                        <label className="custom-control-label catalog-label priority-checkbox custombtn-disabled" htmlFor="Billtostoreid" for="Billtostoreid">Apply to all non pickup supplier</label>
                                    </div>
                                </div>
                            </div> : null}
                            {val.supplier_ID == "W999999999" && this.state.Bentonville_WO && val.deliveryMethod == "Pickup" ? <div className="col-sm-8 pl-22 float-right">
                                <label className="catalog-label d-block">{CookieService.getLocalStorageValues("Bentonville_Address")}</label>
                            </div> : null}
                            {val.deliveryMethod == "Pickup" && val.supplier_ID == "W000000036" && val.pickupStore.length > 0 ?
                                <><div className="col-sm-8 pl-22 float-right">
                                    <span className="cart-count" style={lal}></span>
                                    <span className="errorspan1" style={txt}>Available</span>
                                </div>
                                    <div className="col-sm-8 pl-22 float-right">
                                        <span className="cart-count" style={la}></span>
                                        <span className="errorspan1 " style={txt}>Partially available</span>
                                    </div></>
                                : val.deliveryMethod == "Pickup" && val.supplier_ID != "W000000091" && val.pickupStore.length > 0 ?
                                    <>
                                        <div className="col-sm-8 pl-22 float-right">
                                            <span className="cart-count" style={blk}></span>
                                            <span className="errorspan1 " style={txt}>Contact Branch</span>
                                        </div>
                                        {CurrentLatitude == null && CurrentLongitude == null ?
                                            <div className="col-sm-8 pl-22 float-right mt-2 mr-5">
                                                <p className="float-right alpart-label mt-2">  <img src="/Images/caution.svg" className="fav-popover-alert-img" alt="Fav-Img" />
                                                    <a href="#" id="splitDL" onClick={(e) => this.showStepsForLocation(e)}>Enable location </a> to view miles or <a href="#" onClick={(e) => this.split_zipcode(e)}>Enter Zipcode </a> </p>
                                            </div> : null}
                                    </> : null}


                            {val.deliveryMethod == "Pickup" && val.supplier_ID == "W999999999" && CurrentLatitude == null && CurrentLongitude == null ?
                                <>
                                    <div className="col-sm-10 pl-22 float-right mt-2">
                                        <p className="float-right alpart-label mt-2">  <img src="/Images/caution.svg" className="fav-popover-alert-img" alt="Fav-Img" />
                                            <a href="#" id="splitDL" onClick={(e) => this.showStepsForLocation(e)}> Enable location</a> to view the pickup stores near by or  <a href="#" onClick={(e) => this.split_zipcode(e)}>Enter Zipcode </a> </p>
                                    </div> </> : val.deliveryMethod == "Pickup" && val.supplier_ID == "W999999999" && CurrentLatitude == null && CurrentLongitude == null && this.state.userZipCode == false ? <span className="errorspan1 " style={Errtxt}>Enter valid zipcode</span> : null}
                            {val.deliveryMethod == "Pickup" && val.supplier_ID == "W999999999" && CurrentLatitude != null && CurrentLongitude != null && val.pickupStore.length <= 0 ?
                                <>
                                    <div className="col-sm-12 pl-22 float-right mt-2 mr-5">
                                        <span className="errorspan1 " style={Errtxt}>No Pick-Up location available within 200 miles for your location.</span>

                                    </div> </> : null}




                        </div>
                        <div className="col-md-12 d-flex justify-content-end mt-4">
                            {this.state.supplierList.length > 1 ? <>

                                <div className="col-md-12">

                                    <ReactPaginate
                                        previousLabel={<span className="right-pagination-arrow" />}
                                        nextLabel={<span className="left-pagination-arrow" />}
                                        previousClassName={'page-item'}
                                        nextClassName={'page-item'}
                                        previousLinkClassName={'page-link'}
                                        nextLinkClassName={'page-link'}
                                        disabledClassName={'disabled'}
                                        breakLabel={'...'}
                                        breakClassName={'page-item'}
                                        breakLinkClassName={'page-link'}
                                        pageCount={this.state.supplierList.length}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={this.SplitDelivery_Pagination_Click}
                                        containerClassName={'custom-pagination pagination float-right'}
                                        pageClassName={'page-item'}
                                        pageLinkClassName={'page-link'}
                                        activeClassName={'active'}
                                        hrefBuilder={() => '#'}
                                        forcePage={this.state.supplier_PageNo - 1}
                                    />
                                </div></> : null}
                        </div>
                        <div className="col-md-12">
                            <span className="px-2 errorspan1 mt-3 float-right" id="splitdelivery_Delivery_Error">{this.state.splitdelivery_Delivery_Error}</span>
                        </div>

                        <div className="col-md-12">
                            {parseInt(this.state.supplier_PageNo) == this.state.supplierList.length ? <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={e => this.splitDelivery_Submit_Click()}> Submit Order </button> :
                                <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={e => this.SplitDelivery_Next_Btn_Click()}> Next </button>}

                            <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right mr-2 mb-2" onClick={e => this.splitDelivery_Close_Btn_Click()}>
                                Close
        </button>




                        </div>
                    </div>

                    <div className=" text-center d-none  align-loader" style={{ alignSelf: "center" }} id="splitDelivery_Loader">
                        <RotatingLines
                            strokeColor="#ffc107"
                            strokeWidth="5"
                            animationDuration="0.75"
                            width="70"
                            visible={true}
                        />
                    </div>

                </>)
            }
        }
        )

    }
    //WW-687_PC_09 (4/19/2023)-Aparna
    bindSuppliersItem_InPopup = (supplier_ID) => {
        return this.state.CartItems.map((val, index) => {
            let favicondisplay = true;
            let isEquipment = val.ISA_WBS_ELMNT !== 'Equipment';
            if (val.PaintColor == "PUNCHOUT" || isEquipment) {

                favicondisplay = false;
            }
            // let linkable = true
            //Removing heart icon for unavail item
            this.state.WNA.map((x, index) => {
                if (val.Itemid == x.item) {
                    favicondisplay = false
                }
            })
            let linkable = true
            //******END********
            if (val.Manufacturer != null && val.Manufacturer != undefined) {
                if (val.Manufacturer.includes('KENSTAN')) {
                    linkable = false
                    CookieService.updateLocalStorageValues('kenstancount', CookieService.getLocalStorageValues('kenstancount') + 1);
                }
            }
            //WW-398_PC_04 (5/5/2022) -Aparna
            let linePickUp = false;
            //console.log("BentonvilleStore", this.state.BentonvilleStore)
            if (val.SupplierID == "W999999999" && this.state.Bentonville_WO && val.hasBenItemVal == "C") {
                linePickUp = true;
            }
            let imagePath = "";
            if (val.Image == "Images\noimage_new.png") {
                imagePath = `/Images/noimage_new.png`;
            }
            else if (val.Image) {
                val.Image = val.Image.replace('\\', '/');
                let spliturl = val.Image.split('|');
                if (val.Image.toLowerCase().indexOf("http") >= 0) {
                    imagePath = spliturl[0];
                } else {
                    imagePath = val.Image.lastIndexOf(`/`) >= 0 ? val.Image.substring(val.Image.lastIndexOf("/") + 1, val.Image.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = this.state.apiURL + `Images/${spliturl[0]}`;
                    }
                }
            }

            else {
                imagePath = `/Images/noimage_new.png`;
            }
            let msg = ""
            let labeldot;
            let graingerboolean = false;
            if (this.state.PickupVendor != "" && this.state.PickupVendor != undefined && this.state.PickupVendor != null) {
                if (this.state.PickupVendor.toUpperCase() == "W W GRAINGER" && this.state.pickupcheck == true) {
                    if (this.state.PickupStoreSelected != "" && this.state.PickupStoreSelected != undefined && this.state.PickupStoreSelected != null) {
                        let graingermsg = this.state.GraingerQTY.filter((x) => val.Itemid == x.itemId && x.branchId == this.state.PickupStoreSelected.value)
                        let graingerstr = this.state.GraingerStore.filter((x) => x.branchId == this.state.PickupStoreSelected.value)
                        if (graingerstr.length > 0) {
                            labeldot = graingerstr[0].availablity
                            // console.log("color", labeldot)
                        }
                        if (graingermsg.length > 0) {
                            msg = graingermsg[0].msg
                            graingerboolean = true
                        }
                    }
                }
            }
            let NonCat = val.Itemid.slice(0, 6)
            let ShowPOLNField = true
            if (CookieService.getLocalStorageValues("Session_SITEBU") != "SDM00") {
                ShowPOLNField = false
            }
            let SupplierId = false
            if (val.SupplierID != null && val.SupplierID != "") {
                SupplierId = true
            }
            let Pricevalue = val.Price
            if (NonCat == "NONCAT" && Pricevalue == "Price on Request") {
                SupplierId = false
            }
            let RemoveKey = "  Remove"
            let Showmachinepart = CookieService.getLocalStorageValues("Session_PARTLIST")
            let OrderQuantity = val.Quantity
            let itemNum = index + 1;
            let formateddate = this.convertdate(val.UDueDate)
            let ItemMachinePart = []
            ItemMachinePart = this.state.ItemMachinePartNum.filter((item, index) => item.ItemId == val.Itemid)
            // let EmployName = this.state.OrderEmpyId 
            /*[01/04/21, PC_01,1893], Priyanka D*/
            let EmployName = "";
            if (this.state.OrderEmpyId != undefined) {
                EmployName = this.state.OrderEmpyId.value
            }
            if (val.EmpChgCode != null) {
                EmployName = val.EmpChgCode
            }
            //let EmployName = {}; 
            //let filteremp = {};
            //if (val.EmpChgCode != null && val.EmpChgCode != "" && val.EmpChgCode != undefined) {
            //    filteremp=this.state.Employeelist.filter((i, index) => i.value == val.EmpChgCode)
            //    EmployName = filteremp
            //    //val.EmpChgCode = "";
            //}
            //else {
            //    //filteremp = this.state.Employeelist.filter((i, index) => i.value == this.state.PreferedEmployee)
            //    EmployName= this.state.PreferedEmployee
            //}
            //**NEW***ADDED(1/21/2021)*****
            //if (EmployName != null && EmployName != undefined && EmployName != "") {
            //    console.log("empname", EmployName)
            //   // EmployName = EmployName.toUpperCase()
            //}
            //*****END***********
            const style = {
                image: {
                    position: 'sticky',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                },
            }
            //let FavItem = this.state.FavMenuSub.filter((item, index) => item.CUSTOMERITEMID == val.Itemid || (item.CLIENT_MFG_PART == val.Manufacturerpartnumber && item.MANUFACTURER == val.Manufacturer)).length > 0 ? true : false;
            let FavItem = false
            let RecSuppStr = "";
            let ItemDescValid = "";
            let supplierstr = "";
            let valitemdesc = val.ItemDescription;
            //WW-381 Description With Recommended Supplier and Supplier has to be Removed-Deepthi
            if (val.Itemid.toUpperCase().includes("NONCAT")) {
                linkable = false
                if (val.PaintColor != undefined & val.PaintColor != null && val.PaintColor != "" && val.PaintColor != " ") {
                    if (!val.PaintColor.toUpperCase().includes("PUNCHOUT")) {
                        RecSuppStr = val.LineNo;
                    } else {
                        supplierstr = val.SUPPLIERNAME.toUpperCase();
                    }
                } else {
                    RecSuppStr = val.LineNo;
                }
            }
            else {
                supplierstr = val.SUPPLIERNAME.toUpperCase();
            }
            if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                let recind = val.ItemDescription.indexOf(":");
                RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                let lastlen = val.ItemDescription.length;
                let removedreco = val.ItemDescription.slice(0, ind);
                valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;
                ItemDescValid = removedreco;
            }
            else if (val.ItemDescription.toUpperCase().includes("SUPPLIER:")) {
                let ind = val.ItemDescription.toUpperCase().indexOf("SUPPLIER");
                let supind = val.ItemDescription.indexOf(":");
                supplierstr = val.ItemDescription.substring(supind + 1, val.ItemDescription.length);
                let lastlen = val.ItemDescription.length;
                let removedreco = val.ItemDescription.slice(0, ind);
                valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                ItemDescValid = removedreco;
            }

            this.state.FavMenuSub.map((item, index) => {
                let CLIENT_MFG_PART = item.CLIENT_MFG_PART == null || item.CLIENT_MFG_PART == undefined || item.CLIENT_MFG_PART == "" ? " " : item.CLIENT_MFG_PART
                let CUSTOMERITEMID = item.CUSTOMERITEMID == null || item.CUSTOMERITEMID == undefined || item.CUSTOMERITEMID == "" ? " " : item.CUSTOMERITEMID
                let MANUFACTURER = item.MANUFACTURER == null || item.MANUFACTURER == undefined || item.MANUFACTURER == "" ? " " : item.MANUFACTURER
                let Manufacturer1 = val.Manufacturer == null || val.Manufacturer == undefined || val.Manufacturer == "" ? " " : val.Manufacturer
                let ItemidFav = val.Itemid == null || val.Itemid == undefined || val.Itemid == "" ? " " : val.Itemid
                let Manufacturerpartnumber = val.Manufacturerpartnumber == null || val.Manufacturerpartnumber == undefined || val.Manufacturerpartnumber == "" ? " " : val.Manufacturerpartnumber
                let price = item.PRICE == null || item.PRICE == undefined || item.PRICE == "" || item.PRICE == " " ? " " : item.PRICE
                let des = item.DESCR == null || item.DESCR == undefined || item.DESCR == "" || item.DESCR == " " || item.DESCR == "-" ? "-" : item.DESCR.toUpperCase()
                let UnitPrice = 0.00
                let indexes = des.indexOf("RECOMMENDED SUPPLIER");
                let last = des.length;
                valitemdesc = val.ItemDescription;
                if (valitemdesc != null && valitemdesc != undefined) {
                    valitemdesc = valitemdesc.includes("''") ? valitemdesc.replaceAll("''", "'") : valitemdesc
                }
                Manufacturer1 = Manufacturer1.replace("''", "'");
                let removedrecommend = des.slice(0, indexes);
                if (des.includes("RECOMMENDED SUPPLIER")) {
                    des = removedrecommend;
                }

                if (val.Itemid.toUpperCase().includes("NONCAT")) {
                    if (val.PaintColor != undefined & val.PaintColor != null && val.PaintColor != "" && val.PaintColor != " ") {
                        if (!val.PaintColor.toUpperCase().includes("PUNCHOUT")) {
                            RecSuppStr = val.LineNo;
                        } else {
                            supplierstr = val.SUPPLIERNAME.toUpperCase();
                        }
                    } else {
                        RecSuppStr = val.LineNo.toUpperCase();
                    }

                }
                else {
                    supplierstr = val.SUPPLIERNAME.toUpperCase();
                }
                if (val.ItemDescription.toUpperCase().includes("-INVITEMICON-")) {
                    valitemdesc = val.ItemDescription.split("-INVITEMICON-")
                    valitemdesc = valitemdesc[0].includes("''") ? valitemdesc[0].replaceAll("''", "'") : valitemdesc[0];// BUG-2628 for the description (9/9/2022)-Aparna; ;
                }
                if (val.ItemDescription.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                    let ind = val.ItemDescription.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                    let recind = val.ItemDescription.indexOf(":");
                    RecSuppStr = val.ItemDescription.substring(recind + 1, val.ItemDescription.length);
                    let lastlen = val.ItemDescription.length;
                    let removedreco = val.ItemDescription.slice(0, ind);
                    valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                    ItemDescValid = removedreco;
                }
                else if (val.ItemDescription.toUpperCase().includes("SUPPLIER:")) {
                    let ind = val.ItemDescription.toUpperCase().indexOf("SUPPLIER");
                    let supind = val.ItemDescription.indexOf(":");
                    supplierstr = val.ItemDescription.substring(supind + 1, val.ItemDescription.length);
                    let lastlen = val.ItemDescription.length;
                    let removedreco = val.ItemDescription.slice(0, ind);
                    valitemdesc = removedreco.includes("''") ? removedreco.replaceAll("''", "'") : removedreco;// BUG-2628 for the description (9/9/2022)-Aparna;;
                    ItemDescValid = removedreco;
                }
                UnitPrice = parseFloat(item.PRICE) ? parseFloat(item.PRICE) : 0
                if (NonCat == "NONCAT") {
                    if (CUSTOMERITEMID.toUpperCase() == ItemidFav.toUpperCase() || (CLIENT_MFG_PART.toUpperCase() == Manufacturerpartnumber.toUpperCase()
                        && MANUFACTURER.toUpperCase() == Manufacturer1.toUpperCase())) {
                        if (NonCat == "NONCAT" && Pricevalue == "Price on Request") {
                            if (des.toUpperCase().trim() == valitemdesc.toUpperCase().trim()) {
                                FavItem = true
                            }
                        }
                        else {
                            FavItem = true
                        }
                    }
                }
                else if (CUSTOMERITEMID.toUpperCase() == ItemidFav.toUpperCase() && (CLIENT_MFG_PART.toUpperCase() == Manufacturerpartnumber.toUpperCase()
                    && MANUFACTURER.includes("''") ? item.MANUFACTURER.replace("''", "'") : item.MANUFACTURER.toUpperCase() == Manufacturer1.toUpperCase() && item.SUPPLIER_ID == val.SupplierID)) {
                    FavItem = true
                }
            })
            //  PC_WW-243_06 -Aparna
            if (val.ItemDescription != null || val.ItemDescription != undefined) {
                if (val.ItemDescription.toUpperCase().includes("-INVITEMICON-")) {
                    valitemdesc = val.ItemDescription.split("-INVITEMICON-");
                    valitemdesc = valitemdesc[0].includes("''") ? valitemdesc[0].replaceAll("''", "'") : valitemdesc[0];// BUG-2628 for the description (9/9/2022)-Aparna
                }

            } //exception handling
            let mfg_kenstan = false
            if (val.Manufacturer != null && val.Manufacturer != undefined) {
                if (val.Manufacturer.includes('KENSTAN')) {
                    mfg_kenstan = true
                }
            }
            if (val.SupplierID == supplier_ID) {
                return (<>
                    <tr>
                        <td>
                            <Image
                                id={`Img${val.Itemid}${val.Manufacturerpartnumber}id`}
                                src={imagePath}
                                width={64}
                                height={64}
                                className="table-product-img"
                                noImageSrc="/Images/noimage_new.png"

                            />
                        </td>
                        <td>
                            {favicondisplay && NonCat != "NONCAT" && val.hasCoreCharge == false && val.ISA_WBS_ELMNT !== 'Equipment' ? <a href="#" style={{ cursor: "Pointer" }} onClick={(e) => this.RedirectToItemDetail(e, val, FavItem)}>{val.Manufacturerpartnumber} </a> : <label>{val.Manufacturerpartnumber}</label>}
                            {val.shipping_specs != undefined && val.shipping_specs != null ? val.shipping_specs.toUpperCase() == "PUO ONLY" ? <span className="bg-indigo">P</span> : null : null}
                            {val.hasBenItemVal == "C" ? <span class="i-circlegridBlue">C</span> : val.hasBenItemVal == "T" ? <span class="i-circlegridYellow">T</span> : val.SupplierID == "W999999999" ? < span class="i-circlegrid">w</span> : null}                        </td>
                        <td>
                            <div className="input-group q-box">
                                {val.hasCoreCharge == false ? <div>
                                    {(val.ItemAttribute != undefined && val.ItemAttribute != "" && val.ItemAttribute != " " && val.ItemAttribute != null) ?
                                        <div class="quantity buttons_added">
                                            {/*[02/01/22, PC_EF_35, Priyanka.D]*/}
                                            {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/}
                                            {/*[12/21/22, PC_WW-552_FE_29], Dhevanesam R*/}
                                            <input type="button" value="-" disabled={val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1 || val.Quantity == 1} class="minus" onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} />
                                            <input type="number" disabled={val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1} step={val.MIN_ORD_QTY} class="minus" min={val.MIN_ORD_QTY} name="quantity" name="Quantityvalue" value={val.Quantity} id={'Quantity' + val.CoreSeq} title="Qty" size="4" pattern="" inputmode="" style={{ "width": "60%", "borderLeft": "0" }} />
                                            <input type="button" disabled={val.ItemAttribute.indexOf('BATTERY') > -1 || val.ItemAttribute.indexOf('CHARGER') > -1 || val.Quantity >= 99999} value="+" class="plus" onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} />  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}                                        </div> :
                                        <div class="quantity buttons_added">
                                            {/*[02/01/22, PC_EF_35, Priyanka.D]*/}
                                            {/*[02/15/22, WW-243-Min-ord-Qty issue, Priyanka.D]*/}
                                            <input type="button" value="-" class="minus" disabled={val.Quantity == 1} onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} />
                                            <input type="number" step={val.MIN_ORD_QTY} class="minus" min={val.MIN_ORD_QTY} name="quantity" name="Quantityvalue" value={val.Quantity} id={'Quantity' + val.CoreSeq} title="Qty" size="4" pattern="" inputmode="" style={{ "width": "60%", "borderLeft": "0" }} />
                                            <input type="button" value="+" class="plus" disabled={val.Quantity >= 99999} onClick={(e) => { this.QuantityOnchange(val.CoreSeq, val.Itemid, e); this.LinelevelEmyEdit(val.Itemid, val.CoreSeq, "Quantity", "", e) }} style={{ "backgroundColor": "white" }} />  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}                                        </div>}
                                    {/*<input type="text" value={val.Quantity} id={'Quantity' + val.UniqNum} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.QuantityOnchange(val.UniqNum, val.Itemid, e)} onBlur={(e) => this.LinelevelEmyEdit(val.Itemid, val.UniqNum, "Quantity", "", e)} />*/}
                                </div> : null}

                            </div>
                        </td>
                    </tr>
                </>)
            }
        })
    }
    //WAL-1034_PC_39 -Aparna
    AnykeyPress(e) {
        if (e.keyCode == 13) {
            this.WOText.current.blur();
            this.WorkOrder_Validation(true);
        }
    };
    handleSuccess = (position) => {
        // Location is enabled
        const { latitude, longitude } = position.coords;
        CurrentLatitude = latitude;
        CurrentLongitude = longitude;
        userDeniedLocation = false
    };

    handleError = (error) => {
        // Location is not enabled
        userDeniedLocation = true
        CurrentLatitude = null;
        CurrentLongitude = null;
    };
    showStepsForLocation = (e) => {
        e.preventDefault()
        $('#splitDelivery_Popup').modal('hide')
        $('#locationaccess').modal('show');
        this.setState({ isClosedFrom: e.target.id })
    }
    handleUserZipcode = (e) => {
        e.preventDefault()
        this.setState({ userZipCode: true })
        $('#ZipCode').modal('show');
    }
    zipcodeValidation = () => {
        if (this.state.userZipCode) {
            const zip = $('#ZipCode_no').val();
            let Address = {
                regionCode: "US",
                addressLines: zip
            }
            let ZipcodeValidationBO = {
                address: Address
            }

            ShoppingCartAction.ZipcodeValidation(ZipcodeValidationBO)
            // this.handleZipCodeLookup()
        } else {
            this.ZipCodeClick()
        }
    }
    //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
    Zipcode_Validtn_Response = () => {


        let validAddress = JSON.parse(ShoppingCartStore.ZipcodeValidation);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (validAddress != null && validAddress != "" && validAddress != undefined) {
            validAddress = JSON.parse(validAddress)
            let ValidZipcode = false

            let geocode = validAddress.result.geocode
            let location = geocode.location
            let zipcodeValidation = validAddress.result.address.addressComponents[0].confirmationLevel
            if (zipcodeValidation.toUpperCase() == "CONFIRMED") {
                ValidZipcode = true
            }
            else {
                ValidZipcode = false
            }


            if (this.state.Choose_Delivery_Btn_Click && ValidZipcode) {
                this.ZipBasedPickup(validAddress)
            }
            else if (ValidZipcode) {
                this.handleZipCodeLookup(location)
            }
            else {
                if (this.state.Choose_Delivery_Btn_Click) {

                    let ZipCodeError = "Please enter a valid zip code"
                    this.setState({ userZipcode_Zipcode_Error: ZipCodeError, inventry_zipcode_Error: "", splitDelivery_ZipCode: "", splitdelivery_Zipcode_Error: ZipCodeError })
                }
                else {

                    $('#ZipCodeErrorId').text('Please enter a valid zip code')
                }
            }

        }
        else {
            if (this.state.Choose_Delivery_Btn_Click) {
                let ZipCodeError = "Please enter a valid zip code"
                this.setState({ userZipcode_Zipcode_Error: ZipCodeError, inventry_zipcode_Error: "", splitDelivery_ZipCode: "", splitdelivery_Zipcode_Error: ZipCodeError })
            }
            else {
                $('#ZipCodeErrorId').text('Please enter a valid zip code')
            }
        }
    }



    modifyUserZipcode = (e) => {
        e.preventDefault()
        $('#ZipCode_no').val(this.state.ZipCode_no)
        $('#ZipCode').modal('show');
    }
    //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
    handleZipCodeLookup = (location) => {

        const zip = $('#ZipCode_no').val();
        let selectedPickup = ""
        //    const location = zipcodes.lookup(zip);
        if (location) {
            CurrentLatitude = location.latitude;
            CurrentLongitude = location.longitude;
            document.getElementById("ZipCodeErrorId").innerText = ""
            // this.Bindpickupstore()
            const CurrentLocation = { lat: CurrentLatitude, long: CurrentLongitude };
            let pickDD = []
            let goLocalObject = [];
            let PickupStore = this.state.PickupStore
            //WW-786 INVENTORY 200 Miles Pavithra R
            if (this.state.PickupVendorID == "W999999999") {
                PickupStore.sort((a, b) =>
                    (DistanceCalculator.calculate(CurrentLocation, { lat: a.LATITUDE, long: a.LONGITUDE }) * 0.00062137) > (DistanceCalculator.calculate(CurrentLocation, { lat: b.LATITUDE, long: b.LONGITUDE }) * 0.00062137) ? 1 : -1).map((iresult, index) => {
                        if (iresult != null && iresult != undefined) {

                            let arr1 = ""
                            if (iresult.LATITUDE != null && iresult.LATITUDE != undefined && iresult.LONGITUDE != null && iresult.LONGITUDE != undefined && CurrentLatitude != null && CurrentLongitude != null) {
                                let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.LATITUDE, long: iresult.LONGITUDE })
                                let dis = (dis1 * 0.00062137).toFixed(2)
                                if (dis <= 200) {

                                    arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + dis + " " + "miles"

                                    let val = iresult.VNDR_LOC
                                    let localArray = {
                                        value: val,
                                        label: arr1,
                                        color: "Beige"
                                    }
                                    if (arr1.toUpperCase().startsWith("GO LOCAL")) {
                                        goLocalObject.push(localArray)
                                    } else {
                                        pickDD.push(localArray);
                                    }
                                }

                            }

                        }

                    });
                if (pickDD != [] && pickDD != "" && pickDD != undefined && pickDD != null) {
                    pickDD = pickDD.filter((ele, ind) => ind === pickDD.findIndex(elem => elem.label === ele.label))
                }

                if (goLocalObject != undefined && goLocalObject != null) {
                    pickDD = [...goLocalObject, ...pickDD]

                }
                if (pickDD.length == 0) {
                    $('#ZipCode').modal('hide');
                    document.getElementById('StatusMsg1').innerText = "No Pick-up location available within 200 miles for your location"
                    document.getElementById('StatusMsg').innerText = "No Pick-up location available within 200 miles for your location"
                    //swal({
                    //    allowOutsideClick: false,
                    //    closeOnClickOutside: false,
                    //    text: "No Pick-Up location available within 200 miles."
                    //});

                    this.setState({
                        Pick: pickDD, PickupStoreSelected: "", ZipCode_no: zip
                    });
                    return

                }
                else {
                    document.getElementById('StatusMsg1').innerText = ""
                }
                if (this.state.PickupStoreSelected != undefined && this.state.PickupStoreSelected != null && this.state.PickupStoreSelected != "") {

                    selectedPickup = pickDD.filter((item, index) => item.value == this.state.PickupStoreSelected.value);

                    if (selectedPickup != undefined && selectedPickup != null && selectedPickup != "") {





                        this.setState({
                            PickupStoreSelected: selectedPickup, Pick: pickDD, ZipCode_no: zip
                        });

                    }
                    else {

                        // document.getElementById('StatusMsg1').innerText = "Pick-up location is not available within 200 miles for your selected location"
                        this.setState({
                            PickupStoreSelected: "", Pick: pickDD, ZipCode_no: zip
                        });
                    }


                }
                else {
                    //document.getElementById('StatusMsg1').innerText = "Pick-up location is not available within 200 miles for your selected location"
                    this.setState({
                        PickupStoreSelected: "", Pick: pickDD, ZipCode_no: zip
                    });

                }

                $('#ZipCode').modal('hide');
            }

            else {
                PickupStore.sort((a, b) =>
                    (DistanceCalculator.calculate(CurrentLocation, { lat: a.LATITUDE, long: a.LONGITUDE }) * 0.00062137) > (DistanceCalculator.calculate(CurrentLocation, { lat: b.LATITUDE, long: b.LONGITUDE }) * 0.00062137) ? 1 : -1).map((iresult, index) => {
                        if (iresult != null && iresult != undefined) {
                            let arr1 = ""
                            if ((iresult.LATITUDE == null || iresult.LATITUDE == undefined) && (iresult.LONGITUDE == null || iresult.LONGITUDE == undefined) || (CurrentLatitude == null && CurrentLongitude == null)) {
                                arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + " " + "N/A"

                            }
                            else {
                                let dis1 = DistanceCalculator.calculate(CurrentLocation, { lat: iresult.LATITUDE, long: iresult.LONGITUDE })
                                let dis = (dis1 * 0.00062137).toFixed(2)
                                arr1 = iresult.ADDRESS1 + "," + iresult.STATE + "~" + dis + " " + "miles"
                            }
                            let val = iresult.VNDR_LOC
                            let localArray = {
                                value: val,
                                label: arr1,
                                color: "Beige"
                            }
                            if (arr1.toUpperCase().startsWith("GO LOCAL")) {
                                goLocalObject.push(localArray)
                            } else {
                                pickDD.push(localArray);
                            }
                        }
                    });
                if (goLocalObject != undefined && goLocalObject != null) {
                    pickDD = [...goLocalObject, ...pickDD]
                    pickDD = pickDD.filter((ele, ind) => ind === pickDD.findIndex(elem => elem.label === ele.label))
                }


                if (this.state.PickupStoreSelected != undefined && this.state.PickupStoreSelected != null && this.state.PickupStoreSelected != "" && this.state.PickupStoreSelected != " ") {

                    selectedPickup = pickDD.filter((item, index) => item.value == this.state.PickupStoreSelected.value);



                }
                if (pickDD != [] && pickDD != "" && pickDD != undefined && pickDD != null) {
                    pickDD = pickDD.filter((ele, ind) => ind === pickDD.findIndex(elem => elem.label === ele.label))
                }
                //let selectedPickup = pickDD.filter((item, index) => item.value == this.state.PickupStoreSelected.value);

                this.setState({
                    PickupStoreSelected: selectedPickup[0], Pick: pickDD, PickupStore, ZipCode_no: zip
                });
                $('#ZipCode').modal('hide');

            }
        }
        else {
            $('#ZipCodeErrorId').text('Please enter a valid zip code');
        }
    };
    bindCat = () => {
        let locCat = []
        let locCatSGG = []
        let result = []
        let FavYourCatgPopUp = this.state.FavYourCatgPopUp
        if (FavYourCatgPopUp != undefined && FavYourCatgPopUp != "" && FavYourCatgPopUp != null) {
            FavYourCatgPopUp = this.state.FavYourCatgPopUp.toUpperCase()
        }
        let catsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
        console.log("Fav_Item_SubCat", catsuggestion)
        if (catsuggestion != null && catsuggestion != "" && catsuggestion != undefined) {
            catsuggestion.forEach((sugg, index) => {
                //WW-516_PC_04  (9/30/2022)-Aparna
                if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                    locCat.push({ label: sugg.ISA_FAVS_CATEGORY.toUpperCase(), value: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                }

            });
        }
        if (locCat.length > 0) {
            locCatSGG = locCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.label != null && t.label != " ")) === i)
            locCatSGG = locCatSGG.sort((a, b) =>
                a.value > b.value ? 1 : -1,
            );
        }
        if (locCatSGG != undefined && locCatSGG != null) {
            if (locCatSGG.length != 0) {
                result = locCatSGG.filter(name => name.label.toUpperCase().includes(FavYourCatgPopUp))

            }
        }

        return (
            <Autocomplete
                getItemValue={this.getItemValue}
                items={result}
                renderItem={this.renderItem}
                value={this.state.FavYourCatgPopUp}
                onChange={e => this.onChangeItem(e, "Cat")}
                onSelect={e => this.onSelectItem(e, "Cat")}
                inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                maxLength="40"
            />);
    }

    getCategory = () => {
        let result = [];
        let locSubCat = [];
        let locSubCatSGG = []
        let locCat = []
        let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
        console.log("Fav_Item_SubCat", subcatsuggestion)
        if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
            subcatsuggestion.forEach((sugg, index) => {
                //WW-516_PC_04  (9/30/2022)-Aparna
                if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                    locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), category: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                }

            });
        }
        if (locSubCat.length > 0) {
            locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.category === v.category && t.label != null && t.label != " ")) === i)
            locSubCatSGG = locSubCatSGG.sort((a, b) =>
                a.value > b.value ? 1 : -1,
            );
        }
        return locSubCatSGG;

    }
    handleZipcode = (e, supplierID, Index) => {
        let SupplierList = this.state.supplierList
        let errormsg = ""
        let ZipCodeError = "Please enter a valid zip code"
        if (e != undefined && e.target.value != null) {
            if (e.target.value.trim() != "") {
                if (e.target.value.length == 5) {
                    this.setState({ inventry_zipcode_Error: "", userZipCode_Text: e.target.value })
                    let Address = {
                        regionCode: "US",
                        addressLines: e.target.value
                    }
                    let ZipcodeValidationBO = {
                        address: Address
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ShoppingCartAction.ZipcodeValidation(ZipcodeValidationBO)
                    //this.ZipBasedPickup(zipcode);
                    // this.ZipBasedPickup(e.target.value)


                    //let index = this.state.supplierList.findIndex(x => x.supplier_ID == "W000000036")
                    //if (this.state.splitDelivery_ZipCode != e.target.value && this.state.splitDelivery_ZipCode != null && this.state.splitDelivery_ZipCode != undefined && this.state.splitDelivery_ZipCode != null && e.target.value.length > 4 && index > -1) {
                    //    errormsg = "Grainger stores are updated based on the entered zipcode"
                    //}
                }

                else if (supplierID == "W999999999") {
                    SupplierList.map((val, index) => {
                        if (val.supplier_ID == "W999999999") {

                            this.setState({ inventry_zipcode_Error: ZipCodeError, userZipcode_Zipcode_Error: "" })
                            CurrentLatitude = null;
                            CurrentLongitude = null;
                            SupplierList[index].pickupStore = []
                            SupplierList[index].pickupLocation = ""
                        }



                    })
                }

                else if (supplierID != "W000000036" && supplierID != "W999999999") {

                    CurrentLatitude = null;
                    CurrentLongitude = null;
                    SupplierList.map((val, index) => {
                        SupplierList[index].pickupStore = this.getPickupStore(this.state.pickupstore_tbl, val.supplier_ID)
                        if (val.pickupLocation != undefined && val.pickupLocation != null) {
                            if (SupplierList[index].pickupStore.length == 0) {
                                SupplierList[index].pickupLocation = ""

                            }
                            let selectedPickup = SupplierList[index].pickupStore.filter((item, index) => item.value == val.pickupLocation.value);
                            SupplierList[index].pickupLocation = selectedPickup[0]
                        }

                        else {
                            SupplierList[index].pickupLocation = ""
                        }


                    })
                }
            } else if (supplierID != "W000000036") {
                CurrentLatitude = null;
                CurrentLongitude = null;
                SupplierList.map((val, index) => {
                    SupplierList[index].pickupStore = this.getPickupStore(this.state.pickupstore_tbl, val.supplier_ID)
                })
            }
        }
        this.setState({ userZipCode_Text: e.target.value, supplierList: SupplierList })
    }
    //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
    ZipBasedPickup = (validAddress) => {
        let ZipCodeError = ""
        let SupplierList = this.state.supplierList
        //let zipcode = $('#suplidelivery_zipcode').val()
        let geocode = validAddress.result.geocode
        let location = geocode.location
        let zipcode = validAddress.result.address.addressComponents[0].componentName.text
        //const location = zipcodes.lookup(zipcode);
        if (location) {
            CurrentLatitude = location.latitude;
            CurrentLongitude = location.longitude;
            SupplierList.map((val, index) => {
                if (val.supplier_ID != "W000000036") {
                    SupplierList[index].pickupStore = this.getPickupStore(this.state.pickupstore_tbl, val.supplier_ID)
                    if (val.pickupLocation != undefined & val.pickupLocation != null && val.pickupLocation != "") {

                        let selectedPickup = SupplierList[index].pickupStore.filter((item, index) => item.value == val.pickupLocation.value);
                        SupplierList[index].pickupLocation = selectedPickup[0]
                    }
                } else {
                    SupplierList[index].pickupLocation = ""
                }
            })
            this.setState({ supplierList: SupplierList, userZipcode_Zipcode_Error: "", inventry_zipcode_Error: "", userZipCode_Text: zipcode })
        } else {
            ZipCodeError = "Please enter a valid zip code"
            this.setState({ userZipcode_Zipcode_Error: ZipCodeError, inventry_zipcode_Error: "", })
        }
    }
    split_zipcode = (e) => {
        e.preventDefault()
        this.setState({ splitDelivery_userZipCode: true })
    }
    /**
     * WW-920_PC_04 -Aparna
     * to bind form item in popup
     * */
    bindFormItemID = (formtype) => {
        let enersysconunt = 0
        return this.state.CartItems.map((val, index) => {
            ;

            let isEnersys = this.state.CartItems[index].FormAttribute != null && this.state.CartItems[index].FormAttribute != undefined ? this.state.CartItems[index].FormAttribute.indexOf('BATTERY') > -1 || this.state.CartItems[index].FormAttribute.indexOf('CHARGER') > -1 ? true : false : false
            if (isEnersys) {
                enersysconunt = enersysconunt + 1
            }
            if (val.FormAttribute != " " && val.FormAttribute != null && parseInt(val.RTI_QTY ? val.RTI_QTY : 0, 10) < parseInt(val.Quantity ? val.Quantity : 0, 10)) {
                if (isEnersys && formtype == "1") {
                    return (<>{enersysconunt == 1 ? <p className="mb-1 font-13 font-regular color-light-black">Enersys Form Item(s) in your cart awaites your attention. Would you lick to proceed?</p> : null}


                        <ul className="pl-3"> <li className="font-medium info-label"> {val.SupplierPartNumber}- {val.FormAttribute}</li></ul></>)
                }
                else if (formtype == "2" && isEnersys == false) {
                    return (<ul className="pl-3"><li className="font-medium info-label">{val.SupplierPartNumber}- {val.FormAttribute}</li></ul>)
                }

            }
        })
    }
    render() {
        const { t } = this.props;

        return (
            <div>
                <div className="container-fluid content-section">
                    <div className="row">
                        {/* Shopping Cart starts */}
                        <div className="container-fluid content-margin">
                            <div className="row">
                                <div className="col-md-12 page-heading mb-3">
                                    <h5 className="page-title"><Trans>Shopping Cart</Trans></h5>
                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-a" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                        <label htmlFor="checkbox-a">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                                <div className={this.state.IsInteractiveNonCat == true ? "col-md-12 mb-3" : "col-md-12 page-heading mb-3"}>
                                    <span className="item-count d-inline-block ml-3"># Items: <span className="item-count-bold" id="CartCount">{this.state.CartCOunt}</span></span>
                                    <div className="float-right my-2 row px-2">
                                        {/*this.state.Session_ZEUSNOCATALOGSITE != "Y" ? <div className="input-group charge-code-group float-left mr-2 mb-2" id="QuickItemEntry">
                                            <input type="text" id="QuickItem" className="form-control charge-code-control charge-code-control-search" placeholder="Search for the product" maxLength="30" defaultValue={this.state.txtItemID} name="txtItemID" />
                                            <div className="input-group-append" data-toggle="modal" data-target="#quick-item-popup">
                                                <span className="input-group-text" onClick={(e) => this.quickItemClick(e, "1", false)} data-backdrop="static" data-keyboard="false">
                                                    <span className="shopping-search-icon" />
                                                </span>
                                            </div>
                                        </div> : null*/}
                                        {this.state.FavMenu.length > 0 ? <div className="dropdown fav-order-dropdown fav-dropdown float-left mr-2 mb-2" id="FavMenu">
                                            <button type="button" className="btn btn-labeled btn-primary custom-btn-primary primary-btn float-left py-0 dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <span className="btn-label"><span className="fav-icon" /></span><Trans>Favorites</Trans></button>
                                            {/*<div id="FavItemMenu"></div>*/}
                                            <ul className="dropdown-menu item-box" id="Quickitemmenu">
                                                {this.BuildFavMenu()}
                                                {this.state.FavMenu.length > 5 ? <li className="dropdown-submenu text-center">
                                                    <button className="btn btn-primary custom-btn-showall primary-btn col-md-10 mb-2 mt-2" onClick={(event) => this.headerRedirect(event, "/favorites")}><Trans>Show</Trans><span> </span><Trans>All</Trans></button>
                                                </li> : null}
                                            </ul>
                                        </div> : null}
                                        {this.state.Session_ZEUSNOCATALOGSITE != "Y" ? <a className="btn btn-labeled btn-primary custom-btn-primary ShoppingCart-Top-Button primary-btn float-left mr-2 mb-2" id="EditFavLink" onClick={() => this.BacktoSearh(1)}>
                                            <span className="btn-label"><span className="edit-favs-icon" /></span><Trans>Edit</Trans><Trans>fav</Trans></a> : null}
                                        {this.state.Session_ZEUSNOCATALOGSITE != "Y" ? <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn float-left py-0 mr-2 mb-2 btn-continue" id="ContinueShop1" onClick={() => this.BacktoSearh(3)}>
                                            <span className="btn-label"><span className="shopping-bag" /></span><Trans>Continue Shopping</Trans></button> : null}
                                        {this.state.SearchKey != "" && this.state.SearchKey != null ? <a className="btn btn-primary ShoppingCart-Top-Button custom-btn-primary primary-btn float-left" id="BackSearchpage" onClick={() => this.BacktoSearh(2)}>Back to search results</a> : null}
                                    </div>
                                </div>
                                {this.state.IsInteractiveNonCat == true ? <div className="col-md-12 pb-3 pt-2 page-heading mb-3">
                                    <img class="mr-2 " src="Images/info-icon.png" />
                                    <label class="confirm-content font-14 d-inline">Request to source items have been added to the Walmart non-catalog request.</label>
                                </div> : null}
                                <div className="col-lg-12 mb-4">
                                    <div className="accordion-toggle" onClick={() => this.onAccordianClick(this.state.ShowOrderDetails)}>
                                        <span className="accordion-arrow float-left" id="order-row2" />
                                        <h5 className="fav-item-title float-left p-0 ml-3"><Trans>order_key</Trans><Trans>Details</Trans></h5>
                                    </div>
                                    <div className="col-md-12 p-0 float-left">
                                        <div className="row">


                                            <td colSpan={13} >
                                                <div className="accordian-body" id="order-row1" style={{}}>
                                                    <div className="col-md-12 ">
                                                        <div className="row">

                                                            <div className="col-md-8 col-sm-8 col-ld-8">
                                                                <div className="row">

                                                                    {this.state.Session_MANORDNO != " " && this.state.Session_MANORDNO != null ?
                                                                        <div className="col-md-6 mb-3 CustomerOrderOL" id="CustomerOrderNo">
                                                                            <label className="col-lg-4 col-md-12 catalog-label form-label">Customer Order <span>#</span></label>
                                                                            <div className="col-lg-8 col-md-12 col-12">
                                                                                <input type="text" className="form-control" id="OrderNum" placeholder="Enter value" maxLength={this.state.WordOrderNoLength} defaultValue={'NEXT'} />
                                                                            </div>
                                                                        </div> : null}

                                                                    {/**col-md-6 mb-3 float-left p-0 custom-iphone-padding */}
                                                                    <div className="col-md-12 mb-lg-3">
                                                                        <div className="row">
                                                                            <label className="col-lg-2 col-md-12 catalog-label form-label"> {CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N' ? <span class="color-validation">* </span>: <span>    </span>}<Trans>workorder_key</Trans> <span> #</span></label>
                                                                            <div className="col-lg-4 input-group charge-code-group ">{/*col-lg-6 col-md-12 float-left p-0 col-12**/}
                                                                                <input type="text" className="form-control charge-code-control" placeholder="Enter WO#" id="OLWorkOrderTB" maxLength="9" pattern="[0-9]*" onKeyDown={this.AnykeyPress} ref={this.WOText} value={this.state.WONUM} onChange={e => this.WONumChange(e)} defaultValue={''} />
                                                                                {/*04/22/22,PC_WW-365_03], Priyanka D */}
                                                                                {this.state.WONUM != undefined && this.state.WONUM != null && this.state.WONUM != "" && this.state.WONUM != " " ?
                                                                                    < span class="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.ClearWO()} > </span> : null
                                                                                }
                                                                                <div className="input-group-append" >
                                                                                    <span className="input-group-text" onClick={(e) => this.WorkOrder_Validation(true)} >
                                                                                        <span className="shopping-search-icon" />
                                                                                    </span>
                                                                                </div>
                                                                                <span className="errorspan12 text-left my-2" id="StatusMsgbilltostore"></span>

                                                                                {/* {this.state.ERRWO ? <span className=" W-100 errorspan1" style={{ fontSize: '10px' }}>Enter Std Cost</span> : null}*/}
                                                                            </div>
                                                                            {this.state.isValidWO != false && this.state.WO_Parts.length != 0 ? <div className="col-lg-4">
                                                                                <button class="btn btn-labeled btn-primary custom-btn-primary ShoppingCart-Top-Button primary-btn" onClick={e => this.WO_Parts_ButtonClick(e)} >
                                                                                    <img src="Images/history_icon.svg" alt="History-icon" /> WO# History</button>
                                                                            </div> : null}
                                                                        </div>


                                                                    </div>

                                                                    {/*/<div className="col-md-6 mb-3 float-left p-0 custom-iphone-padding">
                                                        //    <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label" id="OLEmplyIdLabel">{this.state.OLEmplyIdLabel}</label>
                                                        //    <div className="col-lg-6 col-md-12 float-left p-0 col-12" >
                                                        //        <select className="form-control" id="OLEmplyDD" value={this.state.OrderEmpyId} onChange={() => this.BindEmpCCToItemOL("EmplyCCOL", "")}>
                                                        //            <option value=" ">Select</option>
                                                        //            {this.BindEmpCCToItem()}
                                                        //        </select>
                                                        //    </div>
                                                        //</div>*/}


                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="row">
                                                                            <label className="col-lg-4 col-md-12 catalog-label form-label" id="OLEmplyIdLabel"><span class="color-validation">* </span><Trans>{this.state.OLEmplyIdLabel}</Trans></label>
                                                                            <span className="col-lg-8 col-md-12 col-12" style={{ "fontSize": "12px", }}><Select
                                                                                id="OLEmplyDD"
                                                                                name="EmpDD"
                                                                                onChange={(e) => this.BindEmpCCToItemOL("EmplyCCOL", "", e)}
                                                                                value={this.state.OrderEmpyId}
                                                                                options={this.state.EmplyeeNameDD}
                                                                            /></span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="row">
                                                                            <label className="col-lg-4 col-md-12 catalog-label form-label">{t("Asset Tag ID")}</label>
                                                                            <div className="col-lg-8 col-md-12 col-12">
                                                                                {/*<select className="form-control">*/}
                                                                                {this.state.MachineTable.length > 0 ? <select className="form-control" id="OLMachDD">
                                                                                    <option value="0">Select</option>
                                                                                    {this.BuildMachineDD()}
                                                                                </select> : <input type="text" className="form-control" id="OLMachDD" placeholder="Enter Asset Tag ID (Optional)" maxLength="20" defaultValue={''} />}
                                                                                {/* <span className="float-left form-label Machinnum-margin" >If not a tagged asset, leave the field blank </span>*/}
                                                                                {/*<option>Select</option>
                                                                <option>Option</option>
                                                            </select>*/}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/*******/}



                                                                    {(this.state.Session_ZEUSNOCATALOGSITE != "Y" && this.state.OnlyCatalogItem == false) ?
                                                                        <div className="col-md-6 mb-3 OLDatepicker" id="OLDueDateDiv">
                                                                            <div className="row">
                                                                                <label className="col-lg-4 col-md-12  catalog-label form-label"><span className="color-validation">* </span> {t("Delivery Date")}</label>
                                                                                <div className="col-lg-8 col-md-12  col-12">
                                                                                    {/*<input type="text" className="form-control datepicker" placeholder="MM/DD/YYYY" />
                                                        <span className="calendar-icon" />*/}
                                                                                    {this.ShowDatePicker()}
                                                                                    <span className="calendar-icon filter-calendar-icon-shoppingcart " onClick={() => $(`#OLDueDate`).focus()} />
                                                                                </div>
                                                                            </div>
                                                                        </div> : null}

                                                                    {this.state.showshipto ? <div className="col-md-6 mb-3">
                                                                        <div className="row">
                                                                            <label className="col-lg-4 col-md-12 catalog-label form-label"><span class="color-validation">* </span><Trans>{this.state.OLShipToIdLabel}</Trans></label>
                                                                            <div className="col-lg-8 col-md-12 col-12">
                                                                                {this.state.ShipToDDValue.length > 1 ?
                                                                                    <Select
                                                                                        id="OLShipTo"
                                                                                        className={CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N' ? (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' && !this.state.isValidWO ? "DropDown-Font-Size disabled" : "DropDown-Font-Size") : "DropDown-Font-Size"}
                                                                                        value={this.state.defaultShipto}
                                                                                        onChange={(e) => this.handleChangeShipto(e)}
                                                                                        options={this.state.ShipToDDValue}
                                                                                        isDisabled={this.state.EnableShipTo}
                                                                                    />
                                                                                    //    <select className="form-control" id="OLShipTo" defaultValue={this.state.defaultShipto}>
                                                                                    //    <option value="0">--Select Ship To--</option>
                                                                                    //    {this.BuildShipToDD()}
                                                                                    //</select> 
                                                                                    : this.BuildShipToDD()}
                                                                            </div>
                                                                        </div>
                                                                        {!this.state.isCountryMatch && this.state.isValidWO ? (
                                                                            <div className="row">
                                                                                <div className="col-lg-4 col-md-12"></div>
                                                                                <div className="col-lg-8 col-md-12 col-12 mt-2">
                                                                                    <div style={{ display: "flex", alignItems: "start" }}>
                                                                                        <img className="mr-2 align-top" src="Images/info-icon.png" style={{ display: "inline" }} alt="Info Icon" />
                                                                                        <label className="confirm-content shipment-font" style={{ verticalAlign: "middle" }}>
                                                                                            The default Ship-To's Country Code does not match the Work Order Store Country Code.</label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                        {this.state.Checkedbillto && CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' ? <div className="row">
                                                                            <div className="col-lg-4 ">
                                                                            </div>
                                                                            <div className="col-lg-6 float-left mt-2 bill-to-store-padding custom-checkbox item-custom-control" id="bill-to-store">
                                                                                <input type="checkbox" className="custom-control-input " id="Billtostoreid" name="example4" checked={this.state.isWorkToStoreValid} onClick={() => this.CheckBillToStore()} />
                                                                                <label className={`custom-control-label catalog-label priority-checkbox ${this.state.isValidWO ? '' : 'custombtn-disabled'} `} htmlFor="Billtostoreid"><Trans>Bill-to-Store</Trans></label>
                                                                            </div>
                                                                        </div> : null}
                                                                    </div> : null}




                                                                    {/************/}
                                                                    {/*this.state.showshipto ? <div className="col-md-6 mb-3 float-left p-0 custom-iphone-padding">
                                                            <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label"></label>
                                                            <div className="col-lg-6 col-md-12 float-left p-0 col-12">
                                                                <div className="col-md-12 float-left mt-2 bill-to-store">
                                                                    <input type="checkbox" className="custom-control-input " id="Billtostoreid" name="example4" checked={this.state.isWorkToStoreValid} onClick={() => this.CheckBillToStore()} />
                                                                    <label className="custom-control-label catalog-label priority-checkbox" htmlFor="Billtostoreid">Bill-to-Store</label>
                                                                </div>
                                                            </div>
                                                        </div> : null}
                                                {/*<div className="col-md-6 mb-3 float-left p-0"></div>*/}
                                                                    {this.state.TypeTable.length > 0 ? <div className="col-md-6 mb-3 float-left p-0 custom-iphone-padding">
                                                                        <label className="col-lg-5 col-md-12 float-left p-0 catalog-label form-label">Type</label>
                                                                        <div className="col-lg-6 float-left p-0 col-md-12 col-12">
                                                                            <div className="col-lg-12 col-md-12 float-left p-0 col-12">
                                                                                {/*<select className="form-control">*/}
                                                                                <select className="form-control" id="OLTyeDD">
                                                                                    <option value="OP">Select</option>
                                                                                    {this.BuildTypeDD()}
                                                                                </select>
                                                                                {/*<option>Select</option>
                                                                <option>Option</option>
                                                            </select>*/}
                                                                            </div>
                                                                        </div>
                                                                    </div> : null/*<input type="text" className="form-control" id="OLTyeDD" placeholder="Enter Type" maxLength="20" defaultValue={''} />*/}






                                                                    {/*<div className="col-md-6 mb-3 float-left p-0 custom-iphone-padding">
                                                    <label className="col-lg-5 col-md-12 float-left p-0 catalog-label form-label pr-0">Customer Reference</label>
                                                    <div className="col-lg-6 col-md-12 float-left p-0 col-12">
                                                        <input type="text" className="form-control" id="CustRef" placeholder="Customer Reference" maxLength="30" />
                                                    </div>
                                                </div>*/}
                                                                    {/*******NEW**)wal-158***/}
                                                                    {/*this.state.pickups ? <div className="col-md-12 mb-3 float-left p-0 custom-iphone-padding ">
                                                    <div className="custom-control custom-checkbox my-2 pl-3  float-left pr-0 item-custom-control col-md-12 float-left">
                                                        <input type="checkbox" className="custom-control-input " id="pickupcheck" name="example3" onChange={e=>this.pickupchange(e)}  />
                                                        <label className="custom-control-label catalog-label priority-checkbox " htmlFor="pickupcheck">Pickup</label>
                                                    </div>
                                                </div> : <div className="col-md-12 mb-3 float-left p-0 custom-iphone-padding ">
                                                        <div className="custom-control custom-checkbox my-2 pl-3  float-left pr-0 item-custom-control col-md-12 float-left">
                                                            <input type="checkbox" className="custom-control-input "  id="pickupcheck" name="example3" onChange={e => this.pickupchange(e)} />
                                                            <label className="custom-control-label catalog-label priority-checkbox custombtn-disabled" htmlFor="pickupcheck">Pickup</label>
                                                        </div>
                                                        <span className="float-left form-label Machinnum-margin">Items have to be from the same supplier for pickup to be enabled</span>
                                                    </div>*/}
                                                                    {/******/}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 col-sm-4 col-lg-4 mt-md-5 pt-lg-2 pt-md-5">
                                                                <div className="row">
                                                                    <label className="catalog-label d-block col-md-12"><Trans>Customer Notes</Trans></label>
                                                                    <div className="col-md-12">
                                                                        <textarea className="form-control " maxLength="254" id="CusNotes" rows={4} defaultValue={""} />
                                                                    </div>
                                                                    {this.state.Session_ZEUSNOCATALOGSITE != "Y" ?
                                                                        <div className="col-md-3" id="OLPriority">
                                                                            <div className="custom-control custom-checkbox my-2 pl-3 ml-2 item-custom-control ">
                                                                                <input type="checkbox" className="custom-control-input" id="customCheckOP7" name="example4" />{/*NEW*** (1/25/20201)**CHANGED***(id)** customCheck7--> customCheckOP7***/}
                                                                                <label className="custom-control-label catalog-label priority-checkbox" htmlFor="customCheckOP7"><Trans>Priority</Trans></label>{/*NEW*** (1/25/20201)**CHANGED***(htmlfor)** customCheck7--> customCheckOP7***/}
                                                                            </div>
                                                                        </div> : null}


                                                                    {/*[2/10/22], PC_SC_06, WW-330, Dhevanesam R*/}

                                                                    <div className="ml-2">
                                                                        <div className="col-md-4">
                                                                            <div className="custom-control custom-checkbox my-2 pl-3 item-custom-control">
                                                                                <input type="checkbox" className="custom-control-input " id="pickupcheck" checked={this.state.pickupcheck} name="example3" onChange={e => this.pickupchange(e)} />
                                                                                <label className={`custom-control-label catalog-label priority-checkbox  ${this.state.isAllItem_are_Pickup || (this.state.Bentonville_WO && this.state.isAllItem_are_Inv) ? ((this.state.PickupVendorID != "W000000091" && this.state.PickupVendorID != "") && this.state.isPickup == false) || this.state.lowesitem || this.state.isRefrigerantItemInCart ? ' custombtn-disabled' : '' : ' custombtn-disabled'}`} htmlFor="pickupcheck"><Trans>Pickup</Trans></label>

                                                                                <span className="info-container ml-2">
                                                                                    <img className="ml-2 mb-2" src="Images/info-icon.png" />
                                                                                    <span className="Grid-info-icon text-left sdi-fede-tooltippickup ">Items have to be from the same supplier for pickup to be enabled for order level submition</span>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/*PC-1256-02 removing HAL 11/14/2024 -S.Sanjay*/}
                                                                    {this.state.Haldisplay == "HAL" && this.state.sethalboolenval ?
                                                                        <div>
                                                                            <div className="custom-control custom-checkbox my-2 pl-3 ml-2 item-custom-control">
                                                                                <input type="checkbox" className="custom-control-input " id="fedexhal" name="halloc" onChange={e => this.HoldatlocationOnClick(e)} />
                                                                                <label className="custom-control-label catalog-label priority-checkbox " htmlFor="fedexhal"><Trans>Hold At Location</Trans></label>
                                                                                <span className="info-container ml-2">
                                                                                    <img className="ml-2 mb-2" src="Images/info-icon.png" />
                                                                                    <span className="Grid-info-icon text-left sdi-fede-tooltiphal">All items have to be from the  HAL supplier for HAL to be enabled</span>
                                                                                </span>
                                                                            </div>

                                                                        </div>

                                                                        :

                                                                        null}


                                                                    {this.state.displayFedexDrop ?
                                                                        <div className="col-md-12 custom-iphone-padding" >
                                                                            <div class="row">
                                                                                < p className="col-md-12 col-12 col-sm-12 form-label Machinnum-margin"><Trans>Select FedEx Hold At Location for delivery</Trans></p>
                                                                                <label className="col-lg-3 col-md-12 catalog-label form-label">Hal Location</label>
                                                                                <div className="col-lg-9 col-md-12 col-12">
                                                                                    <Select
                                                                                        id="Hal_DD"
                                                                                        name="HalLocationSelected"
                                                                                        className="w-75 DropDown-Font-Size"
                                                                                        className="DropDown-Font-Size"
                                                                                        width='200px'
                                                                                        value={this.state.HalLocationSelected}
                                                                                        onChange={(e, s) => this.handleHalLocationChange(e, s)}
                                                                                        options={this.state.Halloc}
                                                                                    //options={this.Bindpickupstore()}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : null}
                                                                    {/*A1QA-150_PickupDD_display_PC_02  (3//31/2022) -Aparna**/}
                                                                    {this.state.displayPickDrop && this.state.pickupcheck == true ?

                                                                        <div className="col-md-12 float-left p-0 custom-iphone-padding" >
                                                                            <div class="col-md-12 col-lg-10 mb-3 float-left p-0">
                                                                                < p className=" form-label Machinnum-margin"><Trans>Select Supplier Location for pickup</Trans></p>
                                                                                <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label">Pickup Store</label>
                                                                                <div className="col-lg-8 col-md-12 float-left p-0 col-12">
                                                                                    {/*<select className="form-control">*/}
                                                                                    {/*<select className="form-control" id="pickupstore_DD" name="PickupStoreSelected" value={this.state.PickupStoreSelected} onChange={this.handleStoreChange}>
                                                                            <option value="">Select</option>
                                                                            {this.Bindpickupstore()}
                                                                        </select>
                                                                        {/*<option>Select</option>
                                                                <option>Option</option>
                                                            </select>*/}

                                                                                    <Select
                                                                                        id="pickupstore_DD"
                                                                                        name="PickupStoreSelected"
                                                                                        className={(((CurrentLatitude == null || CurrentLongitude == null) && this.state.PickupVendorID == "W999999999") || (this.state.Pick <= 0)) ? "DropDown-Font-Size disabled" : "DropDown-Font-Size"}
                                                                                        value={this.state.PickupStoreSelected}
                                                                                        onChange={(e) => this.handleStoreChange(e)}
                                                                                        options={this.state.Pick}
                                                                                        styles={colourStyles}
                                                                                    //options={this.Bindpickupstore()}
                                                                                    />
                                                                                </div>
                                                                            </div>



                                                                            {this.state.PickupVendor.toUpperCase() == "W W GRAINGER" && this.state.pickupcheck == true ?
                                                                                <>
                                                                                    <div className="col-md-12 float-left p-0">
                                                                                        <span className="cart-count" style={lal}></span>
                                                                                        <span className="errorspan1" style={txt}>Available</span>
                                                                                    </div>
                                                                                    <div className="col-md-12 float-left p-0">
                                                                                        <span className="cart-count" style={la}></span>
                                                                                        <span className="errorspan1 " style={txt}>Partially available</span>
                                                                                    </div>
                                                                                </> : <><div className="col-md-12 float-left p-0">
                                                                                    <span className="cart-count" style={blk}></span>
                                                                                    <span className="errorspan1 " style={txt}>Contact Branch</span>
                                                                                </div>
                                                                                    {CurrentLatitude == null && CurrentLongitude == null ?
                                                                                        <div className="col-md-12 float-left p-0">
                                                                                            <p className="float-left alpart-label mt-2">  <img src="/Images/caution.svg" className="fav-popover-alert-img mb-2" alt="Fav-Img" />
                                                                                                {this.state.PickupVendorID == "W999999999" ?
                                                                                                    <><a href="#" onClick={(e) => this.showStepsForLocation(e)}>Enable location </a>to view the pickup stores near by  <a href="#" onClick={(e) => this.handleUserZipcode(e)}>Enter Zipcode </a></>
                                                                                                    :
                                                                                                    <> <a href="#" onClick={(e) => this.showStepsForLocation(e)}>Enable location </a> to view miles or <a href="#" onClick={(e) => this.handleUserZipcode(e)}>Enter Zipcode </a> </>}
                                                                                            </p>
                                                                                        </div>
                                                                                        :
                                                                                        (this.state.userZipCode ?
                                                                                            <div className="col-md-12 float-left p-0">
                                                                                                <p className="float-left alpart-label mt-2">  <img src="/Images/caution.svg" className="fav-popover-alert-img mb-2" alt="Fav-Img" />
                                                                                                    <a href="#" onClick={(e) => this.modifyUserZipcode(e)}>Modify the Zipcode </a> </p>
                                                                                            </div> : null
                                                                                        )}

                                                                                </>
                                                                            }
                                                                        </div>
                                                                        : <label className="catalog-label d-block">{this.state.BenPickLbl}</label>}
                                                                    <span className="px-2 errorspan1 mt-3" id="StatusMsg1"></span>



                                                                </div>
                                                            </div>

                                                            {/*//Pickup store change location 5/27/2021*/}
                                                            {this.state.CartItems.length > 0 ?
                                                                <>
                                                                    <div className="col-md-12 text-right my-3">
                                                                        {/*[03/16/22,WAL-721_PC_01,WAL-721], Priyanka D */}
                                                                        {/*[04/06/22WW-370] Reorder popup should come after the Multiple supplier popup Priyanka D */}
                                                                        <button className={`btn btn-primary custom-btn-primary primary-btn float-right mt-2 ${this.state.supplierList.length > 1 && this.state.isRefrigerantItemInCart == true ? "disabled" : ""} `} onClick={(e) => this.submitClick()} data-backdrop="static" data-keyboard="false"  ><Trans>Submit</Trans><span> </span><Trans>order_key</Trans></button>
                                                                        {/*{this.state.isQuoteOrderDisplay ? <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mt-2 " onClick={(e) => this.submitClick("QUOTE")} data-backdrop="static" data-keyboard="false" ><Trans>Submit</Trans><span> </span><Trans>Quote</Trans></button> : null}*/}
                                                                        {this.state.supplierList.length > 1 && this.state.Haldisplay != "HAL" ? <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mt-2 " onClick={(e) => this.ChooseDelivery_Click()} data-backdrop="static" data-keyboard="false"  ><Trans>Edit</Trans><span> </span><Trans>Delivery Option</Trans></button> : null}{/**WW-687_PC_08 (4/20/2023)-Aparna*/}
                                                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right mr-2 mt-2 " data-toggle="modal" data-target="#Cancel-btn" data-backdrop="static" data-keyboard="false"><Trans>Cancel</Trans><span> </span><Trans>order_key</Trans></button>
                                                                    </div>
                                                                    {this.state.supplierList.length > 1 && this.state.isRefrigerantItemInCart == true ?
                                                                        <div className="col-md-12 text-right my-3">
                                                                            {/*WW-1041 - Walmart needs to have Choose Delivery Method read Edit Delivery Method.*/}
                                                                            {/*//WW-1162-02 changing the label name S.Sanjay */}
                                                                            <p className="DropDown-Font-Size ">There are pick-up only items in the cart. Either place by "Edit Delivery Option" or remove other supplier items</p>
                                                                        </div> : null}
                                                                </>
                                                                : null}
                                                            {/*/<div className="col-md-12 my-3 float-left">
                                                    //    <button className="btn btn-primary custom-btn-primary primary-btn float-right" onClick={() => this.SubmitOrder()} data-backdrop="static" data-keyboard="false"  >Submit Order</button>
                                                    //    <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right mr-2" data-toggle="modal" data-target="#Cancel-btn" data-backdrop="static" data-keyboard="false">Cancel Order</button>
                                                    //</div>*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </div>
                                    </div>
                                </div>
                                {this.state.supplierList.length > 0 ? <div className="col-lg-12">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                                            <div className="row px-3">
                                                <div className="w-100 sdi-outerframe-style">
                                                    <div className="col-md-12">
                                                        <div className="row align-items-center">
                                                            <div className="col-lg-6 col-line-cart mb-2">
                                                                {/* popup category */}
                                                                <span className="float-right mb-3 d-none">
                                                                    <a href="#" className="mt-2 mx-2 category-icon-toggle">
                                                                        <img
                                                                            src="images/category-icon.svg"
                                                                            alt="category Icon"
                                                                            className="sdi-category-icon-width"
                                                                        />
                                                                    </a>
                                                                </span>
                                                                {/* popup category */}
                                                                <label className="search-category title-font m-0 mt-1">
                                                                    Supplier Details
                </label>
                                                            </div>
                                                            <div className="col-lg-6 col-line-cart">
                                                                <div className="d-flex justify-content-end">
                                                                    <label className=" m-0 mr-4 mt-1 font-16"># Supplier : {this.state.supplierList.length}</label>
                                                                    {/* WW-1321 Set Default Item View to "Expanded" on page load of cart - Nandhini L */}
                                                                    <button className="btn btn-primary custom-btn-primary primary-btn float-left" onClick={this.expandAll}>{!this.state.isExpand ? <Trans>Expand All</Trans> : <Trans>Collapse All</Trans>}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="table-responsive">
                                                            <table className="table ZEUS_Grid sdi-FOM-grid mobileresponsive-grid">
                                                                <tbody>
                                                                    {this.bindSuppliers()}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    {/* {this.BindCart()}*/}
                                </div> : null}
                                {this.state.showprice != "0" ? <div className="row mx-0 d-none">
                                    <div className="col-md-12">
                                        <div className="float-right shopping-order">
                                            Order Total <span className="price-rate">{this.OrderTotalCal()}</span>
                                        </div>
                                    </div>
                                </div> : null}
                                {this.state.CartItems.length > 0 ?
                                    <div className="col-md-12 my-3 float-left">
                                        <button className={`btn btn-primary custom-btn-primary primary-btn float-right mt-2 ${this.state.supplierList.length > 1 && this.state.isRefrigerantItemInCart == true ? "disabled" : ""}`} onClick={() => this.submitClick()} data-backdrop="static" data-keyboard="false"><Trans>Submit</Trans><span> </span><Trans>Order</Trans></button>
                                        {/*{this.state.isQuoteOrderDisplay ? <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mt-2 " onClick={(e) => this.submitClick("QUOTE")} data-backdrop="static" data-keyboard="false" ><Trans>Submit</Trans><span> </span><Trans>Quote</Trans></button> : null}*/}
                                        {this.state.supplierList.length > 1 && this.state.Haldisplay != "HAL" ? <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mt-2 " onClick={(e) => this.ChooseDelivery_Click()} data-backdrop="static" data-keyboard="false" >Edit Delivery Option</button> : null}
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right mr-2 mt-2 " data-toggle="modal" data-target="#Cancel-btn" data-backdrop="static" data-keyboard="false"><Trans>Cancel</Trans><span> </span><Trans>Order</Trans></button>
                                    </div> : null}
                                <div className="col-md-12 my-3 float-right p-0"> <span className="errorspan1 mr-2" id="StatusMsg"></span></div>
                            </div>
                            {/*[2/28/22], PC_IC_07, WW-316, Dhevanesam R*/}
                            {/*//[09/29/22, WAL-780_PC_IDSC_03, Dhevanesam R]*/}
                            {this.state.ImgResponseVal.length > 0 ?
                                <div>
                                    <div>
                                        <h5 className="catalog-label-title mb-3 mt-3">User also bought</h5>
                                    </div>
                                    <div className="col-md-12 owl-carousel owl-theme owl-loaded owl-drag">
                                        <div className="owl-stage-outer">
                                            <div className={this.state.ImgCssVal}>
                                                {this.BindImageGrid()}
                                            </div>
                                        </div>
                                        {/*<div className="owl-nav"><button type="button" role="presentation" className="owl-prev"><span aria-label="Previous"><img src="Images/Prev-arrow.svg" alt="Previous" /></span></button><button type="button" role="presentation" className="owl-next"><span aria-label="Next"><img src="Images/next-arrow.svg" alt="Next" /></span></button></div>*/}
                                        <div className="owl-dots disabled" /></div>
                                    {/*end of image card*/}
                                </div> : null}
                        </div>
                    </div>
                    {/* Edit description popup starts */}
                    <div className="modal" id="Edit-description">
                        {this.state.EditDescPopUp ? <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Edit</Trans> <Trans>Description</Trans></h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal">
                                        X
                             </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <span className="float-left cc-help-info"><Trans>Item</Trans><span> </span><Trans>ID</Trans><span>:</span> <span className="mx-1">{this.state.ItemId}</span><span visibility="hidden">{this.state.UniqId}</span></span>
                                        </div>
                                        <div className="col-12 edit-desc-field mb-4">
                                            <label className="catalog-label d-block"><Trans>Description</Trans></label>
                                            <textarea className="form-control custom-textarea" rows={5} id="DespNewValue" maxLength="254" defaultValue={this.state.Description} />
                                        </div>
                                        <div className="col-12 edit-desc-field mb-4">
                                            <label id="DescriptionValidMsg" className="DropDown-Font-Size errorcolour"></label>
                                        </div>
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4" data-dismiss="modal"><Trans>Cancel</Trans></button>
                                            <button id="DescripUpBtn" className="btn btn-primary custom-btn-primary primary-btn px-4" onClick={() => this.LinelevelEmyEdit("", "", "DESCR254", "")} ><Trans>Update</Trans></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                    </div>
                    {/* Edit description popup end */}
                    <div className="modal" id="quickconfirm" data-backdrop="static" data-keyboard="false">
                        {this.state.strCplusitemid != "0" ? <QuickItemComponent key={qckKeycounter} Itemdetails={this.state.SelectedQuickItem} IsFav={this.state.IsFav} EquipmentDelete={cartDelete} itemid={this.state.txtItemID.trim()} closePopup={this.closePopup} cpitemid={this.state.strCplusitemid} {...this.props} /> : null}
                    </div>
                    {/*Favourite Item Pop up*/}
                    <div className="modal p-0" id="add-fav-popup" data-backdrop="static" data-keyboard="false">
                        {this.state.AddFavPUp ?
                            <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                                <div className="modal-content">
                                    {/* Modal Header */}
                                    <div className="modal-header">
                                        <h4 className="modal-title mt-1">{this.state.FavorPopUptitle}</h4>
                                        <button type="button" className="btn close-btn" data-dismiss="modal " onClick={this.favpopupclose}>
                                            X
              </button>
                                    </div>
                                    {/* Modal body */}
                                    <div className="modal-body">
                                        <div className="row mt-3">
                                            <div className="col-12 edit-desc-field mb-4">
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label"><Trans>ItemKey</Trans><span> </span><Trans>ID</Trans></label>
                                                    <label className="col-md-7 quick-value" id="FavItemId" >{this.state.FavMFGPartNUMPopUp}</label>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label">Manufacturer</label>
                                                    <label className="col-md-7 quick-value" id="FavMFG" >{this.state.FavMFGPopUp}</label>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label indicate-alert"><Trans>Category</Trans></label>
                                                    {/*<div className="col-md-7">
                                                        <textarea className="form-control custom-textarea" id="FavYourCatg" maxLength="15" rows={3} defaultValue={this.state.FavYourCatgPopUp} />
                                                    </div>*/}
                                                    {/*WW-368_SuggestionCat_for_shopping_PC_03**/}
                                                    <div className="float-left search-autocomplete col-md-7  home-search" style={{ zIndex: "9999" }}>
                                                        {this.bindCat()}
                                                        {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                                        {this.state.CategoryErr ? <span className=" W-100 errorspan text-left " style={{ fontSize: '15px' }}>Enter Category</span> : null}

                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label indicate-alert"><Trans>SubCategory</Trans></label>
                                                    {/*<div className="col-md-7">
                                                        <textarea className="form-control custom-textarea" id="FavYourSubCatg" maxLength="15" rows={3} defaultValue={this.state.FavYourCatgPopUp} />
                                                    </div>*/}
                                                    {/*WW-368_SuggestionCat_for_shopping_PC_03**/}
                                                    <div className="float-left search-autocomplete col-md-7  home-search" >
                                                        {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                                        <Autocomplete
                                                            getItemValue={this.getItemValue}
                                                            items={this.state.subCategoryResults}
                                                            renderItem={this.renderItem}
                                                            value={this.state.FavSubCategory}
                                                            onChange={e => this.onChangeItem(e, "SubCat")}
                                                            onSelect={e => this.onSelectItem(e, "SubCat")}
                                                            inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                                            maxLength="40"
                                                        />
                                                        {this.state.SubCategoryErr ? <span className=" W-100 errorspan1 text-left " style={{ fontSize: '15px' }}>Enter SubCategory</span> : null}

                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label"><Trans>Description</Trans></label>
                                                    <label className="col-md-7 quick-value" id="FavItemDescrip" >{this.state.FavItemDescripPopUp}</label>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label"><Trans>Notes</Trans></label>
                                                    <div className="col-md-7">
                                                        <textarea className="form-control custom-textarea" id="FavYourDescrip" maxLength="100" rows={5} defaultValue={this.state.FavYourDescripPopUp} />
                                                    </div>
                                                </div>

                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label">Supplier</label>
                                                    <label className="col-md-7 quick-value" id="FavMFG" >{this.state.FavSupplierPopUp}</label>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label"><Trans>Supplier part#</Trans></label>
                                                    <label className="col-md-7 quick-value" id="FavMFGPartNUM" >{this.state.FavItemIdPopUp}</label>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-md-5 quick-label"><span>Choose Your Own image</span><Trans></Trans></label>
                                                    <div className="col-md-7 mb-0">
                                                        <div className="text-left">
                                                            <input type="file" title=" " accept="image/jpeg, image/png" id="customFile" style={{ "font-size": "10px" }} name="filename" onChange={this.FavItemhandleImgAttachment} onClick={this.onInputClick} />
                                                            <label className="custom-file-label ml-3 sdi-font-12" htmlFor="customFile"><Trans>Choose File</Trans></label>
                                                            {this.bindAttachments()}
                                                            <label className="priority-alert" id="lblerror">{this.state.lblerror}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 text-center mb-2">
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-4" id="FavSaveBtn" onClick={() => this.AddFavItem()}><Trans>Save</Trans></button>
                                            </div>
                                            <div visibility="false">
                                                <label id="txtUOMHide" hidden={true}>{this.state.txtUOMHidePopUp}</label>
                                                <label id="txtMfgItemidHide" hidden={true}>{this.state.txtMfgItemidHidePopUp}</label>
                                                <label id="txtItemidHide" hidden={true}>{this.state.txtItemidHidePopUp}</label>
                                                <label id="txtMFGHide" hidden={true}>{this.state.txtMFGHidePopUp}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> : null}
                    </div>
                    <div className="modal" id="Cancel-confirmation" data-backdrop="static" data-keyboard="false">
                        {this.state.RemoveItemPUp ?
                            <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                                <div className="modal-content">
                                    {/* Modal Header */}
                                    <div className="modal-header">
                                        <h4 className="modal-title mt-1" />
                                        <button type="button" className="btn close-btn" data-dismiss="modal">
                                            X
              </button>
                                    </div>
                                    {/* Modal body */}
                                    <div className="modal-body">
                                        <div className="row text-center">
                                            <div className="col-md-12 my-4">
                                                <span className="question-mark-icon delete-confirm-icon" />
                                            </div>
                                            <div className="col-12 mb-4">
                                                <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                                <label className="confirm-content d-block"><Trans>Do you want to remove this item ?</Trans></label>
                                            </div>
                                            <div className="col-md-12 text-center mb-2">
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal"><Trans>No</Trans></button>
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.DeleteItemConfirmed()}><Trans>Yes</Trans></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null}
                    </div>
                    {/* <!--//[12/06/2024, New Order Placed Popup - WW-1221 Preventive work order -Vishwa S]-->*/}
                    {/* <!--Order Placed Success popup Modal Starts here-->*/}
                    <div class="modal" id="Order-Placed" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-backdrop="static">
                        <div class="modal-dialog modal-dialog-centered custom-success-width" role="document">
                            <div class="modal-content py-2">
                                {/* <!--Success Starts here-->*/}
                                <div class="modal-body pb-2">
                                    <div class="row">

                                        <div class="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                            <img class="mb-3" src="images/tick.svg" alt="tick" />
                                            <p class="mb-1 font-13 font-regular color-light-black">{this.state.OrderPlacedstatus}</p>
                                            <p class="mb-1 font-13 font-regular color-dark-black"><Trans>Order</Trans><span> </span><Trans>No</Trans><span>:</span><span className="mx-2">{this.state.NonCataOrderNum == null || this.state.NonCataOrderNum == "" ? this.state.PricedOrderNum : this.state.NonCataOrderNum}</span></p>
                                        </div>

                                    </div>
                                </div>
                                {/*<!--Success end here-->*/}
                                <div class="modal-footer border-0 d-flex justify-content-center pt-2">
                                    <button class="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal"
                                        onClick={() => {
                                            if (!isQuoteOrderSubmit) {
                                                this.FeedbackPopup()
                                            }
                                            else {
                                                this.OrderPlaced()
                                            }
                                        }}>OK</button>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/*<!--Order Placed Success popup Modal Ends here-->*/}
                    {/*<div className="modal" id="Order-Placedtest" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                    {/*<div className="modal-header">
                                    <h4 className="modal-title mt-1" />
                                    {/*<button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.OrderPlaced()}>
                                    X
              </button>*/}
                    {/*</div>*/}
                    {/* Modal body */}
                    {/*<div className="modal-body">
                                    <div className="row text-center">
                                        <div className="col-md-12 my-4">
                                            <span className="question-mark-icon success-alert-icon" />
                                        </div>
                                        <div className="col-12 mb-4">
                                            <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                            <label className="confirm-content d-block">{this.state.OrderPlacedstatus}</label>
                                            <label className="confirm-label d-block"><Trans>Order</Trans><span> </span><Trans>No</Trans><span>:</span><span className="mx-2">{this.state.NonCataOrderNum == null || this.state.NonCataOrderNum == "" ? this.state.PricedOrderNum : this.state.NonCataOrderNum}</span></label>
                                        </div>
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.FeedbackPopup()}><Trans>OK</Trans></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>*/}
                    {/*SC_PC_01 - WW-349 Notification for Multiple Suppliers - Deepthi N H*/}
                    {/*WW-375 Ability to add Image to Fav Order -Deepthi*/}
                    <div className="modal" id="Imagealertpopup" data-backdrop="static" data-keyboard="false" >
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="text-center mt-2">
                                                <h2 className="mt-1 fav-item-title">Alert</h2>
                                            </div>
                                            <div className="text-center my-4">
                                                <span className="info-label">Note: You have an option to add image for your Order</span>
                                                <div>
                                                    <span className="info-label">Do you want to add Image?</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.ImgYesClick()}>Yes</button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.AddFavOrder("True")} style={{ marginLeft: "10%" }} >No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal" id="add-fav-Img">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />
                                    <button type="button" className="btn close-btn" data-dismiss="modal">
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row text-center">
                                        <div className="col-md-12 my-4">
                                            <span className="question-mark-icon" />
                                        </div>
                                        <div className="col-12 mb-4">
                                            <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                            <label className="confirm-content d-block"><Trans>Do you want to add Image for this item?</Trans></label>
                                        </div>
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.AddFavItem(true)} ><Trans>No</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.BindFavForm()}><Trans>Yes</Trans></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*SC_PC_01 - WW-349 Notification for Multiple Suppliers - Deepthi N H*/}
                    <div className="modal" id="alertpopup" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="text-center mt-2">
                                                <h2 className="mt-1 fav-item-title">Alert</h2>
                                            </div>
                                            <div className="text-center my-4">
                                                {  /*[07/18/22, 2381-Lowe Item cannot be mixed with other vendor items], Priyanka D */}
                                                <span className="info-label">{this.state.IsMultipleSupplier}</span>
                                                <div>
                                                    <span className="info-label">{this.state.IsOkbuttonshow}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*[04/06/22WW-370] Reorder popup should come after the Multiple supplier popup Priyanka D */}
                                    {this.state.IsLowes == false ?
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal"  >Cancel</button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" style={{ marginLeft: "10%" }} onClick={() => this.IsRefrigerantInCart()}>OK</button>{/**WW-600_PC_01 (1/26/2023)-Aparna*/}
                                        </div> :
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" >Ok</button>{/**WW-600_PC_01 (1/26/2023)-Aparna*/}
                                        </div>


                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*-----Alert Pop Up Ends Here-------*/}
                    {/*Modal start*/}
                    <div className="modal" id="reorderreason" aria-modal="true">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/*Modal Header*/}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Reason for Reorder</Trans></h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.reOrderBtnClose()}>
                                        X
                                          </button>
                                </div>
                                {/*Modal body*/}
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12 float-left">
                                            <div className="col-md-12 col-lg-12 mb-3 float-left p-0">
                                                <span id="ErrorMagUserId" className="DropDown-Font-Size errorcolour">You have already ordered this item for Work Order {$('#OLWorkOrderTB').val()}. Please select reason for ordering again</span>
                                                <label className="col-lg-12 col-md-12 float-left p-0 catalog-label form-label"><Trans>Reason</Trans></label>
                                                <div className="col-lg-12 col-md-12 float-left p-0 col-12" style={{ "font": "14px" }}>
                                                    <Select class="form-control col-md-7 col-lg-8"
                                                        id="BusinessUnit"
                                                        name="Area"
                                                        options={this.state.reoderOptions}
                                                        value={this.state.reordervalue} /*[2/24/22, PC_DP_15, Priyanka D]*/
                                                        onChange={(e) => this.handlereorderChange(e)}
                                                    />
                                                </div>
                                                <span id="ErrorMagUserId" className="DropDown-Font-Size errorcolour">{this.state.resonerr}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-lg-12 moredetail-content">
                                            <label className="catalog-label d-block" id="comments"><Trans>Comments</Trans></label>
                                            <textarea className="form-control custom-textarea " id="decreasoncmt" placeholder=""></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2 text-right p-0">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4 mt-3" data-dismiss="modal" onClick={() => this.reOrderBtnClose()} ><Trans>Cancel</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" id="subdecbtn" onClick={() => this.reasonSubmitClick()}><Trans>Submit</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*modal ends*/}
                    <div className="modal" id="addattachment">
                        {this.state.AddAttachPUp ? <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Add Attachment</Trans></h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={this.clearAttaValid}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <label className="w-100 quick-label"><Trans>Select file to attach</Trans></label>
                                            <label className="file w-100">
                                                <input type="file" title=" " id="ShopCartcustomFile" name="filename" multiple aria-label="File browser example" onChange={this.handleAttachment} onClick={this.onInputClick} />
                                                <span className="file-custom" />
                                            </label>
                                            {this.bindAttachments()}
                                            <span className="float-left err-msg text-danger" id="AttachError"></span>

                                        </div>
                                        <div className="col-md-12">
                                            <div className="d-flex justify-content-end mt-3">
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4" data-dismiss="modal" onClick={this.clearAttaValid}><Trans>Cancel</Trans></button>
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal" onClick={(e) => this.LinelevelEmyEdit("", "", "Attachment", "", e)}><Trans>Attach</Trans></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                    </div>
                    <div className="modal" id="line-increment" data-backdrop="static" data-keyboard="false">{/*NEW ***(1/25/2021)ADDED *** data-backdrop="static" data-keyboard="false"***/}
                        {this.state.LineIncrePUp ? <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-8">
                                            <div className="text-center mt-2">
                                                <img src="Images/confirm-question-mark.png" />
                                            </div>
                                            <div className="text-center my-4">
                                                <span className="info-label"><Trans>Would you like to use line numbers by increments of 10?</Trans></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-custom-btn-secondary secondary-btn px-5 mr-3" data-dismiss="modal" onClick={() => this.incrementLineNo(0)}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.incrementLineNo(1)}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                    </div>



                    <div className="modal" id="GreaterThan100Miles" data-backdrop="static" data-keyboard="false">{/*NEW ***(1/25/2021)ADDED *** data-backdrop="static" data-keyboard="false"***/}
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-8">
                                            <div className="text-center mt-2">
                                                <img src="Images/confirm-question-mark.png" />
                                            </div>
                                            <div className="text-center my-4">
                                                <div>
                                                    <span className="info-label">Selected Ship To is greater than 100 miles.</span>
                                                </div>
                                                <span className="info-label">Do you want still want to continue?</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-custom-btn-secondary secondary-btn px-5 mr-3" data-dismiss="modal" onClick={() => $('#GreaterThan100Miles').modal('hide')}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.largerMilesClick()}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal" id="Fav-confirmation" data-backdrop="static" data-keyboard="false">
                        {this.state.FavOrderConfPUp ? <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />
                                    {/* <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.AddFavOrder("False")}>
                                    X
                                </button>*/}
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row text-center">
                                        <div className="col-md-12 my-4">
                                            <span className="question-mark-icon" />
                                        </div>
                                        <div className="col-12 mb-4">
                                            <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                            {/*[02/09/22, PC_01,WW-318], Priyanka D,Hiding fav order popup if enersys Item is present */}
                                            {/*//[1/11/23, WW-552, Dhevanesam R]*/}
                                            {(CookieService.getLocalStorageValues("FormList") != undefined ? CookieService.getLocalStorageValues("FormList").length > 0 : false) ? null : <label className="confirm-content d-block"><Trans>Do you want to save this as a favorite order ?</Trans></label>}
                                        </div>
                                        {(CookieService.getLocalStorageValues("FormList") != undefined ? CookieService.getLocalStorageValues("FormList").length > 0 : false) ?
                                            <div className="col-md-12 text-center mb-2"> <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.AddFavOrder("False")}><Trans>Ok</Trans></button> </div>
                                            :
                                            <div className="col-md-12 text-center mb-2">
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.AddFavOrder("False")}><Trans>No</Trans></button>
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.FavOrdCatPopup()}><Trans>Yes</Trans></button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                    </div>
                    {/*[11/25/22, PC_WAL-926_12], Priyanka D */}
                    <div className="modal" id="RemoveFav" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />

                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row text-center">
                                        <div className="col-md-12 my-4">
                                            <span className="question-mark-icon delete-confirm-icon" />
                                        </div>
                                        <div className="col-12 mb-4">
                                            <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                            <label className="confirm-content d-block"><Trans>Do you want to remove the unavailable items from favourites ?</Trans></label>
                                        </div>
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.noRemovalClick()}><Trans>No</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.RemoveFromFav("", "", this.state.favUnavailItems)}><Trans>Yes</Trans></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal" id="Cancel-btn">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />
                                    <button type="button" className="btn close-btn" data-dismiss="modal">
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row text-center">
                                        <div className="col-md-12 my-4">
                                            <span className="question-mark-icon delete-confirm-icon" />
                                        </div>
                                        <div className="col-12 mb-4">
                                            <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                            <label className="confirm-content d-block"><Trans>Are you sure you want to cancel your order?</Trans></label>
                                        </div>
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal"><Trans>No</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.CancelOrder()}><Trans>Yes</Trans></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Pc-1025-03 commenting for showing the crystal report 09/04/24 S.Sanjay*/}
                    {/* <div className="modal orderstatus-popup" id="pdfPreview" data-backdrop="static" data-keyboard="false">
                        <PDFPreviewComponent key={OrderSuccessCOunt} base64URL={this.state.base64URL} PdfPage="1" pdfTitle="Order Status Report" {...this.props} />
                    </div>*/}




                    {/**********NEW*******wal-158*******/}
                    <div className="modal userid" id="ZipCode" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Zip Code</Trans></h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.ZipCodeClose()}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-10 float-left my-5">
                                            <label className="float-left col-md-3 form-label catalog-label pl-0"><Trans>Zip Code</Trans></label>
                                            <div className="float-left col-md-9">
                                                <input type="text" className="form-control " placeholder="Enter Zip Code" id="ZipCode_no" maxLength="5" />
                                                <span id="ZipCodeErrorId" className="DropDown-Font-Size errorcolour"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={() => this.zipcodeValidation()}><Trans>OK</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/**************END***************/}

                    {/**********NEW*******wal-158*******/}
                    <div className="modal userid" id="PostalCode" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Hold At Location</Trans></h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.ZipCodeClose()}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12 float-left ">
                                            <label className="float-left col-md-3 form-label catalog-label pl-0 my-4"><Trans>Zip Code</Trans></label>
                                            <div className="float-left col-md-9 my-3">
                                                <input type="text" className="form-control " placeholder="Enter Zip Code" id="Zipcodeno" maxLength="5" value={this.state.zipCode} onChange={(e) => this.OnHandleZipCode(e)} />

                                                <span id="PostalCodeErrorId" className="DropDown-Font-Size errorcolour"></span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-3 float-left ">
                                            <label className="float-left col-md-3 form-label catalog-label pl-0 my-4"><Trans>Country Code</Trans></label>
                                            <div className="float-left col-md-9 my-3 p-0">
                                                <div className="col-lg-12 col-md-12 col-12">
                                                    <Select
                                                        id="Hal_DD"
                                                        name="HalLocationSelected"
                                                        className="w-75 DropDown-Font-Size"
                                                        className="DropDown-Font-Size"
                                                        width='200px'
                                                        value={this.state.countrycode}
                                                        onChange={(e) => this.OnHandleCountryCode(e)}
                                                        options={this.state.HALCountryCodeDD}
                                                    //options={this.Bindpickupstore()}
                                                    />
                                                </div>
                                                {/* <input type="text" className="form-control " placeholder="E.g. US" id="Country_Code" maxLength="3" value={this.state.countrycode} onChange={(e) => this.OnHandleCountryCode(e)} /> */}



                                                <span id="CountrycodeErrorId" className="DropDown-Font-Size errorcolour ml-3"></span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2 mt-5 " onClick={() => this.HalPostalClick()}><Trans>OK</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/**************END***************/}



                    {/**********NEW*******wal-158*******/}
                    <div className="modal userid" id="operationalhrs" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered justify-content-center">
                            <div className="modal-content sdi-operational-modal">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Operational Hours</Trans></h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.operationalpopclose()}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row">
                                        <label className="col-md-12 form-label catalog-label "><Trans>{this.state.HalSelectedOphrs.store}</Trans></label>
                                        <label className="col-md-10 form-label catalog-label "><Trans>{this.state.HalSelectedOphrs.storehours}</Trans></label>








                                    </div>

                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal" onClick={() => this.operationalpopclose()}>OK</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/**************END***************/}

                    {/**********NEW*******wal-158*******/}
                    <div className="modal userid" id="Holdatlocation" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered d-flex justify-content-center ">
                            <div className="modal-content" style={{ width: "70%" }}>
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Hold At Location</Trans></h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.holdatlocclose()}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body" >



                                    <label className="custom-radiobtn" id="6m"><Trans>Use Current Location</Trans>
                                        <input type="radio" name="TRradio" id="location" className="geolocation" checked={this.state.Radiolocation} onChange={(e) => this.FedexOnChange(e, "location")} />
                                        <span className="checkmark checkmark-org " />

                                    </label>
                                    <label className="custom-radiobtn" id="dr"><Trans>Use Zip Code</Trans>
                                        <input type="radio" name="TRradio" id="pincode" checked={this.state.Radiopincode} onChange={(e) => this.FedexOnChange(e, "pincode")} />
                                        <span className="checkmark checkmark-org" />
                                    </label>
                                    <p id="HOLDATLOC" className="DropDown-Font-Size errorcolour"></p>


                                </div>
                            </div>
                        </div>
                    </div>
                    {/**************END***************/}
                    <div className="modal" id="QTY-popup" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.WOClose()}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body" >
                                    <div className="row text-center">
                                        <div className="col-md-12 my-4">
                                            <span className="question-mark-icon delete-confirm-icon" />
                                        </div>
                                        <div className="col-12 mb-4" id="modal-unavailable">
                                            <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                            {/* <div className="col-lg-12 float-left ">
                                                <div className="table-responsive">
                                                    <table className="table ZEUS_Grid FOM-grid">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>*/}
                                            {this.NAItems()}
                                            {/* </tbody>
                                                    </table>
                                                </div>
                                            </div>*/}
                                        </div>
                                        <div className="col-12 mb-4">
                                            <label className="confirm-content d-block"><Trans>Item Quantity not available. To place the order change the quantity or remove the item.</Trans></label>
                                        </div>
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-3" data-dismiss="modal" onClick={() => this.QTYNA("1")}><Trans>Remove these items</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.QTYNA("2")} ><Trans>Apply Change</Trans></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/******************/}
                    {/**WAL-541_PC_02 Fav order categroy (3/9/2022)-Aparna**/}
                    <div className="modal userid" id="Fav_Order_Category" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Add to favorite Order</Trans></h4>
                                    <button type="button" className="btn close-btn" data-toggle="modal" data-target="#Fav-confirmation" onClick={() => this.Fav_Order_Category_Close()}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body model-overflow">
                                    <div className="row justify-content-center">
                                        {/*[9/8/22], Bug - 2599 UI is not proper for Add image, Dhevanesam R*/}
                                        <div className="col-md-12 float-left mt-3">
                                            <label className="float-left col-md-3 form-label catalog-label indicate-alert"><Trans>Category</Trans></label>
                                            <div className="float-left search-autocomplete col-md-9 home-search" style={{ zIndex: "9999" }}>
                                                {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                                <Autocomplete
                                                    getItemValue={this.getItemValue}
                                                    items={this.state.autocompleteDataRstl}
                                                    renderItem={this.renderItem}
                                                    value={this.state.FavOrdCat}
                                                    onChange={e => this.onChange(e, "Cat")}
                                                    onSelect={e => this.onSelect(e, "Cat")}
                                                    inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                                />
                                                <span className="FavOrderrorspan1" style={{ fontSize: '14px', paddingRight: '111px' }} id="favordcatid" />
                                            </div>
                                        </div>
                                        {/* <div className="col-md-9 float-left mb-5">
                                            <span className="errorspan1" style={{ fontSize: '14px', paddingRight: '111px' }} id="favordcatid" />
                                        </div>*/}
                                        <div className="col-md-12 float-left mt-3">
                                            <label className="float-left col-md-3 form-label catalog-label indicate-alert"><Trans>Sub Category</Trans></label>
                                            <div className="float-left search-autocomplete col-md-9 home-search" >
                                                {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                                <Autocomplete
                                                    getItemValue={this.getItemValue}
                                                    items={this.state.FavOrdsubCategoryResults}
                                                    renderItem={this.renderItem}
                                                    value={this.state.FavOrdSubCat}
                                                    onChange={e => this.onChange(e, "Subcat")}
                                                    onSelect={e => this.onSelect(e, "Subcat")}
                                                    inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                                />
                                                <span className="FavOrderrorspan1" style={{ fontSize: '14px', paddingRight: '111px' }} id="favordsubcatid" />
                                            </div>
                                        </div>
                                        {/*<div className="col-md-9 float-left mb-5">
                                            <span className="errorspan1" style={{ fontSize: '14px', paddingRight: '111px' }} id="favordsubcatid" />
                                        </div>*/}
                                        {/*[9/8/22], Bug - 2599 UI is not proper for Add image, Dhevanesam R*/}
                                        <div className="col-md-12 float-left mt-3">
                                            <label className="float-left col-md-3 form-label catalog-label"><Trans>Notes</Trans></label>
                                            <div className="float-left col-md-9">
                                                <textarea className="form-control custom-textarea" id="FavYourDescrip" maxLength="255" rows={5} name="FavOrdDes" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdDes} />
                                            </div>
                                        </div>
                                        {/*[9/8/22], Bug - 2599 UI is not proper for Add image, Dhevanesam R*/}
                                        <div className="col-md-12 float-left mt-3">
                                            <label className="float-left col-md-3 form-label catalog-label"><Trans>Add Image</Trans></label>
                                            {/* <input type="file" class="float-left col-md-7 form-control"/> */}
                                            <div className="col-md-8 custom-file mb-3 p-0" style={{ "marginLeft": "4%" }}>
                                                {/*<input type="file" multiple className="custom-file-input" title=" " accept="image/jpeg, image/png" id="nAttachments" name="filename" onChange={this.handleAttachment} />*/}
                                                <div>
                                                    <input type="file" title=" " accept="image/jpeg, image/png" id="customFile" name="filename" onChange={this.handleAttachmentImg} onClick={this.onInputClick} />
                                                    <label className="custom-file-label" htmlFor="customFile"><Trans>Choose File</Trans></label>
                                                    {this.bindAttachmentsImg()}
                                                    <label className="priority-alert" id="Favlblerror">{this.state.lblerror}</label>
                                                    {/*<img src="Images/AddImageIcon.png" style={{ "width": "50%" }} onChange={this.handleAttachment} className="custom-file-label" htmlFor="customFile"  />*/}
                                                </div>
                                                {/*{this.state.ImageFileName!=""?<span className="attachment-file-name pl-0 my-2 pr-3 d-inline-block">
                                                    <label href="#" className="noncat-Attachment-overflow" data-toggle="tooltip" >{this.state.ImageFileName}</label>
                                                    <span className="attachment-remove-icon ml-1">X</span>
                                                </span>:null}*}
                                                {/*<label className="custom-file-label" htmlFor="customFile"><Trans>ChooseFile</Trans></label>
                                                {this.bindAttachments()}
                                                <div className="err-msg text-danger w-100 ">{this.state.attachmentErrormsg}</div>*/}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 float-left mt-3 text-center">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={() => this.FavOrdCatOK()}><Trans>OK</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal" id="FeedbackResponse" data-backdrop="static" data-keyboard="false"  >
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="text-center mt-2">
                                                <img src="Images/success-alert.png" alt="Adjustment Success" />
                                            </div>
                                            <div className="text-center my-4">
                                                <span className="info-label">Thanks for your response</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.OrderPlaced()}>OK</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    { /*'[10/04/22,WW-521_09-Binding Survey ques], Priyanka D */}
                    <div className="modal" id="FeedbackPopup" data-backdrop="static" data-keyboard="false" >
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="">
                                            <div className="text-center mt-2">
                                                {this.state.SurveyQuesList != undefined && this.state.SurveyQuesList != null && this.state.SurveyQuesList != "" && this.state.SurveyQuesList != " " ?
                                                    <span className="info-label">{this.state.SurveyQuesList[this.state.QuesNo].label}</span> : null}
                                            </div>
                                            <div className="text-center">
                                                <Rating
                                                    value={this.state.StarRating}
                                                    max={10}
                                                    onChange={(value) => this.Rating(value)}
                                                />

                                            </div>
                                            <span className="count">{this.state.StarRating}/10</span>


                                            {/*[10/11/22,WW-521-Implementation of Character counter], Priyanka D */}

                                        </div>
                                        <div className="col-md-12">
                                            <textarea className="col-md-12 form-control custom-textarea " id="decreasoncmt" maxLength="254" placeholder="Comments" onChange={(e) => this.HandleComments(e)} value={this.state.Comments}></textarea>
                                            <div>
                                                <span className="commentscount">{this.state.Comments.length}/254</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12 text-center mb-2 mt-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4 mt-3" onClick={(e) => this.Maybelater()} data-dismiss="modal">May be later</button>
                                        {this.state.IsRateNow ?
                                            <span> <button className={`btn btn-primary custom-btn-primary primary-btn px-4 mt-3 ${this.state.StarRating == 0 ? 'CursorAlias' : ''}`} disabled={this.state.StarRating == 0} onClick={(e) => this.HandleNextQues(1)} id="ratenow">Rate now</button></span> :
                                            <span><button className={`btn btn-primary custom-btn-primary primary-btn px-4 mt-3 ${this.state.StarRating == 0 ? 'CursorAlias' : ''}`} disabled={this.state.StarRating == 0} onClick={(e) => this.HandleNextQues(2)} id="next">Next</button></span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/**WW-600_PC_01 (1/26/2023)-Aparna*/}
                    <div className="modal" id="Refrigerant-popup" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                {/*<div className="modal-header">
                                    <h4 className="modal-title mt-1" />

                                </div>*/}
                                {/* Modal body */}

                                <div className="modal-body text-center">
                                    <div className="text-center mt-2">
                                        <label className="mt-1">{this.state.RefrigerantTxt}</label>
                                    </div>
                                    <div className="col-12 my-2">
                                        {/*<label className="confirm-label d-block">{this.state.Pick}</label>*/}
                                        <label className="confirm-content d-block">Item ID: {this.state.RefrigerantItem}</label>
                                    </div>

                                    <div className="col-md-12 text-center mb-2 mt-3">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" id="RefrigerantID" data-dismiss="modal" data-toggle="modal" onClick={() => this.ReorderCheck()} ><Trans>Ok</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/**WW-687_PC_08 (4/20/2023)-Aparna*/}
                    <div className="modal" id="locationaccess" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered" style={{ maxWidth: "578px" }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        Steps to enable location
                                    </h5>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        onClick={() => { if (this.state.isClosedFrom == "splitDL") $('#splitDelivery_Popup').modal('show'); }}
                                        aria-label="Close">X</button>
                                    {/* Modal body */}
                                </div>
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="text-center my-4">
                                                <p className="text-left info-label">1.Click  <img src="Images/location-img.png"></img> The location icon in the top-right corner of the browser window.</p>
                                                <p className="text-left info-label">2.Select "Always allow https://walmarttest.sdi.com to access your location" </p>
                                                <img src="Images/location-access-steps.png" style={{ width: "85%" }}></img>
                                                <p className="text-left info-label mt-2">3.Click the "Done" button</p>
                                                <p className="text-left info-label mt-2">3.To apply your updated settings to this site, reload the page</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => { if (this.state.isClosedFrom == "splitDL") $('#splitDelivery_Popup').modal('show'); }}>OK</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="modal" id="splitDelivery_Popup" style={{ "padding-right": "0px" }} data-backdrop="static" data-keyboard="false"
                    >

                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header sp-delv-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        Edit Supplier Delivery Option
        </h5>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close" onClick={e => this.splitDelivery_Close_Btn_Click()}
                                    >
                                        <span aria-hidden="true">X</span>
                                    </button>
                                </div>
                                <div className="modal-body"  >

                                    {this.bindSuppliers_InPopup()}



                                </div>

                            </div>







                        </div>



                    </div>



                    <div className="modal fade Interactive-Noncat-Confirmation-modal p-0" id="tradeMismatchPopup" data-backdrop="static"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header sp-delv-header align-items-center px-4">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        Confirmation
                                    </h5>
                                </div>
                                <div className="modal-body font-15 px-4">
                                    Validating the entered WO# will remove the unassociated equipment items from the shopping cart. Do you want to proceed with this change?
                                </div>

                                {/*button*/}
                                <div className="modal-footer border-0 px-4">
                                    <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4"
                                        type="button"
                                        data-dismiss="modal" onClick={this.ClearWO} >No</button>

                                    <button
                                        className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.QTYNA("4")}
                                        type="button">Yes</button>


                                </div>
                                {/*button*/}
                            </div>
                        </div>
                    </div>

                    {/*WW-920_PC_03 -Aparna**/}
                    <div className="modal" id="FormItem_Popup" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered" style={{ maxWidth: "440px" }}>
                            <div className="modal-content">
                                <div className="modal-header align-items-center">
                                    <h4 className="modal-title mt-1 font-18 font-semibold"><Trans>Unfilled form item(s)</Trans></h4>
                                    <button type="button" className="btn py-0" data-dismiss="modal">
                                        <img src="images/close-icon.svg" alt="close-icon" />
                                    </button>
                                </div>
                                <div className="modal-body pb-0">
                                    <div className="row">

                                        <div className="col-12  col-sm-12  col-md-12 col-lg-12 ">
                                            {this.bindFormItemID("1")}
                                            <p className="mb-1 font-13 font-regular color-light-black">Item(s) on this list are currently unfilled form.</p>
                                            {this.bindFormItemID("2")}

                                            <p className="mb-1 font-13 font-regular color-light-black">Click 'Cancel' to continue without forms</p>
                                            <p className="mb-1 font-13 font-regular color-light-black">Click 'OK' to update Item's form</p>
                                        </div>

                                    </div>
                                </div>

                                <div className="modal-footer border-0 d-flex justify-content-center">
                                    <button className="btn btn-custom-secondary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={(e) => this.FormNavigation(true)}>OK</button>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/**WW-842_PC_**/}
                    <div className="modal" id="NonCat_Popup" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered" style={{ maxWidth: "440px" }}>
                            <div className="modal-content py-2">

                                <div className="modal-body pb-0">
                                    <div className="row text-center">

                                        <div className="col-12  col-sm-12  col-md-12 col-lg-12 ">
                                            <img src="Images/Alert.png" className="justify-content-center"></img>
                                            <p className="mb-1 font-18 font-bold justify-content-center" style={{ padding: "11px" }}>Alert</p>

                                            <p className="mb-1 font-15 font-semi-bold ">Non Catalog Item(s) cannot be placed with this work order.</p>

                                        </div>

                                    </div>
                                </div>

                                <div className="modal-footer border-0 d-flex justify-content-center">
                                    <button className="btn btn-dark-grey font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-custom-primary font-17 font-medium mr-2 mb-2 px-4 py-2" onClick={(e) => this.QTYNA("3")}>Remove Item(s)</button>
                                </div>

                            </div>

                        </div>
                    </div>
                    {/* WAL-1034_PC_13 WO parts */}
                    <div className="modal" id="WO_Parts_Popup" >
                        {this.state.isValidWO && this.state.WO_Parts.length > 0 && this.state.WONUM != undefined && this.state.WONUM != null ?
                            <WOPartsComponent closePopup={this.WO_Parts_Close}  {...this.props} /> : null}
                    </div>


                    {/*Request to source items remove Confirmation modal Starts here*/}

                    <div className="modal fade Interactive-Noncat-Confirmation-modal p-0" id="IntNonCatRemovePopup" data-backdrop="static"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header sp-delv-header align-items-center px-4">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        Confirmation
                                    </h5>
                                </div>
                                <div className="modal-body font-15 px-4">
                                    The entered work order will remove request to source items from the Walmart non-catalog request. Do you want to proceed with this change?
                                </div>

                                {/*button*/}
                                <div className="modal-footer border-0 px-4">
                                    <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4"
                                        type="button"
                                        data-dismiss="modal" onClick={() => this.ClearWO()}>No</button>

                                    <button
                                        className="btn btn-custom-primary font-14 font-medium px-4" onClick={(e) => this.removeInteractiveNonCat()}
                                        type="button">Yes</button>


                                </div>
                                {/*button*/}
                            </div>
                        </div>
                    </div>

                    {/*Request to source items remove Confirmation Modal Ends here*/}

                    {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                    <div className="modal fade p-0" id="ShoppingMixedOrderConfirmPopup" data-backdrop="static"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header sp-delv-header align-items-center px-4">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        Confirmation
                                    </h5>
                                </div>
                                <div className="modal-body font-15 px-4">
                                    {this.state.cartConfirmationPopupTxt}
                                </div>

                                {/*button*/}
                                <div className="modal-footer border-0 px-4">
                                    <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                        type="button"
                                        data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  >No</button>

                                    <button
                                        className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                        type="button">Yes</button>

                                </div>
                                {/*button*/}
                            </div>
                        </div>
                    </div>
                    {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}

                </div>
            </div>
        );
    };
}
export default withTranslation()(ShoppingCart);
